webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(854);
	module.exports = __webpack_require__(847);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1584)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(650),
	  /* template */
	  __webpack_require__(2086),
	  /* scopeId */
	  "data-v-c881a850",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1600)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(638),
	  /* template */
	  __webpack_require__(2102),
	  /* scopeId */
	  "data-v-e94204fc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1501)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(808),
	  /* template */
	  __webpack_require__(2005),
	  /* scopeId */
	  "data-v-59152f83",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1585)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(707),
	  /* template */
	  __webpack_require__(2087),
	  /* scopeId */
	  "data-v-cea5c924",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1523)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(634),
	  /* template */
	  __webpack_require__(2027),
	  /* scopeId */
	  "data-v-663f835b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1443)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(782),
	  /* template */
	  __webpack_require__(1950),
	  /* scopeId */
	  "data-v-1a4acbfe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1568)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(752),
	  /* template */
	  __webpack_require__(2070),
	  /* scopeId */
	  "data-v-a81d742e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// // 是否是本地开发环境
	var isDev = exports.isDev = location.href.indexOf('http://localhost') === 0 || location.href.indexOf('http://127.0.0.1') === 0;
	// 是否是测试环境
	var isTesting = exports.isTesting = location.href.indexOf('freedom.h5.kf315.net') >= 0;
	// 是否是生产环境
	var isProduction = exports.isProduction = !(isDev || isTesting);
	// 本地开发设置
	// console.log(location.href)
	// console.log(isTesting)
	var devConfig = {
	  //
	  // domain: 'http://localhost:8085/',
	  // token: 'a55c08fa067b4727a79c4297434cc8f7',
	  // // token: '22f5c7280a4c441aa2c4a895c0751f4e',
	  // fileDomain: 'http://filetest.cjm.so/'
	  domain: 'http://freedom.cjmjgw.com/datascreen/runda/',
	  token: '55ffd124436e4119a95618a20fd9c5a3',
	  fileDomain: 'http://file.cjm.so/'
	};
	// 测试环境设置
	var testConfig = {
	  //
	  domain: 'http://freedom.h5.kf315.net/datascreen/runda/',
	  // token: '9c83a7fcd12f440b925a5d5a7dd0d832',
	  token: 'a55c08fa067b4727a79c4297434cc8f7',
	  fileDomain: 'http://filetest.cjm.so/'
	};
	
	// 生产环境设置
	// const productionConfig = {
	//   domain: 'http://freedom.cjmjgw.com/datascreen/runda/',
	//   token: '22f5c7280a4c441aa2c4a895c0751f4e',
	//   fileDomain: 'http://file.cjm.so/'
	// };
	
	// 生产环境设置
	var productionConfig = {
	  domain: 'http://freedom.cjmjgw.com/datascreen/runda-yanshi/',
	  token: '55ffd124436e4119a95618a20fd9c5a3',
	  fileDomain: 'http://file.cjm.so/'
	};
	//
	var config = {};
	if (isDev) {
	  config = devConfig;
	} else if (isTesting) {
	  config = testConfig;
	} else {
	  config = productionConfig;
	}
	exports.default = config;

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1571)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(772),
	  /* template */
	  __webpack_require__(2073),
	  /* scopeId */
	  "data-v-ac30d790",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getOwnPropertyDescriptor = __webpack_require__(860);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _setPrototypeOf = __webpack_require__(320);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _from = __webpack_require__(856);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(219);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _defineProperties = __webpack_require__(859);
	
	var _defineProperties2 = _interopRequireDefault(_defineProperties);
	
	var _assign = __webpack_require__(858);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _map = __webpack_require__(857);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _iterator = __webpack_require__(322);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(321);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _stringify = __webpack_require__(171);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _preventExtensions = __webpack_require__(863);
	
	var _preventExtensions2 = _interopRequireDefault(_preventExtensions);
	
	var _isExtensible = __webpack_require__(861);
	
	var _isExtensible2 = _interopRequireDefault(_isExtensible);
	
	var _create = __webpack_require__(319);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _keys = __webpack_require__(862);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty = __webpack_require__(218);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function (t, e) {
	  "object" == ( false ? "undefined" : (0, _typeof3.default)(exports)) && "object" == ( false ? "undefined" : (0, _typeof3.default)(module)) ? module.exports = e(__webpack_require__(29)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(29)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) ? exports.VueAMap = e(require("vue")) : t.VueAMap = e(t.Vue);
	}("undefined" != typeof self ? self : undefined, function (t) {
	  return function (t) {
	    function e(r) {
	      if (n[r]) return n[r].exports;var o = n[r] = { i: r, l: !1, exports: {} };return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
	    }var n = {};return e.m = t, e.c = n, e.d = function (t, n, r) {
	      e.o(t, n) || (0, _defineProperty2.default)(t, n, { configurable: !1, enumerable: !0, get: r });
	    }, e.n = function (t) {
	      var n = t && t.__esModule ? function () {
	        return t.default;
	      } : function () {
	        return t;
	      };return e.d(n, "a", n), n;
	    }, e.o = function (t, e) {
	      return Object.prototype.hasOwnProperty.call(t, e);
	    }, e.p = "./", e(e.s = 64);
	  }([function (t, e, n) {
	    "use strict";
	    var r = n(45),
	        o = n.n(r),
	        i = n(6),
	        a = n(50),
	        s = n(13),
	        u = n(49),
	        c = n(27);e.a = { data: function data() {
	        return { unwatchFns: [] };
	      }, mounted: function mounted() {
	        var t = this;s.b && s.b.load().then(function () {
	          t.__contextReady && t.__contextReady.call(t, t.convertProps());
	        }), this.$amap = this.$amap || this.$parent.$amap, this.$amap ? this.register() : this.$on(u.a.AMAP_READY_EVENT, function (e) {
	          t.$amap = e, t.register();
	        });
	      }, destroyed: function destroyed() {
	        this.unregisterEvents(), this.$amapComponent && (this.$amapComponent.setMap && this.$amapComponent.setMap(null), this.$amapComponent.close && this.$amapComponent.close(), this.$amapComponent.editor && this.$amapComponent.editor.close(), this.unwatchFns.forEach(function (t) {
	          return t();
	        }), this.unwatchFns = []);
	      }, methods: { getHandlerFun: function getHandlerFun(t) {
	          return this.handlers && this.handlers[t] ? this.handlers[t] : this.$amapComponent["set" + o()(t)] || this.$amapComponent.setOptions;
	        }, convertProps: function convertProps() {
	          var t = this,
	              e = {};this.$amap && (e.map = this.$amap);var n = this.$options.propsData,
	              r = void 0 === n ? {} : n,
	              o = this.propsRedirect;return (0, _keys2.default)(r).reduce(function (n, i) {
	            var a = i,
	                s = t.convertSignalProp(a, r[a]);return void 0 === s ? n : (o && o[i] && (a = o[a]), e[a] = s, n);
	          }, e);
	        }, convertSignalProp: function convertSignalProp(t, e) {
	          var n = "",
	              r = "";if (this.amapTagName) try {
	            var a = o()(this.amapTagName).replace(/^El/, "");r = (c.default[a] || "").props[t].$type, n = i.a[r];
	          } catch (t) {}if (r && n) return n(e);if (this.converters && this.converters[t]) return this.converters[t].call(this, e);var s = i.a[t];return s ? s(e) : e;
	        }, registerEvents: function registerEvents() {
	          if (this.setEditorEvents && this.setEditorEvents(), this.$options.propsData) {
	            if (this.$options.propsData.events) for (var t in this.events) {
	              a.a.addListener(this.$amapComponent, t, this.events[t]);
	            }if (this.$options.propsData.onceEvents) for (var e in this.onceEvents) {
	              a.a.addListenerOnce(this.$amapComponent, e, this.onceEvents[e]);
	            }
	          }
	        }, unregisterEvents: function unregisterEvents() {
	          a.a.clearListeners(this.$amapComponent);
	        }, setPropWatchers: function setPropWatchers() {
	          var t = this,
	              e = this.propsRedirect,
	              n = this.$options.propsData,
	              r = void 0 === n ? {} : n;(0, _keys2.default)(r).forEach(function (n) {
	            var r = n;e && e[n] && (r = e[n]);var o = t.getHandlerFun(r);if (o || "events" === n) {
	              var i = t.$watch(n, function (e) {
	                if ("events" === n) return t.unregisterEvents(), void t.registerEvents();if (o && o === t.$amapComponent.setOptions) {
	                  var i;return o.call(t.$amapComponent, (i = {}, i[r] = t.convertSignalProp(n, e), i));
	                }o.call(t.$amapComponent, t.convertSignalProp(n, e));
	              });t.unwatchFns.push(i);
	            }
	          });
	        }, registerToManager: function registerToManager() {
	          var t = this.amapManager || this.$parent.amapManager;t && void 0 !== this.vid && t.setComponent(this.vid, this.$amapComponent);
	        }, initProps: function initProps() {
	          var t = this;["editable", "visible"].forEach(function (e) {
	            if (void 0 !== t[e]) {
	              var n = t.getHandlerFun(e);n && n.call(t.$amapComponent, t.convertSignalProp(e, t[e]));
	            }
	          });
	        }, printReactiveProp: function printReactiveProp() {
	          var t = this;(0, _keys2.default)(this._props).forEach(function (e) {
	            t.$amapComponent["set" + o()(e)] && console.log(e);
	          });
	        }, register: function register() {
	          var t = this,
	              e = this.__initComponent && this.__initComponent(this.convertProps());e && e.then ? e.then(function (e) {
	            return t.registerRest(e);
	          }) : this.registerRest(e);
	        }, registerRest: function registerRest(t) {
	          !this.$amapComponent && t && (this.$amapComponent = t), this.registerEvents(), this.initProps(), this.setPropWatchers(), this.registerToManager(), this.events && this.events.init && this.events.init(this.$amapComponent, this.$amap, this.amapManager || this.$parent.amapManager);
	        }, $$getInstance: function $$getInstance() {
	          return this.$amapComponent;
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    function r(t, e, n, r, o, i, a, s) {
	      t = t || {};var u = (0, _typeof3.default)(t.default);"object" !== u && "function" !== u || (t = t.default);var c = "function" == typeof t ? t.options : t;e && (c.render = e, c.staticRenderFns = n, c._compiled = !0), r && (c.functional = !0), i && (c._scopeId = i);var p;if (a ? (p = function p(t) {
	        t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), o && o.call(this, t), t && t._registeredComponents && t._registeredComponents.add(a);
	      }, c._ssrRegister = p) : o && (p = s ? function () {
	        o.call(this, this.$root.$options.shadowRoot);
	      } : o), p) if (c.functional) {
	        c._injectStyles = p;var f = c.render;c.render = function (t, e) {
	          return p.call(e), f(t, e);
	        };
	      } else {
	        var l = c.beforeCreate;c.beforeCreate = l ? [].concat(l, p) : [p];
	      }return { exports: t, options: c };
	    }e.a = r;
	  }, function (t, e, n) {
	    var r = n(30)("wks"),
	        o = n(14),
	        i = n(3).Symbol,
	        a = "function" == typeof i;(t.exports = function (t) {
	      return r[t] || (r[t] = a && i[t] || (a ? i : o)("Symbol." + t));
	    }).store = r;
	  }, function (t, e) {
	    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();"number" == typeof __g && (__g = n);
	  }, function (t, e) {
	    t.exports = function (t) {
	      return "object" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) ? null !== t : "function" == typeof t;
	    };
	  }, function (t, e, n) {
	    t.exports = !n(15)(function () {
	      return 7 != Object.defineProperty({}, "a", { get: function get() {
	          return 7;
	        } }).a;
	    });
	  }, function (t, e, n) {
	    "use strict";
	    function r(t) {
	      return new AMap.Pixel(t[0], t[1]);
	    }function o(t) {
	      return new AMap.Size(t[0], t[1]);
	    }function i(t) {
	      return Array.isArray(t) ? t : [t.getX(), t.getY()];
	    }function a(t) {
	      return new AMap.LngLat(t[0], t[1]);
	    }function s(t) {
	      if (t) return Array.isArray(t) ? t.slice() : [t.getLng(), t.getLat()];
	    }function u(t) {
	      return new AMap.Bounds(a(t[0]), a(t[1]));
	    }e.e = r, e.c = i, e.d = a, e.b = s, n.d(e, "a", function () {
	      return c;
	    });var c = { position: a, offset: r, bounds: u, LngLat: a, Pixel: r, Size: o, Bounds: u };
	  }, function (t, e, n) {
	    var r = n(3),
	        o = n(8),
	        i = n(11),
	        a = n(14)("src"),
	        s = Function.toString,
	        u = ("" + s).split("toString");n(16).inspectSource = function (t) {
	      return s.call(t);
	    }, (t.exports = function (t, e, n, s) {
	      var c = "function" == typeof n;c && (i(n, "name") || o(n, "name", e)), t[e] !== n && (c && (i(n, a) || o(n, a, t[e] ? "" + t[e] : u.join(String(e)))), t === r ? t[e] = n : s ? t[e] ? t[e] = n : o(t, e, n) : (delete t[e], o(t, e, n)));
	    })(Function.prototype, "toString", function () {
	      return "function" == typeof this && this[a] || s.call(this);
	    });
	  }, function (t, e, n) {
	    var r = n(9),
	        o = n(20);t.exports = n(5) ? function (t, e, n) {
	      return r.f(t, e, o(1, n));
	    } : function (t, e, n) {
	      return t[e] = n, t;
	    };
	  }, function (t, e, n) {
	    var r = n(10),
	        o = n(31),
	        i = n(33),
	        a = _defineProperty2.default;e.f = n(5) ? _defineProperty2.default : function (t, e, n) {
	      if (r(t), e = i(e, !0), r(n), o) try {
	        return a(t, e, n);
	      } catch (t) {}if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");return "value" in n && (t[e] = n.value), t;
	    };
	  }, function (t, e, n) {
	    var r = n(4);t.exports = function (t) {
	      if (!r(t)) throw TypeError(t + " is not an object!");return t;
	    };
	  }, function (t, e) {
	    var n = {}.hasOwnProperty;t.exports = function (t, e) {
	      return n.call(t, e);
	    };
	  }, function (t, e) {
	    t.exports = {};
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return s;
	    }), n.d(e, "b", function () {
	      return a;
	    });var r = n(97),
	        o = n(19),
	        i = n.n(o),
	        a = null,
	        s = function s(t) {
	      i.a.prototype.$isServer || a || (a || (a = new r.a(t)), a.load());
	    };
	  }, function (t, e) {
	    var n = 0,
	        r = Math.random();t.exports = function (t) {
	      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
	    };
	  }, function (t, e) {
	    t.exports = function (t) {
	      try {
	        return !!t();
	      } catch (t) {
	        return !0;
	      }
	    };
	  }, function (t, e) {
	    var n = t.exports = { version: "2.5.5" };"number" == typeof __e && (__e = n);
	  }, function (t, e, n) {
	    var r = n(71);t.exports = function (t, e, n) {
	      if (r(t), void 0 === e) return t;switch (n) {case 1:
	          return function (n) {
	            return t.call(e, n);
	          };case 2:
	          return function (n, r) {
	            return t.call(e, n, r);
	          };case 3:
	          return function (n, r, o) {
	            return t.call(e, n, r, o);
	          };}return function () {
	        return t.apply(e, arguments);
	      };
	    };
	  }, function (t, e, n) {
	    var r = n(75),
	        o = n(22);t.exports = function (t) {
	      return r(o(t));
	    };
	  }, function (e, n) {
	    e.exports = t;
	  }, function (t, e) {
	    t.exports = function (t, e) {
	      return { enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e };
	    };
	  }, function (t, e) {
	    var n = Math.ceil,
	        r = Math.floor;t.exports = function (t) {
	      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
	    };
	  }, function (t, e) {
	    t.exports = function (t) {
	      if (void 0 == t) throw TypeError("Can't call method on  " + t);return t;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(70),
	        o = n(34),
	        i = n(7),
	        a = n(8),
	        s = n(12),
	        u = n(72),
	        c = n(25),
	        p = n(79),
	        f = n(2)("iterator"),
	        l = !([].keys && "next" in [].keys()),
	        d = function d() {
	      return this;
	    };t.exports = function (t, e, n, h, v, m, y) {
	      u(n, e, h);var g,
	          b,
	          _,
	          x = function x(t) {
	        if (!l && t in M) return M[t];switch (t) {case "keys":case "values":
	            return function () {
	              return new n(this, t);
	            };}return function () {
	          return new n(this, t);
	        };
	      },
	          C = e + " Iterator",
	          w = "values" == v,
	          $ = !1,
	          M = t.prototype,
	          E = M[f] || M["@@iterator"] || v && M[v],
	          A = E || x(v),
	          S = v ? w ? x("entries") : A : void 0,
	          k = "Array" == e ? M.entries || E : E;if (k && (_ = p(k.call(new t()))) !== Object.prototype && _.next && (c(_, C, !0), r || "function" == typeof _[f] || a(_, f, d)), w && E && "values" !== E.name && ($ = !0, A = function A() {
	        return E.call(this);
	      }), r && !y || !l && !$ && M[f] || a(M, f, A), s[e] = A, s[C] = d, v) if (g = { values: w ? A : x("values"), keys: m ? A : x("keys"), entries: S }, y) for (b in g) {
	        b in M || i(M, b, g[b]);
	      } else o(o.P + o.F * (l || $), e, g);return g;
	    };
	  }, function (t, e, n) {
	    var r = n(30)("keys"),
	        o = n(14);t.exports = function (t) {
	      return r[t] || (r[t] = o(t));
	    };
	  }, function (t, e, n) {
	    var r = n(9).f,
	        o = n(11),
	        i = n(2)("toStringTag");t.exports = function (t, e, n) {
	      t && !o(t = n ? t : t.prototype, i) && r(t, i, { configurable: !0, value: e });
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(50);e.a = { methods: { setEditorEvents: function setEditorEvents() {
	          var t = this;if (this.$amapComponent.editor && this.events) {
	            var e = ["addnode", "adjust", "removenode", "end", "move"],
	                n = {};(0, _keys2.default)(this.events).forEach(function (r) {
	              -1 !== e.indexOf(r) && (n[r] = t.events[r]);
	            }), (0, _keys2.default)(n).forEach(function (e) {
	              r.a.addListener(t.$amapComponent.editor, e, n[e]);
	            });
	          }
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    Object.defineProperty(e, "__esModule", { value: !0 });var r = (n(65), n(45)),
	        o = n.n(r),
	        i = n(13),
	        a = n(100),
	        s = n(106),
	        u = n(107),
	        c = n(111),
	        p = n(113),
	        f = n(115),
	        l = n(116),
	        d = n(118),
	        h = n(120),
	        v = n(122),
	        m = n(124),
	        y = n(126),
	        g = n(128),
	        b = n(130),
	        _ = n(131);n.d(e, "AMapManager", function () {
	      return b.a;
	    }), n.d(e, "initAMapApiLoader", function () {
	      return i.a;
	    }), n.d(e, "createCustomComponent", function () {
	      return _.a;
	    }), n.d(e, "lazyAMapApiLoaderInstance", function () {
	      return i.b;
	    });var x = [a.a, s.a, u.a, c.a, p.a, f.a, d.a, l.a, h.a, v.a, m.a, y.a, g.a],
	        C = { initAMapApiLoader: i.a, AMapManager: b.a };C.install = function (t) {
	      C.installed || (t.config.optionMergeStrategies.deferredReady = t.config.optionMergeStrategies.created, x.map(function (e) {
	        t.component(e.name, e), C[o()(e.name).replace(/^El/, "")] = e;
	      }));
	    };"undefined" != typeof window && window.Vue && function t(e) {
	      arguments.length > 1 && void 0 !== arguments[1] && arguments[1];t.installed || C.install(e);
	    }(window.Vue), e.default = C;
	  }, function (t, e, n) {
	    var r = n(29),
	        o = n(2)("toStringTag"),
	        i = "Arguments" == r(function () {
	      return arguments;
	    }()),
	        a = function a(t, e) {
	      try {
	        return t[e];
	      } catch (t) {}
	    };t.exports = function (t) {
	      var e, n, s;return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = a(e = Object(t), o)) ? n : i ? r(e) : "Object" == (s = r(e)) && "function" == typeof e.callee ? "Arguments" : s;
	    };
	  }, function (t, e) {
	    var n = {}.toString;t.exports = function (t) {
	      return n.call(t).slice(8, -1);
	    };
	  }, function (t, e, n) {
	    var r = n(3),
	        o = r["__core-js_shared__"] || (r["__core-js_shared__"] = {});t.exports = function (t) {
	      return o[t] || (o[t] = {});
	    };
	  }, function (t, e, n) {
	    t.exports = !n(5) && !n(15)(function () {
	      return 7 != Object.defineProperty(n(32)("div"), "a", { get: function get() {
	          return 7;
	        } }).a;
	    });
	  }, function (t, e, n) {
	    var r = n(4),
	        o = n(3).document,
	        i = r(o) && r(o.createElement);t.exports = function (t) {
	      return i ? o.createElement(t) : {};
	    };
	  }, function (t, e, n) {
	    var r = n(4);t.exports = function (t, e) {
	      if (!r(t)) return t;var n, o;if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;throw TypeError("Can't convert object to primitive value");
	    };
	  }, function (t, e, n) {
	    var r = n(3),
	        o = n(16),
	        i = n(8),
	        a = n(7),
	        s = n(17),
	        u = function u(t, e, n) {
	      var c,
	          p,
	          f,
	          l,
	          d = t & u.F,
	          h = t & u.G,
	          v = t & u.S,
	          m = t & u.P,
	          y = t & u.B,
	          g = h ? r : v ? r[e] || (r[e] = {}) : (r[e] || {}).prototype,
	          b = h ? o : o[e] || (o[e] = {}),
	          _ = b.prototype || (b.prototype = {});h && (n = e);for (c in n) {
	        p = !d && g && void 0 !== g[c], f = (p ? g : n)[c], l = y && p ? s(f, r) : m && "function" == typeof f ? s(Function.call, f) : f, g && a(g, c, f, t & u.U), b[c] != f && i(b, c, l), m && _[c] != f && (_[c] = f);
	      }
	    };r.core = o, u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, t.exports = u;
	  }, function (t, e, n) {
	    var r = n(10),
	        o = n(73),
	        i = n(38),
	        a = n(24)("IE_PROTO"),
	        s = function s() {},
	        _u = function u() {
	      var t,
	          e = n(32)("iframe"),
	          r = i.length;for (e.style.display = "none", n(78).appendChild(e), e.src = "javascript:", t = e.contentWindow.document, t.open(), t.write("<script>document.F=Object<\/script>"), t.close(), _u = t.F; r--;) {
	        delete _u.prototype[i[r]];
	      }return _u();
	    };t.exports = _create2.default || function (t, e) {
	      var n;return null !== t ? (s.prototype = r(t), n = new s(), s.prototype = null, n[a] = t) : n = _u(), void 0 === e ? n : o(n, e);
	    };
	  }, function (t, e, n) {
	    var r = n(74),
	        o = n(38);t.exports = _keys2.default || function (t) {
	      return r(t, o);
	    };
	  }, function (t, e, n) {
	    var r = n(21),
	        o = Math.min;t.exports = function (t) {
	      return t > 0 ? o(r(t), 9007199254740991) : 0;
	    };
	  }, function (t, e) {
	    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
	  }, function (t, e) {
	    t.exports = function (t, e) {
	      return { value: e, done: !!t };
	    };
	  }, function (t, e, n) {
	    var r = n(7);t.exports = function (t, e, n) {
	      for (var o in e) {
	        r(t, o, e[o], n);
	      }return t;
	    };
	  }, function (t, e) {
	    t.exports = function (t, e, n, r) {
	      if (!(t instanceof e) || void 0 !== r && r in t) throw TypeError(n + ": incorrect invocation!");return t;
	    };
	  }, function (t, e, n) {
	    var r = n(17),
	        o = n(86),
	        i = n(87),
	        a = n(10),
	        s = n(37),
	        u = n(88),
	        c = {},
	        p = {},
	        e = t.exports = function (t, e, n, f, l) {
	      var d,
	          h,
	          v,
	          m,
	          y = l ? function () {
	        return t;
	      } : u(t),
	          g = r(n, f, e ? 2 : 1),
	          b = 0;if ("function" != typeof y) throw TypeError(t + " is not iterable!");if (i(y)) {
	        for (d = s(t.length); d > b; b++) {
	          if ((m = e ? g(a(h = t[b])[0], h[1]) : g(t[b])) === c || m === p) return m;
	        }
	      } else for (v = y.call(t); !(h = v.next()).done;) {
	        if ((m = o(v, g, h.value, e)) === c || m === p) return m;
	      }
	    };e.BREAK = c, e.RETURN = p;
	  }, function (t, e, n) {
	    var r = n(14)("meta"),
	        o = n(4),
	        i = n(11),
	        a = n(9).f,
	        s = 0,
	        u = _isExtensible2.default || function () {
	      return !0;
	    },
	        c = !n(15)(function () {
	      return u((0, _preventExtensions2.default)({}));
	    }),
	        p = function p(t) {
	      a(t, r, { value: { i: "O" + ++s, w: {} } });
	    },
	        f = function f(t, e) {
	      if (!o(t)) return "symbol" == (typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t)) ? t : ("string" == typeof t ? "S" : "P") + t;if (!i(t, r)) {
	        if (!u(t)) return "F";if (!e) return "E";p(t);
	      }return t[r].i;
	    },
	        l = function l(t, e) {
	      if (!i(t, r)) {
	        if (!u(t)) return !0;if (!e) return !1;p(t);
	      }return t[r].w;
	    },
	        d = function d(t) {
	      return c && h.NEED && u(t) && !i(t, r) && p(t), t;
	    },
	        h = t.exports = { KEY: r, NEED: !1, fastKey: f, getWeak: l, onFreeze: d };
	  }, function (t, e, n) {
	    var r = n(4);t.exports = function (t, e) {
	      if (!r(t) || t._t !== e) throw TypeError("Incompatible receiver, " + e + " required!");return t;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(96);t.exports = function () {
	      var t = r.apply(r, arguments);return t.charAt(0).toUpperCase() + t.slice(1);
	    };
	  }, function (t, e) {
	    function n(t, e) {
	      var n = t[1] || "",
	          o = t[3];if (!o) return n;if (e && "function" == typeof btoa) {
	        var i = r(o);return [n].concat(o.sources.map(function (t) {
	          return "/*# sourceURL=" + o.sourceRoot + t + " */";
	        })).concat([i]).join("\n");
	      }return [n].join("\n");
	    }function r(t) {
	      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent((0, _stringify2.default)(t)))) + " */";
	    }t.exports = function (t) {
	      var e = [];return e.toString = function () {
	        return this.map(function (e) {
	          var r = n(e, t);return e[2] ? "@media " + e[2] + "{" + r + "}" : r;
	        }).join("");
	      }, e.i = function (t, n) {
	        "string" == typeof t && (t = [[null, t, ""]]);for (var r = {}, o = 0; o < this.length; o++) {
	          var i = this[o][0];"number" == typeof i && (r[i] = !0);
	        }for (o = 0; o < t.length; o++) {
	          var a = t[o];"number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
	        }
	      }, e;
	    };
	  }, function (t, e, n) {
	    function r(t) {
	      for (var e = 0; e < t.length; e++) {
	        var n = t[e],
	            r = p[n.id];if (r) {
	          r.refs++;for (var o = 0; o < r.parts.length; o++) {
	            r.parts[o](n.parts[o]);
	          }for (; o < n.parts.length; o++) {
	            r.parts.push(i(n.parts[o]));
	          }r.parts.length > n.parts.length && (r.parts.length = n.parts.length);
	        } else {
	          for (var a = [], o = 0; o < n.parts.length; o++) {
	            a.push(i(n.parts[o]));
	          }p[n.id] = { id: n.id, refs: 1, parts: a };
	        }
	      }
	    }function o() {
	      var t = document.createElement("style");return t.type = "text/css", f.appendChild(t), t;
	    }function i(t) {
	      var e,
	          n,
	          r = document.querySelector('style[data-vue-ssr-id~="' + t.id + '"]');if (r) {
	        if (h) return v;r.parentNode.removeChild(r);
	      }if (m) {
	        var i = d++;r = l || (l = o()), e = a.bind(null, r, i, !1), n = a.bind(null, r, i, !0);
	      } else r = o(), e = s.bind(null, r), n = function n() {
	        r.parentNode.removeChild(r);
	      };return e(t), function (r) {
	        if (r) {
	          if (r.css === t.css && r.media === t.media && r.sourceMap === t.sourceMap) return;e(t = r);
	        } else n();
	      };
	    }function a(t, e, n, r) {
	      var o = n ? "" : r.css;if (t.styleSheet) t.styleSheet.cssText = y(e, o);else {
	        var i = document.createTextNode(o),
	            a = t.childNodes;a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
	      }
	    }function s(t, e) {
	      var n = e.css,
	          r = e.media,
	          o = e.sourceMap;if (r && t.setAttribute("media", r), o && (n += "\n/*# sourceURL=" + o.sources[0] + " */", n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent((0, _stringify2.default)(o)))) + " */"), t.styleSheet) t.styleSheet.cssText = n;else {
	        for (; t.firstChild;) {
	          t.removeChild(t.firstChild);
	        }t.appendChild(document.createTextNode(n));
	      }
	    }var u = "undefined" != typeof document;if (false) throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var c = n(103),
	        p = {},
	        f = u && (document.head || document.getElementsByTagName("head")[0]),
	        l = null,
	        d = 0,
	        h = !1,
	        v = function v() {},
	        m = "undefined" != typeof navigator && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports = function (t, e, n) {
	      h = n;var o = c(t, e);return r(o), function (e) {
	        for (var n = [], i = 0; i < o.length; i++) {
	          var a = o[i],
	              s = p[a.id];s.refs--, n.push(s);
	        }e ? (o = c(t, e), r(o)) : o = [];for (var i = 0; i < n.length; i++) {
	          var s = n[i];if (0 === s.refs) {
	            for (var u = 0; u < s.parts.length; u++) {
	              s.parts[u]();
	            }delete p[s.id];
	          }
	        }
	      };
	    };var y = function () {
	      var t = [];return function (e, n) {
	        return t[e] = n, t.filter(Boolean).join("\n");
	      };
	    }();
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(104),
	        o = n(49),
	        i = n(6),
	        a = n(0),
	        s = n(13),
	        u = "function" == typeof _symbol2.default && "symbol" == (0, _typeof3.default)(_iterator2.default) ? function (t) {
	      return typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t);
	    } : function (t) {
	      return t && "function" == typeof _symbol2.default && t.constructor === _symbol2.default && t !== _symbol2.default.prototype ? "symbol" : typeof t === "undefined" ? "undefined" : (0, _typeof3.default)(t);
	    };e.a = { name: "el-amap", mixins: [a.a], props: ["viewMode", "skyColor", "rotateEnable", "pitch", "buildingAnimation", "pitchEnable", "vid", "events", "center", "zoom", "draggEnable", "level", "zooms", "lang", "defaultCursor", "crs", "animateEnable", "isHotspot", "defaultLayer", "rotateEnable", "resizeEnable", "showIndoorMap", "indoorMap", "expandZoomRange", "dragEnable", "zoomEnable", "doubleClickZoom", "keyboardEnable", "jogEnable", "scrollWheel", "touchZoom", "mapStyle", "plugin", "features", "amapManager"], beforeCreate: function beforeCreate() {
	        this._loadPromise = s.b.load();
	      }, destroyed: function destroyed() {
	        this.$amap && this.$amap.destroy();
	      }, computed: { plugins: function plugins() {
	          var t = [],
	              e = /^AMap./,
	              n = function n(t) {
	            return e.test(t) ? t : "AMap." + t;
	          },
	              r = function r(t) {
	            return t.replace(e, "");
	          };return "string" == typeof this.plugin ? t.push({ pName: n(this.plugin), sName: r(this.plugin) }) : this.plugin instanceof Array && (t = this.plugin.map(function (t) {
	            var e = {};return "string" == typeof t ? e = { pName: n(t), sName: r(t) } : (t.pName = n(t.pName), t.sName = r(t.pName), e = t), e;
	          })), t;
	        } }, data: function data() {
	        return { converters: { center: function center(t) {
	              return Object(i.d)(t);
	            } }, handlers: { zoomEnable: function zoomEnable(t) {
	              this.setStatus({ zoomEnable: t });
	            }, dragEnable: function dragEnable(t) {
	              this.setStatus({ dragEnable: t });
	            }, rotateEnable: function rotateEnable(t) {
	              this.setStatus({ rotateEnable: t });
	            } } };
	      }, mounted: function mounted() {
	        this.createMap();
	      }, addEvents: function addEvents() {
	        var t = this;this.$amapComponent.on("moveend", function () {
	          var e = t.$amapComponent.getCenter();t.center = [e.getLng(), e.getLat()];
	        });
	      }, methods: { addPlugins: function addPlugins() {
	          var t = this.plugins.filter(function (t) {
	            return !AMap[t.sName];
	          });return t && t.length ? this.$amapComponent.plugin(t, this.addMapControls) : this.addMapControls();
	        }, addMapControls: function addMapControls() {
	          var t = this;this.plugins && this.plugins.length && (this.$plugins = this.$plugins || {}, this.plugins.forEach(function (e) {
	            var n = t.convertAMapPluginProps(e),
	                r = t.$plugins[n.pName] = new AMap[n.sName](n);if (t.$amapComponent.addControl(r), e.events) for (var o in e.events) {
	              var i = e.events[o];"init" === o ? i(r) : AMap.event.addListener(r, o, i);
	            }
	          }));
	        }, convertAMapPluginProps: function convertAMapPluginProps(t) {
	          if ("object" === (void 0 === t ? "undefined" : u(t)) && t.pName) {
	            switch (t.pName) {case "AMap.ToolBar":case "AMap.Scale":
	                t.offset && t.offset instanceof Array && (t.offset = Object(i.e)(t.offset));}return t;
	          }return "";
	        }, setStatus: function setStatus(t) {
	          this.$amap.setStatus(t);
	        }, createMap: function createMap() {
	          var t = this;this._loadPromise.then(function () {
	            var e = t.$el.querySelector(".el-vue-amap"),
	                n = t.vid || Object(r.a)();e.id = n, t.$amap = t.$amapComponent = new AMap.Map(n, t.convertProps()), t.amapManager && t.amapManager.setMap(t.$amap), t.$emit(o.a.AMAP_READY_EVENT, t.$amap), t.$children.forEach(function (e) {
	              e.$emit(o.a.AMAP_READY_EVENT, t.$amap);
	            }), t.plugins && t.plugins.length && t.addPlugins();
	          });
	        }, $$getCenter: function $$getCenter() {
	          return this.$amap ? Object(i.b)(this.$amap.getCenter()) : Object(i.b)(this.center);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    e.a = { AMAP_READY_EVENT: "AMAP_READY_EVENT" };
	  }, function (t, e, n) {
	    "use strict";
	    function r(t, e) {
	      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	    }var o = void 0,
	        i = function () {
	      function t() {
	        r(this, t), this._listener = new _map2.default();
	      }return t.prototype.addListener = function (t, e, n, r) {
	        if (!AMap.event) throw new Error("please wait for Map API load");var o = AMap.event.addListener(t, e, n, r);this._listener.get(t) || this._listener.set(t, {});var i = this._listener.get(t);i[e] || (i[e] = []), i[e].push(o);
	      }, t.prototype.removeListener = function (t, e, n) {
	        if (!AMap.event) throw new Error("please wait for Map API load");if (this._listener.get(t) && this._listener.get(t)[e]) {
	          var r = this._listener.get(t)[e];if (n) {
	            var o = r.indexOf(n);AMap.event.removeListener(r[o]), r.splice(o, 1);
	          } else r.forEach(function (t) {
	            AMap.event.removeListener(t);
	          }), this._listener.get(t)[e] = [];
	        }
	      }, t.prototype.addListenerOnce = function (t, e, n, r) {
	        return AMap.event.addListenerOnce(t, e, n, r);
	      }, t.prototype.trigger = function (t, e, n) {
	        return AMap.event.trigger(t, e, n);
	      }, t.prototype.clearListeners = function (t) {
	        var e = this,
	            n = this._listener.get(t);n && (0, _keys2.default)(n).map(function (n) {
	          e.removeListener(t, n);
	        });
	      }, t;
	    }();o = o || new i(), e.a = o;
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = n(6),
	        i = n(52),
	        a = n(19),
	        s = n.n(a),
	        u = "el-amap-marker";e.a = { name: u, mixins: [r.a], props: ["vid", "position", "offset", "icon", "content", "topWhenClick", "bubble", "draggable", "raiseOnDrag", "cursor", "visible", "zIndex", "angle", "autoRotation", "animation", "shadow", "title", "clickable", "shape", "extData", "label", "events", "onceEvents", "template", "vnode", "contentRender"], data: function data() {
	        var t = this;return { $tagName: u, withSlots: !1, tmpVM: null, propsRedirect: { template: "content", vnode: "content", contentRender: "content" }, converters: { shape: function shape(t) {
	              return new AMap.MarkerShape(t);
	            }, shadow: function shadow(t) {
	              return new AMap.Icon(t);
	            }, template: function template(e) {
	              var n = Object(i.a)(e, t);return this.$customContent = n, n.$el;
	            }, vnode: function vnode(e) {
	              var n = "function" == typeof e ? e(t) : e,
	                  r = Object(i.c)(n);return this.$customContent = r, r.$el;
	            }, contentRender: function contentRender(e) {
	              var n = Object(i.b)(e, t);return this.$customContent = n, n.$el;
	            }, label: function label(t) {
	              var e = t.content,
	                  n = void 0 === e ? "" : e,
	                  r = t.offset,
	                  i = void 0 === r ? [0, 0] : r;return { content: n, offset: Object(o.e)(i) };
	            } }, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } } };
	      }, created: function created() {
	        this.tmpVM = new s.a({ data: function data() {
	            return { node: "" };
	          }, render: function render(t) {
	            var e = this.node;return t("div", { ref: "node" }, Array.isArray(e) ? e : [e]);
	          } }).$mount();
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$slots.default && this.$slots.default.length && (t.content = this.tmpVM.$refs.node), this.$amapComponent = new AMap.Marker(t);
	        }, $$getExtData: function $$getExtData() {
	          return this.$amapComponent.getExtData();
	        }, $$getPosition: function $$getPosition() {
	          return Object(o.b)(this.$amapComponent.getPosition());
	        }, $$getOffset: function $$getOffset() {
	          return Object(o.c)(this.$amapComponent.getOffset());
	        } }, render: function render(t) {
	        var e = this.$slots.default || [];return e.length && (this.tmpVM.node = e), null;
	      }, destroyed: function destroyed() {
	        this.tmpVM.$destroy(), this.$customContent && this.$customContent.$destroy && this.$customContent.$destroy();
	      } };
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return a;
	    }), n.d(e, "c", function () {
	      return s;
	    }), n.d(e, "b", function () {
	      return u;
	    });var r = n(19),
	        o = n.n(r),
	        i = _assign2.default || function (t) {
	      for (var e = 1; e < arguments.length; e++) {
	        var n = arguments[e];for (var r in n) {
	          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	        }
	      }return t;
	    },
	        a = function a(t, e) {
	      var n = ["methods", "computed", "data", "filters"],
	          r = {},
	          a = o.a.compile(t);n.forEach(function (t) {
	        r[t] = e.$parent.$parent.$options[t], "data" === t && "function" == typeof r[t] && (r[t] = r[t]());
	      });var s = new o.a(i({}, r, a));return s.$mount(), s;
	    },
	        s = function s(t) {
	      var e = new o.a({ render: function render(e) {
	          return e("div", t);
	        } });return e.$mount(), e;
	    },
	        u = function u(t, e) {
	      var n = new o.a({ render: function render(n) {
	          return t(n, e);
	        } });return n.$mount(), n;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = n(13);e.a = { name: "el-amap-search-box", mixins: [r.a], props: ["searchOption", "onSearchResult", "events", "default"], data: function data() {
	        return { keyword: this.default || "", tips: [], selectedTip: -1, loaded: !1 };
	      }, mounted: function mounted() {
	        var t = this;o.b.load().then(function () {
	          t.loaded = !0, t._onSearchResult = t.onSearchResult, t.events && t.events.init && t.events.init({ autoComplete: t._autoComplete, placeSearch: t._placeSearch });
	        });
	      }, computed: { _autoComplete: function _autoComplete() {
	          if (this.loaded) return new AMap.Autocomplete(this.searchOption || {});
	        }, _placeSearch: function _placeSearch() {
	          if (this.loaded) return new AMap.PlaceSearch(this.searchOption || {});
	        } }, methods: { autoComplete: function autoComplete() {
	          var t = this;this.keyword && this._autoComplete && this._autoComplete.search(this.keyword, function (e, n) {
	            "complete" === e && (t.tips = n.tips);
	          });
	        }, search: function search() {
	          var t = this;this.tips = [], this._placeSearch && this._placeSearch.search(this.keyword, function (e, n) {
	            if (n && n.poiList && n.poiList.count) {
	              var r = n.poiList.pois,
	                  o = r.map(function (t) {
	                return t.lat = t.location.lat, t.lng = t.location.lng, t;
	              });t._onSearchResult(o);
	            } else if (void 0 === n.poiList) throw new Error(n);
	          });
	        }, changeTip: function changeTip(t) {
	          this.keyword = t.name, this.search();
	        }, selectTip: function selectTip(t) {
	          "up" === t && this.selectedTip > 0 ? (this.selectedTip -= 1, this.keyword = this.tips[this.selectedTip].name) : "down" === t && this.selectedTip + 1 < this.tips.length && (this.selectedTip += 1, this.keyword = this.tips[this.selectedTip].name);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = n(6),
	        i = n(26);e.a = { name: "el-amap-circle", mixins: [r.a, i.a], props: ["vid", "zIndex", "center", "bubble", "radius", "strokeColor", "strokeOpacity", "strokeWeight", "editable", "fillColor", "fillOpacity", "strokeStyle", "extData", "strokeDasharray", "events", "visible", "extData", "onceEvents"], data: function data() {
	        return { converters: { center: function center(t) {
	              return Object(o.d)(t);
	            } }, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            }, editable: function editable(t) {
	              !0 === t ? this.editor.open() : this.editor.close();
	            } } };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.Circle(t), this.$amapComponent.editor = new AMap.CircleEditor(this.$amap, this.$amapComponent);
	        }, $$getCenter: function $$getCenter() {
	          return Object(o.b)(this.$amapComponent.getCenter());
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0);e.a = { name: "el-amap-ground-image", mixins: [r.a], props: ["vid", "clickable", "opacity", "url", "bounds", "visible", "events", "onceEvents"], destroyed: function destroyed() {
	        this.$amapComponent.setMap(null);
	      }, data: function data() {
	        return { converters: {}, handlers: { visible: function visible(t) {
	              !1 === t ? this.setMap(null) : this.setMap(this.$amap);
	            } } };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.ImageLayer(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(6),
	        o = n(0),
	        i = n(52),
	        a = n(19),
	        s = n.n(a);e.a = { name: "el-amap-info-window", mixins: [o.a], props: ["vid", "isCustom", "autoMove", "closeWhenClickMap", "content", "size", "offset", "position", "showShadow", "visible", "events", "template", "vnode", "contentRender"], data: function data() {
	        var t = this;return { withSlots: !1, tmpVM: null, propsRedirect: { template: "content", vnode: "content", contentRender: "content" }, converters: { template: function template(e) {
	              var n = Object(i.a)(e, t);return this.$customContent = n, n.$el;
	            }, vnode: function vnode(e) {
	              var n = "function" == typeof e ? e(t) : e,
	                  r = Object(i.c)(n);return this.$customContent = r, r.$el;
	            }, contentRender: function contentRender(e) {
	              var n = Object(i.b)(e, t);return this.$customContent = n, n.$el;
	            } }, handlers: { visible: function visible(e) {
	              var n = this.getPosition();n && (!1 === e ? this.close() : this.open(t.$amap, [n.lng, n.lat]));
	            }, template: function template(t) {
	              this.setContent(t);
	            } } };
	      }, created: function created() {
	        this.tmpVM = new s.a({ data: function data() {
	            return { node: "" };
	          }, render: function render(t) {
	            var e = this.node;return t("div", { ref: "node" }, Array.isArray(e) ? e : [e]);
	          } }).$mount();
	      }, destroyed: function destroyed() {
	        this.$amapComponent.close(), this.tmpVM.$destroy(), this.$customContent && this.$customContent.$destroy && this.$customContent.$destroy();
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$slots.default && this.$slots.default.length && (t.content = this.tmpVM.$refs.node), delete t.map, this.$amapComponent = new AMap.InfoWindow(t), !1 !== this.visible && this.$amapComponent.open(this.$amap, Object(r.d)(this.position));
	        } }, render: function render(t) {
	        var e = this.$slots.default || [];return e.length && (this.tmpVM.node = e), null;
	      } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = n(26),
	        i = n(6);e.a = { name: "el-amap-polyline", mixins: [r.a, o.a], props: ["vid", "zIndex", "visible", "editable", "bubble", "geodesic", "isOutline", "outlineColor", "path", "strokeColor", "strokeOpacity", "strokeWeight", "strokeStyle", "strokeDasharray", "events", "extData", "onceEvents", "lineJoin"], data: function data() {
	        return { converters: {}, handlers: { visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            }, editable: function editable(t) {
	              !0 === t ? this.editor.open() : this.editor.close();
	            } } };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.Polyline(t), this.$amapComponent.editor = new AMap.PolyEditor(this.$amap, this.$amapComponent);
	        }, $$getPath: function $$getPath() {
	          return this.$amapComponent.getPath().map(i.b);
	        }, $$getBounds: function $$getBounds() {
	          return this.$amapComponent.getBounds();
	        }, $$getExtData: function $$getExtData() {
	          return this.$amapComponent.getExtData();
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = n(26),
	        i = n(6);e.a = { name: "el-amap-polygon", mixins: [r.a, o.a], props: ["vid", "zIndex", "path", "bubble", "strokeColor", "strokeOpacity", "strokeWeight", "fillColor", "editable", "fillOpacity", "extData", "strokeStyle", "visible", "strokeDasharray", "events", "onceEvents", "draggable"], data: function data() {
	        return { converters: {}, handlers: { visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            }, zIndex: function zIndex(t) {
	              this.setOptions({ zIndex: t });
	            }, editable: function editable(t) {
	              !0 === t ? this.editor.open() : this.editor.close();
	            } } };
	      }, methods: { __initComponent: function __initComponent() {
	          var t = this.convertProps();this.$amapComponent = new AMap.Polygon(t), this.$amapComponent.editor = new AMap.PolyEditor(this.$amap, this.$amapComponent);
	        }, $$getPath: function $$getPath() {
	          return this.$amapComponent.getPath().map(i.b);
	        }, $$getExtData: function $$getExtData() {
	          return this.$amapComponent.getExtData();
	        }, $$contains: function $$contains(t) {
	          return Array.isArray(t) && (t = new AMap.LngLat(t[0], t[1])), this.$amapComponent.getBounds().contains(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = "el-amap-text";e.a = { name: o, mixins: [r.a], props: { vid: { type: String, default: "" }, text: { type: String, default: "" }, textAlign: { type: String, default: "" }, verticalAlign: { type: String, default: "" }, position: { type: Array, default: function _default() {
	            return [0, 0];
	          }, $type: "LngLat" }, offset: { type: Array, default: function _default() {
	            return [0, 0];
	          }, $type: "Pixel" }, topWhenClick: { type: Boolean, default: function _default() {
	            return !1;
	          } }, bubble: { type: Boolean, default: function _default() {
	            return !1;
	          } }, draggable: { type: Boolean, default: function _default() {
	            return !1;
	          } }, raiseOnDrag: { type: Boolean, default: function _default() {
	            return !1;
	          } }, cursor: { type: String, default: function _default() {
	            return "";
	          } }, visible: { type: Boolean, default: function _default() {
	            return !0;
	          } }, zIndex: { type: Number, default: function _default() {
	            return 100;
	          } }, angle: { type: Number, default: function _default() {
	            return 0;
	          } }, autoRotation: { type: Boolean, default: function _default() {
	            return !1;
	          } }, animation: { type: String, default: function _default() {
	            return "“AMAP_ANIMATION_NONE”";
	          } }, shadow: { type: Object, default: function _default() {
	            return {};
	          }, $type: "Icon" }, title: { type: String, default: function _default() {
	            return "";
	          } }, clickable: { type: Boolean, default: !0 }, events: { type: Object, default: function _default() {
	            return {};
	          } } }, data: function data() {
	        return { converters: {}, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } }, amapTagName: o };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.Text(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = "el-amap-bezier-curve";e.a = { name: o, mixins: [r.a], props: { vid: { type: String }, path: { type: Array }, strokeColor: { type: String }, strokeOpacity: { type: Number }, strokeWeight: { type: Number, default: function _default() {
	            return 1;
	          } }, strokeStyle: { type: String }, strokeDasharray: { type: Array }, zIndex: { type: Number }, showDir: { type: Boolean }, bubble: { type: Boolean }, cursor: { type: String }, outlineColor: { type: Boolean }, isOutline: { type: Boolean }, visible: { type: Boolean, default: !0 }, events: { type: Object, default: function _default() {
	            return {};
	          } } }, data: function data() {
	        return { converters: {}, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } }, amapTagName: o };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.BezierCurve(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = "el-amap-circle-marker";e.a = { name: o, mixins: [r.a], props: { vid: { type: String }, zIndex: { type: Number }, visible: { type: Boolean, default: !0 }, center: { type: Array, $type: "LngLat" }, bubble: { type: Boolean }, radius: { type: Number }, strokeColor: { type: String }, strokeOpacity: { type: Number }, strokeWeight: { type: Number }, fillColor: { type: String }, fillOpacity: { type: Number }, extData: { type: Object }, events: { type: Object, default: function _default() {
	            return {};
	          } } }, data: function data() {
	        return { converters: {}, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } }, amapTagName: o };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.CircleMarker(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = "el-amap-ellipse";e.a = { name: o, mixins: [r.a], props: { vid: { type: String }, zIndex: { type: Number }, center: { type: Array, $type: "LngLat" }, radius: { type: Array, default: function _default() {
	            return [1e3, 1e3];
	          } }, bubble: { type: Boolean }, cursor: { type: String }, strokeColor: { type: String }, strokeOpacity: { type: Number }, strokeWeight: { type: Number }, fillColor: { type: String }, fillOpacity: { type: Number }, strokeStyle: { type: String }, extData: { type: Object, default: function _default() {
	            return {};
	          } }, visible: { type: Boolean, default: !0 }, events: { type: Object, default: function _default() {
	            return {};
	          } } }, data: function data() {
	        return { converters: {}, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } }, amapTagName: o };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.Ellipse(t);
	        } } };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = "el-amap-rectangle";e.a = { name: o, mixins: [r.a], props: { vid: { type: String }, zIndex: { type: Number }, center: { type: Array, $type: "LngLat" }, bounds: { type: Array, $type: "Bounds" }, bubble: { type: Boolean }, cursor: { type: String }, strokeColor: { type: String }, strokeOpacity: { type: Number }, strokeWeight: { type: Number }, fillColor: { type: String }, fillOpacity: { type: Number }, strokeStyle: { type: String }, extData: { type: Object, default: function _default() {
	            return {};
	          } }, visible: { type: Boolean, default: !0 }, events: { type: Object, default: function _default() {
	            return {};
	          } } }, data: function data() {
	        return { converters: {}, handlers: { zIndex: function zIndex(t) {
	              this.setzIndex(t);
	            }, visible: function visible(t) {
	              !1 === t ? this.hide() : this.show();
	            } }, amapTagName: o };
	      }, methods: { __initComponent: function __initComponent(t) {
	          this.$amapComponent = new AMap.Rectangle(t);
	        } } };
	  }, function (t, e, n) {
	    t.exports = n(27);
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(66);n.n(r);
	  }, function (t, e, n) {
	    n(67), n(68), n(81), n(84), t.exports = n(16).Map;
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(28),
	        o = {};o[n(2)("toStringTag")] = "z", o + "" != "[object z]" && n(7)(Object.prototype, "toString", function () {
	      return "[object " + r(this) + "]";
	    }, !0);
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(69)(!0);n(23)(String, "String", function (t) {
	      this._t = String(t), this._i = 0;
	    }, function () {
	      var t,
	          e = this._t,
	          n = this._i;return n >= e.length ? { value: void 0, done: !0 } : (t = r(e, n), this._i += t.length, { value: t, done: !1 });
	    });
	  }, function (t, e, n) {
	    var r = n(21),
	        o = n(22);t.exports = function (t) {
	      return function (e, n) {
	        var i,
	            a,
	            s = String(o(e)),
	            u = r(n),
	            c = s.length;return u < 0 || u >= c ? t ? "" : void 0 : (i = s.charCodeAt(u), i < 55296 || i > 56319 || u + 1 === c || (a = s.charCodeAt(u + 1)) < 56320 || a > 57343 ? t ? s.charAt(u) : i : t ? s.slice(u, u + 2) : a - 56320 + (i - 55296 << 10) + 65536);
	      };
	    };
	  }, function (t, e) {
	    t.exports = !1;
	  }, function (t, e) {
	    t.exports = function (t) {
	      if ("function" != typeof t) throw TypeError(t + " is not a function!");return t;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(35),
	        o = n(20),
	        i = n(25),
	        a = {};n(8)(a, n(2)("iterator"), function () {
	      return this;
	    }), t.exports = function (t, e, n) {
	      t.prototype = r(a, { next: o(1, n) }), i(t, e + " Iterator");
	    };
	  }, function (t, e, n) {
	    var r = n(9),
	        o = n(10),
	        i = n(36);t.exports = n(5) ? _defineProperties2.default : function (t, e) {
	      o(t);for (var n, a = i(e), s = a.length, u = 0; s > u;) {
	        r.f(t, n = a[u++], e[n]);
	      }return t;
	    };
	  }, function (t, e, n) {
	    var r = n(11),
	        o = n(18),
	        i = n(76)(!1),
	        a = n(24)("IE_PROTO");t.exports = function (t, e) {
	      var n,
	          s = o(t),
	          u = 0,
	          c = [];for (n in s) {
	        n != a && r(s, n) && c.push(n);
	      }for (; e.length > u;) {
	        r(s, n = e[u++]) && (~i(c, n) || c.push(n));
	      }return c;
	    };
	  }, function (t, e, n) {
	    var r = n(29);t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
	      return "String" == r(t) ? t.split("") : Object(t);
	    };
	  }, function (t, e, n) {
	    var r = n(18),
	        o = n(37),
	        i = n(77);t.exports = function (t) {
	      return function (e, n, a) {
	        var s,
	            u = r(e),
	            c = o(u.length),
	            p = i(a, c);if (t && n != n) {
	          for (; c > p;) {
	            if ((s = u[p++]) != s) return !0;
	          }
	        } else for (; c > p; p++) {
	          if ((t || p in u) && u[p] === n) return t || p || 0;
	        }return !t && -1;
	      };
	    };
	  }, function (t, e, n) {
	    var r = n(21),
	        o = Math.max,
	        i = Math.min;t.exports = function (t, e) {
	      return t = r(t), t < 0 ? o(t + e, 0) : i(t, e);
	    };
	  }, function (t, e, n) {
	    var r = n(3).document;t.exports = r && r.documentElement;
	  }, function (t, e, n) {
	    var r = n(11),
	        o = n(80),
	        i = n(24)("IE_PROTO"),
	        a = Object.prototype;t.exports = _getPrototypeOf2.default || function (t) {
	      return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
	    };
	  }, function (t, e, n) {
	    var r = n(22);t.exports = function (t) {
	      return Object(r(t));
	    };
	  }, function (t, e, n) {
	    for (var r = n(82), o = n(36), i = n(7), a = n(3), s = n(8), u = n(12), c = n(2), p = c("iterator"), f = c("toStringTag"), l = u.Array, d = { CSSRuleList: !0, CSSStyleDeclaration: !1, CSSValueList: !1, ClientRectList: !1, DOMRectList: !1, DOMStringList: !1, DOMTokenList: !0, DataTransferItemList: !1, FileList: !1, HTMLAllCollection: !1, HTMLCollection: !1, HTMLFormElement: !1, HTMLSelectElement: !1, MediaList: !0, MimeTypeArray: !1, NamedNodeMap: !1, NodeList: !0, PaintRequestList: !1, Plugin: !1, PluginArray: !1, SVGLengthList: !1, SVGNumberList: !1, SVGPathSegList: !1, SVGPointList: !1, SVGStringList: !1, SVGTransformList: !1, SourceBufferList: !1, StyleSheetList: !0, TextTrackCueList: !1, TextTrackList: !1, TouchList: !1 }, h = o(d), v = 0; v < h.length; v++) {
	      var m,
	          y = h[v],
	          g = d[y],
	          b = a[y],
	          _ = b && b.prototype;if (_ && (_[p] || s(_, p, l), _[f] || s(_, f, y), u[y] = l, g)) for (m in r) {
	        _[m] || i(_, m, r[m], !0);
	      }
	    }
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(83),
	        o = n(39),
	        i = n(12),
	        a = n(18);t.exports = n(23)(Array, "Array", function (t, e) {
	      this._t = a(t), this._i = 0, this._k = e;
	    }, function () {
	      var t = this._t,
	          e = this._k,
	          n = this._i++;return !t || n >= t.length ? (this._t = void 0, o(1)) : "keys" == e ? o(0, n) : "values" == e ? o(0, t[n]) : o(0, [n, t[n]]);
	    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
	  }, function (t, e, n) {
	    var r = n(2)("unscopables"),
	        o = Array.prototype;void 0 == o[r] && n(8)(o, r, {}), t.exports = function (t) {
	      o[r][t] = !0;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(85),
	        o = n(44);t.exports = n(90)("Map", function (t) {
	      return function () {
	        return t(this, arguments.length > 0 ? arguments[0] : void 0);
	      };
	    }, { get: function get(t) {
	        var e = r.getEntry(o(this, "Map"), t);return e && e.v;
	      }, set: function set(t, e) {
	        return r.def(o(this, "Map"), 0 === t ? 0 : t, e);
	      } }, r, !0);
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(9).f,
	        o = n(35),
	        i = n(40),
	        a = n(17),
	        s = n(41),
	        u = n(42),
	        c = n(23),
	        p = n(39),
	        f = n(89),
	        l = n(5),
	        d = n(43).fastKey,
	        h = n(44),
	        v = l ? "_s" : "size",
	        m = function m(t, e) {
	      var n,
	          r = d(e);if ("F" !== r) return t._i[r];for (n = t._f; n; n = n.n) {
	        if (n.k == e) return n;
	      }
	    };t.exports = { getConstructor: function getConstructor(t, e, n, c) {
	        var p = t(function (t, r) {
	          s(t, p, e, "_i"), t._t = e, t._i = o(null), t._f = void 0, t._l = void 0, t[v] = 0, void 0 != r && u(r, n, t[c], t);
	        });return i(p.prototype, { clear: function clear() {
	            for (var t = h(this, e), n = t._i, r = t._f; r; r = r.n) {
	              r.r = !0, r.p && (r.p = r.p.n = void 0), delete n[r.i];
	            }t._f = t._l = void 0, t[v] = 0;
	          }, delete: function _delete(t) {
	            var n = h(this, e),
	                r = m(n, t);if (r) {
	              var o = r.n,
	                  i = r.p;delete n._i[r.i], r.r = !0, i && (i.n = o), o && (o.p = i), n._f == r && (n._f = o), n._l == r && (n._l = i), n[v]--;
	            }return !!r;
	          }, forEach: function forEach(t) {
	            h(this, e);for (var n, r = a(t, arguments.length > 1 ? arguments[1] : void 0, 3); n = n ? n.n : this._f;) {
	              for (r(n.v, n.k, this); n && n.r;) {
	                n = n.p;
	              }
	            }
	          }, has: function has(t) {
	            return !!m(h(this, e), t);
	          } }), l && r(p.prototype, "size", { get: function get() {
	            return h(this, e)[v];
	          } }), p;
	      }, def: function def(t, e, n) {
	        var r,
	            o,
	            i = m(t, e);return i ? i.v = n : (t._l = i = { i: o = d(e, !0), k: e, v: n, p: r = t._l, n: void 0, r: !1 }, t._f || (t._f = i), r && (r.n = i), t[v]++, "F" !== o && (t._i[o] = i)), t;
	      }, getEntry: m, setStrong: function setStrong(t, e, n) {
	        c(t, e, function (t, n) {
	          this._t = h(t, e), this._k = n, this._l = void 0;
	        }, function () {
	          for (var t = this, e = t._k, n = t._l; n && n.r;) {
	            n = n.p;
	          }return t._t && (t._l = n = n ? n.n : t._t._f) ? "keys" == e ? p(0, n.k) : "values" == e ? p(0, n.v) : p(0, [n.k, n.v]) : (t._t = void 0, p(1));
	        }, n ? "entries" : "values", !n, !0), f(e);
	      } };
	  }, function (t, e, n) {
	    var r = n(10);t.exports = function (t, e, n, o) {
	      try {
	        return o ? e(r(n)[0], n[1]) : e(n);
	      } catch (e) {
	        var i = t.return;throw void 0 !== i && r(i.call(t)), e;
	      }
	    };
	  }, function (t, e, n) {
	    var r = n(12),
	        o = n(2)("iterator"),
	        i = Array.prototype;t.exports = function (t) {
	      return void 0 !== t && (r.Array === t || i[o] === t);
	    };
	  }, function (t, e, n) {
	    var r = n(28),
	        o = n(2)("iterator"),
	        i = n(12);t.exports = n(16).getIteratorMethod = function (t) {
	      if (void 0 != t) return t[o] || t["@@iterator"] || i[r(t)];
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(3),
	        o = n(9),
	        i = n(5),
	        a = n(2)("species");t.exports = function (t) {
	      var e = r[t];i && e && !e[a] && o.f(e, a, { configurable: !0, get: function get() {
	          return this;
	        } });
	    };
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(3),
	        o = n(34),
	        i = n(7),
	        a = n(40),
	        s = n(43),
	        u = n(42),
	        c = n(41),
	        p = n(4),
	        f = n(15),
	        l = n(91),
	        d = n(25),
	        h = n(92);t.exports = function (t, e, n, v, m, y) {
	      var g = r[t],
	          b = g,
	          _ = m ? "set" : "add",
	          x = b && b.prototype,
	          C = {},
	          w = function w(t) {
	        var e = x[t];i(x, t, "delete" == t ? function (t) {
	          return !(y && !p(t)) && e.call(this, 0 === t ? 0 : t);
	        } : "has" == t ? function (t) {
	          return !(y && !p(t)) && e.call(this, 0 === t ? 0 : t);
	        } : "get" == t ? function (t) {
	          return y && !p(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
	        } : "add" == t ? function (t) {
	          return e.call(this, 0 === t ? 0 : t), this;
	        } : function (t, n) {
	          return e.call(this, 0 === t ? 0 : t, n), this;
	        });
	      };if ("function" == typeof b && (y || x.forEach && !f(function () {
	        new b().entries().next();
	      }))) {
	        var $ = new b(),
	            M = $[_](y ? {} : -0, 1) != $,
	            E = f(function () {
	          $.has(1);
	        }),
	            A = l(function (t) {
	          new b(t);
	        }),
	            S = !y && f(function () {
	          for (var t = new b(), e = 5; e--;) {
	            t[_](e, e);
	          }return !t.has(-0);
	        });A || (b = e(function (e, n) {
	          c(e, b, t);var r = h(new g(), e, b);return void 0 != n && u(n, m, r[_], r), r;
	        }), b.prototype = x, x.constructor = b), (E || S) && (w("delete"), w("has"), m && w("get")), (S || M) && w(_), y && x.clear && delete x.clear;
	      } else b = v.getConstructor(e, t, m, _), a(b.prototype, n), s.NEED = !0;return d(b, t), C[t] = b, o(o.G + o.W + o.F * (b != g), C), y || v.setStrong(b, t, m), b;
	    };
	  }, function (t, e, n) {
	    var r = n(2)("iterator"),
	        o = !1;try {
	      var i = [7][r]();i.return = function () {
	        o = !0;
	      }, (0, _from2.default)(i, function () {
	        throw 2;
	      });
	    } catch (t) {}t.exports = function (t, e) {
	      if (!e && !o) return !1;var n = !1;try {
	        var i = [7],
	            a = i[r]();a.next = function () {
	          return { done: n = !0 };
	        }, i[r] = function () {
	          return a;
	        }, t(i);
	      } catch (t) {}return n;
	    };
	  }, function (t, e, n) {
	    var r = n(4),
	        o = n(93).set;t.exports = function (t, e, n) {
	      var i,
	          a = e.constructor;return a !== n && "function" == typeof a && (i = a.prototype) !== n.prototype && r(i) && o && o(t, i), t;
	    };
	  }, function (t, e, n) {
	    var r = n(4),
	        o = n(10),
	        i = function i(t, e) {
	      if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
	    };t.exports = { set: _setPrototypeOf2.default || ("__proto__" in {} ? function (t, e, r) {
	        try {
	          r = n(17)(Function.call, n(94).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
	        } catch (t) {
	          e = !0;
	        }return function (t, n) {
	          return i(t, n), e ? t.__proto__ = n : r(t, n), t;
	        };
	      }({}, !1) : void 0), check: i };
	  }, function (t, e, n) {
	    var r = n(95),
	        o = n(20),
	        i = n(18),
	        a = n(33),
	        s = n(11),
	        u = n(31),
	        c = _getOwnPropertyDescriptor2.default;e.f = n(5) ? c : function (t, e) {
	      if (t = i(t), e = a(e, !0), u) try {
	        return c(t, e);
	      } catch (t) {}if (s(t, e)) return o(!r.f.call(t, e), t[e]);
	    };
	  }, function (t, e) {
	    e.f = {}.propertyIsEnumerable;
	  }, function (t, e, n) {
	    "use strict";
	    t.exports = function () {
	      var t = [].map.call(arguments, function (t) {
	        return t.trim();
	      }).filter(function (t) {
	        return t.length;
	      }).join("-");return t.length ? 1 !== t.length && /[_.\- ]+/.test(t) ? t.replace(/^[_.\- ]+/, "").toLowerCase().replace(/[_.\- ]+(\w|$)/g, function (t, e) {
	        return e.toUpperCase();
	      }) : t[0] === t[0].toLowerCase() && t.slice(1) !== t.slice(1).toLowerCase() ? t : t.toLowerCase() : "";
	    };
	  }, function (t, e, n) {
	    "use strict";
	    function r(t, e) {
	      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	    }var o = n(98),
	        i = _assign2.default || function (t) {
	      for (var e = 1; e < arguments.length; e++) {
	        var n = arguments[e];for (var r in n) {
	          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	        }
	      }return t;
	    },
	        a = { key: null, v: "1.4.4", protocol: "https", hostAndPath: "webapi.amap.com/maps", plugin: [], callback: "amapInitComponent" },
	        s = function () {
	      function t(e) {
	        r(this, t), this._config = i({}, a, e), this._document = document, this._window = window, this._scriptLoaded = !1, this._queueEvents = [o.a];
	      }return t.prototype.load = function () {
	        var t = this;if (this._window.AMap && this._window.AMap.Map) return this.loadUIAMap();if (this._scriptLoadingPromise) return this._scriptLoadingPromise;var e = this._document.createElement("script");e.type = "text/javascript", e.async = !0, e.defer = !0, e.src = this._getScriptSrc();var n = this._config.uiVersion ? this.loadUIAMap() : null;return this._scriptLoadingPromise = new _promise2.default(function (r, o) {
	          t._window.amapInitComponent = function () {
	            for (; t._queueEvents.length;) {
	              t._queueEvents.pop().apply();
	            }if (!n) return r();n.then(function () {
	              window.initAMapUI(), setTimeout(r);
	            });
	          }, e.onerror = function (t) {
	            return o(t);
	          };
	        }), this._document.head.appendChild(e), this._scriptLoadingPromise;
	      }, t.prototype.loadUIAMap = function () {
	        var t = this;return !this._config.uiVersion || window.AMapUI ? _promise2.default.resolve() : new _promise2.default(function (e, n) {
	          var r = document.createElement("script"),
	              o = t._config.uiVersion.split("."),
	              i = o[0],
	              a = o[1],
	              s = o[2];if (void 0 === i || void 0 === a) return void console.error("amap ui version is not correct, please check! version: ", t._config.uiVersion);var u = t._config.protocol + "://webapi.amap.com/ui/" + i + "." + a + "/main-async.js";s && (u += "?v=" + i + "." + a + "." + s), r.src = u, r.type = "text/javascript", r.async = !0, t._document.head.appendChild(r), r.onload = function () {
	            setTimeout(e, 0);
	          }, r.onerror = function () {
	            return n();
	          };
	        });
	      }, t.prototype._getScriptSrc = function () {
	        var t = /^AMap./,
	            e = this._config,
	            n = ["v", "key", "plugin", "callback"];if (e.plugin && e.plugin.length > 0) {
	          e.plugin.push("Autocomplete", "PlaceSearch", "PolyEditor", "CircleEditor");var r = [];e.plugin.forEach(function (e) {
	            var n = t.test(e) ? e : "AMap." + e,
	                o = n.replace(t, "");r.push(n, o);
	          }), e.plugin = r;
	        }var o = (0, _keys2.default)(e).filter(function (t) {
	          return ~n.indexOf(t);
	        }).filter(function (t) {
	          return null != e[t];
	        }).filter(function (t) {
	          return !Array.isArray(e[t]) || Array.isArray(e[t]) && e[t].length > 0;
	        }).map(function (t) {
	          var n = e[t];return Array.isArray(n) ? { key: t, value: n.join(",") } : { key: t, value: n };
	        }).map(function (t) {
	          return t.key + "=" + t.value;
	        }).join("&");return this._config.protocol + "://" + this._config.hostAndPath + "?" + o;
	      }, t;
	    }();e.a = s;
	  }, function (t, e, n) {
	    "use strict";
	    function r() {
	      if (AMap.UA.ios && "https:" !== document.location.protocol) {
	        var t = new o.a();navigator.geolocation.getCurrentPosition = function () {
	          return t.getCurrentPosition.apply(t, arguments);
	        }, navigator.geolocation.watchPosition = function () {
	          return t.watchPosition.apply(t, arguments);
	        };
	      }
	    }e.a = r;var o = n(99);
	  }, function (t, e, n) {
	    "use strict";
	    function r() {
	      this._remoteSvrUrl = "https://webapi.amap.com/html/geolocate.html", this._callbackList = [], this._seqBase = 1, this._frameReady = 0, this._watchIdMap = {};
	    }r.prototype = { _getSeq: function _getSeq() {
	        return this._seqBase++;
	      }, _onRrameReady: function _onRrameReady(t) {
	        if (0 === this._frameReady) return this._frameReadyList || (this._frameReadyList = []), this._frameReadyList.push(t), void this._prepareIframe();t.call(this);
	      }, _prepareIframe: function _prepareIframe() {
	        if (!this._iframeWin) {
	          var t = document.createElement("iframe");t.src = this._remoteSvrUrl + (this._remoteSvrUrl.indexOf("?") > 0 ? "&" : "?"), t.width = "0px", t.height = "0px", t.style.position = "absolute", t.style.display = "none", t.allow = "geolocation";var e = this,
	              n = setTimeout(function () {
	            e._frameReady = !1, e._callbackFrameReadyList();
	          }, 5e3);t.onload = function () {
	            clearTimeout(n), e._frameReady = !0, e._callbackFrameReadyList(), t.onload = null;
	          }, document.body.appendChild(t), this._iframeWin = t.contentWindow, window.addEventListener("message", function (t) {
	            0 === e._remoteSvrUrl.indexOf(t.origin) && e._handleRemoteMsg(t.data);
	          }, !1);
	        }
	      }, _callbackFrameReadyList: function _callbackFrameReadyList() {
	        if (this._frameReadyList) {
	          var t = this._frameReadyList;this._frameReadyList = null;for (var e = 0, n = t.length; e < n; e++) {
	            t[e].call(this, this._frameReady);
	          }
	        }
	      }, _pickCallback: function _pickCallback(t, e) {
	        for (var n = this._callbackList, r = 0, o = n.length; r < o; r++) {
	          var i = n[r];if (t === i.seq) return e || n.splice(r, 1), i;
	        }
	      }, _handleRemoteMsg: function _handleRemoteMsg(t) {
	        var e = t.seq,
	            n = this._pickCallback(e, !!t.notify);n ? n.cbk.call(null, t.error, t.result) : console.warn("Receive remote msg: ", t);
	      }, _postMessage: function _postMessage(t, e, n, r) {
	        this._prepareIframe();var o = { cmd: t, args: e, seq: r || this._getSeq() };this._callbackList.push({ cbk: n, seq: o.seq }), this._onRrameReady(function () {
	          if (!0 === this._frameReady) try {
	            this._iframeWin.postMessage(o, "*");
	          } catch (t) {
	            this._pickCallback(o.seq), n(t);
	          } else this._pickCallback(o.seq), n({ message: "iFrame load failed!" });
	        });
	      }, getCurrentPosition: function getCurrentPosition(t, e, n) {
	        this._postMessage("getCurrentPosition", [n], function (n, r) {
	          if (n) return void (e && e(n));t && t(r);
	        });
	      }, watchPosition: function watchPosition(t, e, n) {
	        var r = "wk" + this._getSeq(),
	            o = this._getSeq();this._watchIdMap[r] = { stat: 0, seq: o };var i = this;return this._postMessage("watchPosition", [n], function (n, o) {
	          var a = null;o && (a = o.id);var s = i._watchIdMap[r];if (s.id = a, s.stat = 1, s.callbackList) {
	            var u = s.callbackList;s.callbackList = null;for (var c = 0, p = u.length; c < p; c++) {
	              u[c].call(i, a);
	            }
	          }if (n) return void (e && e(n));t && t(o.pos);
	        }, o), r;
	      }, clearWatch: function clearWatch(t, e) {
	        function n(n) {
	          o._postMessage("clearWatch", [n], function (n, i) {
	            n || (o._pickCallback(r.seq), delete o._watchIdMap[t]), e && e(n, i);
	          });
	        }if (!this._watchIdMap[t]) return void e("Id not exists: " + t);var r = this._watchIdMap[t],
	            o = this;r.stat < 1 ? (r.callbackList || (r.callbackList = []), r.callbackList.push(function (t) {
	          n(t);
	        })) : n(r.id);
	      } }, e.a = r;
	  }, function (t, e, n) {
	    "use strict";
	    function r(t) {
	      n(101);
	    }var o = n(48),
	        i = n(105),
	        a = n(1),
	        s = r,
	        u = Object(a.a)(o.a, i.a, i.b, !1, s, null, null);e.a = u.exports;
	  }, function (t, e, n) {
	    var r = n(102);"string" == typeof r && (r = [[t.i, r, ""]]), r.locals && (t.exports = r.locals);n(47)("d6014b94", r, !0);
	  }, function (t, e, n) {
	    e = t.exports = n(46)(!1), e.push([t.i, ".el-vue-amap-container,.el-vue-amap-container .el-vue-amap{height:100%}", ""]);
	  }, function (t, e) {
	    t.exports = function (t, e) {
	      for (var n = [], r = {}, o = 0; o < e.length; o++) {
	        var i = e[o],
	            a = i[0],
	            s = i[1],
	            u = i[2],
	            c = i[3],
	            p = { id: t + ":" + o, css: s, media: u, sourceMap: c };r[a] ? r[a].parts.push(p) : n.push(r[a] = { id: a, parts: [p] });
	      }return n;
	    };
	  }, function (t, e, n) {
	    "use strict";
	    function r() {
	      for (var t = [], e = "0123456789abcdef", n = 0; n < 36; n++) {
	        t[n] = e.substr(Math.floor(16 * Math.random()), 1);
	      }return t[14] = "4", t[19] = e.substr(3 & t[19] | 8, 1), t[8] = t[13] = t[18] = t[23] = "-", t.join("");
	    }e.a = r;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement,
	          n = t._self._c || e;return n("div", { staticClass: "el-vue-amap-container" }, [n("div", { staticClass: "el-vue-amap" }), t._v(" "), t._t("default")], 2);
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(51),
	        o = n(1),
	        i = Object(o.a)(r.a, void 0, void 0, !1, null, null, null);e.a = i.exports;
	  }, function (t, e, n) {
	    "use strict";
	    function r(t) {
	      n(108);
	    }var o = n(53),
	        i = n(110),
	        a = n(1),
	        s = r,
	        u = Object(a.a)(o.a, i.a, i.b, !1, s, null, null);e.a = u.exports;
	  }, function (t, e, n) {
	    var r = n(109);"string" == typeof r && (r = [[t.i, r, ""]]), r.locals && (t.exports = r.locals);n(47)("80e271aa", r, !0);
	  }, function (t, e, n) {
	    e = t.exports = n(46)(!1), e.push([t.i, ".el-vue-search-box-container{position:relative;width:360px;height:45px;background:#fff;box-shadow:0 2px 2px rgba(0,0,0,.15);border-radius:2px 3px 3px 2px;z-index:10}.el-vue-search-box-container .search-box-wrapper{position:absolute;display:flex;align-items:center;left:0;top:0;width:100%;height:100%;box-sizing:border-box}.el-vue-search-box-container .search-box-wrapper input{flex:1;height:20px;line-height:20px;letter-spacing:.5px;font-size:14px;text-indent:10px;box-sizing:border-box;border:none;outline:none}.el-vue-search-box-container .search-box-wrapper .search-btn{width:45px;height:100%;display:flex;align-items:center;justify-content:center;background:transparent;cursor:pointer}.el-vue-search-box-container .search-tips{position:absolute;top:100%;border:1px solid #dbdbdb;background:#fff;overflow:auto}.el-vue-search-box-container .search-tips ul{padding:0;margin:0}.el-vue-search-box-container .search-tips ul li{height:40px;line-height:40px;box-shadow:0 1px 1px rgba(0,0,0,.1);padding:0 10px;cursor:pointer}.el-vue-search-box-container .search-tips ul li.autocomplete-selected{background:#eee}", ""]);
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement,
	          n = t._self._c || e;return n("div", { staticClass: "el-vue-search-box-container", on: { keydown: [function (e) {
	            if (!("button" in e) && t._k(e.keyCode, "up", 38, e.key, ["Up", "ArrowUp"])) return null;t.selectTip("up");
	          }, function (e) {
	            if (!("button" in e) && t._k(e.keyCode, "down", 40, e.key, ["Down", "ArrowDown"])) return null;t.selectTip("down");
	          }] } }, [n("div", { staticClass: "search-box-wrapper" }, [n("input", { directives: [{ name: "model", rawName: "v-model", value: t.keyword, expression: "keyword" }], attrs: { type: "text" }, domProps: { value: t.keyword }, on: { keyup: function keyup(e) {
	            return "button" in e || !t._k(e.keyCode, "enter", 13, e.key, "Enter") ? t.search(e) : null;
	          }, input: [function (e) {
	            e.target.composing || (t.keyword = e.target.value);
	          }, t.autoComplete] } }), t._v(" "), n("span", { staticClass: "search-btn", on: { click: t.search } }, [t._v("搜索")])]), t._v(" "), n("div", { staticClass: "search-tips" }, [n("ul", t._l(t.tips, function (e, r) {
	        return n("li", { key: r, class: { "autocomplete-selected": r === t.selectedTip }, on: { click: function click(n) {
	              t.changeTip(e);
	            }, mouseover: function mouseover(e) {
	              t.selectedTip = r;
	            } } }, [t._v(t._s(e.name))]);
	      }))])]);
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(54),
	        o = n(112),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(55),
	        o = n(114),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(56),
	        o = n(1),
	        i = Object(o.a)(r.a, void 0, void 0, !1, null, null, null);e.a = i.exports;
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(57),
	        o = n(117),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(58),
	        o = n(119),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(59),
	        o = n(121),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(60),
	        o = n(123),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(61),
	        o = n(125),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(62),
	        o = n(127),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(63),
	        o = n(129),
	        i = n(1),
	        a = Object(i.a)(r.a, o.a, o.b, !1, null, null, null);e.a = a.exports;
	  }, function (t, e, n) {
	    "use strict";
	    n.d(e, "a", function () {
	      return r;
	    }), n.d(e, "b", function () {
	      return o;
	    });var r = function r() {
	      var t = this,
	          e = t.$createElement;return (t._self._c || e)("div");
	    },
	        o = [];
	  }, function (t, e, n) {
	    "use strict";
	    function r(t, e) {
	      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
	    }var o = function () {
	      function t() {
	        r(this, t), this._componentMap = new _map2.default(), this._map = null;
	      }return t.prototype.setMap = function (t) {
	        this._map = t;
	      }, t.prototype.getMap = function () {
	        return this._map;
	      }, t.prototype.setComponent = function (t, e) {
	        this._componentMap.set(t, e);
	      }, t.prototype.getComponent = function (t) {
	        return this._componentMap.get(t);
	      }, t.prototype.getChildInstance = function (t) {
	        return this.getComponent(t);
	      }, t.prototype.removeComponent = function (t) {
	        this._componentMap.delete(t);
	      }, t;
	    }();e.a = o;
	  }, function (t, e, n) {
	    "use strict";
	    var r = n(0),
	        o = _assign2.default || function (t) {
	      for (var e = 1; e < arguments.length; e++) {
	        var n = arguments[e];for (var r in n) {
	          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
	        }
	      }return t;
	    };e.a = function (t) {
	      var e = t.init,
	          n = t.data,
	          i = void 0 === n ? function () {
	        return {};
	      } : n,
	          a = t.converters,
	          s = void 0 === a ? {} : a,
	          u = t.handlers,
	          c = void 0 === u ? {} : u,
	          p = t.computed,
	          f = t.methods,
	          l = t.name,
	          d = t.render,
	          h = t.contextReady,
	          v = t.template,
	          m = t.mixins,
	          y = void 0 === m ? [] : m,
	          g = t.props,
	          b = void 0 === g ? {} : g,
	          _ = o({}, t, { props: b, data: function data() {
	          return o({}, i(), { converters: s, handlers: c });
	        }, mixins: [r.a].concat(y), computed: p, methods: o({}, f, { __initComponent: e, __contextReady: h }) });return v || d || (_.render = function () {
	        return null;
	      }), _.install = function (t) {
	        return t.use(l, _);
	      }, _;
	    };
	  }]);
	});
	//# sourceMappingURL=index.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(587)(module)))

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1558)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(728),
	  /* template */
	  __webpack_require__(2060),
	  /* scopeId */
	  "data-v-86d1c14c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1430)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(799),
	  /* template */
	  __webpack_require__(1937),
	  /* scopeId */
	  "data-v-0d3c2cea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/video.7075dde.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/you.19c892c.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1477)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(737),
	  /* template */
	  __webpack_require__(1983),
	  /* scopeId */
	  "data-v-3b35c554",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1418)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(764),
	  /* template */
	  __webpack_require__(1925),
	  /* scopeId */
	  "data-v-08e4e011",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjZFRkM2QTE0MDEyNTExRUFCNkZGRTdENDYxNEUyMjZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjZFRkM2QTE1MDEyNTExRUFCNkZGRTdENDYxNEUyMjZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NkVGQzZBMTIwMTI1MTFFQUI2RkZFN0Q0NjE0RTIyNkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NkVGQzZBMTMwMTI1MTFFQUI2RkZFN0Q0NjE0RTIyNkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz75bzkcAAABUElEQVR42rSVvy8EQRTHZ+8cokMiTiJBLqGkkejRaU5BqTq/EhGFTvwHipOwjUJFrldJXCXRiYrEiQ7XCYWK83my15ndN5Pdb/KpdvZ9due92Q1Gjh9NQqZgA+ZgGHLwBHU4el4r3cbdHMQIOuEANmPub8Eh7CD6/m9BziaGs4Ti7XVbUBsNG4GLYAnKRh9Zu+4i2DXu2eMt8hpBH0x6CAZhWiPoj/bWJ2MawZfxz49G8AIfnoJ7jUCe4sKjeAPutFNU9ZkiDltLK7iBE4fipxQ/dzkHku2oH0l5gIrtYpwgrxzXDij4CGpQVAhKcMkpLrgIxmHeoQczsOD6NXVN07Z/tsYtwiz0REhPPi3/hCum6DruhzMAQybdvCJtyhuEsGoyCI2vSg9WTHapiKArQ0G3bFFvhoK/KXqHCVhOufYbTQ7bYyqC/ZQF8ukOfwUYAFTMQ9X3w3iwAAAAAElFTkSuQmCC"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAZCAYAAAAv3j5gAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjc1M0Q1QzQ1MDEyNTExRUE4M0E5OEQwNTgyOUE4Q0Q0IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjc1M0Q1QzQ2MDEyNTExRUE4M0E5OEQwNTgyOUE4Q0Q0Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzUzRDVDNDMwMTI1MTFFQTgzQTk4RDA1ODI5QThDRDQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzUzRDVDNDQwMTI1MTFFQTgzQTk4RDA1ODI5QThDRDQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7UBvgUAAAB+UlEQVR42rSWT0hUURSHZwZnrMCZSMVFIEZ/yMkW4UZdKYkmBkJGtChauHBS1FYWbcKNuC0NXY6jkBS50Nq4cBOzCzcxETUQRbR3KoIIx+/AGXg8Zt6cmTce+Lhv7n3n/t5559zzJti2/CVgsCCMwgR0wXH4Dtuw8DVx7ke5DUIGkQhswCvoUxGxVpiEzJmV7GAthJ7CLY/1KGwiFvcj1AHjhoc5AfN+hG5rfiw2TFTRaoUuBuxWBxf85KgSO6hW6FMFIv8hW63QC8gbhd5ynnLVCmVgxSDyBx77PUcP4KXHukRxg2g++hX6p2V+E3b16eV1foNFiCOyYylJi8nGr5WI8lsWEDFtEDKe+oJdgZ/wS5ppoMJDVqpbX4cZOA9tGpW8wka9ZxoeyQUd4SFDPzyDN0SZt0QkzTENW3BVu3Snrq3reRFbdfgMqZD4pBG+VE7oDuxBt2t+RMcP8Fmv32k0DQw9jnvF9z3zd0sJJWAN6otEOeLIV6GfFTaXb1TYdf8xSCF23y0koT/3yOVlzVOPI6+9Og54+C0hNlwohlOibqhAcTjt+C15aIZrZao6iVi7CM1Bk6FCpQpbXHNjcLaMn+z9JMifE2khDcYOEXZ9CPchZvDN1VXQHSJF5mJG33BIK+2oLSXRTMFfuAcnaywgrzYJs4cCDABn+2cCUXQaLQAAAABJRU5ErkJggg=="

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjdDRkZBODIyMDEyNTExRUFBODFGRjc4QUJEODMzQkVEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdDRkZBODIzMDEyNTExRUFBODFGRjc4QUJEODMzQkVEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6N0NGRkE4MjAwMTI1MTFFQUE4MUZGNzhBQkQ4MzNCRUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N0NGRkE4MjEwMTI1MTFFQUE4MUZGNzhBQkQ4MzNCRUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B4z0dAAABF0lEQVR42mJUmH6bAQ3UA3EVELMxYIIWIK4F4mYgrsEi/wuI2+5nqDQiCzKhKQoE4gYcFoAALxqNDkD6GhRn3AnEZYk0EM9hoA6YA7RIGt0SEL0IiIWoZAnInEVAi5iQLSkBYicG6gInqLlgS4ygEUoL0AL0jRELkKEHxMeI1HQGiT5IpB49RixJmCQATK4E1YB8EownSRIEwOAgpOQTyJI1DDQGTAx0AKOWjFBLWND4HUB8E8kBaUBsTk1LfkIro29IYjzUtoQdiK8C8UMonxmITWkRXApQTNM4SQKVeTgSCCgorSi15DcQ7wDi5zjUxlDDElZofHzD4RNeSoLrM5IBIIv4qRwln0AuzIVaRAvwCYizAAIMABvzMuTOyvusAAAAAElFTkSuQmCC"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAYAAAA1vze2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjg1MjZENTc3MDEyNTExRUFCNTYxRjU1NTZGNzg0NTBCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjg1MjZENTc4MDEyNTExRUFCNTYxRjU1NTZGNzg0NTBCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6ODUyNkQ1NzUwMTI1MTFFQUI1NjFGNTU1NkY3ODQ1MEIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6ODUyNkQ1NzYwMTI1MTFFQUI1NjFGNTU1NkY3ODQ1MEIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7K8cAmAAABXklEQVR42uyUPyhFURzHz33h8RYbhYFSRgYZZCJlMrCIIoP8WZSJlLKJVXmJiTJYKKNRmBSjRyZFnpcoEh6fX/1eXadzB917ZfCrT933vfeezzvnnvPzalcyRqsCzqDShK/01Vj9eOFHke/GG1xDaUjBO9z4A09nUgYNJtp6Zjbn/pn0w1rEkpe69EUVooeEBr0m+pLVGZALkZRDh4mnRgqSbiiJSdLIkrWIpMfEW6Mi6YpZ0ieSXMDNo4D88If5nUjmXScWJmQbWvmpfsOMlT/CMGw5xpqWc7IKWRiEJOzCBrxCK0xBNRzDIuShTV6GJrjU/BaG4AQ64Unby77n611SxdAOS/rvZuEAPnTAOWhWwY6caqgB6VOTuirrDJxztRWjDy7rtrZ7UT5gm4sk5chnEC24GmTSIbCfsSsVkH9rsgnzC/Uv+duS+wjHzQZJtmEPPkMKpOdt+oMvAQYA2pxOd+WcgvEAAAAASUVORK5CYII="

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjhGNUM3MjlFMDEyNTExRUFCRDgxODkxN0Y0NEE2MjFBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjhGNUM3MjlGMDEyNTExRUFCRDgxODkxN0Y0NEE2MjFBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6OEY1QzcyOUMwMTI1MTFFQUJEODE4OTE3RjQ0QTYyMUEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6OEY1QzcyOUQwMTI1MTFFQUJEODE4OTE3RjQ0QTYyMUEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7yzPWhAAACHUlEQVR42rSWP2gTURjAr2cVqtaAdSxGRTu4pBS6pBW0ouIfChYipZuD0C7SLXSxZCwqdLJODk5SawZFskgQilNQOQousUglbhkaSywqof6+8kUex13epZd+8OOR3OX75b33ve+u69RS2WkRvTAB12EYknAA/sJ3+ARvYeXb9Nl6WJKuEEkPZGEWEo49fsJjeITsl/+iG/CDFHgwH1EgcQxy8Pn006+DNskYfIBzzt5iAFYRjYVJZAav4YgTL47CK0Qn/BLZg5cdEEj8hnvsTdUvycZYIjM24QqCFfnAbLqbkl6torhRgVEEqyo4z/CR8XC3noNETMEa3EBQUUGa4Q0cl/yuHjRbVPXwBcV7uGAIbjK8U4HELVdPsk0gJTkC675ry3ANQU0Fd7VCe4x7hlxtFTbBmq75RUO0CJMI/qhgjuFZwNlLSlvZCRH8gEvg7zv9cFUT7rYmFd4P+6dibQR8Lw3wsiEYh2mjipqCQ/CilUDyi2Qj4MJBeKAd97Z0WViCGV+/kg58x7KnG1LCJTgTcHEKTkLaWOcn2hWeQ0E2NUJllly9OSxGAzbyIXyJKJAoSII81No8fH0R75O8eZFsaXXsRyxS4lvNpVgIKNW4Uda8/9d7GzJQ75BA8mSYxbb/oeXpeah3QDCOwAt7/Ba1R5VjLNEIgqLtRcLTR3Gujaqr6f0pcwa2VyLbe1dDO0VJz1leqigsyT8BBgA9c5WPGzNDcwAAAABJRU5ErkJggg=="

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbgAAAAECAYAAAD8tSoJAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkExQUIxQkQ0MDEyMTExRUFCOTRFQzQ3QTJBNzEyQUMzIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkExQUIxQkQ1MDEyMTExRUFCOTRFQzQ3QTJBNzEyQUMzIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTFBQjFCRDIwMTIxMTFFQUI5NEVDNDdBMkE3MTJBQzMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTFBQjFCRDMwMTIxMTFFQUI5NEVDNDdBMkE3MTJBQzMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7MKlAxAAAAVUlEQVR42uzYQQ2AMAxA0XVByBzgaMYwgBdUzAN3CA7KhQB579J7Lz9tTMt+lLxo61YA4Gmjz9dINyvuBE7cAHhB5FKqdQHwR+FFCcCHrrd0s04BBgCICxK//phglwAAAABJRU5ErkJggg=="

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/3.a194901.png";

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(171);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const qs = require('qs');
	
	function formatParams(params) {
	  params = params || {};
	  var result = {};
	  for (var key in params) {
	    var objType = Object.prototype.toString.call(params[key]).slice(8, -1);
	    if (objType === 'Object' || objType === 'Array') {
	      result[key] = (0, _stringify2.default)(params[key]);
	    } else {
	      result[key] = params[key];
	    }
	  }
	  return result;
	}
	
	function urlFix(url) {
	  return '/apiInterface' + url;
	}
	
	function ajaxGet(url, params, options) {
	  options = options || {};
	  var formatResult = formatParams(params);
	  if (!options.radomLess) {
	    formatResult._r_ = Math.floor(Math.random() * 10000000 + 10000000); // 增加一个随机数参数，禁止IE的缓存
	  }
	  options.params = formatResult;
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.get(url, options).then(function (res) {
	      if (res) {
	        resolve(res.data);
	      }
	    }).catch(reject);
	  });
	}
	
	function ajaxPost(url, params, options) {
	  console.log(options);
	  // 需要对复杂对象进行JSON序列化
	  // let formatResult = formatParams(params);
	  // console.log(formatResult)
	  // formatResult = qs.stringify(formatResult);
	
	  console.log(params);
	  return new _promise2.default(function (resolve, reject) {
	    _axios2.default.post(url, params, options).then(function (res) {
	      if (res) {
	        resolve(res.data);
	      }
	    }).catch(reject);
	  });
	}
	
	var ajax = {
	  get: function get(url, params, options) {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var err, res;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              options = options || {
	                headers: {
	                  'Content-Type': 'application/json;charset=utf-8',
	                  'super-token': _config2.default.token
	                }
	              };
	              if (url.indexOf("apiInterface") < 0) {
	                url = urlFix(url);
	              }
	              // console.log(config.token)
	              err = null, res = null;
	              _context.prev = 3;
	              _context.next = 6;
	              return ajaxGet(url, params, options);
	
	            case 6:
	              res = _context.sent;
	
	              if (res.resultCode !== 200) {
	                err = new Error(res.msg);
	              }
	              _context.next = 13;
	              break;
	
	            case 10:
	              _context.prev = 10;
	              _context.t0 = _context['catch'](3);
	
	              err = _context.t0;
	
	            case 13:
	              return _context.abrupt('return', {
	                res: res,
	                err: err
	              });
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this, [[3, 10]]);
	    }))();
	  },
	  post: function post(url, params, options) {
	    var _this2 = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      var err, res;
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              options = options || {
	                headers: {
	                  'Content-Type': 'application/json;charset=utf-8',
	                  'super-token': _config2.default.token
	                }
	              };
	              if (url.indexOf("apiInterface") < 0) {
	                url = urlFix(url);
	              }
	              err = null, res = null;
	              _context2.prev = 3;
	              _context2.next = 6;
	              return ajaxPost(url, params, options);
	
	            case 6:
	              res = _context2.sent;
	
	              if (res.resultCode !== 200) {
	                err = new Error(res.msg);
	              }
	              _context2.next = 13;
	              break;
	
	            case 10:
	              _context2.prev = 10;
	              _context2.t0 = _context2['catch'](3);
	
	              err = _context2.t0;
	
	            case 13:
	              return _context2.abrupt('return', {
	                res: res,
	                err: err
	              });
	
	            case 14:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this2, [[3, 10]]);
	    }))();
	  },
	  addHandler: function addHandler(handler) {
	    _axios2.default.interceptors.response.use(function (res) {
	      handler(res);
	      return res;
	    }, function (error) {
	      handler(error);
	      return _promise2.default.reject(error);
	    });
	  }
	};
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$ajax = ajax;
	    Vue.ajax = ajax;
	  }
	};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(171);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storageVue = new _vue2.default({
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    get: function get(key) {
	      var saveData = this.getSaveData();
	      var matchData = saveData.find(function (item) {
	        return item.key === key;
	      });
	      if (matchData) {
	        return matchData.value;
	      }
	    },
	    set: function set(key, value) {
	      var saveData = this.getSaveData();
	      var item = saveData.find(function (item) {
	        return item.key === key;
	      });
	      if (item) {
	        item.value = value;
	      } else {
	        saveData.push({ key: key, value: value });
	      }
	      this.setSaveData(saveData);
	    },
	    del: function del(key) {
	      var saveData = this.getSaveData();
	      saveData = saveData.filter(function (item) {
	        return item.key !== key;
	      });
	      this.setSaveData(saveData);
	    },
	    clear: function clear() {
	      this.setSaveData([]);
	    },
	    getSaveData: function getSaveData() {
	      return JSON.parse(localStorage.saveData || '[]');
	    },
	    setSaveData: function setSaveData(data) {
	      localStorage.saveData = (0, _stringify2.default)(data);
	    }
	  }
	});
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$storage = storageVue;
	    Vue.storage = storageVue;
	  }
	};

/***/ }),
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro1.49bf3c7.png";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro2.b6f33c9.png";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro3.0b111d9.png";

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro4.bbc4284.png";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro5.8b5da07.png";

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABNElEQVRIie3VIUtDURiH8d8uG7omwuIsokEGY9fqqkGDVpNfwE+g2W7wA7i0PASrsGEwODQPy2ZbMokIarjnolMRdu/i/u2cw3mec943vIVGdyhkHcfYQUW2jHGF036zOoAoHOzhHocB/pxRUAmMh7g32ksF62ijjHfsYglbeM0oKqMd90ZrkaQs5XBwJ/ki3OA6oyCVnESSmqdZlbweFrGRQwA7RZMNXcYtLrGNlZyCSqHRHX7khPyb4o/1I85zMo8kpf5T8ISzaWj9ZnViHfdG+98F0c8Ls85cMBfMBb8FpRkwJxiRZMyl2UQtKznujWqBkWZcaHSHF5Ixl+ZVMnjepuSXAnzh216r0OgO1/Dga6rNKi+oRxjgIGzMEn7Qb1YHaZM7qKNlsifTZhwY9X6z2oFPs7w+cs4tO+8AAAAASUVORK5CYII="

/***/ }),
/* 576 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAATCAYAAACKsM07AAABjklEQVQ4jbXUPWsUURTG8d/OjusLYjpBcCyEKJYZENSwFtpEsBAtrbaxEr+BfgAbP0JS2ymChY3umKgo01iKhRlUCIhG8Y1kXYt7A2lmJrjrA9PcO+f/nHvuuaczN1w9ikWcQWo62sQKBmmEn50SeEtpZC4mmJ8yfLvmE3T/o0G3reY3cQ/rOBTXEozxHvtxEbfrAG0GBd4gx0L8fw828ADP8bgJ0GbwDMdwA+di1uuYjeu3yn72Mi+qWkDSYrAXV3AZM3iBJXzGJVzLiyprArQZnI/Z/sE73C/72RLu4hNOCXdQq7YSzeIRDuM4juRFNYPhtuR2T2LwGq9wEifQE15piQ/4LnTUnX81+CWUpxu/sdBFC7gQ439McoIudmFfzD6JMadxtSV2RwZvhbZ8iI9CF33BE6HDUnzF9TpAZ264Oq7bLPtZB/KiSjEu+9koL6qtl9wr+9nvuF/LaDTAQWEcHBDuoxez3ogma/iJb3WAFCP1A2+twXwnGiVYnhDSpOUEAzwV+nta2hQG5eAvnMZge3zgR/0AAAAASUVORK5CYII="

/***/ }),
/* 577 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAAB3klEQVQ4jZWUsUscQRSHvx3ixSYEIcE0w1lYCSmyCIHAgFjpga1nmVQipAoJqHWMpE8fSRX8A9TGO80WUQnT2Ebw3CCRBEKSRi7Fpdh3Zu7d7mX9Ncv7zbxv3ryZnajT6aAVJ2kVWABqwDhwB/gOfAa2gPfe2ZbOi0JYnKTDwCvgKTDUt8o//QHeAKve2cs+WJykd2XVyQEQrU9AzTv77QoWJ2kFaAKPrgHq6hCY8s5eGjHWckAtYAmoAjfluyR+qIfAS4DowYczS9bYSjBhB5j3zv7WZcRJegvYBGYCuw2MG6CuQKdAPQ8EIP68zOuqAtQNMKfmr3tnf+WBFPC1sucMMKHM7UGgQFsqnjDAiDIvSsK+qnjEAOfKHC0Ju6ficwPsKXO2JGxGxU0DbChzRY6/UDK+oux3xjvbILvFXY0Bm0XA4J6NBfaRd3b3hgQvgH0gCrZwHCfpOtmpXZD1siYVVQNQB3gOvT/6W+DxoO0VaMM7+wTABOYz4OyaoJbk0QPzzv4gexDbJUFtYEHyemEC/Agsl4Qte2cPQiMqeLb/17+rPoUyeTOBRaBRMNaQ8T7lVibV3QYS4H5gHwPOO/szL6eoMiShBpyIdUL23ueCBsIE+AWYJvt/pyUu1F8kgZk68Vu/TAAAAABJRU5ErkJggg=="

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACA0lEQVRIiaXWP2gUQRQG8F+WyKWMWJ9YCCYQMF6rV8RUQixEEdJa5IKoYJHGpFCIhYpCxCJBQayCgk04sAx4lSBHkGAiKIgn1hEFDUi0mDmyXvb+rH7NvH375vtm38x7s33HXn7SAcOYxBhGMBj9W1jHKpbr5eJGO4K+NgJDuIOJTuopVDFTLxc3W18kGcEVrOUgF2PXSrVGpZvAPBZRSPl2ehQpYLFUa8y3E6hgtmXSZyFdd3sUgdn0lzQFhrDQEvhV2IcCbuBLDpGFUq0xlBZoEqXxCPdxBt9wNYdAIXJKhKOYtaHv4/gcZ/EM73KITJRqjeFEOOdZOBDHtziMFRzJIQCTiVBEWRhteT6dkxzGEqFCszCOfdFuW6ldMJLYLf9W7MepaK/gxT8IDGZVchpXUvZF/MirkAiNqx3GcTLaH3E9J/9WInTFTniAgWjfw5tof8CTLnPXE6HldsIwbkf7F47jFqZwAa87zF1NsNxFAC5HMviOaziPPlzC7zbzlhPhCFZ7EHmIc9HeEVrJVL1cfIXHGfHVerm40TxFM9juIpDgqdBjBoXUHCrVGkdxsCV2O3L+daNVhLugF/y0m/sTGe+n6+XiEvSnnEso2nsnZGGgDTHcbJKz90abw7Tu6crCtrDyubQzq5KXhEbXy8Y3UcVoeuVN9GcEw6bQPf/7t+UPy892KUMsrPIAAAAASUVORK5CYII="

/***/ }),
/* 579 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAYCAYAAAD+vg1LAAABzUlEQVRIia3VP0hWURzG8c/7aoHQ4BBB0A0KorYQhIa4IAU1uFVa5NASQRHVFAmNBdEkCA25NElpthcUITa0XGhLwgbtD0iDSCAU+Ta859L1dv+8aQ8cuDzP7/e9h3POvafRN7uoQg0cwVAYMB3GW7SSOCpuLADnYcWdLGVfksRRqwjcxFGcxqkKWJmW8AwzeJPE0Xqjb3ZxPAB3/yOsTF8x0+ibXWzVlm5C3R3WvcbL8HwcA1sF/8J5TGW8OxjGJLrKGps14LEcNNVUyEpVB35akU1vBbxp1YHPVGRDFVkt+Ib2RuU1HLJS1Z2KLjzBZbwK3jH/4bilGugElgevK1+SebzAJ/wI3nbswQkcLOlb78YCDuSCj7iC5zUTO4kH2J/zF5raX9AGE/0dQIWa/tCT1WRT+wv6kjH3YaQDaKqR0JPqM8aaWMFZrIWgiXE8Qm8FsDfUjPuzR2s4l8TRSmrMYRCrmcYL2pt3FT0Zvyd486Em1SoGkzia4++r6RAe43Budt/wMDxfws5c/i7M9H1qFN1523ATt7AjH+b0HfdwP4mjn9mgCJxqF27joo1LQXstJ3A3iaPlouaqf8UyrmEvRvEhjNHgXQ81hfoNMpJsoAQcL4sAAAAASUVORK5CYII="

/***/ }),
/* 580 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAATCAYAAACKsM07AAABoElEQVQ4ja3UPWgUURTF8d/GuIiQKjaCQxAbm0AcUBAdxSCoYCOiNhZKCssUFiaWguBHZ6UExSqgjdgoCEF0ELFwmmBhlAQcwUJEoiAhorF4M2EcYrK77mmGy7ucP++8O7ex4/kHHWod3uF1lkQn/tXU26k7+rAV31ZrahXQhxm8xGn8wDyeYbpsitN8Cx7ha5ZE+6GnRcACPuEYxtDEyQL4PU7zw3GaN3ALg3jf7g1+4gDGhdxnMFA5H8cL3EaK660AduEMdmIDPmIKV7EZ93C3ODuPvVjMkmi4atJYYYqauImzq8Cf4BBkSSRO8yZeYQi78Qb9+FJ/gwYm1zCHgzhaFlkSLeJ+UQ5hFnOYrUd0CsfXMCcMxwS2CRMFUfGdFxIYxHQZ0UYh23NY3wKg1BieCnE8wG8MZEn0uWzoLQwfY18bxqWu1OqLVXPCVUc7NF9JI3Ga99cBI10yJ7zJpTpgexcBhD/8L8BClwGbirWxDEi7DJjLkmipCrjcZcCdatEjrNxRYYb/V1O4VgfADezBQ/xq03QJb3EBR4q1saw/cO1idh/mbuUAAAAASUVORK5CYII="

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAACuElEQVQ4jY3VW4hWVRQH8N93pplRJ0uFxMZODPlgpEFKkV3Oi9CFgqCgC0IM9GAiDPXQQ08+pZXR7SXCinzTgSCoMIoeosmishPVQyVdIL8gMWPKMcbx8vWw1gefX2diFmzO3nut9d9rrf1f+7Q2fPSrBhnBNjyAFRjCAP7BNN7Ei5ipq/I8x1YfYAuP4RGsSpCzONlz0AA6+A0v4am6KjtNgEN4BzdjMdo4hL34KQ9bg3Fch9WYxae4va7KuV7AFt7HZpzAe9iKv7AE3+ahV2fay/AKbsmoP8bmuio7RRo+jirBnsb9CQbDuDDHcO5N417sznJcjx3dCC/CdxjFpLiIfrksv+0G3f4MoI31BR7Fpbmxtc/4zkzngxwHcUefzbb0XY2JAneLGh7C32nUwhvYh5uwNseNGdFk2qirchpf5vqeQhT4nLjNruzO6JY2pLgUd2FXz97exFheCLrM4OdUjmALFjWAdWURHhT0kr4nMVgIkhYYTGWFlf8D1pWV2JTzYZFypxDkHMFVqRzDBQsAHMTlOV8naHWqEC3UwkOp/AGnFgA4ix9zPp7fo4Vg/FyeMiZocmwBgMfw2capI2Miuzm8XAgatEVN9ovH4ElxUfPJCewUNzuZvm3sK3AGE6LVNuAtvIpn8Mc8kT2L1/E2rknfiboqz3R7+UCmfhq34RtM4drc/wKf4zXRtx/ia9yaPnvqqjzAf9/DJ7Ady0XX/J6O3wt6rc2IVuFi/Inn6qrc2QXoByRabY+4oCXNJTSDXzBeV+VXvYomvh3EfZnyafESnU3dYqwXNdsk3sbzZD4C7xBpH8YNPftDgnujeBjP9zsWfetluFL8Bjp4V6TeHaMJOCCerSs2Th25pBegt4Zr8ElGvULQ6XhD9C3Bu3M9+hfqqtzVn/Jcjg6ONgB1pUk/2538C35kuXGXry+jAAAAAElFTkSuQmCC"

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAPCAYAAAAYjcSfAAAA8klEQVQ4jb3NIU/DUBQG0EP/GQQSQkAwcAgcDgVyKIIFNTs3NzcMCDI1MzUBBjyCZMkSQJA0xdwmS6FpC9s+9+697ztrrSy7RNvqcpXgAtcrAm/QTuJxjs6SwQ7OIEcznKK7JLAb/dk8msMn6C0Y7EVvlg+SwkGKY/QXBPajL50fFtEcPsLgn+Bt9KTFxW8ofOEQd38E73EQPT9ShuZwC8OG4BD7ZWAVCp/YxagmOMJe/CtNFQof2MG44m4cd+9VhXVQmGEbk5L9JPazOmV1UZhiC4+F+VPMp3WLmqDwFsBzvF+wGfPaaYrCKzbwgPV4N8o3p9M3+2B7PhwAAAAASUVORK5CYII="

/***/ }),
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1483)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(636),
	  /* template */
	  __webpack_require__(1988),
	  /* scopeId */
	  "data-v-3f1a073a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1458)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(639),
	  /* template */
	  __webpack_require__(1964),
	  /* scopeId */
	  "data-v-269c2b72",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1515)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(653),
	  /* template */
	  __webpack_require__(2019),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _particles = __webpack_require__(586);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      seller: {}
	    };
	  },
	
	  components: {
	    particles: _particles2.default
	  },
	  created: function created() {}
	};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _part1Content = __webpack_require__(1645);
	
	var _part1Content2 = _interopRequireDefault(_part1Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    activeItem: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    var that = this;
	    return {
	      navItem: [1, 2, 3, 4],
	      banner: [{ name: '芒果园', src: _part1Content2.default }, { name: '百色芒果', src: _part1Content2.default }],
	      swiperOption: {
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        // 自动播放
	        autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "horizontal",
	        // 小手掌抓取滑动
	        grabCursor: true,
	        on: {
	          // 滑动之后回调函数
	          slideChangeTransitionStart: function slideChangeTransitionStart() {
	            /* realIndex为滚动到当前的slide索引值 */
	            that.imgIndex = this.realIndex - 1;
	          }
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      },
	      activeIndex: 0,
	      content3Data: [{ name: '土壤温度', value: '24℃' }, { name: '土壤湿度', value: '43%' }, { name: '土壤铵根离子', value: '1.0ppm' }, { name: '土壤硝酸离子', value: '0ppm' }, { name: '土壤钾离子', value: ' 41.93ppm' }],
	      content4Data: [{ name: '电磁阀1', value: '开' }, { name: '电磁阀2', value: '开' }, { name: '电磁阀3', value: '开' }],
	      show: false
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    switchNav: function switchNav(index) {
	      this.$emit('indexChange', index);
	    },
	    showDetails: function showDetails() {
	      this.show = true;
	    },
	    hideDetails: function hideDetails() {
	      this.show = false;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _pro = __webpack_require__(1646);
	
	var _pro2 = _interopRequireDefault(_pro);
	
	var _pro3 = __webpack_require__(1647);
	
	var _pro4 = _interopRequireDefault(_pro3);
	
	var _pro5 = __webpack_require__(1648);
	
	var _pro6 = _interopRequireDefault(_pro5);
	
	var _pro7 = __webpack_require__(1649);
	
	var _pro8 = _interopRequireDefault(_pro7);
	
	var _pro9 = __webpack_require__(1650);
	
	var _pro10 = _interopRequireDefault(_pro9);
	
	var _pro11 = __webpack_require__(1651);
	
	var _pro12 = _interopRequireDefault(_pro11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      navItem: ['企业简介', '种植品种'],
	      activeIndex: 0,
	      content3Data: [{ name: '土壤温度', value: '24℃' }, { name: '土壤湿度', value: '43%' }, { name: '土壤铵根离子', value: '1.0ppm' }, { name: '土壤硝酸离子', value: '0ppm' }, { name: '土壤钾离子', value: ' 41.93ppm' }],
	      content4Data: [{ name: '电磁阀1', value: '开' }, { name: '电磁阀2', value: '开' }, { name: '电磁阀3', value: '开' }],
	      show: false,
	      banner: [_pro2.default, _pro4.default, _pro6.default, _pro8.default, _pro10.default, _pro12.default],
	      swiperOption: {
	        slidesPerView: 2,
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "horizontal",
	        // 小手掌抓取滑动
	        grabCursor: true,
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        },
	        on: {
	          // 滑动之后回调函数
	          slideChangeTransitionStart: function slideChangeTransitionStart() {
	            /* realIndex为滚动到当前的slide索引值 */
	            that.imgIndex = this.realIndex - 1;
	          }
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    switchNav: function switchNav(index) {
	      this.activeIndex = index;
	    },
	    showDetails: function showDetails() {
	      this.show = true;
	    },
	    hideDetails: function hideDetails() {
	      this.show = false;
	    }
	  }
	};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _weatherIcon = __webpack_require__(1652);
	
	var _weatherIcon2 = _interopRequireDefault(_weatherIcon);
	
	var _monitorIcon = __webpack_require__(1644);
	
	var _monitorIcon2 = _interopRequireDefault(_monitorIcon);
	
	var _icon = __webpack_require__(1642);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(1643);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _amap = __webpack_require__(139);
	
	var _amap2 = _interopRequireDefault(_amap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_vue2.default.use(_amap2.default);
	_amap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.CircleEditor', 'AMap.MouseTool', 'AMap.Polygon', 'AMap.Marker']
	});
	var amapManager = new _amap2.default.AMapManager();
	var path = [[106.948887, 23.76081], [107.030254, 23.816729], [107.107502, 23.692606], [106.996952, 23.691349], [106.989742, 23.730641], [106.948887, 23.76081]];
	var markers = [{ point: [106.96262, 23.752012], src: _weatherIcon2.default, index: 1 }, { point: [107.001758, 23.767094], src: _monitorIcon2.default, index: 0 }, { point: [106.986309, 23.756097], src: _icon2.default, index: 3 }, { point: [107.019611, 23.730327], src: _icon4.default, index: 2 }];
	var list = {
	  '106.96262, 23.752012': 1,
	  '107.001758, 23.767094': 0,
	  '106.986309, 23.756097': 3,
	  '107.019611, 23.730327': 2
	};
	exports.default = {
	  name: 'index',
	  props: {
	    activeItem: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    var _this = this;
	
	    return {
	      amapManager: amapManager,
	      zoom: 12,
	      center: [107.0156629745, 23.7356699750],
	      plugin: [],
	      events: {
	        init: function init(o) {
	          _this.map = _this.$refs.map.$$getInstance();
	          var AMap = window.AMap;
	          if (AMap) {
	            // var mouseTool = new AMap.MouseTool(this.map);
	            // this.mouseTool = mouseTool;
	          }
	        },
	        complete: function complete(o) {
	          var RoadNet = new AMap.TileLayer.Satellite();
	          _this.map.add([RoadNet]);
	          // 画区域图
	          var polyline = new AMap.Polygon({
	            path: path,
	            isOutline: true,
	            outlineColor: '#ffeeff',
	            borderWeight: 1,
	            strokeColor: "rgb(0,255,255)",
	            strokeOpacity: 0.8,
	            strokeWeight: 6,
	            fillColor: 'rgba(0,168,255,.8)',
	            // 折线样式还支持 'dashed'
	            strokeStyle: "solid",
	            // strokeStyle是dashed时有效
	            strokeDasharray: [10, 5],
	            lineJoin: 'round',
	            lineCap: 'round',
	            zIndex: 50
	          });
	          polyline.setMap(_this.map);
	          var that = _this;
	          polyline.on('click', function (e) {
	            console.log(e.lnglat.getLng());
	            console.log(e.lnglat.getLat());
	          });
	          // 标记点
	
	          var _loop = function _loop(i) {
	            var icon = new AMap.Icon({
	              size: new AMap.Size(40, 40),
	              imageSize: new AMap.Size(40, 40),
	              image: markers[i].src
	            });
	            var marker = new AMap.Marker({
	              position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
	              cursor: 'pointer',
	              icon: icon,
	              extData: markers[i]
	            });
	            marker.on('click', function () {
	              that.$emit('indexChange', marker.getExtData().index);
	            });
	            _this.map.add(marker);
	          };
	
	          for (var i in markers) {
	            _loop(i);
	          }
	        }
	      }
	    };
	  },
	
	  methods: {}
	};

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    activeItem: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      show: false
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {},
	
	  methods: {
	    // 点击切换索引
	    change: function change(newIndex) {
	      this.$emit('indexChange', newIndex);
	    }
	  }
	};

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var daysArr = ["日", "一", "二", "三", "四", "五", "六"];
	exports.default = {
	  props: {
	    name: String,
	    isDashboard: {
	      type: Boolean,
	      default: false
	    },
	    onBack: false
	  },
	  created: function created() {},
	
	  methods: {
	    back: function back() {
	      // console.log(this.timerDashboard)
	      // if (this.onBack) {
	      //   this.$emit('backClick');
	      // } else {
	      //   this.$router.push('/rundadashboard');
	      // }
	    }
	  },
	  data: function data() {
	    return {
	      color: this.$store.state.color,
	      // time: moment().format('LLLL')
	      time: (0, _moment2.default)().format("YYYY.MM.DD") + " ",
	      weekdays: "\u661F\u671F" + daysArr[(0, _moment2.default)().day()]
	    };
	  }
	};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var daysArr = ['日', '一', '二', '三', '四', '五', '六'];
	exports.default = {
	  props: {
	    name: String,
	    isDashboard: {
	      type: Boolean,
	      default: false
	    },
	    onBack: false
	  },
	  created: function created() {},
	
	  methods: {
	    back: function back() {
	      // console.log(this.timerDashboard)
	      // if (this.onBack) {
	      //   this.$emit('backClick');
	      // } else {
	      //   this.$router.push('/rundadashboard');
	      // }
	    }
	  },
	  data: function data() {
	    return {
	      color: this.$store.state.color,
	      // time: moment().format('LLLL')
	      time: (0, _moment2.default)().format('YYYY.MM.DD') + ' ',
	      weekdays: '\u661F\u671F' + daysArr[(0, _moment2.default)().day()]
	    };
	  }
	};

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var daysArr = ['日', '一', '二', '三', '四', '五', '六'];
	exports.default = {
	  props: {
	    name: String,
	    isDashboard: {
	      type: Boolean,
	      default: false
	    },
	    onBack: false
	  },
	  created: function created() {},
	
	  methods: {
	    back: function back() {
	      // console.log(this.timerDashboard)
	      // if (this.onBack) {
	      //   this.$emit('backClick');
	      // } else {
	      //   this.$router.push('/rundadashboard');
	      // }
	    }
	  },
	  data: function data() {
	    return {
	      color: this.$store.state.color,
	      // time: moment().format('LLLL')
	      time: (0, _moment2.default)().format('YYYY.MM.DD') + ' ',
	      weekdays: '\u661F\u671F' + daysArr[(0, _moment2.default)().day()]
	    };
	  }
	};

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var daysArr = ['日', '一', '二', '三', '四', '五', '六'];
	exports.default = {
	  props: {
	    name: String,
	    isDashboard: {
	      type: Boolean,
	      default: false
	    },
	    onBack: false
	  },
	  created: function created() {},
	
	  methods: {
	    back: function back() {
	      // console.log(this.timerDashboard)
	      // if (this.onBack) {
	      //   this.$emit('backClick');
	      // } else {
	      //   this.$router.push('/rundadashboard');
	      // }
	    }
	  },
	  data: function data() {
	    return {
	      color: this.$store.state.color,
	      // time: moment().format('LLLL')
	      time: (0, _moment2.default)().format('YYYY.MM.DD') + ' ',
	      weekdays: '\u661F\u671F' + daysArr[(0, _moment2.default)().day()]
	    };
	  }
	};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(4);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var daysArr = ["日", "一", "二", "三", "四", "五", "六"];
	exports.default = {
	  props: {
	    name: String,
	    isDashboard: {
	      type: Boolean,
	      default: false
	    },
	    onBack: false
	  },
	  created: function created() {},
	
	  methods: {
	    back: function back() {
	      // console.log(this.timerDashboard)
	      // if (this.onBack) {
	      //   this.$emit('backClick');
	      // } else {
	      //   this.$router.push('/rundadashboard');
	      // }
	    }
	  },
	  data: function data() {
	    return {
	      color: this.$store.state.color,
	      // time: moment().format('LLLL')
	      time: (0, _moment2.default)().format("YYYY.MM.DD") + " ",
	      weekdays: "\u661F\u671F" + daysArr[(0, _moment2.default)().day()]
	    };
	  }
	};

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      timer: null,
	      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
	      myChart: {},
	      name: "可追溯覆盖率",
	      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
	      instructionData: [{ name: "追溯码赋码量", value: "11432083" }, { name: "可追溯主体数", value: "498" }, { name: "可追溯商品品种", value: "58" }, { name: "三品一标可追溯覆盖率", value: "93%" }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: 0
	          },
	          data: ["百色芒果", "田东香芒", "百色番茄", "凌云牛心李", "德保山楂", "西林沙塘桔", "田阳香芒", "平果火龙果", "隆林板栗", "凌云白毫茶"],
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            // alignWithLabel: true,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "#C0E450"
	              }, {
	                offset: 0.8,
	                color: "#75CD2D"
	              }], false)
	            }
	          },
	          data: this.data
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '扶贫情况',
	      listData: [{ name: '贫困户总数', val: '186183' }, { name: '产业扶贫金额', val: '65286万' }, { name: '未脱贫户数', val: '21168' }, { name: '电商扶贫金额', val: '24777万' }, { name: '已脱贫户数', val: '165015' }],
	      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#0092ee'],
	      lengthList: [300, 285, 155, 150],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  computed: {},
	  methods: {
	    width: function width() {},
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    },
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'background:' + this.colorList[index];
	      } else {
	        return 'background:' + this.colorList[3];
	      }
	    },
	    changeLength: function changeLength(index) {
	      return 'width:' + this.lengthList[index] + 'px';
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      swiperData: ['总屏', '溯源信息', '产业信息', '环境监测', '监控视频', '产品展示', '精准扶贫', '备案信息'],
	      swiperOption: {
	        slidesPerView: 5,
	        speed: 300,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // current swiper instance
	    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
	    console.log('this is current swiper instance object', this.swiper);
	    // this.swiper.slideTo(3, 1000, false)
	  },
	
	  computed: {
	    swiper: function swiper() {
	      return this.$refs.mySwiper.swiper;
	    }
	  },
	  methods: {
	    clickPage: function clickPage(index) {
	      if (index === 0) {
	        // 总屏
	        this.$router.push('/dashboard');
	      } else if (index === 1) {
	        // 溯源信息
	        this.$router.push('/trace');
	      } else if (index === 2) {
	        // 产业信息
	        this.$router.push('/industryInformation');
	      } else if (index === 3) {
	        // 环境监测
	        this.$router.push('/environmentMonitor');
	      } else if (index === 4) {
	        // 监控视频
	        this.$router.push('/video');
	      } else if (index === 5) {
	        // 产品展示
	        this.$router.push('/product');
	      } else if (index === 6) {
	        // 精准扶贫
	        this.$router.push('/helpPoor');
	      } else if (index === 7) {
	        // 备案信息
	        this.$router.push('/recordInformation');
	      }
	    }
	  }
	};

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    areaName: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {},
	  methods: {
	    jumpChild: function jumpChild() {
	      this.$router.push('/base');
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.map .main'));
	    _axios2.default.get('static/data/\u767E\u8272\u5E02/' + this.areaName + '.json').then(function (res) {
	      var geoCoordMapList = res.data.features[0].geometry.coordinates[0][0];
	      // 引入地区地图
	      _echarts2.default.registerMap(_this.areaName, res.data);
	      // 每个地区的坐标
	      var geoCoordMap = {
	        '广西百色翠丰特色农产品有限责任公司': [106.887345, 24.1138430000001],
	        '广西百色盛泰和农业有限公司': [106.933768339844, 23.9298854804688],
	        '广西田阳新靖田农产品贸易有限公司 ': [107.03298953125, 23.875044171875],
	        '广西田阳古鼎香农产品综合批发市场有限公司 ': [107.003172636719, 23.6282497382813],
	        '广西田阳穗丰园农产品贸易有限公司 ': [106.592535429688, 23.4990334296876]
	
	        // 每个地区的设备数量值
	      };var data = [{ name: '广西百色翠丰特色农产品有限责任公司', value: 10 }, { name: '广西百色盛泰和农业有限公司', value: 20 }, { name: '广西田阳新靖田农产品贸易有限公司 ', value: 20 }, { name: '广西田阳古鼎香农产品综合批发市场有限公司 ', value: 20 }, { name: '广西田阳穗丰园农产品贸易有限公司 ', value: 20 }];
	
	      var convertData = function convertData(data) {
	        var res = [];
	        for (var i = 0; i < data.length; i++) {
	          var geoCoord = geoCoordMap[data[i].name];
	          if (geoCoord) {
	            res.push({
	              name: data[i].name,
	              value: geoCoord.concat(data[i].value)
	            });
	          }
	        }
	        return res;
	      };
	
	      function tooltipCharts() {
	        var tooltipDom = document.getElementById('tooltipPieId');
	        if (tooltipDom) {
	          var _tooltipCharts = _echarts2.default.init(document.getElementById('tooltipPieId'));
	          var _data = [{ 'name': '百色芒果', 'value': 675 }, { 'name': '圣女果', 'value': 1397 }, { 'name': '牛心李', 'value': 318 }, { 'name': '西林火姜', 'value': 101 }, { 'name': '其他', 'value': 110 }];
	          var total = 0;
	          for (var i = 0; i < _data.length; i++) {
	            total += _data[i].value;
	          }
	          var tooltopOpiton = {
	            color: ['#CC68FA', '#FF6438', '#35CDFD', '#FF7B7B', '#FFFE75', '#22FAA1'],
	            title: {
	              text: '总数',
	              subtext: total,
	              textStyle: {
	                fontSize: 12,
	                color: '#fff',
	                align: 'center'
	              },
	              subtextStyle: {
	                fontSize: 12,
	                color: '#fff'
	              },
	              x: '22%',
	              y: '33%'
	            },
	            grid: {
	              bottom: 150,
	              left: 100,
	              right: '10%'
	            },
	            legend: {
	              right: 'right',
	              top: '-4%',
	              textStyle: {
	                color: '#f2f2f2',
	                fontSize: 12
	              },
	              icon: 'pin',
	              data: _data,
	              formatter: function formatter(name) {
	                for (var _i = 0; _i < _data.length; _i++) {
	                  if (name === _data[_i].name) {
	                    return name + ' ' + (_data[_i].value / total).toFixed(2) * 100 + '% ' + _data[_i].value;
	                  }
	                }
	              }
	            },
	            series: [{
	              radius: ['40%', '70%'],
	              center: ['30%', '50%'],
	              type: 'pie',
	              label: {
	                normal: {
	                  show: false
	                },
	                emphasis: {
	                  show: true
	                }
	              },
	              labelLine: {
	                normal: {
	                  show: false
	                }
	              },
	              name: "信息统计",
	              data: _data
	            }]
	          };
	          _tooltipCharts.setOption(tooltopOpiton);
	        }
	      }
	
	      var option = {
	        // 自定义引导饼图
	        tooltip: {
	          show: true,
	          trigger: 'item',
	          triggerOn: 'mousemove',
	          enterable: true,
	          transitionDuration: 1,
	          formatter: function formatter(params) {
	            var tipHtml = '<div style="height:150px;width:266px;padding: 10px;background:#2369D3;box-shadow:0 0 1px 1px #14CBF5">' + '    <div style="height: 15px;">产量分析 <span style="font-size: 10px">(吨)</span></div>' + '    <div id="tooltipPieId" style="height:135px;width:100%"></div>' + '</div>';
	            setTimeout(function () {
	              tooltipCharts();
	            }, 10);
	            return tipHtml;
	          }
	        },
	        geo: {
	          map: _this.areaName,
	          show: true,
	          label: {
	            emphasis: {
	              show: false
	            }
	          },
	          itemStyle: {
	            normal: {
	              areaColor: '#7868EC',
	              borderColor: '#BCC5EA',
	              borderWidth: 2,
	              shadowColor: '#5AB2FE',
	              shadowBlur: 5
	            }
	          },
	          zoom: 1.2
	        },
	        series: [{
	          type: 'map',
	          map: _this.areaName,
	          geoIndex: 1,
	          aspectScale: 0.75,
	          zoom: 1.2,
	          markPoint: {
	            symbol: 'image://https://s2.ax1x.com/2019/05/20/Extm4S.png',
	            symbolSize: 40
	          },
	          label: {
	            normal: {
	              show: true,
	              textStyle: {
	                color: '#fff',
	                fontSize: 20
	              }
	            },
	            emphasis: {
	              textStyle: {
	                color: '#fff',
	                fontSize: 20
	              }
	            }
	          },
	          roam: false,
	          itemStyle: {
	            normal: {
	              areaColor: '#7868EC',
	              borderColor: '#BCC5EA',
	              borderWidth: 2
	            },
	            emphasis: {
	              areaColor: '#328DDF',
	              borderColor: '#BCC5EA',
	              shadowBlur: 8
	            }
	          },
	          data: data
	        }, {
	          name: '企业图片',
	          type: 'scatter',
	          coordinateSystem: 'geo',
	          label: {
	            normal: {
	              show: true,
	              formatter: '{b|{b}}',
	              rich: {
	                b: {
	                  height: 30,
	                  padding: [0, 10],
	                  align: 'center',
	                  backgroundColor: '#1375C9',
	                  borderColor: '#0ECAF7',
	                  borderRadius: '5px',
	                  color: '#fff'
	                }
	              }
	            }
	          },
	          zlevel: 6,
	          data: convertData(data)
	        }]
	      };
	      _this.myChart.setOption(option);
	      var index = 0;
	      setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: 'showTip',
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        if (index >= data.length) {
	          index = 0;
	        }
	      }, 3000);
	    });
	  }
	};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _satelliteMap = __webpack_require__(1739);
	
	var _satelliteMap2 = _interopRequireDefault(_satelliteMap);
	
	var _mapChart = __webpack_require__(1738);
	
	var _mapChart2 = _interopRequireDefault(_mapChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      ifSatellite: false
	    };
	  },
	
	  components: {
	    satelliteMap: _satelliteMap2.default,
	    mapChart: _mapChart2.default
	  },
	  mounted: function mounted() {},
	  methods: {
	    clickSatellite: function clickSatellite() {
	      this.ifSatellite = true;
	    },
	    clickNormal: function clickNormal() {
	      this.ifSatellite = false;
	    }
	  }
	};

/***/ }),
/* 643 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  components: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _centerTop = __webpack_require__(1736);
	
	var _centerTop2 = _interopRequireDefault(_centerTop);
	
	var _centerMap = __webpack_require__(1735);
	
	var _centerMap2 = _interopRequireDefault(_centerMap);
	
	var _centerChildMap = __webpack_require__(1734);
	
	var _centerChildMap2 = _interopRequireDefault(_centerChildMap);
	
	var _centerBottom = __webpack_require__(1733);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    child: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      areaName: ''
	    };
	  },
	
	  components: {
	    centerTop: _centerTop2.default,
	    centerMap: _centerMap2.default,
	    centerChildMap: _centerChildMap2.default,
	    centerBottom: _centerBottom2.default
	  },
	  methods: {
	    // 点击地图上的区域进入区域地图
	    clickMap: function clickMap(areaName) {
	      this.areaName = areaName;
	      this.child = false;
	      this.$router.push('/secondMap?areaName=' + areaName);
	    },
	
	    // 判断是否点到子区域地图
	    clickChild: function clickChild() {
	      this.$emit('clickChild', true);
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _tip = __webpack_require__(1655);
	
	var _tip2 = _interopRequireDefault(_tip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector(".map .main"));
	    var self = this;
	
	    _axios2.default.get("static/data/百色市.json").then(function (res) {
	      // 引入地区地图
	      _echarts2.default.registerMap("百色市", res.data);
	      // 每个地区的坐标
	      var geoCoordMap = {
	        '右江区': [106.6189648699, 23.9011510432],
	        '靖西市': [106.4176986464, 23.1340325224],
	        '田阳县': [106.9156629745, 23.735669975],
	        '田东县': [107.1260862186, 23.5972525589],
	        '平果县': [107.5898772387, 23.3293469441],
	        '德保县': [106.6154958178, 23.3234056946],
	        '那坡县': [105.8335036062, 23.3871180613],
	        '凌云县': [106.561596792, 24.3475183354],
	        '乐业县': [106.5616359496, 24.7858389344],
	        '田林县': [106.2285227061, 24.2943864015],
	        '西林县': [105.0938229983, 24.4895710923],
	        '隆林各族自治县': [105.3438807417, 24.7706591482]
	      };
	
	      // 每个地区的设备数量值
	      var data = [{ name: "右江区", value: 10 }, { name: "靖西市", value: 20 }, { name: "田阳县", value: 30 }, { name: "田东县", value: 10 }, { name: "平果县", value: 20 }, { name: "德保县", value: 30 }, { name: "那坡县", value: 10 }, { name: "凌云县", value: 20 }, { name: "乐业县", value: 30 }, { name: "田林县", value: 30 }, { name: "西林县", value: 30 }, { name: "隆林各族自治县", value: 30 }];
	
	      var convertData = function convertData(data) {
	        var res = [];
	        for (var i = 0; i < data.length; i++) {
	          var geoCoord = geoCoordMap[data[i].name];
	          if (geoCoord) {
	            res.push({
	              name: data[i].name,
	              value: geoCoord.concat(data[i].value)
	            });
	          }
	        }
	        return res;
	      };
	
	      function tooltipCharts() {
	        var tooltipDom = document.getElementById("tooltipPieId");
	        if (tooltipDom) {
	          var _tooltipCharts = _echarts2.default.init(document.getElementById("tooltipPieId"));
	          var _data = [{ name: "百色芒果", value: 35.02 }, { name: "香芒", value: 9.5 }, { name: "百色番茄", value: 7.6 }, { name: "沙塘桔", value: 2.4 }, { name: "其他", value: 34.5 }];
	          var total = 0;
	          for (var i = 0; i < _data.length; i++) {
	            total = Math.round((total + _data[i].value) * 100) / 100;
	          }
	          var tooltopOpiton = {
	            color: ["#CC68FA", "#FF6438", "#35CDFD", "#FF7B7B", "#FFFE75", "#22FAA1"],
	            title: {
	              text: "总数",
	              subtext: total,
	              textStyle: {
	                fontSize: 12,
	                color: "#fff",
	                align: "center"
	              },
	              subtextStyle: {
	                fontSize: 12,
	                color: "#fff"
	              },
	              x: "12%",
	              y: "33%"
	            },
	            grid: {
	              bottom: 150,
	              left: 100,
	              right: "10%"
	            },
	            legend: {
	              right: "right",
	              top: "-4%",
	              textStyle: {
	                color: "#f2f2f2",
	                fontSize: 12
	              },
	              icon: "pin",
	              data: _data,
	              formatter: function formatter(name) {
	                for (var _i = 0; _i < _data.length; _i++) {
	                  if (name === _data[_i].name) {
	                    var n = Math.round(_data[_i].value / total * 10000) / 100;
	                    return name + " " + n + "% " + _data[_i].value;
	                  }
	                }
	              }
	            },
	            series: [{
	              radius: ["40%", "70%"],
	              center: ["20%", "50%"],
	              type: "pie",
	              itemStyle: {
	                normal: {
	                  areaColor: "#328DDF",
	                  borderColor: "#BCC5EA",
	                  borderWidth: 0
	                },
	                borderWidth: 10,
	                shadowColor: "rgba(0, 0, 0, 0)",
	                shadowBlur: 10
	              },
	              label: {
	                normal: {
	                  show: false
	                },
	                emphasis: {
	                  show: true
	                }
	              },
	              labelLine: {
	                normal: {
	                  show: false
	                }
	              },
	              name: "信息统计",
	              data: _data
	            }]
	          };
	          _tooltipCharts.setOption(tooltopOpiton);
	        }
	      }
	
	      var option = {
	        // 地图映射颜色
	        visualMap: {
	          show: false,
	          min: 0,
	          max: 100,
	          left: "left",
	          top: "bottom",
	          text: ["高", "低"],
	          calculable: true,
	          inRange: {
	            color: ["#06A1E7", "#2B72D6", "#ADBFFF", "#328DDF", "#6676EF", "#A5D3F0"]
	          }
	        },
	        // 自定义引导饼图
	        tooltip: {
	          show: true,
	          trigger: "item",
	          backgroundColor: 'transparent',
	          triggerOn: "mousemove",
	          enterable: true,
	          transitionDuration: 1,
	          formatter: function formatter(params) {
	            var tipHtml = "<div id=\"bgImage\" style=\"height:180px;width:306px;background: url(" + _tip2.default + ") no-repeat transparent;background-size:100% 100%;padding: 20px;\">" + '    <div style="height: 15px;">产量分析 <span style="font-size: 10px">(吨)</span></div>' + '    <div id="tooltipPieId" style="height:135px;width:100%"></div>' + "</div>";
	            setTimeout(function () {
	              tooltipCharts();
	            }, 10);
	            return tipHtml;
	          },
	          borderWidth: 0,
	          padding: 0
	        },
	        geo: {
	          map: "百色市",
	          show: true,
	          label: {
	            emphasis: {
	              show: false
	            }
	          },
	          itemStyle: {
	            normal: {
	              areaColor: "red",
	              borderColor: "#BCC5EA",
	              borderWidth: 0,
	              shadowColor: "#fff",
	              shadowBlur: 0
	            }
	          },
	          zoom: 1.2
	        },
	        series: [{
	          type: "map",
	          map: "百色市",
	          geoIndex: 1,
	          aspectScale: 0.75,
	          zoom: 1.2,
	          label: {
	            normal: {
	              show: true,
	              textStyle: {
	                color: "#fff",
	                fontSize: 18
	              }
	            },
	            emphasis: {
	              textStyle: {
	                color: "#fff",
	                fontSize: 18
	              }
	            }
	          },
	          roam: false,
	          itemStyle: {
	            normal: {
	              areaColor: "#328DDF",
	              borderColor: "#BCC5EA",
	              borderWidth: 1
	            },
	            emphasis: {
	              areaColor: "#66b616",
	              borderColor: "#f1c22f"
	            }
	          },
	          data: data
	        }, {
	          name: "产品图片",
	          type: "scatter",
	          coordinateSystem: "geo3D",
	          label: {
	            normal: {
	              show: true,
	              formatter: function formatter(params) {
	                var val = params.data.value[2];
	                if (val === 10) {
	                  return "{a|}";
	                }
	                if (val === 20) {
	                  return "{b|}";
	                }
	                if (val === 30) {
	                  return "{c|}";
	                }
	              },
	              rich: {
	                a: {
	                  backgroundColor: {
	                    image: "https://s2.ax1x.com/2019/05/20/Extm4S.png"
	                  },
	                  width: 60,
	                  height: 60
	                },
	                b: {
	                  backgroundColor: {
	                    image: "https://s2.ax1x.com/2019/05/21/Ez0z0H.png"
	                  },
	                  width: 60,
	                  height: 60
	                },
	                c: {
	                  backgroundColor: {
	                    image: "https://s2.ax1x.com/2019/05/21/EzB9AA.png"
	                  },
	                  width: 60,
	                  height: 60
	                }
	              }
	            }
	          },
	          itemStyle: {
	            normal: {
	              color: "#1C3E64"
	            }
	          },
	          zlevel: 6,
	          data: convertData(data)
	        }]
	      };
	      self.myChart.setOption(option);
	      // 切换具体的子地图
	      self.myChart.on("click", function (params) {
	        var name = params.name;
	
	        if (name === '田阳县') {
	          self.$router.push("/secondMap?areaName=" + name);
	        }
	      });
	      var index = 2;
	      setInterval(function () {
	        self.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        // index++;
	        // if (index >= data.length) {
	        //   index = 0;
	        // }
	      }, 3000);
	    });
	  },
	  methods: {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _monitorIcon = __webpack_require__(574);
	
	var _monitorIcon2 = _interopRequireDefault(_monitorIcon);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _amap = __webpack_require__(139);
	
	var _amap2 = _interopRequireDefault(_amap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_amap2.default); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_amap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.DistrictSearch', 'AMap.Polygon'],
	  uiVersion: '1.0.11',
	  v: '1.4.15'
	});
	var opts = { subdistrict: 0, extensions: 'all' };
	var colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
	var markers = [{ point: [106.592535429688, 23.4990334296876], content: '文本内容1文本内容1文本内容1', title: '标题1' }, { point: [107.003172636719, 23.6282497382813], content: '文本内容2文本内容2文本内容2', title: '标题2' }, { point: [107.03298953125, 23.875044171875], content: '文本内容3文本内容3文本内容3', title: '标题3' }];
	var geoCoordMap = {
	  '右江区': [106.6189648699, 23.9011510432],
	  '靖西市': [106.4176986464, 23.1340325224],
	  '田阳县': [106.9156629745, 23.7356699750],
	  '田东县': [107.1260862186, 23.5972525589],
	  '平果县': [107.5898772387, 23.3293469441],
	  '德保县': [106.6154958178, 23.3234056946],
	  '那坡县': [105.8335036062, 23.3871180613],
	  '凌云县': [106.5615967920, 24.3475183354],
	  '乐业县': [106.5616359496, 24.7858389344],
	  '田林县': [106.2285227061, 24.2943864015],
	  '西林县': [105.0938229983, 24.4895710923],
	  '隆林县': [105.3438807417, 24.7706591482]
	};
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {},
	      id: 'map-' + Date.now(),
	      map: null,
	      district: null,
	      districtExplorer: null,
	      cityAdcode: '',
	      cityName: '百色市',
	      ifSatellite: true
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    this.initMap();
	    // setTimeout(this.initMap, 500);
	  },
	  methods: {
	    initMap: function initMap() {
	      var _this = this;
	
	      _amap.lazyAMapApiLoaderInstance.load().then((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.district = new AMap.DistrictSearch(opts);
	                _context.next = 3;
	                return _this.renderCity();
	
	              case 3:
	                _context.next = 5;
	                return _this.createDistrictExplorer();
	
	              case 5:
	                _this.renderDistrict();
	                _context.next = 8;
	                return _this.createText();
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      })));
	    },
	    renderCity: function renderCity() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	        _this2.district.search(_this2.cityName, function (status, result) {
	          _this2.cityAdcode = result.districtList[0].adcode;
	          var bounds = result.districtList[0].boundaries;
	          var mask = [];
	          for (var i = 0; i < bounds.length; i += 1) {
	            mask.push([bounds[i]]);
	          }
	          _this2.map = new AMap.Map(_this2.id, {
	            mask: mask,
	            viewMode: '3D',
	            zoom: 8,
	            cursor: 'pointer',
	            center: new AMap.LngLat(106.2285227061, 24.0943864015),
	            layers: [new AMap.TileLayer.Satellite()]
	          });
	          resolve();
	        });
	      });
	    },
	    handleMarkerClick: function handleMarkerClick(marker) {
	      var _this3 = this;
	
	      return function () {
	        var extData = marker.getExtData();
	        var infoWindow = new AMap.InfoWindow({
	          content: '<div>title:' + extData.title + '<br/>content:' + extData.content + '</div>',
	          offset: new AMap.Pixel(0, -35)
	        });
	        infoWindow.open(_this3.map, marker.getPosition());
	      };
	    },
	    renderMarkers: function renderMarkers() {
	      for (var i in markers) {
	        var icon = new AMap.Icon({
	          size: new AMap.Size(30, 30),
	          imageSize: new AMap.Size(30, 30),
	          image: _monitorIcon2.default
	        });
	        var marker = new AMap.Marker({
	          position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
	          cursor: 'pointer',
	          icon: icon,
	          extData: markers[i]
	        });
	        marker.on('click', this.handleMarkerClick(marker));
	        this.map.add(marker);
	      }
	    },
	    createDistrictExplorer: function createDistrictExplorer() {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve) {
	        AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], function (DistrictExplorer, $) {
	          _this4.districtExplorer = new DistrictExplorer({ eventSupport: true, map: _this4.map });
	          resolve();
	        });
	      });
	    },
	    renderDistrict: function renderDistrict() {
	      var _this5 = this;
	
	      var that = this;
	      return new _promise2.default(function (resolve) {
	        _this5.districtExplorer.loadAreaNode(_this5.cityAdcode, function (error, areaNode) {
	          console.log(error);
	          _this5.districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
	            var fillColor = colors[i % colors.length]; // 填充色
	            var strokeColor = colors[colors.length - 1 - i % colors.length]; // 边框色
	            resolve();
	            return {
	              cursor: 'default',
	              bubble: true,
	              strokeColor: strokeColor, // 线颜色
	              strokeOpacity: 1, // 线透明度
	              strokeWeight: 1, // 线宽
	              fillColor: fillColor, // 填充色
	              fillOpacity: 0.1 // 填充透明度
	            };
	          });
	          _this5.districtExplorer.on('featureClick', function (e, feature) {
	            that.$router.push('/secondMap?areaName=' + feature.properties.name);
	          });
	        });
	      });
	    },
	    createText: function createText() {
	      // 创建纯文本标记
	      for (var i in geoCoordMap) {
	        var text = new AMap.Text({
	          text: i,
	          anchor: 'center', // 设置文本标记锚点
	          draggable: true,
	          cursor: 'pointer',
	          angle: 10,
	          style: {
	            'padding': '10px 5px',
	            'background-color': 'transparent',
	            'width': '80px',
	            'border': 'none',
	            'text-align': 'center',
	            'font-size': '16px',
	            'color': '#fff'
	          },
	          position: geoCoordMap[i]
	        });
	        text.setMap(this.map);
	      }
	    }
	  }
	};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart2: {},
	      name: '农安信用数据构成',
	      circleBarData: [{ value: 19.05, name: '质量安全评估信息' }, { value: 4.76, name: '其他信息' }, { value: 14.29, name: '奖励信息' }, { value: 9.52, name: '监督检查信息' }, { value: 14.29, name: '认证(登记)信息' }, { value: 14.28, name: '行政处罚' }, { value: 19.05, name: '行政许可信息' }, { value: 9.52, name: '基础信息' }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart2 = _echarts2.default.init(document.querySelector('.circleBar .main'));
	    this.myChart2.setOption({
	      tooltip: {
	        show: false
	      },
	      legend: {
	        show: false
	      },
	      color: this.color,
	      series: [{
	        type: 'pie',
	        selectedMode: 'single',
	        radius: [0, '40%'],
	        label: {
	          normal: {
	            show: false,
	            position: 'inner',
	            formatter: '{d}%',
	            textStyle: {
	              color: '#fff',
	              fontWeight: 'normal',
	              fontSize: 20
	            }
	          }
	        },
	        labelLine: {
	          normal: {
	            show: false
	          }
	        },
	        data: this.circleBarData
	      }, {
	        type: 'pie',
	        radius: ['50%', '55%'],
	        label: {
	          normal: {
	            formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
	            rich: {
	              b: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'left',
	                padding: 4
	              },
	              hr: {
	                borderColor: '#12EABE',
	                width: '100%',
	                borderWidth: 2,
	                height: 0
	              },
	              d: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'left',
	                padding: 4
	              },
	              c: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'center',
	                padding: 4
	              }
	            }
	          }
	        },
	        labelLine: {
	          normal: {
	            show: true,
	            length: 20,
	            length2: 20
	          }
	        },
	        data: this.circleBarData
	      }]
	    });
	  }
	};

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '农安信用评估模型',
	      circleBarData: [{ value: 19.05, name: '质量安全评估信息' }, { value: 4.76, name: '其他信息' }, { value: 14.29, name: '奖励信息' }, { value: 9.52, name: '监督检查信息' }, { value: 14.29, name: '认证(登记)信息' }, { value: 14.28, name: '行政处罚' }, { value: 19.05, name: '行政许可信息' }, { value: 9.52, name: '基础信息' }],
	      data: [
	        // { name: '田阳农副产品综合批发市场', num: 889 },
	        // { name: '广西田阳县果发果蔬种植专业合作社', num: 856 },
	        // { name: '田阳县农村商业银行(三雷支行)', num: 844 },
	        // { name: '田阳县田州镇供销合作社化肥农药店', num: 829 },
	        // { name: '田阳县鲜达康果蔬专业合作社', num: 798 },
	        // { name: '家家乐果蔬专业合作社', num: 788 }
	        //   // { name: '广西田阳农村商业银行(牌楼支行)', num: 410 },
	        //   // { name: '田美火龙果种植专业合作社', num: 330 },
	        //   // { name: '田阳县龙友百香果种植专业合作社', num: 310 },
	        //   // { name: '田阳县福桂香蕉种植专业合作社', num: 270 }
	      ],
	      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#fff'],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.circleBar .main'));
	    this.myChart.setOption({
	      tooltip: {
	        show: false
	      },
	      legend: {
	        show: false
	      },
	      color: this.color,
	      series: [{
	        type: 'pie',
	        selectedMode: 'single',
	        radius: [0, '40%'],
	        label: {
	          normal: {
	            show: false,
	            position: 'inner',
	            formatter: '{d}%',
	            textStyle: {
	              color: '#fff',
	              fontWeight: 'normal',
	              fontSize: 20
	            }
	          }
	        },
	        labelLine: {
	          normal: {
	            show: false
	          }
	        },
	        data: this.circleBarData
	      }, {
	        type: 'pie',
	        radius: ['50%', '55%'],
	        label: {
	          normal: {
	            formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
	            rich: {
	              b: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'left',
	                padding: 4
	              },
	              hr: {
	                borderColor: '#12EABE',
	                width: '100%',
	                borderWidth: 2,
	                height: 0
	              },
	              d: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'left',
	                padding: 4
	              },
	              c: {
	                fontSize: 14,
	                color: '#fff',
	                align: 'center',
	                padding: 4
	              }
	            }
	          }
	        },
	        labelLine: {
	          normal: {
	            show: true,
	            length: 20,
	            length2: 20
	          }
	        },
	        data: this.circleBarData
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '扶贫情况',
	      circleData: [{ name: '贫困户总数', value: '20012' }, { name: '产业扶贫金额', value: '1028472' }, { name: '未脱贫户数', value: '16002' }, { name: '电商扶贫金额', value: '2013210' }, { name: '已脱贫户数', value: '4010' }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 650 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(206);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var geoCoordMap = {
	  "海门": [121.15, 31.89],
	  "鄂尔多斯": [109.781327, 39.608266],
	  "招远": [120.38, 37.35],
	  "舟山": [122.207216, 29.985295],
	  "齐齐哈尔": [123.97, 47.33],
	  "盐城": [120.13, 33.38],
	  "赤峰": [118.87, 42.28],
	  "青岛": [120.33, 36.07],
	  "乳山": [121.52, 36.89],
	  "金昌": [102.188043, 38.520089],
	  "泉州": [118.58, 24.93],
	  "莱西": [120.53, 36.86],
	  "日照": [119.46, 35.42],
	  "胶南": [119.97, 35.88],
	  "南通": [121.05, 32.08],
	  "拉萨": [91.11, 29.97],
	  "云浮": [112.02, 22.93],
	  "梅州": [116.1, 24.55],
	  "文登": [122.05, 37.2],
	  "上海": [121.48, 31.22],
	  "攀枝花": [101.718637, 26.582347],
	  "威海": [122.1, 37.5],
	  "承德": [117.93, 40.97],
	  "厦门": [118.1, 24.46],
	  "汕尾": [115.375279, 22.786211],
	  "潮州": [116.63, 23.68],
	  "丹东": [124.37, 40.13],
	  "太仓": [121.1, 31.45],
	  "曲靖": [103.79, 25.51],
	  "烟台": [121.39, 37.52],
	  "福州": [119.3, 26.08],
	  "瓦房店": [121.979603, 39.627114],
	  "即墨": [120.45, 36.38],
	  "抚顺": [123.97, 41.97],
	  "玉溪": [102.52, 24.35],
	  "张家口": [114.87, 40.82],
	  "阳泉": [113.57, 37.85],
	  "莱州": [119.942327, 37.177017],
	  "湖州": [120.1, 30.86],
	  "汕头": [116.69, 23.39],
	  "昆山": [120.95, 31.39],
	  "宁波": [121.56, 29.86],
	  "湛江": [110.359377, 21.270708],
	  "揭阳": [116.35, 23.55],
	  "荣成": [122.41, 37.16],
	  "连云港": [119.16, 34.59],
	  "葫芦岛": [120.836932, 40.711052],
	  "常熟": [120.74, 31.64],
	  "东莞": [113.75, 23.04],
	  "河源": [114.68, 23.73],
	  "淮安": [119.15, 33.5],
	  "泰州": [119.9, 32.49],
	  "南宁": [108.33, 22.84],
	  "营口": [122.18, 40.65],
	  "惠州": [114.4, 23.09],
	  "江阴": [120.26, 31.91],
	  "蓬莱": [120.75, 37.8],
	  "韶关": [113.62, 24.84],
	  "嘉峪关": [98.289152, 39.77313],
	  "广州": [113.23, 23.16],
	  "延安": [109.47, 36.6],
	  "太原": [112.53, 37.87],
	  "清远": [113.01, 23.7],
	  "中山": [113.38, 22.52],
	  "昆明": [102.73, 25.04],
	  "寿光": [118.73, 36.86],
	  "盘锦": [122.070714, 41.119997],
	  "长治": [113.08, 36.18],
	  "深圳": [114.07, 22.62],
	  "珠海": [113.52, 22.3],
	  "宿迁": [118.3, 33.96],
	  "咸阳": [108.72, 34.36],
	  "铜川": [109.11, 35.09],
	  "平度": [119.97, 36.77],
	  "佛山": [113.11, 23.05],
	  "海口": [110.35, 20.02],
	  "江门": [113.06, 22.61],
	  "章丘": [117.53, 36.72],
	  "肇庆": [112.44, 23.05],
	  "大连": [121.62, 38.92],
	  "临汾": [111.5, 36.08],
	  "吴江": [120.63, 31.16],
	  "石嘴山": [106.39, 39.04],
	  "沈阳": [123.38, 41.8],
	  "苏州": [120.62, 31.32],
	  "茂名": [110.88, 21.68],
	  "嘉兴": [120.76, 30.77],
	  "长春": [125.35, 43.88],
	  "胶州": [120.03336, 36.264622],
	  "银川": [106.27, 38.47],
	  "张家港": [120.555821, 31.875428],
	  "三门峡": [111.19, 34.76],
	  "锦州": [121.15, 41.13],
	  "南昌": [115.89, 28.68],
	  "柳州": [109.4, 24.33],
	  "三亚": [109.511909, 18.252847],
	  "自贡": [104.778442, 29.33903],
	  "吉林": [126.57, 43.87],
	  "阳江": [111.95, 21.85],
	  "泸州": [105.39, 28.91],
	  "西宁": [101.74, 36.56],
	  "宜宾": [104.56, 29.77],
	  "呼和浩特": [111.65, 40.82],
	  "成都": [104.06, 30.67],
	  "大同": [113.3, 40.12],
	  "镇江": [119.44, 32.2],
	  "桂林": [110.28, 25.29],
	  "张家界": [110.479191, 29.117096],
	  "宜兴": [119.82, 31.36],
	  "北海": [109.12, 21.49],
	  "西安": [108.95, 34.27],
	  "金坛": [119.56, 31.74],
	  "东营": [118.49, 37.46],
	  "牡丹江": [129.58, 44.6],
	  "遵义": [106.9, 27.7],
	  "绍兴": [120.58, 30.01],
	  "扬州": [119.42, 32.39],
	  "常州": [119.95, 31.79],
	  "潍坊": [119.1, 36.62],
	  "重庆": [106.54, 29.59],
	  "台州": [121.420757, 28.656386],
	  "南京": [118.78, 32.04],
	  "滨州": [118.03, 37.36],
	  "贵阳": [106.71, 26.57],
	  "无锡": [120.29, 31.59],
	  "本溪": [123.73, 41.3],
	  "克拉玛依": [84.77, 45.59],
	  "渭南": [109.5, 34.52],
	  "马鞍山": [118.48, 31.56],
	  "宝鸡": [107.15, 34.38],
	  "焦作": [113.21, 35.24],
	  "句容": [119.16, 31.95],
	  "北京": [116.46, 39.92],
	  "徐州": [117.2, 34.26],
	  "衡水": [115.72, 37.72],
	  "包头": [110, 40.58],
	  "绵阳": [104.73, 31.48],
	  "乌鲁木齐": [87.68, 43.77],
	  "枣庄": [117.57, 34.86],
	  "杭州": [120.19, 30.26],
	  "淄博": [118.05, 36.78],
	  "鞍山": [122.85, 41.12],
	  "溧阳": [119.48, 31.43],
	  "库尔勒": [86.06, 41.68],
	  "安阳": [114.35, 36.1],
	  "开封": [114.35, 34.79],
	  "济南": [117, 36.65],
	  "德阳": [104.37, 31.13],
	  "温州": [120.65, 28.01],
	  "九江": [115.97, 29.71],
	  "邯郸": [114.47, 36.6],
	  "临安": [119.72, 30.23],
	  "兰州": [103.73, 36.03],
	  "沧州": [116.83, 38.33],
	  "临沂": [118.35, 35.05],
	  "南充": [106.110698, 30.837793],
	  "天津": [117.2, 39.13],
	  "富阳": [119.95, 30.07],
	  "泰安": [117.13, 36.18],
	  "诸暨": [120.23, 29.71],
	  "郑州": [113.65, 34.76],
	  "哈尔滨": [126.63, 45.75],
	  "聊城": [115.97, 36.45],
	  "芜湖": [118.38, 31.33],
	  "唐山": [118.02, 39.63],
	  "平顶山": [113.29, 33.75],
	  "邢台": [114.48, 37.05],
	  "德州": [116.29, 37.45],
	  "济宁": [116.59, 35.38],
	  "荆州": [112.239741, 30.335165],
	  "宜昌": [111.3, 30.7],
	  "义乌": [120.06, 29.32],
	  "丽水": [119.92, 28.45],
	  "洛阳": [112.44, 34.7],
	  "秦皇岛": [119.57, 39.95],
	  "株洲": [113.16, 27.83],
	  "石家庄": [114.48, 38.03],
	  "莱芜": [117.67, 36.19],
	  "常德": [111.69, 29.05],
	  "保定": [115.48, 38.85],
	  "湘潭": [112.91, 27.87],
	  "金华": [119.64, 29.12],
	  "岳阳": [113.09, 29.37],
	  "长沙": [113, 28.21],
	  "衢州": [118.88, 28.97],
	  "廊坊": [116.7, 39.53],
	  "菏泽": [115.480656, 35.23375],
	  "合肥": [117.27, 31.86],
	  "武汉": [114.31, 30.52],
	  "大庆": [125.03, 46.58],
	  "林芝地": [94.25, 29.59],
	  "果洛藏族自治": [97.42, 34.81],
	  "闵行": [121.23, 31.07],
	  "普洱": [100.9662264708, 22.8252001070],
	  "百色": [106.6183748699, 23.9021610432],
	  "那曲地": [92.1, 31.47]
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var XNData = [
	  // [{ name: '百色' }, { name: '广州', value: 35252 }],
	  // [{ name: '百色' }, { name: '北京', value: 32674 }],
	  // [{ name: '百色' }, { name: '上海', value: 32234 }],
	  // [{ name: '百色' }, { name: '杭州', value: 24834 }],
	  // [{ name: '百色' }, { name: '苏州', value: 20134 }],
	  // [{ name: '百色' }, { name: '西安', value: 14365 }],
	  // [{ name: '百色' }, { name: '厦门', value: 11543 }],
	  // [{ name: '百色' }, { name: '长沙', value: 10789 }],
	  // [{ name: '百色' }, { name: '南昌', value: 10103 }]
	];
	
	var planePath = 'arrow';
	
	var convertData = function convertData(data) {
	  var res = [];
	  for (var i = 0; i < data.length; i++) {
	    var dataItem = data[i];
	
	    var fromCoord = geoCoordMap[dataItem[0].name];
	    var toCoord = geoCoordMap[dataItem[1].name];
	    if (fromCoord && toCoord) {
	      res.push({
	        fromName: dataItem[0].name,
	        toName: dataItem[1].name,
	        coords: [fromCoord, toCoord],
	        value: dataItem[1].value
	      });
	    }
	  }
	  return res;
	};
	
	var color = ['#a6c84c', '#ffa022', '#46bee9']; // 航线的颜色
	var series = [];
	[['百色', XNData]].forEach(function (item, i) {
	  series.push({
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 1,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0.7,
	      color: 'red', // arrow箭头的颜色
	      symbolSize: 3
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 0,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 3,
	    symbol: ['none', 'arrow'],
	    symbolSize: 10,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0,
	      symbol: planePath,
	      symbolSize: 15
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 1,
	        opacity: 0.6,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'effectScatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      brushType: 'stroke'
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        formatter: '{b}'
	      }
	    },
	    symbolSize: function symbolSize(val) {
	      return 10;
	    },
	    itemStyle: {
	      normal: {
	        color: color[i]
	      },
	      emphasis: {
	        areaColor: '#2B91B7'
	      }
	    },
	    data: item[1].map(function (dataItem) {
	      return {
	        name: dataItem[1].name,
	        value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
	      };
	    })
	  },
	  // 被攻击点
	  {
	    type: 'scatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      period: 4,
	      brushType: 'stroke',
	      scale: 4
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        color: '#0f0',
	        formatter: '{b}',
	        textStyle: {
	          color: "#0f0"
	        }
	      },
	      emphasis: {
	        show: true,
	        color: "#f60"
	      }
	    },
	    symbol: 'path://M512 39.384615l169.353846 295.384615 342.646154 63.015385-240.246154 248.123077L827.076923 984.615385l-315.076923-145.723077L196.923077 984.615385l43.323077-334.769231L0 401.723077l342.646154-63.015385L512 39.384615',
	    symbolSize: 20,
	    data: [{
	      name: item[0],
	      value: geoCoordMap[item[0]].concat([10])
	    }]
	  });
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '农产品流通数据'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    resizeFunc: function resizeFunc() {
	      this.myChart.resize();
	    },
	    init: function init() {
	      var resizeFunc = this.resizeFunc;
	      window.addEventListener('resize', resizeFunc);
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.flow .main'));
	    this.myChart.setOption({
	      tooltip: {
	        show: false
	      },
	      legend: {
	        orient: 'vertical',
	        left: 'left',
	        data: ['广州', '深圳', '上海'],
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      geo: {
	        map: 'china',
	        roam: true,
	        itemStyle: {
	          normal: {
	            areaColor: '#3A64C8',
	            borderColor: '#195BB9',
	            borderWidth: 1
	          },
	          emphasis: {
	            areaColor: '#2B91B7'
	          }
	        }
	      },
	      series: series
	    });
	    this.init();
	  },
	  destroyed: function destroyed() {
	    var resizeFunc = this.resizeFunc;
	    window.removeEventListener('resize', resizeFunc);
	  }
	};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _pro = __webpack_require__(569);
	
	var _pro2 = _interopRequireDefault(_pro);
	
	var _pro3 = __webpack_require__(570);
	
	var _pro4 = _interopRequireDefault(_pro3);
	
	var _pro5 = __webpack_require__(571);
	
	var _pro6 = _interopRequireDefault(_pro5);
	
	var _pro7 = __webpack_require__(572);
	
	var _pro8 = _interopRequireDefault(_pro7);
	
	var _pro9 = __webpack_require__(573);
	
	var _pro10 = _interopRequireDefault(_pro9);
	
	var _pro11 = __webpack_require__(1653);
	
	var _pro12 = _interopRequireDefault(_pro11);
	
	var _pro13 = __webpack_require__(1654);
	
	var _pro14 = _interopRequireDefault(_pro13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// require('../../../video/swfobject');
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	window.devid = null;
	window.self2 = null;
	window.screenNum = '1';
	window.setClickCallback2 = function (index) {
	  for (var i = 0; i < parseInt(window.screenNum); i++) {
	    document.getElementById('WebAPI3').setWindowSelected(false, i);
	  }
	  document.getElementById('WebAPI3').setWindowSelected(true, index);
	  window.devid = document.getElementById('WebAPI3').getSelectedDevId();
	  if (window.devid > 0) {
	    // window.self2.sendCommand(1000);
	  } else {
	      // window.self2.$emit('setPTZ', false);
	    }
	};
	window.self1 = null;
	
	exports.default = {
	  data: function data() {
	    return {
	      contentStyle: {
	        height: '204px',
	        width: '180px'
	      },
	      name: 'IOT智能监测',
	      imgList1: [{ name: '百色芒果园', src: _pro12.default
	        // { name: '圣女果', src: pro2 }
	      }],
	      imgList2: [{ name: '牛心李', src: _pro14.default
	        // { name: '圣女果', src: pro4 }
	      }],
	      swiperOption: {
	        slidesPerView: 1,
	        notNextTick: true,
	        loop: true,
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next0',
	          prevEl: '.swiper-button-prev0'
	        },
	        speed: 800,
	        direction: "horizontal"
	      },
	      swiperOption1: {
	        slidesPerView: 1,
	        notNextTick: true,
	        loop: true,
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next1',
	          prevEl: '.swiper-button-prev1'
	        },
	        speed: 800,
	        direction: "horizontal"
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.onload();
	  },
	
	  methods: {
	    setCamera: function setCamera(deviceName) {
	      // 设置设备名称大于12个字符显示省略号
	      return deviceName.length > 12 ? deviceName.substring(0, 11) + '...' : deviceName;
	    },
	    init: function init() {
	      // 初始化视频
	      var deviceList = [{
	        deviceName: '河凤桥乡赵棚村',
	        deviceCode: '17967'
	      }];
	      for (var i = 0; i < 1; i++) {
	        document.getElementById('WebAPI3').setClickCallback('setClickCallback2', i, i);
	        document.getElementById('WebAPI3').playVideo('rtmp://dev.svideo.com.cn/myapp', deviceList[i].deviceCode, this.setCamera(deviceList[i].deviceName));
	      }
	    },
	    rvalue: function rvalue() {
	      var pageHost = document.location.protocol === 'https:' ? 'https://' : 'http://';
	      var imgv = '<img src=\'' + pageHost + 'www.adobe.com/images/shared/download_buttons/get_flash_player.gif\' alt=\'Get Adobe Flash player\' />';
	      return '<a href=\'http://www.adobe.com/go/getflashplayer\'>' + imgv + '</a>';
	    },
	
	    // 初始化flas
	    onload: function onload() {
	      window.self1 = this;
	      var isFlashInstalled = navigator.plugins && navigator.plugins['Shockwave Flash'] || window.ActiveXObject && !!new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash');
	      var vhtml = document.getElementById('tablevideo');
	      var ip = '';
	      console.log(navigator);
	      console.log(isFlashInstalled);
	      if (isFlashInstalled) {
	        vhtml.innerHTML = "<div id='flashContent'>" + '<p>' + 'To view this page ensure that Adobe Flash Player version ' + '11.1.0 or greater is installed. ' + '</p>' + this.rvalue() + '</div>' + '<noscript>' + "<object classid='clsid:D27CDB6E-AE6D-11cf-96B8-444553540000' width='100%' height='100%' id='WebAPI3'>" + "<param name='movie' value='" + ip + "/src/WebAPI5.swf' />" + "<param name='quality' value='high' />" + "<param name='bgcolor' value='#ffffff' />" + "<param name='allowScriptAccess' value='always' />" + "<param name='allowFullScreen' value='true' />" + "<param name='allowNetworking' value='all'>" + '<!--[if !IE]>-->' + "<object type='application/x-shockwave-flash' data='" + ip + "/src/WebAPI5.swf' width='100%' height='100%'>" + "<param name='quality' value='high' />" + "<param name='bgcolor' value='#ffffff' />" + "<param name='allowScriptAccess' value='always' />" + "<param name='allowFullScreen' value='true' />" + "<param name='allowNetworking' value='all'>" + '<!--<![endif]-->' + '<!--[if gte IE 6]>-->' + '<p> ' + 'Either scripts and active content are not permitted to run or Adobe Flash Player version' + '11.1.0 or greater is not installed.' + '</p>' + '<!--<![endif]-->' + "<a href='http://www.adobe.com/go/getflashplayer'>" + "<img src='http://www.adobe.com/images/shared/download_buttons/get_flash_player.gif' alt='Get Adobe Flash Player' />" + '</a>' + '<!--[if !IE]>-->' + '</object>' + '<!--<![endif]-->' + '</object>' + '</noscript>';
	        // For version detection, set to min. required Flash Player version, or 0 (or 0.0.0), for no version detection.
	        var swfVersionStr = '11.1.0';
	        // To use express install, set to playerProductInstall.swf, otherwise the empty string.
	        var xiSwfUrlStr = ip + '/playerProductInstall.swf';
	        var flashvars = {};
	        flashvars.initcompletecb = function () {
	          setTimeout(function () {
	            window.self1.init();
	          }, 5);
	        };
	        flashvars.screenNum = 1;
	        var params = {};
	        params.quality = 'high';
	        params.bgcolor = '#ffffff';
	        params.allowscriptaccess = 'always';
	        params.allowfullscreen = 'true';
	        var attributes = {};
	        attributes.id = 'WebAPI3';
	        attributes.name = 'WebAPI3';
	        attributes.align = 'middle';
	        window.swfobject.embedSWF(ip + '/src/WebAPI5.swf', 'flashContent', '100%', '100%', swfVersionStr, xiSwfUrlStr, flashvars, params, attributes);
	        // JavaScript enabled so display the flashContent div in case it is not replaced with a swf object.
	        window.swfobject.createCSS('#flashContent', 'display:block;text-align:left;');
	      }
	    }
	  }
	};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	
	exports.default = {
	  name: 'ParticlesJS',
	  mounted: function mounted() {
	    // require('particles.js')
	    // this.$nextTick(() => {
	    //   this.initParticlesJS()
	    // })
	  },
	
	
	  methods: {
	    initParticlesJS: function initParticlesJS() {
	      /* eslint-disable */
	      particlesJS('particles-js', {
	
	        "particles": {
	          "number": {
	            "value": 40,
	            "density": {
	              "enable": true,
	              "value_area": 460
	            }
	          },
	          "color": {
	            "value": "#fff"
	          },
	          "shape": {
	            "type": "circle",
	            "stroke": {
	              "width": 0.2,
	              "color": "#fff"
	            },
	            "polygon": {
	              "nb_sides": 5
	            },
	            "image": {
	              "src": "img/github.svg",
	              "width": 1000,
	              "height": 1000
	            }
	          },
	          "opacity": {
	            "value": .3,
	            "random": false,
	            "anim": {
	              "enable": false,
	              "speed": 1,
	              "opacity_min": 0.1,
	              "sync": false
	            }
	          },
	          "size": {
	            "value": 4,
	            "random": true,
	            "anim": {
	              "enable": false,
	              "speed": 2,
	              "size_min": 0.1,
	              "sync": false
	            }
	          },
	          "line_linked": {
	            "enable": true,
	            "distance": 100,
	            "color": "#fff",
	            "opacity": 0.745114691578601,
	            "width": 0.6409588744762158
	          },
	          "move": {
	            "enable": true,
	            "speed": 1.409588744762158,
	            "direction": "none",
	            "random": false,
	            "straight": false,
	            "out_mode": "out",
	            "bounce": false,
	            "attract": {
	              "enable": false,
	              "rotateX": 600,
	              "rotateY": 1200
	            }
	          }
	        },
	        "interactivity": {
	          "detect_on": "canvas",
	          "events": {
	            "onhover": {
	              "enable": true,
	              "mode": "repulse"
	            },
	            "onclick": {
	              "enable": true,
	              "mode": "push"
	            },
	            "resize": true
	          },
	          "modes": {
	            "grab": {
	              "distance": 400,
	              "line_linked": {
	                "opacity": 1
	              }
	            },
	            "bubble": {
	              "distance": 400,
	              "size": 40,
	              "duration": 2,
	              "opacity": 8,
	              "speed": 3
	            },
	            "repulse": {
	              "distance": 200,
	              "duration": 0.4
	            },
	            "push": {
	              "particles_nb": 4
	            },
	            "remove": {
	              "particles_nb": 2
	            }
	          }
	        },
	        "retina_detect": false
	
	      });
	    }
	  }
	
	};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '新型农业经营主体',
	      chartData: [{ value: 116, name: '龙头企业' }, { value: 4064, name: '农民合作社' }, { value: 549, name: '家庭农场' }, { value: 1849, name: '农资店' }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      legend: [{
	        orient: 'vertical',
	        // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	        left: '10',
	        top: '20',
	        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }, {
	        orient: 'vertical',
	        icon: "none",
	        left: '86',
	        top: '20',
	        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
	        formatter: function formatter(name) {
	          var oa = data;
	          var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value;
	          for (var i = 0; i < data.length; i++) {
	            if (name === oa[i].name) {
	              return oa[i].value;
	            }
	          }
	        },
	        textStyle: {
	          color: '#fff',
	          padding: [2, 0, 0, 0, 0]
	        }
	      }],
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['70%', '50%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '支柱产业市场分析',
	      tableData: [{ name: '百色芒果', scale: '120.16万亩', output: '35.02亿', production: '672900吨', listed: '夏季' }, { name: '百色番茄', scale: '24.25万亩', output: '9.5亿', production: '850000吨', listed: '全年' }, { name: '田东香芒', scale: '23万亩', output: '7.6亿', production: '58000吨', listed: '夏季' }, { name: '凌云牛心李', scale: '5万亩', output: '2.4亿', production: '60000吨', listed: '秋季' }, { name: '德保山楂', scale: '8万亩', output: '1.8亿', production: '45000吨', listed: '夏季' }, { name: '西林沙塘桔', scale: '16.6万亩', output: '12亿', production: '400000吨', listed: '秋季' }, { name: '田阳香芒', scale: '39.7万亩', output: '11.3亿', production: '236000吨', listed: '夏季' }, { name: '平果火龙果', scale: '2.3万亩', output: '8亿', production: '8000吨', listed: '夏季' }, { name: '隆林板栗', scale: '13.78万亩', output: '0.28亿', production: '4000吨', listed: '秋季' }, { name: '凌云白毫茶', scale: '12.6万亩', output: '4.51亿', production: '5412吨', listed: '春季' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '电商扶贫产品分析',
	      listData: [{ name: '芒果', total: 83452, mount: 3558, price: 6.232 }, { name: '沃柑', total: 73452, mount: 2558, price: 2.232 }, { name: '圣女果', total: 63452, mount: 4558, price: 3.232 }, { name: '火龙果', total: 53452, mount: 6558, price: 4.232 }, { name: '百香果', total: 43452, mount: 5558, price: 5.232 }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        // autoplay: false,
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    changeClassName: function changeClassName(index) {
	      if (index % 2 === 0) {
	        return 'top';
	      } else {
	        return 'bottom';
	      }
	    },
	    changeTitClass: function changeTitClass(index) {
	      if (index % 2 === 0) {
	        return 'tit tit1';
	      } else {
	        return 'tit tit2';
	      }
	    },
	    changeListClass: function changeListClass(index) {
	      if (index % 2 === 0) {
	        return 'list';
	      } else {
	        return 'list reverse-list';
	      }
	    },
	    changeListItemClass: function changeListItemClass(index) {
	      if (index % 2 === 0) {
	        return 'list-item';
	      } else {
	        return 'list-item reverse';
	      }
	    }
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: "各地区电商帮扶总额排行",
	      listData: [{ name: "田州镇", val: "5313309元" }, { name: "坡洪镇", val: "4762707元" }, { name: "那坡镇", val: "4349740元" }, { name: "五村镇", val: "3386202元" }, { name: "头塘镇", val: "3110901元" }, { name: "洞靖镇", val: "2092287元" }, { name: "百育镇", val: "2009696元" }, { name: "那满镇", val: "1156264元" }, { name: "玉凤镇", val: "853433元" }, { name: "巴别乡", val: "495541元" }],
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"],
	      lengthList: [300, 285, 255, 230, 200, 180, 160, 150, 140, 130],
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  computed: {},
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return "background:" + this.colorList[index];
	      } else {
	        return "background:" + this.colorList[3];
	      }
	    },
	    changeLength: function changeLength(index) {
	      return "width:" + this.lengthList[index] + "px";
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '电商扶贫产业排行'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.bars .main'));
	    this.myChart.setOption({
	      xAxis: {
	        grid: {
	          top: 0
	        },
	        data: ['芒果', '沃柑', '圣女果', '牛心李', '火龙果', '百香果', '番茄'],
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          interval: 0,
	          color: '#77CAD8',
	          fontSize: 12
	        }
	      },
	      yAxis: {
	        nameTextStyle: {
	          color: '#77CAD8',
	          fontSize: 12
	        },
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          color: '#77CAD8',
	          fontSize: 12
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: '#0177d4'
	          }
	        }
	      },
	      series: [{
	        type: 'bar',
	        barWidth: 18,
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#C0E450'
	            }, {
	              offset: 0.8,
	              color: '#75CD2D'
	            }], false)
	          }
	        },
	        data: [135264, 54263, 25563, 28535, 27424, 16437, 12473]
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _twoBars = __webpack_require__(1756);
	
	var _twoBars2 = _interopRequireDefault(_twoBars);
	
	var _line = __webpack_require__(1753);
	
	var _line2 = _interopRequireDefault(_line);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  components: {
	    'v-two-bar': _twoBars2.default,
	    'v-line': _line2.default
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 660 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      data1: [630123, 730123, 830123],
	      data2: [20045023, 10045023, 9045023],
	      itemData1: 18335,
	      itemData2: 2352,
	      num: 0
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    // const that = this;
	    // setInterval(function () {
	    //   that.itemData1 = that.data1[that.num % 3]
	    //   that.itemData2 = that.data2[that.num % 3]
	    //   that.num++
	    // }, 5000)
	  }
	};

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _centerTop = __webpack_require__(1751);
	
	var _centerTop2 = _interopRequireDefault(_centerTop);
	
	var _centerMiddle = __webpack_require__(1750);
	
	var _centerMiddle2 = _interopRequireDefault(_centerMiddle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import centerMap from './centerMap';
	// import centerChildMap from './centerChildMap';
	// import centerBottom from './centerBottom'
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    child: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      areaName: ''
	    };
	  },
	
	  components: {
	    centerTop: _centerTop2.default,
	    centerMiddle: _centerMiddle2.default
	    // centerMap,
	    // centerChildMap,
	    // centerBottom
	  },
	  methods: {
	    // 点击地图上的区域进入区域地图
	    clickMap: function clickMap(areaName) {
	      this.areaName = areaName;
	      this.child = false;
	    },
	
	    // 判断是否点到子区域地图
	    clickChild: function clickChild() {
	      this.$emit('clickChild', true);
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line .main'));
	    this.myChart.setOption({
	      tooltip: {
	        trigger: 'axis'
	      },
	      legend: {
	        data: ['家庭人口', '帮扶金额'],
	        textStyle: {
	          color: "#fff"
	        }
	      },
	      grid: {
	        left: '3%',
	        right: '4%',
	        bottom: '3%',
	        containLabel: true
	      },
	      toolbox: {},
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['章*晨', '张*敏', '陈*飞', '陈*泳', '刘*明', '周*轮', '苏*曼', '李*万', '王*说', '顾*网'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      series: [{
	        name: '家庭人口',
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        stack: '总量',
	        itemStyle: {
	          normal: {
	            color: '#FF9E2C'
	          }
	        },
	        data: [2, 3, 2, 4, 3, 1, 3, 5, 2, 4]
	      }, {
	        name: '帮扶金额',
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        stack: '总量',
	        itemStyle: {
	          normal: {
	            color: '#31C2E2'
	          }
	        },
	        data: [2045, 1935, 1902, 1852, 1832, 1789, 1780, 1747, 1734, 1696]
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '电商企业带动贫困户分布'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie .main'));
	    var data = [{
	      value: 19.3,
	      name: '田州镇'
	    }, {
	      value: 11.3,
	      name: '头塘镇'
	    }, {
	      value: 7.6,
	      name: '洞靖镇'
	    }, {
	      value: 7.3,
	      name: '百育镇'
	    }, {
	      value: 4.2,
	      name: '那满镇'
	    }, {
	      value: 3.1,
	      name: '玉凤镇'
	    }, {
	      value: 12.3,
	      name: '五村镇'
	    }, {
	      value: 17.3,
	      name: '坡洪镇'
	    }, {
	      value: 15.8,
	      name: '那坡镇'
	    }, {
	      value: 1.8,
	      name: '巴别乡'
	    }];
	    this.myChart.setOption({
	      tooltip: {
	        trigger: 'item',
	        formatter: "{b} : {c} ({d}%)"
	      },
	
	      visualMap: {
	        show: false,
	        min: 500,
	        max: 600,
	        inRange: {
	          // colorLightness: [0, 1]
	        }
	      },
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: '50%',
	        center: ['50%', '50%'],
	        color: ['rgb(131,249,103)', '#FBFE27', '#FE5050', '#1DB7E5', '#00B9FE', '#E7BCF3', '#14D1B0', '#FBFE27', 'rgb(11,228,96)', '#FE5050'], // '#FBFE27','rgb(11,228,96)','#FE5050'
	        data: data.sort(function (a, b) {
	          return a.value - b.value;
	        }),
	        roseType: 'radius',
	        label: {
	          normal: {
	            formatter: ['{b|{b}}', '{c|{c}%}'].join('  '),
	            rich: {
	              c: {
	                color: 'rgb(241,246,104)',
	                fontSize: 14,
	                fontWeight: 'bold',
	                lineHeight: 10
	              },
	              b: {
	                color: 'rgb(98,137,169)',
	                fontSize: 15,
	                height: 40
	              }
	            }
	          }
	        },
	        labelLine: {
	          normal: {
	            lineStyle: {
	              color: 'rgb(98,137,169)'
	            },
	            smooth: 0.2,
	            length: 10,
	            length2: 20
	          }
	        },
	        itemStyle: {
	          normal: {
	            shadowColor: 'rgba(0, 0, 0, 0.8)',
	            shadowBlur: 50
	          }
	        }
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '电商扶贫企业',
	      tableData: [{ name: '广西百色翠丰特色农产品有限责任公司', input: '133500.58元' }, { name: '广西百色盛泰和农业有限公司', input: '803500.58元' }, { name: '广西田阳新靖田农产品贸易有限公司', input: '603500.58元' }, { name: '广西田阳古鼎香农产品综合批发市场有限公司', input: '703500.58元' }, { name: '广西田阳穗丰园农产品贸易有限公司', input: '903500.58元' }, { name: '广西田阳天穗农产品贸易有限公司', input: '303500.58元' }, { name: '田阳县蔬心特色农产品经营部', input: '233500.58元' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.twoBars .main'));
	    this.myChart.setOption({
	      // backgroundColor: '#00265f',
	      tooltip: {
	        trigger: 'axis',
	        axisPointer: {
	          type: 'shadow'
	        }
	      },
	      legend: {
	        data: ['采购总额', '帮扶金额'],
	        align: 'right',
	        right: 10,
	        textStyle: {
	          color: "#fff"
	        },
	        itemWidth: 10,
	        itemHeight: 10,
	        itemGap: 35
	      },
	      grid: {
	        left: '3%',
	        right: '4%',
	        bottom: '3%',
	        containLabel: true
	      },
	      xAxis: [{
	        type: 'category',
	        data: ['芒果', '沃柑', '圣女果', '牛心李', '火龙果', '百香果', '番茄'],
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          show: true,
	          interval: 0,
	          textStyle: {
	            color: "#00c7ff",
	            fontSize: 12
	          }
	        }
	      }],
	      yAxis: [{
	        type: 'value',
	        axisLabel: {
	          formatter: '{value}'
	        },
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: "#063374"
	          }
	        }
	      }],
	      series: [{
	        name: '采购总额',
	        type: 'bar',
	        data: [235304, 93584, 56823, 48398, 39875, 33415, 25436],
	        barWidth: 5, // 柱子宽度
	        barGap: 1, // 柱子之间间距
	        itemStyle: {
	          normal: {
	            color: '#FF9E2C',
	            barBorderRadius: 4,
	            opacity: 1
	          }
	        }
	      }, {
	        name: '帮扶金额',
	        type: 'bar',
	        data: [135264, 54263, 25563, 28535, 27424, 16437, 12473],
	        barWidth: 5,
	        barGap: 1,
	        itemStyle: {
	          normal: {
	            color: '#31C2E2',
	            barBorderRadius: 4,
	            opacity: 1
	          }
	        }
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '电商企业带动贫困户家庭分析'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.twoWayBar .main'));
	
	    this.myChart.setOption({
	      tooltip: {
	        trigger: 'axis',
	        axisPointer: { // 坐标轴指示器，坐标轴触发有效
	          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
	        }
	      },
	      legend: {
	        data: ['家庭人口', '人均扶贫收入', '电商增收(元)'],
	        bottom: 10,
	        textStyle: {
	          color: '#fff',
	          fontSize: 16
	        }
	      },
	      grid: {
	        top: '3%',
	        left: '3%',
	        right: '4%',
	        bottom: '15%',
	        containLabel: true
	      },
	      xAxis: [{
	        type: 'value',
	        axisTick: { show: false },
	        axisLine: {
	          show: false
	        },
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 16
	        },
	        splitLine: {
	          lineStyle: {
	            color: '#0092EE'
	          }
	        }
	      }],
	      yAxis: [{
	        type: 'category',
	        axisTick: { show: false },
	        data: ['章*晨', '张*敏', '陈*飞', '陈*泳', '刘*明', '周*轮', '苏*曼', '李*万', '王*说', '顾*网'],
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 18
	        }
	      }],
	      series: [{
	        name: '人均扶贫收入',
	        type: 'bar',
	        barWidth: 8,
	        label: {
	          normal: {
	            // show: true
	            // position: 'inside'
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF9E2C'
	            }, {
	              offset: 0.8,
	              color: '#FF4E00'
	            }], false)
	          }
	        },
	        data: [2045, 1935, 1902, 1852, 1832, 1789, 1780, 1747, 1734, 1696]
	      }, {
	        name: '电商增收(元)',
	        type: 'bar',
	        barWidth: 8,
	        stack: '总量',
	        label: {
	          normal: {
	            // show: true
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#5EB5FF'
	            }, {
	              offset: 0.8,
	              color: '#00DAEE'
	            }], false)
	          }
	        },
	        data: [1732, 1712, 1706, 1677, 1606, 1583, 1580, 1487, 1389, 1373]
	      }, {
	        name: '家庭人口',
	        type: 'bar',
	        barWidth: 8,
	        stack: '总量',
	        label: {
	          normal: {
	            // show: true
	            // position: 'left'
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#C0E450'
	            }, {
	              offset: 0.8,
	              color: '#75CD2D'
	            }], false)
	          }
	        },
	        data: [2, 3, 2, 4, 3, 1, 3, 5, 2, 4]
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    tit: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      myChart: {},
	      colorList: {
	        '年平均降雨量': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#3CA6FF'
	        }, {
	          offset: 1,
	          color: '#4451FF'
	        }], false),
	        '无霜期': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#C4F4FA'
	        }, {
	          offset: 1,
	          color: '#04CBE2'
	        }], false),
	        '年平均日照时长': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#F69211'
	        }, {
	          offset: 1,
	          color: '#EC5D24'
	        }], false)
	      },
	      dataList: {
	        '年平均降雨量': [50, 40, 30, 20, 100, 150, 160, 180, 190, 100, 60, 20],
	        '无霜期': [10, 12, 15, 20, 25, 30, 31, 31, 30, 20, 15, 20],
	        '年平均日照时长': [7, 10, 10, 11, 12, 12, 12, 12, 11, 10, 9, 8]
	      },
	      unitList: {
	        '年平均降雨量': 'ml',
	        '无霜期': '天',
	        '年平均日照时长': 'h'
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    console.log(this.colorList[this.tit]);
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart2 = _echarts2.default.init(document.querySelector('.line .main2'));
	    this.myChart3 = _echarts2.default.init(document.querySelector('.line .main3'));
	    this.myChart4 = _echarts2.default.init(document.querySelector('.line .main4'));
	    var option = {
	      title: {
	        text: this.tit,
	        left: 'center',
	        top: 10,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '15%',
	        top: '22%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          formatter: "{value}" + this.unitList[this.tit],
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            opacity: 0.3,
	            width: 1,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: this.dataList[this.tit],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: this.colorList[this.tit]
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	    if (this.tit === '年平均降雨量') {
	      this.myChart2.setOption(option);
	    } else if (this.tit === '无霜期') {
	      this.myChart3.setOption(option);
	    } else if (this.tit === '年平均日照时长') {
	      this.myChart4.setOption(option);
	    }
	
	    this.init();
	  }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line .main'));
	    var option = {
	      title: {
	        text: '年平均昼夜温差',
	        left: 'center',
	        top: 10,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '15%',
	        top: '22%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          formatter: "{value}℃",
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            width: 1,
	            opacity: 0.3,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: [2, 10, 15, 20, 25, 30, 35, 37, 35, 22, 10, 4],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF813C'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }, {
	        data: [2, 2, 4, 15, 20, 20, 25, 28, 30, 17, 5, 0],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#E4A537'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(option);
	    this.init();
	  }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _monitorIcon = __webpack_require__(574);
	
	var _monitorIcon2 = _interopRequireDefault(_monitorIcon);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _amap = __webpack_require__(139);
	
	var _amap2 = _interopRequireDefault(_amap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_amap2.default); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_amap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.DistrictSearch', 'AMap.Polygon'],
	  uiVersion: '1.0.11',
	  v: '1.4.15'
	});
	var opts = { subdistrict: 0, extensions: 'all' };
	var colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
	var markers = [{ point: [106.831977, 23.712686], content: '经度：106.831977 纬度：23.712686' }, { point: [106.969063, 23.738953], content: '经度：106.969063 纬度：23.738953' }, { point: [106.54027, 23.623629], content: '经度：106.54027 纬度：23.623629' }];
	var path = [[106.835325, 23.826152], [106.772154, 23.609897], [106.883391, 23.685375],
	// [106.972655, 23.72687],
	[106.835325, 23.826152]];
	var path1 = [[106.939488, 23.800139], [107.010213, 23.700837], [106.965581, 23.71404], [106.939488, 23.800139]];
	var path2 = [[106.542814, 23.650157], [106.601866, 23.601088], [106.481016, 23.577176], [106.542814, 23.650157]];
	exports.default = {
	  data: function data() {
	    return {
	      id: 'map-' + Date.now(),
	      areaName: '田阳县',
	      map: null,
	      district: null,
	      districtExplorer: null,
	      cityAdcode: '',
	      cityName: '田阳县',
	      lng: 0,
	      lag: 0,
	      isClick: false
	    };
	  },
	
	  components: {},
	  methods: {
	    renderCity: function renderCity() {
	      var _this = this;
	
	      return new _promise2.default(function (resolve) {
	        _this.district.search(_this.cityName, function (status, result) {
	          _this.cityAdcode = result.districtList[0].adcode;
	          var bounds = result.districtList[0].boundaries;
	          var mask = [];
	          for (var i = 0; i < bounds.length; i += 1) {
	            mask.push([bounds[i]]);
	          }
	          _this.map = new AMap.Map(_this.id, {
	            mask: mask,
	            viewMode: '3D',
	            zoom: 10.2,
	            cursor: 'pointer',
	            center: new AMap.LngLat(106.9156629745, 23.7356699750)
	            // layers: [new AMap.TileLayer.Satellite()]
	          });
	          resolve();
	        });
	      });
	    },
	    handleMarkerClick: function handleMarkerClick(marker) {
	      var _this2 = this;
	
	      return function () {
	        var extData = marker.getExtData();
	        var infoWindow = new AMap.InfoWindow({
	          content: '<div>title:' + extData.title + '<br/>content:' + extData.content + '</div>',
	          offset: new AMap.Pixel(0, -35)
	        });
	        infoWindow.open(_this2.map, marker.getPosition());
	      };
	    },
	    renderMarkers: function renderMarkers() {
	      for (var i in markers) {
	        var icon = new AMap.Icon({
	          size: new AMap.Size(30, 30),
	          imageSize: new AMap.Size(30, 30),
	          image: _monitorIcon2.default
	        });
	        var marker = new AMap.Marker({
	          position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
	          cursor: 'pointer',
	          icon: icon,
	          extData: markers[i]
	        });
	        marker.on('click', this.handleMarkerClick(marker));
	        this.map.add(marker);
	      }
	    },
	    createDistrictExplorer: function createDistrictExplorer() {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve) {
	        AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], function (DistrictExplorer, $) {
	          _this3.districtExplorer = new DistrictExplorer({ eventSupport: true, map: _this3.map });
	          resolve();
	        });
	      });
	    },
	    renderDistrict: function renderDistrict() {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve) {
	        _this4.districtExplorer.loadAreaNode(_this4.cityAdcode, function (error, areaNode) {
	          console.log(error);
	          _this4.districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
	            var fillColor = colors[i % colors.length]; // 填充色
	            var strokeColor = colors[colors.length - 1 - i % colors.length]; // 边框色
	            resolve();
	            return {
	              cursor: 'default',
	              bubble: true,
	              strokeColor: strokeColor, // 线颜色
	              strokeOpacity: 1, // 线透明度
	              strokeWeight: 1, // 线宽
	              fillColor: fillColor, // 填充色
	              fillOpacity: 0.1 // 填充透明度
	            };
	          });
	        });
	      });
	    },
	    drawPath: function drawPath(path, index) {
	      var polyline = new AMap.Polygon({
	        path: path,
	        isOutline: true,
	        outlineColor: '#ffeeff',
	        borderWeight: 1,
	        strokeColor: "#19B4E7",
	        strokeOpacity: 1,
	        strokeWeight: 1,
	        fillColor: '#3AF3FF',
	        // 折线样式还支持 'dashed'
	        strokeStyle: "solid",
	        // strokeStyle是dashed时有效
	        strokeDasharray: [10, 5],
	        lineJoin: 'round',
	        lineCap: 'round',
	        zIndex: 50
	      });
	      polyline.setMap(this.map);
	      var that = this;
	      polyline.on('click', function (e) {
	        that.lng = e.lnglat.getLng();
	        that.lag = e.lnglat.getLat();
	        that.isClick = true;
	        that.$emit('indexChange', index);
	      });
	    },
	    initMap: function initMap() {
	      var _this5 = this;
	
	      _amap.lazyAMapApiLoaderInstance.load().then((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this5.district = new AMap.DistrictSearch(opts);
	                _context.next = 3;
	                return _this5.renderCity();
	
	              case 3:
	                _context.next = 5;
	                return _this5.createDistrictExplorer();
	
	              case 5:
	                _this5.renderDistrict();
	                _context.next = 8;
	                return _this5.drawPath(path, 0);
	
	              case 8:
	                _context.next = 10;
	                return _this5.drawPath(path1, 1);
	
	              case 10:
	                _context.next = 12;
	                return _this5.drawPath(path2, 2);
	
	              case 12:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this5);
	      })));
	    }
	  },
	  mounted: function mounted() {
	    setTimeout(this.initMap, 2000);
	  },
	  created: function created() {}
	};

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      name: '溯源企业活跃度',
	      data: [{ name: '广西百色翠丰特色农产品有限责任公司', num: 90 }, { name: '广西百色盛泰和农业有限公司', num: 81 }, { name: '广西田阳新靖田农产品贸易有限公司', num: 72 }, { name: '广西田阳穗丰园农产品贸易有限公司', num: 60 }, { name: '广西田阳天穗农产品贸易有限公司', num: 57 }, { name: '田阳县蔬心特色农产品经营部', num: 49 }, { name: '广西田阳骄阳农产品贸易有限公司', num: 37 }, { name: '蔬心特色农产品经营部', num: 28 }, { name: '广西蔬心特色农产品经营部', num: 19 }],
	      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#0092ee'],
	      lengthList: [356, 330, 310, 280, 250, 230, 210, 190, 160, 120],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'background:' + this.colorList[index];
	      } else {
	        return 'background:' + this.colorList[3];
	      }
	    },
	    changeLength: function changeLength(index) {
	      return 'width:' + this.lengthList[index] + 'px';
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _base = __webpack_require__(1683);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _monitor = __webpack_require__(1685);
	
	var _monitor2 = _interopRequireDefault(_monitor);
	
	var _weather = __webpack_require__(1689);
	
	var _weather2 = _interopRequireDefault(_weather);
	
	var _company = __webpack_require__(1684);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _amap = __webpack_require__(139);
	
	var _amap2 = _interopRequireDefault(_amap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_vue2.default.use(_amap2.default);
	_amap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.CircleEditor', 'AMap.MouseTool']
	});
	var amapManager = new _amap2.default.AMapManager();
	var markers = [{ point: [107.00836, 23.773378], src: _base2.default }, { point: [106.897124, 23.676572], src: _base2.default }, { point: [106.713103, 23.66651], src: _base2.default }, { point: [106.825712, 23.797255], src: _monitor2.default }, { point: [107.130583, 23.836201], src: _monitor2.default }, { point: [106.855925, 23.667767], src: _monitor2.default }, { point: [106.941069, 23.753269], src: _weather2.default }, { point: [107.12921, 23.723098], src: _weather2.default }, { point: [106.983641, 23.622479], src: _company2.default }, { point: [106.942442, 23.696693], src: _company2.default }, { point: [106.994627, 23.602346], src: _company2.default }];
	exports.default = {
	  data: function data() {
	    var _this = this;
	
	    return {
	      positionTimes: 0,
	      amapManager: amapManager,
	      zoom: 12,
	      center: [106.9156629745, 23.7356699750],
	      plugin: [],
	      events: {
	        init: function init(o) {
	          _this.map = _this.$refs.map.$$getInstance();
	          var AMap = window.AMap;
	        },
	        complete: function complete(o) {
	          var RoadNet = new AMap.TileLayer.Satellite();
	          _this.map.add([RoadNet]);
	          // 标记点
	
	          var _loop = function _loop(i) {
	            var icon = new AMap.Icon({
	              size: new AMap.Size(50, 50),
	              imageSize: new AMap.Size(50, 50),
	              image: markers[i].src
	            });
	            var marker = new AMap.Marker({
	              position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
	              cursor: 'pointer',
	              icon: icon,
	              extData: markers[i]
	            });
	            marker.on('click', function () {
	              console.log(marker.getExtData());
	            });
	            _this.map.add(marker);
	          };
	
	          for (var i in markers) {
	            _loop(i);
	          }
	        }
	      },
	      positionList: [{ top: 100, left: 450, name: '广西省百色市', address: '百色市芒果生产基地', manager: '李大力', year: '10年' }, { top: 150, left: 150, name: '广西省百色市', address: '百色市圣女果生产基地', manager: '张明', year: '3年' }, { top: 100, left: 400, name: '广西省百色市', address: '百色市牛心李生产基地', manager: '王玉', year: '6年' }],
	      detailList: [{ name: '广西田阳天穗农产品贸易有限公司', address: '广西省百色市', phone: '88383928' }, { name: '广西百色盛泰和农业有限公司', address: '广西省百色市', phone: '88383928' }, { name: '田阳县蔬心特色农产品经营部', address: '广西省百色市', phone: '88383928' }]
	    };
	  },
	
	  components: {},
	  computed: {
	    positionItem: function positionItem() {
	      return this.positionList[this.positionTimes % this.positionList.length];
	    },
	    positionItem1: function positionItem1() {
	      return this.detailList[this.positionTimes % this.detailList.length];
	    },
	    detailStyle: function detailStyle() {
	      var len = this.positionList.length;
	      return 'top:' + this.positionList[this.positionTimes % len].top + 'px;left:' + this.positionList[this.positionTimes % len].left + 'px';
	    }
	  },
	  methods: {
	    changeSwiper: function changeSwiper() {
	      var that = this;
	      setTimeout(function () {
	        that.positionTimes++;
	        that.changeSwiper();
	      }, 3000);
	    }
	  },
	  mounted: function mounted() {
	    this.changeSwiper();
	  }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	exports.default = {
	  props: {
	    positionTimes: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      detailList: [{ name: '广西田阳天穗农产品贸易有限公司', address: '广西省百色市', phone: '88383928' }, { name: '广西百色盛泰和农业有限公司', address: '广西省百色市', phone: '88383928' }, { name: '田阳县蔬心特色农产品经营部', address: '广西省百色市', phone: '88383928' }]
	    };
	  },
	
	  components: {},
	  computed: {
	    positionItem: function positionItem() {
	      return this.detailList[this.positionTimes % this.detailList.length];
	    }
	  },
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {},
	      name: '赋码趋势图',
	      nameList: ['广西百色翠丰特色农产品有限责任公司', '广西百色盛泰和农业有限公司', '广西田阳新靖田农产品贸易有限公司', '广西田阳穗丰园农产品贸易有限公司', '广西田阳天穗农产品贸易有限公司', '田阳县蔬心特色农产品经营部', '广西田阳骄阳农产品贸易有限公司', '蔬心特色农产品经营部', '广西蔬心特色农产品经营部'],
	      num: 0
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.lines .main'));
	    var option = {
	      title: {
	        text: this.nameList[this.num],
	        left: 'center',
	        top: 10,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '10%',
	        top: '22%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#00c7ff",
	            width: 1,
	            type: "solid"
	          }
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: "#4797FA",
	            width: 1,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: [400, 603, 800, 731, 900, 1203, 1011, 803, 763, 930, 621, 321],
	        type: 'line',
	        stack: 'area',
	        smooth: true,
	        symbolSize: 0,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FCC849'
	            }, {
	              offset: 0.8,
	              color: '#FF8801'
	            }], false),
	            shadowColor: 'rgba(0, 0, 0, 0.1)',
	            shadowBlur: 10
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#FF8801'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(option);
	    var that = this;
	    setInterval(function () {
	      that.num++;
	      var option = {
	        title: {
	          text: that.nameList[that.num % that.nameList.length],
	          left: 'center',
	          top: 10,
	          textStyle: {
	            color: '#fff'
	          }
	        },
	        grid: { // 设置图表位置
	          left: '15%',
	          bottom: '10%',
	          top: '22%'
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: false,
	          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	          axisTick: {
	            show: false
	          },
	          axisLine: {
	            show: true,
	            lineStyle: {
	              color: "#00c7ff",
	              width: 1,
	              type: "solid"
	            }
	          },
	          splitLine: {
	            show: false
	          }
	        },
	        yAxis: {
	          type: 'value',
	          axisTick: {
	            show: false
	          },
	          axisLine: {
	            show: true,
	            lineStyle: {
	              color: "#00c7ff",
	              width: 1,
	              type: "solid"
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#4797FA",
	              width: 1,
	              type: "solid"
	            }
	          }
	        },
	        series: [{
	          data: [400, 603, 800, 731, 900, 1203, 1011, 803, 763, 930, 621, 321],
	          type: 'line',
	          stack: 'area',
	          smooth: true,
	          symbolSize: 0,
	          lineStyle: {
	            normal: {
	              width: 0
	            }
	          },
	          areaStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#FCC849'
	              }, {
	                offset: 0.8,
	                color: '#FF8801'
	              }], false),
	              shadowColor: 'rgba(0, 0, 0, 0.1)',
	              shadowBlur: 10
	            }
	          },
	          itemStyle: {
	            normal: {
	              color: '#FF8801'
	            }
	          }
	        }]
	      };
	      that.myChart.setOption(option);
	    }, 3000);
	
	    this.init();
	  }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '企业红黑榜',
	      tableData: [{ area: '田阳县', name: '广西百色盛泰和农业有限公司' }, { area: '田阳县', name: '广西田阳新靖田农产品贸易有限公司 ' }, { area: '田阳县', name: '广西田阳穗丰园农产品贸易有限公司' }, { area: '田阳县', name: '广西田阳天穗农产品贸易有限公司' }, { area: '田阳县', name: '田阳县蔬心特色农产品经营部' }, { area: '田阳县', name: '广西田阳骄阳农产品贸易有限公司' }, { area: '田阳县', name: '广西百色翠丰特色农产品有限责任公司' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      timer: {},
	      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
	      myChart: {},
	      name: "可追溯覆盖率",
	      data: [30.02, 8.5, 6.6, 2.2, 1.7, 11, 10.3],
	      instructionData: [{ name: "追溯码赋码量", value: "1253761" }, { name: "可追溯主体数", value: "49" }, { name: "可追溯商品品种", value: "10" }, { name: "三品一标可追溯覆盖率", value: "85%" }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = Math.floor(Math.random() * 100);
	      //   console.log(this.data);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: 0
	          },
	          data: ["百色芒果", "圣女果", "牛心李", "西林火姜", "八渡笋", "田东香芒", "砂糖橘"],
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            rotate: 30,
	            fontSize: 12
	          }
	        },
	        yAxis: {
	          name: '十万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "#C0E450"
	              }, {
	                offset: 0.8,
	                color: "#75CD2D"
	              }], false)
	            }
	          },
	          data: this.data
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      swiperData: ['总屏', '溯源信息', '产业信息', '环境监测', '监控视频', '产品展示', '精准扶贫', '备案信息'],
	      swiperOption: {
	        slidesPerView: 5,
	        speed: 300,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // current swiper instance
	    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
	    console.log('this is current swiper instance object', this.swiper);
	    // this.swiper.slideTo(3, 1000, false)
	  },
	
	  computed: {
	    swiper: function swiper() {
	      return this.$refs.mySwiper.swiper;
	    }
	  },
	  methods: {
	    clickPage: function clickPage(index) {
	      if (index === 0) {
	        // 总屏
	        this.$router.push('/dashboard');
	      } else if (index === 1) {
	        // 溯源信息
	        this.$router.push('/trace');
	      } else if (index === 2) {
	        // 产业信息
	        this.$router.push('/industryInformation');
	      } else if (index === 3) {
	        // 环境监测
	        this.$router.push('/environmentMonitor');
	      } else if (index === 4) {
	        // 监控视频
	        this.$router.push('/video');
	      } else if (index === 5) {
	        // 产品展示
	        this.$router.push('/product');
	      } else if (index === 6) {
	        // 精准扶贫
	        this.$router.push('/helpPoor');
	      } else if (index === 7) {
	        // 备案信息
	        this.$router.push('/recordInformation');
	      }
	    }
	  }
	};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _satelliteMap = __webpack_require__(1772);
	
	var _satelliteMap2 = _interopRequireDefault(_satelliteMap);
	
	var _mapChart = __webpack_require__(1771);
	
	var _mapChart2 = _interopRequireDefault(_mapChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    areaName: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      myChart: {},
	      ifSatellite: false
	    };
	  },
	
	  components: {
	    satelliteMap: _satelliteMap2.default,
	    mapChart: _mapChart2.default
	  },
	  methods: {
	    jumpChild: function jumpChild() {
	      this.$router.push('/base');
	    },
	    clickSatellite: function clickSatellite() {
	      this.ifSatellite = true;
	    },
	    clickNormal: function clickNormal() {
	      this.ifSatellite = false;
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 678 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  components: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _centerTop = __webpack_require__(1769);
	
	var _centerTop2 = _interopRequireDefault(_centerTop);
	
	var _centerChildMap = __webpack_require__(1768);
	
	var _centerChildMap2 = _interopRequireDefault(_centerChildMap);
	
	var _centerBottom = __webpack_require__(1767);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    child: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      areaName: ''
	    };
	  },
	
	  components: {
	    centerTop: _centerTop2.default,
	    centerChildMap: _centerChildMap2.default,
	    centerBottom: _centerBottom2.default
	  },
	  methods: {
	    // 点击地图上的区域进入区域地图
	    clickMap: function clickMap(areaName) {
	      this.areaName = areaName;
	      this.child = false;
	    },
	
	    // 判断是否点到子区域地图
	    clickChild: function clickChild() {
	      this.$emit('clickChild', true);
	    }
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _com = __webpack_require__(1690);
	
	var _com2 = _interopRequireDefault(_com);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {},
	      name: this.$route.query.areaName
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    var self = this;
	    console.log(this.$route.query.areaName);
	    var areaName = this.$route.query.areaName;
	    // 基于准备好的dom，初始化echarts实例
	    // this.myChart = echarts.init(document.querySelector(".map .main"));
	
	    _axios2.default.get("static/data/\u767E\u8272\u5E02/" + areaName + ".json").then(function (res) {
	      var _b, _ref;
	
	      var geoCoordMapList = res.data.features[0].geometry.coordinates[0][0];
	      // 引入地区地图
	      _echarts2.default.registerMap(areaName, res.data);
	      var data;
	      if (self.name === "田阳县") {
	        data = [{ name: "广西百色翠丰特色农产品有限责任公司", value: 10 }, { name: "广西百色盛泰和农业有限公司", value: 20 }, { name: "广西田阳新靖田农产品贸易有限公司", value: 20 }, { name: "广西田阳古鼎香农产品综合批发市场有限公司", value: 20 }, { name: "广西田阳穗丰园农产品贸易有限公司", value: 20 }];
	      } else {
	        data = [{ name: "广西百色翠丰特3色农产品有限责任公司", value: 10 }, { name: "广西百色盛泰3和农业有限公司", value: 20 }, { name: "广西田阳新靖3田农产品贸易有限公司", value: 20 }, { name: "广西田阳古3鼎香农产品综合批发市场有限公司 ", value: 20 }, { name: "广西田阳穗丰3园农产品贸易有限公司 ", value: 20 }];
	      }
	      // 每个地区的坐标
	      var geoCoordMap = {
	        "广西百色翠丰特色农产品有限责任公司": [107.029082, 23.870741],
	        "广西百色盛泰和农业有限公司": [106.929082, 23.670741],
	        "广西田阳新靖田农产品贸易有限公司": [106.529082, 23.650741],
	        "广西田阳古鼎香农产品综合批发市场有限公司": [106.875151, 23.762067],
	        "广西田阳穗丰园农产品贸易有限公司": [106.533201, 23.555777]
	      };
	
	      // 每个地区的设备数量值
	
	      var convertData = function convertData(data) {
	        var res = [];
	        for (var i = 0; i < data.length; i++) {
	          var geoCoord = geoCoordMap[data[i].name];
	          if (geoCoord) {
	            res.push({
	              name: data[i].name,
	              value: geoCoord.concat(data[i].value)
	            });
	          }
	        }
	        return res;
	      };
	
	      function tooltipCharts() {
	        var tooltipDom = document.getElementById("tooltipPieId");
	        if (tooltipDom) {
	          var _tooltipCharts = _echarts2.default.init(document.getElementById("tooltipPieId"));
	          var _data = [{ name: "百色芒果", value: 675 }, { name: "圣女果", value: 1397 }, { name: "牛心李", value: 318 }, { name: "西林火姜", value: 101 }, { name: "其他", value: 110 }];
	          var total = 0;
	          for (var i = 0; i < _data.length; i++) {
	            total += _data[i].value;
	          }
	          var tooltopOpiton = {
	            color: ["#CC68FA", "#FF6438", "#35CDFD", "#FF7B7B", "#FFFE75", "#22FAA1"],
	            title: {
	              text: "总数",
	              subtext: total,
	              textStyle: {
	                fontSize: 12,
	                color: "#fff",
	                align: "center"
	              },
	              subtextStyle: {
	                fontSize: 12,
	                color: "#fff"
	              },
	              x: "22%",
	              y: "33%"
	            },
	            grid: {
	              bottom: 150,
	              left: 100,
	              right: "10%"
	            },
	            legend: {
	              right: "right",
	              top: "-4%",
	              textStyle: {
	                color: "#f2f2f2",
	                fontSize: 12
	              },
	              icon: "pin",
	              data: _data,
	              formatter: function formatter(name) {
	                for (var _i = 0; _i < _data.length; _i++) {
	                  if (name === _data[_i].name) {
	                    return name + " " + (_data[_i].value / total).toFixed(2) * 100 + "% " + _data[_i].value;
	                  }
	                }
	              }
	            },
	            series: [{
	              radius: ["40%", "70%"],
	              center: ["30%", "50%"],
	              type: "pie",
	              label: {
	                normal: {
	                  show: false
	                },
	                emphasis: {
	                  show: true
	                }
	              },
	              labelLine: {
	                normal: {
	                  show: false
	                }
	              },
	              name: "信息统计",
	              data: _data
	            }]
	          };
	          _tooltipCharts.setOption(tooltopOpiton);
	        }
	      }
	
	      var option = {
	        // 自定义引导饼图
	        tooltip: {
	          show: true,
	          trigger: "item",
	          triggerOn: "mousemove",
	          enterable: true,
	          transitionDuration: 1
	        },
	        geo: {
	          map: areaName,
	          show: true,
	          label: {
	            emphasis: {
	              show: false
	            }
	          },
	          itemStyle: {
	            normal: {
	              areaColor: "#7868EC",
	              borderColor: "#BCC5EA",
	              borderWidth: 2,
	              shadowColor: "#5AB2FE",
	              shadowBlur: 5
	            }
	          },
	          zoom: 1.2
	        },
	        series: [{
	          type: "map",
	          map: areaName,
	          backgroundColor: "#2a70da",
	          geoIndex: 1,
	          aspectScale: 0.75,
	          zoom: 1.2,
	          markPoint: {
	            symbol: "image://https://s2.ax1x.com/2019/05/20/Extm4S.png",
	            symbolSize: 400
	          },
	          label: {
	            normal: {
	              show: true,
	              textStyle: {
	                color: "#fff",
	                fontSize: 20
	              }
	            },
	            emphasis: {
	              textStyle: {
	                color: "#fff",
	                fontSize: 20
	              }
	            }
	          },
	          roam: false,
	          itemStyle: {
	            normal: {
	              areaColor: "#2a70da",
	              borderColor: "#52ffff",
	              borderWidth: 2
	            },
	            emphasis: {
	              areaColor: "#328DDF",
	              borderColor: "#BCC5EA",
	              shadowBlur: 8
	            }
	          },
	          data: data
	        }, (_ref = {
	          name: "企业图片",
	          type: "scatter",
	          markPoint: {
	            symbol: "pin"
	          },
	          coordinateSystem: "geo",
	          symbol: "image://" + _com2.default,
	          symbolSize: 40
	        }, (0, _defineProperty3.default)(_ref, "markPoint", {
	          symbol: "pin"
	        }), (0, _defineProperty3.default)(_ref, "label", {
	          normal: {
	            show: true,
	            position: "top",
	            formatter: "{b|{b}}",
	            rich: {
	              b: (_b = {
	                fontFamily: "sans-serif",
	                height: 30,
	                padding: [0, 10],
	                fontSize: 14,
	                align: "center",
	                backgroundColor: "#1375C9",
	                borderColor: "rgba(0,0,0,1)",
	                borderRadius: 10,
	                textShadowColor: "transparent",
	                color: "#fff",
	                textBorderWidth: 0
	              }, (0, _defineProperty3.default)(_b, "textShadowColor", "transparent"), (0, _defineProperty3.default)(_b, "textShadowBlur", 0), (0, _defineProperty3.default)(_b, "textShadowOffsetX", 0), (0, _defineProperty3.default)(_b, "textShadowOffsetY", 0), _b)
	            }
	          }
	        }), (0, _defineProperty3.default)(_ref, "zlevel", 6), (0, _defineProperty3.default)(_ref, "data", convertData(data)), _ref)]
	      };
	      _this.myChart.setOption(option);
	      var index = 0;
	      setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        if (index >= data.length) {
	          index = 0;
	        }
	      }, 3000);
	    });
	  },
	  methods: {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _company = __webpack_require__(1691);
	
	var _company2 = _interopRequireDefault(_company);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _amap = __webpack_require__(139);
	
	var _amap2 = _interopRequireDefault(_amap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_amap2.default); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_amap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.DistrictSearch', 'AMap.Polygon'],
	  uiVersion: '1.0.11',
	  v: '1.4.15'
	});
	var opts = { subdistrict: 0, extensions: 'all', level: 'street' };
	var colors = ["#3366cc", "#dc3912", "#ff9900", "#109618", "#990099", "#0099c6", "#dd4477", "#66aa00", "#b82e2e", "#316395", "#994499", "#22aa99", "#aaaa11", "#6633cc", "#e67300", "#8b0707", "#651067", "#329262", "#5574a6", "#3b3eac"];
	var markers = [{ point: [107.029082, 23.870741], content: '广西百色翠丰特色农产品有限责任公司', title: '标题1' }, { point: [106.929082, 23.670741], content: '广西百色盛泰和农业有限公司', title: '标题2' }, { point: [106.875151, 23.762067], content: '广西田阳古鼎香农产品综合批发市场有限公司', title: '标题3' }, { point: [106.533201, 23.555777], content: '广西田阳穗丰园农产品贸易有限公司', title: '标题4' }, { point: [106.529082, 23.650741], content: '广西田阳新靖田农产品贸易有限公司', title: '标题5' }];
	var geoCoordMap = {
	  '右江区': [106.6189648699, 23.9011510432],
	  '靖西市': [106.4176986464, 23.1340325224],
	  '田阳县': [106.8156629745, 23.7356699750],
	  '田东县': [107.1260862186, 23.5972525589],
	  '平果县': [107.5898772387, 23.3293469441],
	  '德保县': [106.6154958178, 23.3234056946],
	  '那坡县': [105.8335036062, 23.3871180613],
	  '凌云县': [106.5615967920, 24.3475183354],
	  '乐业县': [106.5616359496, 24.7858389344],
	  '田林县': [106.1285227061, 24.2943864015],
	  '西林县': [105.0938229983, 24.4895710923],
	  '隆林各族自治县': [105.2438807417, 24.6706591482]
	};
	var companyList = {
	  '广西百色翠丰特色农产品有限责任公司': [107.029082, 23.870741],
	  '广西百色盛泰和农业有限公司': [106.929082, 23.670741],
	  '广西田阳新靖田农产品贸易有限公司': [106.529082, 23.650741],
	  '广西田阳古鼎香农产品综合批发市场有限公司': [106.875151, 23.762067],
	  '广西田阳穗丰园农产品贸易有限公司': [106.533201, 23.555777]
	};
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {},
	      id: 'map-' + Date.now(),
	      map: null,
	      district: null,
	      districtExplorer: null,
	      cityAdcode: '',
	      cityName: '田阳县',
	      ifSatellite: true,
	      viewIndex: 0,
	      companyList: ['广西百色翠丰特色农产品有限责任公司', '广西百色盛泰和农业有限公司', '广西田阳古鼎香农产品综合批发市场有限公司', '广西田阳穗丰园农产品贸易有限公司', '广西田阳新靖田农产品贸易有限公司']
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    var areaName = this.$route.query.areaName;
	
	    this.cityName = areaName;
	    this.initMap();
	    // setTimeout(this.initMap, 500);
	  },
	  methods: {
	    initMap: function initMap() {
	      var _this = this;
	
	      _amap.lazyAMapApiLoaderInstance.load().then((0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _this.district = new AMap.DistrictSearch(opts);
	                _context.next = 3;
	                return _this.renderCity();
	
	              case 3:
	                _this.renderMarkers();
	                _context.next = 6;
	                return _this.createDistrictExplorer();
	
	              case 6:
	                _this.renderDistrict();
	                // await this.createText()
	
	              case 7:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      })));
	    },
	    renderCity: function renderCity() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve) {
	        _this2.district.search(_this2.cityName, function (status, result) {
	          _this2.cityAdcode = result.districtList[0].adcode;
	          var bounds = result.districtList[0].boundaries;
	          var mask = [];
	          for (var i = 0; i < bounds.length; i += 1) {
	            mask.push([bounds[i]]);
	          }
	          _this2.map = new AMap.Map(_this2.id, {
	            mask: mask,
	            viewMode: '3D',
	            zoom: 9.5,
	            cursor: 'pointer',
	            center: new AMap.LngLat(geoCoordMap[_this2.cityName][0], geoCoordMap[_this2.cityName][1]),
	            layers: [new AMap.TileLayer.Satellite()]
	          });
	          resolve();
	        });
	      });
	    },
	    handleMarkerClick: function handleMarkerClick(marker) {
	      var _this3 = this;
	
	      return function () {
	        var extData = marker.getExtData();
	        var infoWindow = new AMap.InfoWindow({
	          content: '<div>title:' + extData.title + '<br/>content:' + extData.content + '</div>',
	          offset: new AMap.Pixel(0, -35)
	        });
	        infoWindow.open(_this3.map, marker.getPosition());
	      };
	    },
	    renderMarkers: function renderMarkers() {
	      var orgMarkers = [];
	      for (var i in markers) {
	        var icon = new AMap.Icon({
	          size: new AMap.Size(30, 30),
	          imageSize: new AMap.Size(30, 30),
	          image: _company2.default
	        });
	        var marker = new AMap.Marker({
	          position: new AMap.LngLat(markers[i].point[0], markers[i].point[1]),
	          cursor: 'pointer',
	          icon: icon,
	          extData: markers[i]
	        });
	        orgMarkers.push(marker);
	        // setInterval(marker.setAnimation('AMAP_ANIMATION_BOUNCE'), 2000)
	        // marker.on('click', this.handleMarkerClick(marker));
	
	        this.map.add(marker);
	      }
	      var viewIndex = 0;
	      var that = this;
	      setInterval(function () {
	        orgMarkers.forEach(function (marker, index) {
	          if (index === that.viewIndex) {
	            marker.setAnimation('AMAP_ANIMATION_BOUNCE');
	          } else {
	            marker.setAnimation('AMAP_ANIMATION_NONE');
	          }
	        });
	        that.viewIndex++;
	        if (!orgMarkers[that.viewIndex]) {
	          that.viewIndex = 0;
	        }
	      }, 2000);
	    },
	    createDistrictExplorer: function createDistrictExplorer() {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve) {
	        AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], function (DistrictExplorer, $) {
	          _this4.districtExplorer = new DistrictExplorer({ eventSupport: true, map: _this4.map });
	          resolve();
	        });
	      });
	    },
	    renderDistrict: function renderDistrict() {
	      var _this5 = this;
	
	      var that = this;
	      return new _promise2.default(function (resolve) {
	        _this5.districtExplorer.loadAreaNode(_this5.cityAdcode, function (error, areaNode) {
	          console.log(error);
	          _this5.districtExplorer.renderSubFeatures(areaNode, function (feature, i) {
	            var fillColor = colors[i % colors.length]; // 填充色
	            var strokeColor = colors[colors.length - 1 - i % colors.length]; // 边框色
	            resolve();
	            return {
	              cursor: 'default',
	              bubble: true,
	              strokeColor: strokeColor, // 线颜色
	              strokeOpacity: 1, // 线透明度
	              strokeWeight: 1, // 线宽
	              fillColor: fillColor, // 填充色
	              fillOpacity: 0.1 // 填充透明度
	            };
	          });
	          _this5.districtExplorer.on('featureClick', function (e, feature) {
	            that.$router.push('/secondMap?areaName=' + feature.properties.name);
	          });
	        });
	      });
	    },
	    createText: function createText() {
	      // 创建纯文本标记
	      for (var i in companyList) {
	        var text = new AMap.Text({
	          text: i,
	          anchor: 'center', // 设置文本标记锚点
	          draggable: true,
	          cursor: 'pointer',
	          angle: 10,
	          style: {
	            'padding': '10px 5px',
	            'background-color': 'transparent',
	            'width': '360px',
	            'border': 'none',
	            'text-align': 'center',
	            'font-size': '16px',
	            'color': '#fff'
	          },
	          position: companyList[i]
	        });
	        text.setMap(this.map);
	      }
	    }
	  }
	};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '农安信用排名',
	      circleBarData: [{ value: 19.05, name: '质量安全评估信息' }, { value: 4.76, name: '其他信息' }, { value: 14.29, name: '奖励信息' }, { value: 9.52, name: '监督检查信息' }, { value: 14.29, name: '认证(登记)信息' }, { value: 14.28, name: '行政处罚' }, { value: 19.05, name: '行政许可信息' }, { value: 9.52, name: '基础信息' }],
	      data: [{ name: '田阳山友现代农业综合开发有限公司', num: 882 }, { name: '百色市右江区陆东芒果种植农民专...', num: 834 }, { name: '田阳县鲜吃道农业开发有限公司公司', num: 818 }, { name: '广西田阳赶街农业综合开发有限公司', num: 792 }, { name: '广西田阳县鲜加原商贸有限公司 ', num: 784 }, { name: '广西田阳县阳帆农牧科技有限公司', num: 775 }, { name: ' 田阳县百育惠先农业开发有限公司', num: 771 }, { name: '广西壮乡河谷农业科技有限公司', num: 768 }, { name: ' 广西田阳煦日农业科技有限公司', num: 763 }, { name: '田阳新生农业有限公司', num: 761 }],
	      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#fff'],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    // init() {
	    //   window.addEventListener('resize', function() {
	    //     this.myChart.resize()
	    //   }.bind(this))
	    // }
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    // this.myChart = echarts.init(document.querySelector('.circleBar .main'));
	    // this.myChart.setOption({
	    //   tooltip: {
	    //     show: false
	    //   },
	    //   legend: {
	    //     show: false
	    //   },
	    //   color: this.color,
	    //   series: [
	    //     {
	    //       type: 'pie',
	    //       selectedMode: 'single',
	    //       radius: [0, '40%'],
	    //       label: {
	    //         normal: {
	    //           show: false,
	    //           position: 'inner',
	    //           formatter: '{d}%',
	    //           textStyle: {
	    //             color: '#fff',
	    //             fontWeight: 'normal',
	    //             fontSize: 20
	    //           }
	    //         }
	    //       },
	    //       labelLine: {
	    //         normal: {
	    //           show: false
	    //         }
	    //       },
	    //       data: this.circleBarData
	    //     },
	    //     {
	    //       type: 'pie',
	    //       radius: ['50%', '55%'],
	    //       label: {
	    //         normal: {
	    //           formatter: '{b|{b}}\n{hr|}\n{d|{d}%}',
	    //           rich: {
	    //             b: {
	    //               fontSize: 14,
	    //               color: '#fff',
	    //               align: 'left',
	    //               padding: 4
	    //             },
	    //             hr: {
	    //               borderColor: '#12EABE',
	    //               width: '100%',
	    //               borderWidth: 2,
	    //               height: 0
	    //             },
	    //             d: {
	    //               fontSize: 14,
	    //               color: '#fff',
	    //               align: 'left',
	    //               padding: 4
	    //             },
	    //             c: {
	    //               fontSize: 14,
	    //               color: '#fff',
	    //               align: 'center',
	    //               padding: 4
	    //             }
	    //           }
	    //         }
	    //       },
	    //       labelLine: {
	    //         normal: {
	    //           show: true,
	    //           length: 20,
	    //           length2: 20
	    //         }
	    //       },
	    //       data: this.circleBarData
	    //     }
	    //   ]
	    // })
	    // this.init();
	  }
	};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '扶贫情况',
	      listData: [{ name: '贫困户总数', val: '20687' }, { name: '产业扶贫金额', val: '7254万' }, { name: '未脱贫户数', val: '2352' }, { name: '电商扶贫金额', val: '2753万' }, { name: '已脱贫户数', val: '18335' }],
	      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#0092ee'],
	      lengthList: [300, 285, 155, 150],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  computed: {},
	  methods: {
	    width: function width() {},
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    },
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'background:' + this.colorList[index];
	      } else {
	        return 'background:' + this.colorList[3];
	      }
	    },
	    changeLength: function changeLength(index) {
	      return 'width:' + this.lengthList[index] + 'px';
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(206);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var geoCoordMap = {
	  "海门": [121.15, 31.89],
	  "鄂尔多斯": [109.781327, 39.608266],
	  "招远": [120.38, 37.35],
	  "舟山": [122.207216, 29.985295],
	  "齐齐哈尔": [123.97, 47.33],
	  "盐城": [120.13, 33.38],
	  "赤峰": [118.87, 42.28],
	  "青岛": [120.33, 36.07],
	  "乳山": [121.52, 36.89],
	  "金昌": [102.188043, 38.520089],
	  "泉州": [118.58, 24.93],
	  "莱西": [120.53, 36.86],
	  "日照": [119.46, 35.42],
	  "胶南": [119.97, 35.88],
	  "南通": [121.05, 32.08],
	  "拉萨": [91.11, 29.97],
	  "云浮": [112.02, 22.93],
	  "梅州": [116.1, 24.55],
	  "文登": [122.05, 37.2],
	  "上海": [121.48, 31.22],
	  "攀枝花": [101.718637, 26.582347],
	  "威海": [122.1, 37.5],
	  "承德": [117.93, 40.97],
	  "厦门": [118.1, 24.46],
	  "汕尾": [115.375279, 22.786211],
	  "潮州": [116.63, 23.68],
	  "丹东": [124.37, 40.13],
	  "太仓": [121.1, 31.45],
	  "曲靖": [103.79, 25.51],
	  "烟台": [121.39, 37.52],
	  "福州": [119.3, 26.08],
	  "瓦房店": [121.979603, 39.627114],
	  "即墨": [120.45, 36.38],
	  "抚顺": [123.97, 41.97],
	  "玉溪": [102.52, 24.35],
	  "张家口": [114.87, 40.82],
	  "阳泉": [113.57, 37.85],
	  "莱州": [119.942327, 37.177017],
	  "湖州": [120.1, 30.86],
	  "汕头": [116.69, 23.39],
	  "昆山": [120.95, 31.39],
	  "宁波": [121.56, 29.86],
	  "湛江": [110.359377, 21.270708],
	  "揭阳": [116.35, 23.55],
	  "荣成": [122.41, 37.16],
	  "连云港": [119.16, 34.59],
	  "葫芦岛": [120.836932, 40.711052],
	  "常熟": [120.74, 31.64],
	  "东莞": [113.75, 23.04],
	  "河源": [114.68, 23.73],
	  "淮安": [119.15, 33.5],
	  "泰州": [119.9, 32.49],
	  "南宁": [108.33, 22.84],
	  "营口": [122.18, 40.65],
	  "惠州": [114.4, 23.09],
	  "江阴": [120.26, 31.91],
	  "蓬莱": [120.75, 37.8],
	  "韶关": [113.62, 24.84],
	  "嘉峪关": [98.289152, 39.77313],
	  "广州": [113.23, 23.16],
	  "延安": [109.47, 36.6],
	  "太原": [112.53, 37.87],
	  "清远": [113.01, 23.7],
	  "中山": [113.38, 22.52],
	  "昆明": [102.73, 25.04],
	  "寿光": [118.73, 36.86],
	  "盘锦": [122.070714, 41.119997],
	  "长治": [113.08, 36.18],
	  "深圳": [114.07, 22.62],
	  "珠海": [113.52, 22.3],
	  "宿迁": [118.3, 33.96],
	  "咸阳": [108.72, 34.36],
	  "铜川": [109.11, 35.09],
	  "平度": [119.97, 36.77],
	  "佛山": [113.11, 23.05],
	  "海口": [110.35, 20.02],
	  "江门": [113.06, 22.61],
	  "章丘": [117.53, 36.72],
	  "肇庆": [112.44, 23.05],
	  "大连": [121.62, 38.92],
	  "临汾": [111.5, 36.08],
	  "吴江": [120.63, 31.16],
	  "石嘴山": [106.39, 39.04],
	  "沈阳": [123.38, 41.8],
	  "苏州": [120.62, 31.32],
	  "茂名": [110.88, 21.68],
	  "嘉兴": [120.76, 30.77],
	  "长春": [125.35, 43.88],
	  "胶州": [120.03336, 36.264622],
	  "银川": [106.27, 38.47],
	  "张家港": [120.555821, 31.875428],
	  "三门峡": [111.19, 34.76],
	  "锦州": [121.15, 41.13],
	  "南昌": [115.89, 28.68],
	  "柳州": [109.4, 24.33],
	  "三亚": [109.511909, 18.252847],
	  "自贡": [104.778442, 29.33903],
	  "吉林": [126.57, 43.87],
	  "阳江": [111.95, 21.85],
	  "泸州": [105.39, 28.91],
	  "西宁": [101.74, 36.56],
	  "宜宾": [104.56, 29.77],
	  "呼和浩特": [111.65, 40.82],
	  "成都": [104.06, 30.67],
	  "大同": [113.3, 40.12],
	  "镇江": [119.44, 32.2],
	  "桂林": [110.28, 25.29],
	  "张家界": [110.479191, 29.117096],
	  "宜兴": [119.82, 31.36],
	  "北海": [109.12, 21.49],
	  "西安": [108.95, 34.27],
	  "金坛": [119.56, 31.74],
	  "东营": [118.49, 37.46],
	  "牡丹江": [129.58, 44.6],
	  "遵义": [106.9, 27.7],
	  "绍兴": [120.58, 30.01],
	  "扬州": [119.42, 32.39],
	  "常州": [119.95, 31.79],
	  "潍坊": [119.1, 36.62],
	  "重庆": [106.54, 29.59],
	  "台州": [121.420757, 28.656386],
	  "南京": [118.78, 32.04],
	  "滨州": [118.03, 37.36],
	  "贵阳": [106.71, 26.57],
	  "无锡": [120.29, 31.59],
	  "本溪": [123.73, 41.3],
	  "克拉玛依": [84.77, 45.59],
	  "渭南": [109.5, 34.52],
	  "马鞍山": [118.48, 31.56],
	  "宝鸡": [107.15, 34.38],
	  "焦作": [113.21, 35.24],
	  "句容": [119.16, 31.95],
	  "北京": [116.46, 39.92],
	  "徐州": [117.2, 34.26],
	  "衡水": [115.72, 37.72],
	  "包头": [110, 40.58],
	  "绵阳": [104.73, 31.48],
	  "乌鲁木齐": [87.68, 43.77],
	  "枣庄": [117.57, 34.86],
	  "杭州": [120.19, 30.26],
	  "淄博": [118.05, 36.78],
	  "鞍山": [122.85, 41.12],
	  "溧阳": [119.48, 31.43],
	  "库尔勒": [86.06, 41.68],
	  "安阳": [114.35, 36.1],
	  "开封": [114.35, 34.79],
	  "济南": [117, 36.65],
	  "德阳": [104.37, 31.13],
	  "温州": [120.65, 28.01],
	  "九江": [115.97, 29.71],
	  "邯郸": [114.47, 36.6],
	  "临安": [119.72, 30.23],
	  "兰州": [103.73, 36.03],
	  "沧州": [116.83, 38.33],
	  "临沂": [118.35, 35.05],
	  "南充": [106.110698, 30.837793],
	  "天津": [117.2, 39.13],
	  "富阳": [119.95, 30.07],
	  "泰安": [117.13, 36.18],
	  "诸暨": [120.23, 29.71],
	  "郑州": [113.65, 34.76],
	  "哈尔滨": [126.63, 45.75],
	  "聊城": [115.97, 36.45],
	  "芜湖": [118.38, 31.33],
	  "唐山": [118.02, 39.63],
	  "平顶山": [113.29, 33.75],
	  "邢台": [114.48, 37.05],
	  "德州": [116.29, 37.45],
	  "济宁": [116.59, 35.38],
	  "荆州": [112.239741, 30.335165],
	  "宜昌": [111.3, 30.7],
	  "义乌": [120.06, 29.32],
	  "丽水": [119.92, 28.45],
	  "洛阳": [112.44, 34.7],
	  "秦皇岛": [119.57, 39.95],
	  "株洲": [113.16, 27.83],
	  "石家庄": [114.48, 38.03],
	  "莱芜": [117.67, 36.19],
	  "常德": [111.69, 29.05],
	  "保定": [115.48, 38.85],
	  "湘潭": [112.91, 27.87],
	  "金华": [119.64, 29.12],
	  "岳阳": [113.09, 29.37],
	  "长沙": [113, 28.21],
	  "衢州": [118.88, 28.97],
	  "廊坊": [116.7, 39.53],
	  "菏泽": [115.480656, 35.23375],
	  "合肥": [117.27, 31.86],
	  "武汉": [114.31, 30.52],
	  "大庆": [125.03, 46.58],
	  "林芝地": [94.25, 29.59],
	  "果洛藏族自治": [97.42, 34.81],
	  "闵行": [121.23, 31.07],
	  "普洱": [100.9662264708, 22.8252001070],
	  "百色": [106.6183748699, 23.9021610432],
	  "那曲地": [92.1, 31.47]
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var XNData = [[{ name: '百色' }, { name: '广州', value: 3563 }], [{ name: '百色' }, { name: '深圳', value: 3249 }], [{ name: '百色' }, { name: '上海', value: 3202 }], [{ name: '百色' }, { name: '郑州', value: 2485 }], [{ name: '百色' }, { name: '南宁', value: 2043 }], [{ name: '百色' }, { name: '长沙', value: 1507 }], [{ name: '百色' }, { name: '厦门', value: 1204 }], [{ name: '百色' }, { name: '杭州', value: 1032 }], [{ name: '百色' }, { name: '南昌', value: 803 }]];
	
	var planePath = 'arrow';
	
	var convertData = function convertData(data) {
	  var res = [];
	  for (var i = 0; i < data.length; i++) {
	    var dataItem = data[i];
	
	    var fromCoord = geoCoordMap[dataItem[0].name];
	    var toCoord = geoCoordMap[dataItem[1].name];
	    if (fromCoord && toCoord) {
	      res.push({
	        fromName: dataItem[0].name,
	        toName: dataItem[1].name,
	        coords: [fromCoord, toCoord],
	        value: dataItem[1].value
	      });
	    }
	  }
	  return res;
	};
	
	var color = ['#a6c84c', '#ffa022', '#46bee9']; // 航线的颜色
	var series = [];
	[['百色', XNData]].forEach(function (item, i) {
	  series.push({
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 1,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0.7,
	      color: 'red', // arrow箭头的颜色
	      symbolSize: 3
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 0,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 3,
	    symbol: ['none', 'arrow'],
	    symbolSize: 10,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0,
	      symbol: planePath,
	      symbolSize: 15
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 1,
	        opacity: 0.6,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'effectScatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      brushType: 'stroke'
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        formatter: '{b}'
	      }
	    },
	    symbolSize: function symbolSize(val) {
	      return 1 + val[2] / 400;
	    },
	    itemStyle: {
	      normal: {
	        color: color[i]
	      },
	      emphasis: {
	        areaColor: '#2B91B7'
	      }
	    },
	    data: item[1].map(function (dataItem) {
	      return {
	        name: dataItem[1].name,
	        value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
	      };
	    })
	  },
	  // 被攻击点
	  {
	    type: 'scatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      period: 4,
	      brushType: 'stroke',
	      scale: 4
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        color: '#0f0',
	        formatter: '{b}',
	        textStyle: {
	          color: "#0f0"
	        }
	      },
	      emphasis: {
	        show: true,
	        color: "#f60"
	      }
	    },
	    symbol: 'path://M512 39.384615l169.353846 295.384615 342.646154 63.015385-240.246154 248.123077L827.076923 984.615385l-315.076923-145.723077L196.923077 984.615385l43.323077-334.769231L0 401.723077l342.646154-63.015385L512 39.384615',
	    symbolSize: 30,
	    data: [{
	      name: item[0],
	      value: geoCoordMap[item[0]].concat([10])
	    }]
	  });
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '农产品流通数据'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    resizeFunc: function resizeFunc() {
	      this.myChart.resize();
	    },
	    init: function init() {
	      var resizeFunc = this.resizeFunc;
	      window.addEventListener('resize', resizeFunc);
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.flow .main'));
	    this.myChart.setOption({
	      tooltip: {
	        show: false
	      },
	      legend: {
	        orient: 'vertical',
	        left: 'left',
	        data: ['广州', '深圳', '上海'],
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      geo: {
	        map: 'china',
	        roam: true,
	        itemStyle: {
	          normal: {
	            areaColor: '#3A64C8',
	            borderColor: '#195BB9',
	            borderWidth: 1
	          },
	          emphasis: {
	            areaColor: '#2B91B7'
	          }
	        }
	      },
	      series: series
	    });
	    this.init();
	  },
	  destroyed: function destroyed() {
	    var resizeFunc = this.resizeFunc;
	    window.removeEventListener('resize', resizeFunc);
	  }
	};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _pro = __webpack_require__(569);
	
	var _pro2 = _interopRequireDefault(_pro);
	
	var _pro3 = __webpack_require__(570);
	
	var _pro4 = _interopRequireDefault(_pro3);
	
	var _pro5 = __webpack_require__(571);
	
	var _pro6 = _interopRequireDefault(_pro5);
	
	var _pro7 = __webpack_require__(572);
	
	var _pro8 = _interopRequireDefault(_pro7);
	
	var _pro9 = __webpack_require__(573);
	
	var _pro10 = _interopRequireDefault(_pro9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: 'IOT智能监测',
	      imgList1: [{ name: '芒果园区', src: _pro2.default
	        // { name: '圣女果', src: pro2 }
	      }],
	      imgList2: [{ name: '圣女果园区', src: _pro10.default
	        // { name: '圣女果', src: pro4 }
	      }],
	      swiperOption: {
	        slidesPerView: 1,
	        notNextTick: true,
	        loop: true,
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next0',
	          prevEl: '.swiper-button-prev0'
	        },
	        speed: 800,
	        direction: "horizontal"
	      },
	      swiperOption1: {
	        slidesPerView: 1,
	        notNextTick: true,
	        loop: true,
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        autoplay: false,
	        navigation: {
	          nextEl: '.swiper-button-next1',
	          prevEl: '.swiper-button-prev1'
	        },
	        speed: 800,
	        direction: "horizontal"
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '新型农业经营主体',
	      chartData: [{ value: 18, name: '龙头企业' }, { value: 567, name: '农民合作社' }, { value: 79, name: '家庭农场' }, { value: 280, name: '农资店' }]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      legend: [{
	        orient: 'vertical',
	        // icon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	        left: '10',
	        top: '20',
	        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }, {
	        orient: 'vertical',
	        icon: "none",
	        left: '86',
	        top: '20',
	        data: ['龙头企业', '农民合作社', '家庭农场', '农资店'],
	        formatter: function formatter(name) {
	          var oa = data;
	          var num = oa[0].value + oa[1].value + oa[2].value + oa[3].value;
	          for (var i = 0; i < data.length; i++) {
	            if (name === oa[i].name) {
	              return oa[i].value;
	            }
	          }
	        },
	        textStyle: {
	          color: '#fff',
	          padding: [2, 0, 0, 0, 0]
	        }
	      }],
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['70%', '50%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '支柱产业市场分析',
	      tableData: [{ name: '田阳香芒', scale: '39.7万亩', output: '11.3', production: '236000', listed: '夏季' }, { name: '百色番茄', scale: '19万亩', output: '14', production: '550000', listed: '夏季' }, { name: '蔬菜', scale: '15万亩', output: '9', production: '164000', listed: '全年' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.bar1 .main'));
	    this.myChart.setOption({
	      xAxis: {
	        grid: {
	          left: '3%',
	          right: '4%',
	          bottom: '3%',
	          containLabel: true
	        },
	        data: ['百色芒果', '圣女果', '牛心李', '八渡笋', '田东香芒', '砂糖橘', '西林火姜'],
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          interval: 0,
	          color: '#77CAD8',
	          fontSize: 12
	        }
	      },
	      yAxis: {
	        nameTextStyle: {
	          color: '#77CAD8',
	          fontSize: 12
	        },
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          color: '#77CAD8',
	          fontSize: 12
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: '#0177d4'
	          }
	        }
	      },
	      series: [{
	        type: 'bar',
	        barWidth: 18,
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FCC94A'
	            }, {
	              offset: 0.8,
	              color: '#FF7200'
	            }], false)
	          }
	        },
	        data: [4000, 2000, 9000, 5500, 1000, 7000, 8000]
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {},
	      name: '赋码趋势图'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.map .main'));
	    var allData = {};
	    _axios2.default.get('static/data/百色市.json').then(function (res) {
	      // 引入地区地图
	      _echarts2.default.registerMap('百色市', res.data);
	      // 每个地区的坐标
	      var geoCoordMap = {
	        '右江区': [106.6189648699, 23.9011510432],
	        '靖西市': [106.4176986464, 23.1340325224],
	        '田阳县': [106.9156629745, 23.7356699750],
	        '田东县': [107.1260862186, 23.5972525589],
	        '平果县': [107.5898772387, 23.3293469441],
	        '德保县': [106.6154958178, 23.3234056946],
	        '那坡县': [105.8335036062, 23.3871180613],
	        '凌云县': [106.5615967920, 24.3475183354],
	        '乐业县': [106.5616359496, 24.7858389344],
	        '田林县': [106.2285227061, 24.2943864015],
	        '西林县': [105.0938229983, 24.4895710923],
	        '隆林各族自治县': [105.3438807417, 24.7706591482]
	      };
	
	      var BJData = [[{ name: '' }, { name: '田阳县', value: 80 }], [{ name: '田阳县' }, { name: '靖西市', value: 80 }], [{ name: '田阳县' }, { name: '右江区', value: 80 }], [{ name: '田阳县' }, { name: '平果县', value: 80 }], [{ name: '田阳县' }, { name: '那坡县', value: 80 }], [{ name: '田阳县' }, { name: '乐业县', value: 80 }], [{ name: '田阳县' }, { name: '西林县', value: 80 }]];
	
	      var convertData = function convertData(data) {
	        var res = [];
	        for (var i = 0; i < data.length; i++) {
	          var dataItem = data[i];
	          var fromCoord = geoCoordMap[dataItem[0].name];
	          var toCoord = geoCoordMap[dataItem[1].name];
	          if (fromCoord && toCoord) {
	            res.push({
	              fromName: dataItem[0].name,
	              toName: dataItem[1].name,
	              coords: [fromCoord, toCoord]
	            });
	          }
	        }
	        return res;
	      };
	
	      var color = ['#06A1E7', '#2B72D6', '#ADBFFF', '#328DDF', '#6676EF', '#A5D3F0'];
	      var series = [];
	
	      function area(name, color) {
	        var a = {
	          name: name,
	          selected: true,
	          itemStyle: {
	            emphasis: {
	              areaColor: color,
	              borderColor: '#fff',
	              borderWidth: 1
	            }
	          }
	        };
	        return a;
	      }
	
	      [['百色市', BJData]].forEach(function (item, i) {
	        series.push({
	          type: 'lines',
	          zlevel: 1,
	          effect: {
	            show: true,
	            period: 6,
	            trailLength: 0.7,
	            color: '#fff', // 流向的颜色
	            symbolSize: 5
	          },
	          lineStyle: {
	            normal: {
	              color: '#EF850E',
	              width: 1,
	              curveness: 0.2
	            }
	          },
	          data: convertData(item[1])
	        }, {
	          type: 'effectScatter',
	          coordinateSystem: 'geo',
	          zlevel: 2,
	          rippleEffect: {
	            brushType: 'stroke'
	          },
	          label: {
	            normal: {
	              show: true,
	              position: 'right',
	              formatter: function formatter(val) {
	                return val.name + '\n' + val.value[2];
	              },
	              fontSize: 18,
	              color: '#fff'
	            }
	          },
	          symbolSize: function symbolSize(val) {
	            return val[2] / 8;
	          },
	          itemStyle: {
	            normal: {
	              color: color[i]
	            }
	          },
	          data: item[1].map(function (dataItem) {
	            return {
	              name: dataItem[1].name,
	              value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
	            };
	          })
	        });
	      });
	
	      var option = {
	        tooltip: {
	          trigger: 'item'
	        },
	        // 地图映射颜色
	        visualMap: [{
	          show: false,
	          inRange: {
	            color: ['#ff0']
	            // splitNumber: 0
	          } }],
	        grid: {
	          bottom: 10,
	          left: 10,
	          right: '2%'
	        },
	        legend: {
	          orient: 'vertical',
	          top: 'bottom',
	          left: 'right',
	          textStyle: {
	            color: '#fff'
	          },
	          selectedMode: 'single'
	        },
	        geo: {
	          map: '百色市',
	          zoom: 1.2,
	          label: {
	            emphasis: {
	              show: false
	            }
	          },
	          roam: false,
	          itemStyle: {
	            normal: {
	              areaColor: '#328DDF',
	              borderColor: '#BCC5EA',
	              borderWidth: 2,
	              shadowColor: '#5AB2FE',
	              shadowBlur: 5
	            }
	          },
	          regions: [area('右江区', '#328DDF'), area('靖西市', '#06A1E7'), area('田阳县', '#2B72D6'), area('平果县', '#ADBFFF'), area('那坡县', '#328DDF'), area('乐业县', '#6676EF'), area('西林县', '#A5D3F0')]
	        },
	        series: series
	      };
	
	      _this.myChart.setOption(option);
	
	      _this.init();
	    });
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 690 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      data: [3, 0, 0, 8, 2, 1],
	      num: 0
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {
	    var that = this;
	    setInterval(function () {
	      if (that.num % 3 === 1) {
	        that.data = [3, 0, 0, 8, 2, 1];
	      } else if (that.num % 3 === 2) {
	        that.data = [3, 0, 0, 8, 5, 1];
	      } else if (that.num % 3 === 0) {
	        that.data = [3, 0, 0, 9, 0, 0];
	      }
	      that.num++;
	    }, 5000);
	  }
	};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _centerTop = __webpack_require__(1781);
	
	var _centerTop2 = _interopRequireDefault(_centerTop);
	
	var _centerMap = __webpack_require__(1780);
	
	var _centerMap2 = _interopRequireDefault(_centerMap);
	
	var _centerBottom = __webpack_require__(1779);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    child: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      areaName: ''
	    };
	  },
	
	  components: {
	    centerTop: _centerTop2.default,
	    centerMap: _centerMap2.default,
	    centerBottom: _centerBottom2.default
	  },
	  methods: {},
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var i = 0;
	    return {
	      myChart: {},
	      name: '赋码趋势图',
	      list: [{ name: '右江区', flag: true }, { name: '靖西市', flag: false }, { name: '田阳县', flag: false }, { name: '田东县', flag: false }, { name: '平果县', flag: false }, { name: '德保县', flag: false }, { name: '那坡县', flag: false }, { name: '凌云县', flag: false }, { name: '乐业县', flag: false }, { name: '西林县', flag: false }, { name: '隆林县', flag: false }, { name: '田林县', flag: false }],
	      num: 1,
	      colorList: [new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	        offset: 0,
	        color: '#FCC849'
	      }, {
	        offset: 0.8,
	        color: '#FF8801'
	      }], false), new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	        offset: 0,
	        color: '#C4F4FA'
	      }, {
	        offset: 0.8,
	        color: '#04CBE2'
	      }], false)]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    setActive: function setActive() {
	      var len = this.list.length;
	      var that = this;
	      setTimeout(function () {
	        that.list[(that.num - 1) % len].flag = false;
	        that.list[that.num % len].flag = true;
	        that.num++;
	        that.setActive();
	      }, 2000);
	    },
	    setCharts: function setCharts() {
	      var that = this;
	      setTimeout(function () {
	        that.charts();
	        that.setCharts();
	      }, 2000);
	    },
	    charts: function charts() {
	      if (this.num % 2 === 0) {
	        this.myChart = _echarts2.default.init(document.querySelector('.lines .main'));
	      } else {
	        this.myChart1 = _echarts2.default.init(document.querySelector('.lines .main1'));
	      }
	      var option = {
	        xAxis: {
	          type: 'category',
	          boundaryGap: false,
	          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	          axisTick: {
	            show: false
	          },
	          axisLine: {
	            show: true,
	            lineStyle: {
	              color: "#00c7ff",
	              width: 1,
	              type: "solid"
	            }
	          },
	          splitLine: {
	            show: false
	          }
	        },
	        yAxis: {
	          type: 'value',
	          axisTick: {
	            show: false
	          },
	          axisLine: {
	            show: true,
	            lineStyle: {
	              color: "#00c7ff",
	              width: 1,
	              type: "solid"
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#4797FA",
	              width: 1,
	              type: "solid"
	            }
	          }
	        },
	        series: [{
	          data: [820, 932, 901, 934, 1290, 1330, 1320, 901, 934, 1290, 1330, 1320],
	          type: 'line',
	          stack: 'area',
	          smooth: true,
	          symbolSize: 0,
	          lineStyle: {
	            normal: {
	              width: 0
	            }
	          },
	          areaStyle: {
	            normal: {
	              color: this.colorList[this.num % 2],
	              shadowColor: 'rgba(0, 0, 0, 0.1)',
	              shadowBlur: 10
	            }
	          },
	          itemStyle: {
	            normal: {
	              color: '#FF8801'
	            }
	          }
	        }]
	      };
	      if (this.num % 2 === 0) {
	        this.myChart.setOption(option);
	      } else {
	        this.myChart1.setOption(option);
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.charts();
	    this.setCharts();
	    this.init();
	    this.setActive();
	  }
	};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _p = __webpack_require__(1705);
	
	var _p2 = _interopRequireDefault(_p);
	
	var _p3 = __webpack_require__(1706);
	
	var _p4 = _interopRequireDefault(_p3);
	
	var _p5 = __webpack_require__(1707);
	
	var _p6 = _interopRequireDefault(_p5);
	
	var _lb = __webpack_require__(1702);
	
	var _lb2 = _interopRequireDefault(_lb);
	
	var _lb3 = __webpack_require__(1703);
	
	var _lb4 = _interopRequireDefault(_lb3);
	
	var _lb5 = __webpack_require__(1704);
	
	var _lb6 = _interopRequireDefault(_lb5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '品控产品（10个）',
	      banner: [{
	        url: _p2.default,
	        name: '白色芒果'
	      }, {
	        url: _p4.default,
	        name: '牛心李'
	      }, {
	        url: _p6.default,
	        name: '圣女果'
	      }, {
	        url: _lb2.default,
	        name: '猕猴桃'
	      }, {
	        url: _lb4.default,
	        name: '西林火姜'
	      }, {
	        url: _lb6.default,
	        name: '砂糖桔'
	      }],
	      swiperOption: {
	        slidesPerView: 3,
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "horizontal",
	        // 小手掌抓取滑动
	        grabCursor: true,
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        },
	        on: {
	          // 滑动之后回调函数
	          slideChangeTransitionStart: function slideChangeTransitionStart() {
	            /* realIndex为滚动到当前的slide索引值 */
	            that.imgIndex = this.realIndex - 1;
	          }
	        }
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '可追溯商品（18个）'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '追溯产品展示old',
	      tableData: [{ name: '百色芒果', codeNum: 16154, scanNum: 16154 }, { name: '圣女果', codeNum: 11523, scanNum: 9713 }, { name: '牛心李', codeNum: 14316, scanNum: 7351 }, { name: '西林火姜', codeNum: 10126, scanNum: 4018 }, { name: '八渡笋', codeNum: 11256, scanNum: 4115 }, { name: '田东香芒', codeNum: 13256, scanNum: 4301 }, { name: '砂糖橘', codeNum: 16154, scanNum: 16154 }, { name: '桂七香芒', codeNum: 16154, scanNum: 16154 }, { name: '乐业猕猴桃', codeNum: 16154, scanNum: 16154 }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可追溯商品排名',
	      tableData: [{ name: '百色芒果', num: 15694 }, { name: '圣女果', num: 9525 }, { name: '西林火姜', num: 6978 }, { name: '牛心李', num: 4525 }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _details = __webpack_require__(1726);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _leftDetails = __webpack_require__(1727);
	
	var _leftDetails2 = _interopRequireDefault(_leftDetails);
	
	var _map = __webpack_require__(1728);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _sign = __webpack_require__(1729);
	
	var _sign2 = _interopRequireDefault(_sign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      items: [],
	      activeItem: 0,
	      name: '广西百色翠丰特色农产品有限责任公司'
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    jumpChild: function jumpChild() {
	      this.$router.push('/dashboardChild');
	    },
	
	    // 下标改变事件
	    indexChange: function indexChange(newIndex) {
	      this.activeItem = newIndex;
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-left-details': _leftDetails2.default,
	    'v-details': _details2.default,
	    'v-map': _map2.default,
	    'v-sign': _sign2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _pie = __webpack_require__(1745);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _table = __webpack_require__(1746);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _circle = __webpack_require__(1742);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _iot = __webpack_require__(1744);
	
	var _iot2 = _interopRequireDefault(_iot);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _bars = __webpack_require__(585);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _circleBar = __webpack_require__(1741);
	
	var _circleBar2 = _interopRequireDefault(_circleBar);
	
	var _circleB = __webpack_require__(1740);
	
	var _circleB2 = _interopRequireDefault(_circleB);
	
	var _flow = __webpack_require__(1743);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _center = __webpack_require__(1737);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _particles = __webpack_require__(1620);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Stats from '../../../static/js/particles'
	// import '../../../static/js/app'
	// import '../../../static/js/lib/stats'
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      items: [],
	      countParticles: '',
	      stats: '',
	      update: '',
	      name: '百色市农业大脑',
	      child: false
	    };
	  },
	  mounted: function mounted() {
	    particlesJS.load('particles', '../../../static/data/don.json');
	  },
	
	  methods: {
	    clickChild: function clickChild(bool) {
	      this.child = bool;
	    },
	    backToDashboard: function backToDashboard() {
	      this.child = false;
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-table': _table2.default,
	    'v-circle': _circle2.default,
	    'v-pie': _pie2.default,
	    'v-iot': _iot2.default,
	    'v-bar': _bar2.default,
	    'v-bars': _bars2.default,
	    'v-flow': _flow2.default,
	    'v-circle-bar': _circleBar2.default,
	    'v-circ': _circleB2.default,
	    'v-center': _center2.default
	  }
	};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '田阳县农业大脑——环境监测中心',
	      show: false,
	      options: [{ text: '百色市田阳县气象监控站', value: false }],
	      listData: [{ temperature: 26, humidity: 94, winds: 1, air: 40 }, { temperature: 27, humidity: 93, winds: 2, air: 43 }, { temperature: 32, humidity: 91, winds: 2, air: 46 }, { temperature: 30, humidity: 95, winds: 2, air: 55 }, { temperature: 25, humidity: 89, winds: 3, air: 70 }],
	      num: 0
	    };
	  },
	  mounted: function mounted() {
	    var currentHour = new Date().getHours();
	    if (currentHour <= 8) {
	      this.num = 0;
	    } else if (currentHour <= 11 && currentHour > 8) {
	      this.num = 1;
	    } else if (currentHour <= 14 && currentHour > 11) {
	      this.num = 2;
	    } else if (currentHour <= 16 && currentHour > 14) {
	      this.num = 3;
	    } else {
	      this.num = 4;
	    }
	  },
	
	  methods: {
	    up: function up() {
	      this.show = !this.show;
	    }
	  },
	  components: {
	    'v-header': _header2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bar = __webpack_require__(1748);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _twoWayBar = __webpack_require__(1757);
	
	var _twoWayBar2 = _interopRequireDefault(_twoWayBar);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _pie = __webpack_require__(1754);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _table = __webpack_require__(1755);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _bars = __webpack_require__(1749);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _center = __webpack_require__(1752);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _analyse = __webpack_require__(1747);
	
	var _analyse2 = _interopRequireDefault(_analyse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      items: [],
	      name: '田阳县农业大脑——扶贫数据中心'
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {},
	  components: {
	    'v-bars': _bar2.default,
	    'v-header': _header2.default,
	    'v-table': _table2.default,
	    'v-pie': _pie2.default,
	    'v-bar': _bars2.default,
	    'v-center': _center2.default,
	    'v-two-way-bar': _twoWayBar2.default,
	    'v-analyse': _analyse2.default
	  }
	};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _line = __webpack_require__(1758);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _lines = __webpack_require__(1759);
	
	var _lines2 = _interopRequireDefault(_lines);
	
	var _map = __webpack_require__(1760);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '田阳县农业大脑——基地数据',
	      areaList: ['右江区', '靖西市', '田阳县', '田东县', '平果县', '德保县', '那坡县', '凌云县', '乐业县', '田林县', '西林县', '隆林县'],
	      baseDetailList: [{ baseName: '田阳县基地', name: '周*礼', phone: '136****2930', company: '田阳县蔬心特色农产品经营部', total: '100亩', time: '2016.10至2020.10', region: '百色市田阳县' }, { baseName: '镇巴基地', name: '李*雨', phone: '132****3212', company: '广西百色盛泰和农业有限公司', total: '200亩', time: '2017.1至2021.12', region: '百色市田阳县' }, { baseName: '五村基地', name: '梁*欣', phone: '182****3012', company: '广西田阳骄阳农产品贸易有限公司', total: '140亩', time: '2017.1至2027.12', region: '百色市田阳县' }],
	      activeItem: 0
	
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    // 下标改变事件
	    indexChange: function indexChange(newIndex) {
	      this.activeItem = newIndex;
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-line': _line2.default,
	    'v-lines': _lines2.default,
	    'v-map': _map2.default
	  }
	};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	var _certify = __webpack_require__(1661);
	
	var _certify2 = _interopRequireDefault(_certify);
	
	var _certify3 = __webpack_require__(1662);
	
	var _certify4 = _interopRequireDefault(_certify3);
	
	var _certify5 = __webpack_require__(1663);
	
	var _certify6 = _interopRequireDefault(_certify5);
	
	var _pic = __webpack_require__(1665);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(1671);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(1672);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(1673);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(1674);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	var _pic11 = __webpack_require__(1675);
	
	var _pic12 = _interopRequireDefault(_pic11);
	
	var _pic13 = __webpack_require__(1676);
	
	var _pic14 = _interopRequireDefault(_pic13);
	
	var _pic15 = __webpack_require__(1677);
	
	var _pic16 = _interopRequireDefault(_pic15);
	
	var _pic17 = __webpack_require__(1678);
	
	var _pic18 = _interopRequireDefault(_pic17);
	
	var _pic19 = __webpack_require__(1666);
	
	var _pic20 = _interopRequireDefault(_pic19);
	
	var _pic21 = __webpack_require__(1667);
	
	var _pic22 = _interopRequireDefault(_pic21);
	
	var _pic23 = __webpack_require__(1668);
	
	var _pic24 = _interopRequireDefault(_pic23);
	
	var _pic25 = __webpack_require__(1669);
	
	var _pic26 = _interopRequireDefault(_pic25);
	
	var _pic27 = __webpack_require__(1670);
	
	var _pic28 = _interopRequireDefault(_pic27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '田阳县农业大脑——特色产品展示',
	      banner: [_certify2.default, _certify4.default, _certify6.default],
	      steps1: [{ name: '采摘', src: _pic2.default }, { name: '鲜叶农残快速检测', src: _pic4.default }, { name: '收鲜', src: _pic6.default }, { name: '摊青', src: _pic8.default }, { name: '杀青', src: _pic10.default }],
	      steps2: [{ name: '干燥', src: _pic20.default }, { name: '渥堆', src: _pic18.default }, { name: '分筛', src: _pic16.default }, { name: '晾晒', src: _pic14.default }, { name: '揉捻', src: _pic12.default }],
	      steps3: [{ name: '送检', src: _pic22.default }, { name: '压制', src: _pic22.default }, { name: '包装', src: _pic24.default }, { name: '装箱', src: _pic26.default }, { name: '入库', src: _pic28.default }],
	      swiperOption: {
	        watchSlidesProgress: true,
	        // 滑动方向
	        direction: "horizontal",
	        // 循环
	        loop: true,
	        slidesPerView: 3,
	        centeredSlides: true,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          // stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        },
	        // 滑动速度
	        speed: 800,
	        // 小手掌抓取滑动
	        // grabCursor: true,
	        on: {}
	      }
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {},
	  components: {
	    'v-header': _header2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  }
	};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bar = __webpack_require__(1761);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _line = __webpack_require__(1764);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _center = __webpack_require__(1762);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _detail = __webpack_require__(1763);
	
	var _detail2 = _interopRequireDefault(_detail);
	
	var _table = __webpack_require__(1765);
	
	var _table2 = _interopRequireDefault(_table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      items: [],
	      name: '田阳县农业大脑——主体备案信息',
	      positionTimes: 0
	    };
	  },
	  mounted: function mounted() {
	    this.changeSwiper();
	  },
	
	  methods: {
	    changeSwiper: function changeSwiper() {
	      var that = this;
	      setTimeout(function () {
	        that.positionTimes++;
	        that.changeSwiper();
	      }, 3000);
	    }
	  },
	  components: {
	    'v-bar': _bar2.default,
	    'v-header': _header2.default,
	    'v-line': _line2.default,
	    'v-center': _center2.default,
	    'v-detail': _detail2.default,
	    'v-table': _table2.default
	  }
	};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '收支公开',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        "tooltip": {
	          "trigger": "axis",
	          "axisPointer": {
	            "type": "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        "legend": {
	          x: '40%',
	          top: '2%',
	          textStyle: {
	            color: '#FFF'
	          },
	          itemHeight: 4,
	          itemWidth: 14,
	          "data": ['收入', '支出']
	        },
	        "xAxis": [{
	          "type": "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "splitLine": {
	            "show": false
	          },
	          "axisTick": {
	            "show": false
	          },
	          "splitArea": {
	            "show": false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	          },
	          "data": [2012, 2013, 2014, 2015, 2016, 2017]
	        }],
	        "yAxis": [(0, _defineProperty3.default)({
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, -20]
	          },
	          "type": "value",
	          "splitLine": {
	            "show": false
	          },
	          "axisLine": {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "axisTick": {
	            "show": false
	          },
	          "axisLabel": {
	            "interval": 0
	
	          },
	          "splitArea": {
	            "show": false
	          }
	        }, 'axisLabel', {
	          interval: 0,
	          color: "#fff",
	          fontSize: 12
	        })],
	        "series": [{
	          "name": "收入",
	          "type": "bar",
	          "stack": "总量",
	          "barMaxWidth": 20,
	          "barGap": "10%",
	          "itemStyle": {
	            "normal": {
	              "color": "#76CD2E",
	              "label": {
	                "show": false,
	                "textStyle": {
	                  "color": "#fff"
	                },
	                "position": "insideTop"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [80, 60, 50, 60, 100, 110]
	        }, {
	          "name": "支出",
	          "type": "bar",
	          "stack": "总量",
	          "itemStyle": {
	            "normal": {
	              "color": "#486FF1",
	              "barBorderRadius": 0,
	              "label": {
	                "show": false,
	                "position": "top"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [10, 10, 20, 30, 40, 40]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index >= 6) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [80, 50, 60, 100, 150, 120];
	    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var _swiperOption;
	
	    return {
	      list: [{
	        node: "育苗",
	        name: "邵建国",
	        time: "2016-03-16",
	        note: "",
	        id: "3117"
	      }, {
	        node: "施肥",
	        name: "邵建国",
	        time: "2016-04-06",
	        note: "物料",
	        note1: "有机肥",
	        id: "4102"
	      }, {
	        node: "灌溉",
	        name: "王雨",
	        time: "2016-04-28",
	        note: "灌溉方式",
	        note1: "地面流灌",
	        id: "4218"
	      }, {
	        node: "植保",
	        name: "赵大海",
	        time: "2017-05-16",
	        note: "预防",
	        note1: "茶尺蠖",
	        id: "5315"
	      }, {
	        node: "修剪",
	        name: "王雨",
	        time: "2018-06-23",
	        note: "",
	        id: "6624"
	      }, {
	        node: "采收",
	        name: "孙强",
	        time: "2019-03-26",
	        note: "采收方式",
	        note1: "手采法",
	        id: "7435"
	      }, {
	        node: "摊青",
	        name: "周志勇",
	        time: "2019-04-02",
	        note: "摊青温度",
	        note1: "19度",
	        id: "7529"
	      }, {
	        node: "杀青",
	        name: "周志勇",
	        time: "2019-04-11",
	        note: "",
	        id: "7832"
	      }, {
	        node: "揉捻",
	        name: "孙强",
	        time: "2019-04-17",
	        note: "揉捻方式",
	        note1: "冷揉",
	        id: "7961"
	      }, {
	        node: "干燥",
	        name: "孙强",
	        time: "2019-04-20",
	        note: "",
	        id: "8221"
	      }, {
	        node: "包装",
	        name: "孙强",
	        time: "2019-04-22",
	        note: "包装材质",
	        note1: "金属罐包装",
	        id: "8265"
	      }],
	      swiperOption: (_swiperOption = {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 170,
	        // 自动播放
	        autoplay: {
	          delay: 5000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "horizontal"
	      }, (0, _defineProperty3.default)(_swiperOption, "slidesPerView", "auto"), (0, _defineProperty3.default)(_swiperOption, "spaceBetween", 0), (0, _defineProperty3.default)(_swiperOption, "grabCursor", true), _swiperOption)
	    };
	  },
	
	  components: { swiper: _vueAwesomeSwiper.swiper, swiperSlide: _vueAwesomeSwiper.swiperSlide },
	  mounted: function mounted() {}
	};

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _centerBottom = __webpack_require__(1796);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(1125);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _base = __webpack_require__(1625);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import earth from "@/assets/img/chaye/8.png";
	//  星空背景
	// import bathymetry from "@/assets/img/chaye/bathymetry_bw_composite_4k.jpg";
	//  星空背景
	// import starfield from "@/assets/img/chaye/starfield.jpg";
	
	// import starfield from "@/assets/img/chaye/22.png";
	exports.default = {
	  data: function data() {
	    return {
	      datalist: [],
	      dataFJ: [],
	      dataYN: []
	    };
	  },
	
	  components: {
	    "v-bottom": _centerBottom2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getRandomData: function getRandomData(base1, base2) {
	      return {
	        coords: [[base1, base2], [Math.random() * 135.2, Math.random() * 53.33]],
	        value: (Math.random() * 30).toFixed(2)
	      };
	    }
	  },
	  mounted: function mounted() {
	    var _geo;
	
	    for (var i = 0; i < 30; i++) {
	      this.dataFJ.push(this.getRandomData(119.3, 26.08));
	      this.dataYN.push(this.getRandomData(102.72, 25.05));
	    }
	    this.dataGX = [{
	      coords: [[95.45587012885734, 33.63134659765145], [121.51585, 31.23045]],
	      value: "20"
	    }];
	    this.dataHN = [{
	      coords: [[95.45587012885734, 33.63134659765145], [121.51585, 31.23045]],
	      value: "20"
	    }];
	    this.dataZJ = [{
	      coords: [[95.45587012885734, 33.63134659765145], [121.51585, 31.23045]],
	      value: "20"
	    }];
	    var canvas = document.createElement("canvas");
	    var mapChart = _echarts2.default.init(canvas, null, {
	      width: 4096,
	      height: 2048
	    });
	    var pOp = {
	      geo: (_geo = {
	        map: "china",
	        label: {
	          fontSize: 12
	        }
	      }, (0, _defineProperty3.default)(_geo, "label", {
	        normal: {
	          show: false,
	          textStyle: {
	            color: "#fff",
	            fontSize: 12
	          }
	        },
	        emphasis: {
	          textStyle: {
	            color: "#fff",
	            fontSize: 12
	          }
	        }
	      }), (0, _defineProperty3.default)(_geo, "itemStyle", {
	        normal: {
	          areaColor: "transparent",
	          borderColor: "#e6722c",
	          borderWidth: 3
	        },
	        emphasis: {
	          areaColor: "rgba(229,46,46,0.5)",
	          borderColor: "#e6722c",
	          // borderColor: "rgb(4,69,239)",
	          borderWidth: 3
	        }
	      }), (0, _defineProperty3.default)(_geo, "regions", [{
	        name: "南海诸岛",
	        value: 0,
	        itemStyle: {
	          normal: {
	            opacity: 0,
	            label: {
	              show: false
	            }
	          }
	        }
	      }]), (0, _defineProperty3.default)(_geo, "top", 0), (0, _defineProperty3.default)(_geo, "left", 0), (0, _defineProperty3.default)(_geo, "right", 0), (0, _defineProperty3.default)(_geo, "bottom", 0), (0, _defineProperty3.default)(_geo, "boundingCoords", [[-180, 90], [180, -90]]), _geo),
	      data: []
	    };
	    mapChart.setOption(pOp);
	    this.myChart = _echarts2.default.init(document.querySelector(".map .main"));
	    var op = {
	      backgroundColor: "transparent",
	      visualMap: [{
	        show: false,
	        type: "continuous",
	        seriesIndex: 0,
	        text: ["scatter3D"],
	        textStyle: {
	          color: "#fff"
	        },
	        calculable: true,
	        max: 3000,
	        inRange: {
	          color: ["#87aa66", "#eba438", "#d94d4c"],
	          symbolSize: [8, 30]
	        }
	      }],
	      globe: {
	        baseTexture: _base2.default,
	        // heightTexture: bathymetry,
	        displacementScale: 0.04,
	        shading: "lambert",
	        // environment: starfield,
	        light: {
	          // 光照阴影
	          main: {
	            color: "#fff", // 光照颜色
	            intensity: 1.2, // 光照强度
	            shadow: true, // 是否显示阴影
	            alpha: 40,
	            beta: -30
	          },
	          ambient: {
	            intensity: 1.2
	          }
	        },
	        viewControl: {
	          alpha: 30,
	          beta: 160,
	          // targetCoord: [116.46, 39.92],
	          autoRotate: true,
	          autoRotateAfterStill: 10,
	          autoRotateDirection: 'ccw',
	          distance: 150
	          // projection: "perspective",
	          // alpha: 90,
	          // beta: 0,
	          // center: [0, 50, 0], // 视角
	          // targetCoord: [110.46, 10.92],
	          // autoRotate: true,
	          // autoRotateAfterStill: 10,
	          // distance: 150 // 视距
	        },
	        postEffectL: {
	          enable: true,
	          depthOfFieldL: {
	            enable: true,
	            focalDistance: 1000,
	            fstop: 100
	          }
	        },
	        layers: [{
	          type: "blend",
	          texture: mapChart
	        }]
	      },
	      series: [{
	        type: "scatter3D",
	        coordinateSystem: "globe",
	        label: {
	          show: false
	        },
	        emphasis: {
	          label: {
	            show: false
	          }
	        },
	        data: []
	      }, {
	        name: "lines3D",
	        type: "lines3D",
	        coordinateSystem: "globe",
	        effect: {
	          show: true,
	          period: 5,
	          trailWidth: 3,
	          trailLength: 0.5,
	          trailOpacity: 1,
	          trailColor: "#0087f4"
	        },
	        blendMode: "lighter",
	        lineStyle: {
	          width: 1,
	          color: "#0087f4",
	          opacity: 0
	        },
	        data: this.dataFJ,
	        silent: false
	      }, {
	        name: "lines3D",
	        type: "lines3D",
	        coordinateSystem: "globe",
	        effect: {
	          show: true,
	          period: 5,
	          trailWidth: 3,
	          trailLength: 0.5,
	          trailOpacity: 1,
	          trailColor: "rgb(47,34,175)"
	        },
	        blendMode: "lighter",
	        lineStyle: {
	          width: 1,
	          color: "rgb(47,34,175)",
	          opacity: 0
	        },
	        data: this.dataYN,
	        silent: false
	      }]
	    };
	
	    this.myChart.setOption(op);
	    var self = this;
	    self.init();
	    // axios.get("../static/json/population.json").then(res => {
	    //   // console.log(res.data)
	    //   this.myData = res.data
	    //     .filter(function(dataItem) {
	    //       return dataItem[2] > 0;
	    //     })
	    //     .map(function(dataItem) {
	    //       return [dataItem[0], dataItem[1], Math.sqrt(dataItem[2])];
	    //     });
	    //   console.log(this.myData);
	    //   this.myChart = echarts.init(document.querySelector(".center .map"));
	    //   var op = {
	    //     visualMap: {
	    //       show: false,
	    //       min: 0,
	    //       max: 60,
	    //       inRange: {
	    //         symbolSize: [1.0, 10.0]
	    //       }
	    //     },
	    //     globe: {
	    //       environment: starfield,
	
	    //       heightTexture: bathymetry,
	
	    //       displacementScale: 0.05,
	    //       displacementQuality: "high",
	
	    //       globeOuterRadius: 100,
	
	    //       baseColor: "#000",
	
	    //       shading: "realistic",
	    //       realisticMaterial: {
	    //         roughness: 0.2,
	    //         metalness: 0
	    //       },
	
	    //       postEffect: {
	    //         enable: true,
	    //         depthOfField: {
	    //           focalRange: 15,
	    //           enable: true,
	    //           focalDistance: 100
	    //         }
	    //       },
	    //       temporalSuperSampling: {
	    //         enable: true
	    //       },
	    //       light: {
	    //         ambient: {
	    //           intensity: 0
	    //         },
	    //         main: {
	    //           intensity: 0.1,
	    //           shadow: false
	    //         },
	    //         ambientCubemap: {
	    //           texture: earth,
	    //           exposure: 1,
	    //           diffuseIntensity: 0.5,
	    //           specularIntensity: 2
	    //         }
	    //       },
	    //       viewControl: {
	    //         autoRotate: false,
	    //         beta: 180,
	    //         alpha: 20,
	    //         distance: 100
	    //       }
	    //     },
	    //     series: {
	    //       type: "scatter3D",
	    //       coordinateSystem: "globe",
	    //       blendMode: "lighter",
	    //       symbolSize: 2,
	    //       itemStyle: {
	    //         color: "rgb(50, 50, 150)",
	    //         opacity: 1
	    //       },
	    //       data: this.myData
	    //     }
	    //   };
	    //   this.myChart.setOption(op);
	    //   this.init();
	    // });
	  },
	  beforeDestroy: function beforeDestroy() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 707 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    top: {
	      type: String,
	      default: ""
	    },
	    min: {
	      type: String,
	      default: "box-wrap"
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '环境质量管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      dataY: [],
	      dataX: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: '10%',
	            left: '20%',
	            right: '10%',
	            bottom: '20%',
	            containLabel: true
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          splitNumber: 4,
	          name: '百万',
	          min: 0,
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	
	            formatter: function formatter(value, index) {
	              return value / 1000000;
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#eb64fb'
	              }, {
	                offset: 1,
	                color: '#3fbbff0d'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i, self;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results.dataList;
	                // console.log(resultData)
	
	                for (i = 0; i < resultData.length; i++) {
	                  _this.dataY.push(resultData[i].harvestQuantity);
	                  _this.dataX.push(resultData[i].month);
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	              self = _this;
	
	              self.chart();
	              self.init();
	              _this.timer = setInterval(function () {
	                // 某些定时器操作
	                self.getData();
	              }, 3000);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '垃圾分类积分排行',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // const data = ['鹿邑县张万里农资门市部', '鹿邑县钻草农资经营门市部', '鹿邑县绍游农资商店', '鹿邑县星灿农业农村服务']
	              //   .map(x => ({
	              //     id: x,
	              //     productionForecast: Math.round(Math.random() * 10000 + 200)
	              //   }))
	              _this.tableData = [{ id: '鹿邑县张万里农资门市部', productionForecast: 10000 }, { id: '鹿邑县钻草农资经营门市部', productionForecast: 8888 }, { id: '鹿邑县绍游农资商店', productionForecast: 7777 }, { id: '鹿邑县星灿农业农村服务', productionForecast: 6666 }, { id: '鹿邑县张永明农资批零部', productionForecast: 5555 }];
	              _this.sum = 10000;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '项目公开',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 22 }, { id: '绿化改造工程', productionForecast: 25 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 50;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: "新生男女比例"
	    };
	  },
	
	  components: {
	    countTo: _vueCountTo2.default
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "销售数据分析",
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    fontSize: function fontSize(res) {
	      var docEl = document.documentElement;
	      var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	      if (!clientWidth) {
	        return;
	      }
	      var fontSize = 100 * (clientWidth / 1920);
	      return res * fontSize;
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        tooltip: {
	          trigger: "axis",
	          axisPointer: {
	            type: "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: "15%",
	          left: "8%",
	          right: "8%",
	          bottom: "10%",
	          containLabel: true
	        },
	        xAxis: [{
	          type: "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          splitLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          },
	          splitArea: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: this.fontSize(0.14)
	          },
	          data: ["铁皮石斛", "安吉白茶", "马站四季柚", "西湖龙井", "西湖藕粉"]
	        }],
	        yAxis: [(0, _defineProperty3.default)({
	          type: "value",
	          splitNumber: 3,
	          // splitLine: {
	          //   show: false
	          // },
	          axisLine: {
	            show: true,
	            lineStyle: {
	              color: "#144088"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0
	          },
	          splitArea: {
	            show: false
	          },
	          splitLine: {
	            show: true,
	            lineStyle: {
	              color: "#144088"
	            }
	          }
	        }, "axisLabel", {
	          interval: 0,
	          color: "#30ABE7",
	          fontSize: this.fontSize(0.14)
	        }), {
	          name: "单位：kg",
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: this.fontSize(0.14),
	            position: "right",
	            padding: [10, 4, 0, -30]
	          },
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          }
	        }],
	        series: [{
	          name: "销售数据",
	          type: "bar",
	          barMaxWidth: this.fontSize(0.18),
	          barGap: "10%",
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 1, 0, 0, [{
	                offset: 0,
	                // color: "#03fef1"
	                color: "rgba(255,183,11,1)"
	              }, {
	                offset: 0.8,
	                // color: "#0173ff"
	                color: "rgba(233,104,0,1)"
	              }], false)
	            }
	          },
	          label: {
	            normal: {
	              show: true,
	              lineHeight: 30,
	              width: 80,
	              height: 30,
	              color: "#1FFFF2",
	              position: "top",
	              distance: -5,
	              fontSize: 14
	            }
	          },
	          data: [1207, 7320, 1442, 386, 283, 1708, 176]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index > 5) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    // this.dataY = [80, 50, 60, 100, 150, 120]
	    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	};

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: "近30天扫码趋势图",
	      min: "box-wrap4",
	      dataY: [],
	      dataX: [],
	      tableData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".area .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    fontSize: function fontSize(res) {
	      var docEl = document.documentElement;
	      var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	      if (!clientWidth) {
	        return;
	      }
	      var fontSize = 100 * (clientWidth / 1920);
	      return res * fontSize;
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".area .main"));
	      this.myChart.setOption({
	        grid: {
	          top: "15%",
	          left: "10%",
	          right: "10%",
	          bottom: "0%",
	          containLabel: true
	        },
	        xAxis: [{
	          type: "category",
	          boundaryGap: false,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          splitLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          },
	          splitArea: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: this.fontSize(0.16)
	          },
	          data: this.dataX
	        }],
	        yAxis: [(0, _defineProperty3.default)({
	          type: "value",
	          // splitLine: {
	          //   show: false
	          // },
	          axisLine: {
	            show: false,
	            lineStyle: {
	              color: "#144088"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0
	          },
	          splitArea: {
	            show: false
	          },
	          splitLine: {
	            show: true,
	            lineStyle: {
	              color: "#144088"
	            }
	          }
	        }, "axisLabel", {
	          interval: 0,
	          color: "#30ABE7",
	          fontSize: this.fontSize(0.14)
	        }), {
	          name: "数量：天/次",
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: this.fontSize(0.14),
	            position: "right",
	            padding: [10, 4, 0, -30]
	          },
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          }
	        }],
	        series: [{
	          name: "注册总量",
	          type: "line",
	          smooth: false, // 是否平滑曲线显示
	          showAllSymbol: true,
	          symbol: "emptyCircle",
	          symbolSize: this.fontSize(0.1),
	          lineStyle: {
	            normal: {
	              color: "rgba(254, 54, 134, 1)" // 线条颜色
	            }
	          },
	          label: {
	            show: true,
	            position: "top",
	            textStyle: {
	              color: "#fff"
	            }
	          },
	          itemStyle: {
	            color: "#F33585",
	            borderColor: "#F33585",
	            borderWidth: this.fontSize(0.03)
	          },
	          tooltip: {
	            show: false
	          },
	          areaStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 1, 0, 0, [{
	                offset: 0,
	                color: "rgba(255, 96, 219, 0.3)"
	              }, {
	                offset: 0.8,
	                color: "rgba(255, 96, 219, 1)"
	              }], false)
	            }
	          },
	          data: [6212, 6582, 8135, 7810, 8000, 9000]
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var myDate = new Date();
	    myDate.setDate(myDate.getDate() - 30);
	    var dateArray = [];
	    var dateTemp;
	    var flag = 1;
	    for (var i = 0; i < 6; i++) {
	      myDate.setDate(myDate.getDate() + 5);
	      var day = myDate.getDate();
	      dateTemp = myDate.getMonth() + 1 + "-" + day;
	      this.dataX.push(dateTemp);
	    }
	
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      self.getData();
	    }, 5000);
	  }
	};

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
	      myChart: {},
	      name: "会员购买商品排行",
	      tableData: [],
	      arr: ["会员积分兑换产品排行", "会员扫码产品排行", "会员参加活动排行", "会员购买商品排行"],
	      list: {
	        会员积分兑换产品排行: [{ id: "随机红包0.5～1元", productionForecast: 39987 }, { id: "光明纯牛奶250ml", productionForecast: 30231 }, { id: "滴滴打车优惠券（随机)", productionForecast: 25121 }, { id: "天猫超市优惠券（随机)", productionForecast: 22123 }, { id: "燕之屋燕窝70g", productionForecast: 20313 }, { id: "茅台体验装", productionForecast: 18219 }, { id: "帮宝适纸尿裤1片装", productionForecast: 16213 }, { id: "婴儿泡泡沐浴露", productionForecast: 12312 }, { id: "曼哈顿儿童咬胶", productionForecast: 10742 }, { id: "花王纸尿裤1片装", productionForecast: 9490 }],
	        会员扫码产品排行: [{ id: "光明新鲜杯优倍200ml", productionForecast: 609987 }, { id: "光明纯牛奶250ml", productionForecast: 590231 }, { id: "光明莫斯利安常温酸牛奶200g", productionForecast: 424121 }, { id: "光明优加纯牛奶250ml", productionForecast: 353123 }, {
	          id: "光明中老年奶粉高钙维生素E调制奶粉听装800g",
	          productionForecast: 300313
	        }, {
	          id: "光明优倍高品质巴氏杀菌鲜牛奶950ml",
	          productionForecast: 287219
	        }, { id: "光明随心订致优全鲜乳尊享杯260ml", productionForecast: 255213 }, { id: "光明噜渴酸奶盒装200ml", productionForecast: 202312 }, { id: "光明如实洋槐蜂蜜发酵乳135g", productionForecast: 198742 }, { id: "光明巧克力味含乳饮料250ml", productionForecast: 158490 }],
	        会员参加活动排行: [{ id: "微信红包", productionForecast: 599987 }, { id: "大转盘抽奖", productionForecast: 450231 }, { id: "翻牌活动", productionForecast: 394121 }, { id: "扫码拿抵扣券", productionForecast: 353123 }, {
	          id: "刮刮乐活动",
	          productionForecast: 292313
	        }, {
	          id: "微信抽免单",
	          productionForecast: 253219
	        }, { id: "签到领积分", productionForecast: 213213 }, { id: "投篮领抵扣券", productionForecast: 192312 }, { id: "集印花领红包", productionForecast: 158742 }, { id: "一起猜歌名", productionForecast: 128490 }],
	        会员购买商品排行: [{ id: "帮宝适纸尿裤", productionForecast: 109987 }, { id: "美赞臣荷兰版铂睿幼儿配方奶粉", productionForecast: 99987 }, { id: "life space婴儿益生菌粉", productionForecast: 97623 }, {
	          id: "lifeline care婴幼儿宝宝鱼油DHA维D3",
	          productionForecast: 83412
	        }, {
	          id: "费雪欢乐成长玩具套餐",
	          productionForecast: 80213
	        }, {
	          id: "曼哈顿咬胶婴幼儿咬胶",
	          productionForecast: 75213
	        }, { id: "花王纸尿裤", productionForecast: 64352 }, { id: "德国施巴婴儿泡泡沐浴露", productionForecast: 45099 }, { id: "儿童声波软毛电动牙刷", productionForecast: 42812 }, { id: "利其尔透透杯系列", productionForecast: 24123 }]
	      },
	      sum: 0,
	      index: 0,
	      swiperOption: {
	        slidesPerView: "auto",
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return "cur";
	      }
	      if (index === 2) {
	        return "cur1";
	      }
	      if (index === 3) {
	        return "cur2";
	      }
	    },
	    getData: function getData() {
	      this.tableData = [];
	      this.index = this.index + 1;
	      if (this.index >= 4) {
	        this.index = 0;
	      }
	      this.name = this.arr[this.index];
	      console.log(this.name);
	      this.tableData = this.list[this.arr[this.index]];
	      this.sum = this.list[this.arr[this.index]][0].productionForecast * 1.1;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    this.getData();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var placeHolderStyle = {
	  normal: {
	    label: {
	      show: false
	    },
	    labelLine: {
	      show: false
	    }
	  }
	};
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "扫码量数据分析",
	      dataY: [],
	      min: "box-wrap2",
	      top: "topname",
	      dataX: [],
	      tableData: [],
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    fontSize: function fontSize(res) {
	      var docEl = document.documentElement;
	      var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	      if (!clientWidth) {
	        return;
	      }
	      var fontSize = 100 * (clientWidth / 1920);
	      return res * fontSize;
	    },
	
	    // getData() {
	    //   this.myChart = echarts.init(document.querySelector(".bar3D .main"));
	    //   this.myChart.clear();
	    //   this.chart();
	    // },
	    chart: function chart() {
	      this.data = [{
	        value: 1207,
	        name: "铁皮石斛"
	      }, {
	        value: 7320,
	        name: "安吉白茶"
	      }, {
	        value: 1442,
	        name: "马站四季柚"
	      }, {
	        value: 386,
	        name: "西湖龙井"
	      }, {
	        value: 283,
	        name: "西湖藕粉"
	      }];
	      var obj = {
	        铁皮石斛: 11.35,
	        安吉白茶: 68.81,
	        马站四季柚: 13.55,
	        西湖龙井: 3.63,
	        西湖藕粉: 2.66
	      };
	      this.myChart = _echarts2.default.init(document.querySelector(".bar3D .main"));
	      var colors = ["#0036D4", "#3FECFF", "#4C63F2", "#FF610B", "#59D267", "#FDD100", "#00A1FD", "#FF7DA4"];
	
	      var op = {
	        tooltip: {
	          trigger: "item",
	          formatter: "{a} <br/>{b}:{d}%"
	        },
	        title: {
	          text: "数据分析",
	          x: "22%",
	          y: "50%",
	          textStyle: {
	            fontSize: this.fontSize(0.16),
	            fontWeight: "normal",
	            color: ["#3FECFF"]
	          }
	        },
	        legend: {
	          orient: "vertical",
	          right: this.fontSize(0.3),
	          top: this.fontSize(0.55),
	          data: ["铁皮石斛", "安吉白茶", "马站四季柚", "西湖龙井", "西湖藕粉"],
	          formatter: function formatter(name) {
	            return "{title|" + name + "}:   {value|" + obj[name] + "%" + "}";
	          },
	          textStyle: {
	            rich: {
	              title: {
	                fontSize: this.fontSize(0.16),
	                lineHeight: this.fontSize(0.15),
	                color: "rgb(0, 178, 246)"
	              },
	              value: {
	                fontSize: this.fontSize(0.16),
	                lineHeight: this.fontSize(0.15),
	                color: "#fff"
	              }
	            }
	          }
	        },
	        series: [{
	          name: "扫码比重",
	          tooltip: {
	            show: false
	          },
	          type: "pie",
	          center: ["30%", "55%"],
	          selectedMode: "single",
	          radius: [0, this.fontSize(0.4)],
	          itemStyle: {
	            normal: {
	              label: {
	                show: false
	              },
	              labelLine: {
	                show: false
	              }
	            }
	          },
	          color: colors,
	          data: [{
	            value: 335,
	            name: "直达"
	          }]
	        }, {
	          name: "扫码比重",
	          type: "pie",
	          center: ["30%", "55%"],
	          radius: [this.fontSize(0.6), this.fontSize(0.8)],
	          color: colors,
	          labelLine: {
	            normal: {
	              show: false
	            }
	          },
	          label: {
	            show: false
	          },
	          itemStyle: {
	            normal: {
	              label: {
	                show: false
	              },
	              labelLine: {
	                show: false
	              }
	            }
	          },
	          data: this.data
	        }]
	      };
	      this.myChart.setOption(op);
	      this.init();
	
	      // const that = this;
	      // let index = 0;
	      // clearInterval(this.timer);
	      // this.timer = setInterval(() => {
	      //   this.myChart.dispatchAction({
	      //     type: "showTip",
	      //     seriesIndex: 0,
	      //     dataIndex: index
	      //   });
	      //   index++;
	      //   // console.log(index)
	      //   if (index >= 6) {
	      //     index = 0;
	      //   }
	      // }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    // this.dataY = [80, 50, 60, 100, 150, 120]
	    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "微店转化率",
	      dataY: [],
	      dataX: [],
	      index: 0,
	      tab: 0,
	      tablist: ["10%", "20%", "15%", "25%", "30%"],
	      data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"],
	      tableData: [],
	      list: {
	        tableData1: [{ value: 80, name: "宝妈" }, { value: 60, name: "牛奶美食" }, { value: 40, name: "纯牛奶" }, { value: 50, name: "纸尿裤" }, { value: 50, name: "投资理财" }, { value: 30, name: "贝尔比" }, { value: 20, name: "打折" }, { value: 20, name: "天猫" }, { value: 25, name: "双十一" }, { value: 30, name: "周杰伦" }, { value: 20, name: "学区房" }, { value: 20, name: "生发素" }, { value: 20, name: "会员" },
	        // { value: 20, name: "积分" },
	        { value: 25, name: "天猫" }, { value: 30, name: "拼多多" }],
	        tableData2: [{ value: 80, name: "领养一头牛" }, { value: 60, name: "抽免单" }, { value: 40, name: "集印花" }, { value: 50, name: "积分兑换" }, { value: 50, name: "微信红包" }, { value: 30, name: "大转盘" },
	        // { value: 20, name: "抵扣" },
	        { value: 20, name: "翻牌" }, { value: 20, name: "打鱼" }, { value: 30, name: "测星座" }, { value: 20, name: "打地鼠" }, { value: 20, name: "签到" }, { value: 20, name: "赛车" }, { value: 20, name: "投篮" }, { value: 25, name: "对对碰" }, { value: 30, name: "刮刮乐" }]
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    chart: function chart() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar6 .main"));
	      var option = {
	        color: ["rgba(70,202,246,0.5)", "rgba(206,134,217,0.5)", "rgba(120,116,235,0.5)"],
	        calculable: true,
	        series: [{
	          type: "treemap",
	          width: "100%",
	          height: "100%",
	          // left: "10%",
	          roam: false, // 是否开启拖拽漫游（移动和缩放）
	          nodeClick: false, // 点击节点后的行为,false无反应
	          breadcrumb: {
	            show: false
	          },
	          label: {
	            normal: {
	              textStyle: {
	                fontWeight: "bold",
	                color: "rgba(255,255,255,1)",
	                fontSize: "30"
	              }
	            }
	          },
	          itemStyle: {
	            normal: {
	              label: {
	                show: true,
	                formatter: "{b}"
	              },
	              borderWidth: 5,
	              borderColor: "transparent "
	            }
	          },
	          data: this.tableData
	        }]
	      };
	      this.myChart.setOption(option);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    var self = this;
	    this.tableData = this.list.tableData1;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      if (_this.index === 1) {
	        _this.tableData = _this.list.tableData2;
	        _this.index = 2;
	      } else {
	        _this.tableData = _this.list.tableData1;
	        _this.index = 1;
	      }
	      _this.chart();
	    }, 15000);
	    this.indextimer = setInterval(function () {
	      _this.tab = _this.tab + 1;
	      if (_this.tab >= _this.tablist.length) {
	        _this.tab = 0;
	      }
	    }, 3000);
	  }
	};

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '产业情况',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    countTo: _vueCountTo2.default
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }];
	  }
	};
	// import '/../../../../static/css/swiper.css'

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#407FFF', '#F45E23', '#E6AF08', '#49C8CF'],
	      myChart: {},
	      name: '补贴发放',
	      dataX: [],
	      timer: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    // console.log(this.chartData)
	    this.dataX = ['危房改造', '大病救助', '留守儿童', '低保五保'];
	    this.chartData = [{ name: '危房改造', value: 30 }, { name: '大病救助', value: 20 }, { name: '留守儿童', value: 30 }, { name: '低保五保', value: 20 }];
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie1 .main'));
	    var op = {
	      title: {
	        text: '第三季度',
	        textStyle: {
	          color: '#33D8FB',
	          fontSize: 20
	        },
	        top: '%',
	        right: '5%'
	      },
	      legend: [{
	        orient: 'vertical',
	        right: '20',
	        bottom: '20',
	        itemHeight: 16,
	        itemWidth: 16,
	        data: this.dataX,
	        textStyle: {
	          color: "#FFF",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '75%'],
	        center: ['35%', '50%'],
	        data: data,
	        label: {
	          position: 'outside',
	          normal: {
	            // formatter: '{b|{b}}\n{hr|}\n{c|{c}%}',
	            // rich: {
	            //   b: {
	            //     fontSize: 16,
	            //     color: '#FFF',
	            //     align: 'left',
	            //     padding: 4
	            //   },
	            //   hr: {
	            //     borderColor: '#CCCCCC',
	            //     width: '100%',
	            //     borderWidth: 2,
	            //     height: 0
	            //   },
	            //   c: {
	            //     fontSize: 16,
	            //     align: 'center',
	            //     padding: 4,
	            //     color: '#00EDED'
	            //   }
	            // }
	          }
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '种植批次数据',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                // console.log(resultData)
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '区域在售登记种类',
	      dataY: [],
	      dataX: [],
	      type: {
	        '农药': 779,
	        '种子': 50,
	        '肥料': 200,
	        '兽药': 596,
	        '饲料': 354
	      },
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.setOption({
	        animation: true,
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        xAxis: {
	          name: '类型',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	            // top: 20,
	            // padding: [25, 0, 0, -10]
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	            // rotate: 30
	          }
	        },
	        yAxis: {
	          name: '交易量（笔）',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, 10]
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              if (value > 10000) {
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(232,159,31,1)"
	              }, {
	                offset: 0.8,
	                color: "rgba(241,100,30,1)"
	              }], false)
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [1000, 600, 100, Math.round(Math.random() * 100 + 100)];
	    this.dataX = ['进货台账', '销售台账', '高剧毒农药', '废弃物回收'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	
	    var that = this;
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      index++;
	      // console.log(index)
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ["salesDataRealTime"],
	  data: function data() {
	    return {
	      name: "农残抽检分析",
	      tableData: [],
	      time: null,
	      min: "box-wrap5",
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return "color:" + this.colorList[index];
	      } else {
	        return "color:" + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{
	      time: "2019/11/16",
	      base: "铁皮石斛1907119批次",
	      id: "7.6",
	      node: "100%"
	    }, {
	      time: "2019/10/29",
	      base: "安吉白茶1902004批次",
	      id: "6.4",
	      node: "100%"
	    }, {
	      time: "2019/10/08",
	      base: "马站四季柚1903221批次",
	      id: "6.8",
	      node: "100%"
	    }, {
	      time: "2019/09/29",
	      base: "西湖龙井1910548批次",
	      id: "7.2",
	      node: "100%"
	    }, {
	      time: "2019/09/16",
	      base: "西湖藕粉1903182批次",
	      id: "5.3",
	      node: "100%"
	    }];
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.time);
	    this.time = null;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ["salesDataRealTime"],
	  data: function data() {
	    return {
	      name: "溯源记录",
	      tableData: [],
	      time: null,
	      min: "box-wrap3",
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return "color:" + this.colorList[index];
	      } else {
	        return "color:" + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{
	      time: "2019/10/19 09:21:31",
	      base: "杭州余杭莲花种植基地",
	      id: "1910548",
	      node: "灌溉"
	    }, {
	      time: "2019/09/14 08:01:12",
	      base: "杭州梅家坞龙井种植基地/",
	      id: "1907119",
	      node: "修剪"
	    }, {
	      time: "2019/08/11 14:51:11 ",
	      base: "温州乐清铁皮石斛种植基地",
	      id: "190322",
	      node: "施肥"
	    }, {
	      time: "2019/09/04 08:18:22",
	      base: "湖州安吉白茶种植基地",
	      id: "1902004",
	      node: "植保"
	    }, {
	      time: "2019/08/22 16:44:30",
	      base: "温州马站四季柚种植基地",
	      id: "1903182",
	      node: "灌溉"
	    }];
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.time);
	    this.time = null;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(39);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可视化管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _chayeheader = __webpack_require__(1730);
	
	var _chayeheader2 = _interopRequireDefault(_chayeheader);
	
	var _item = __webpack_require__(1802);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _item3 = __webpack_require__(1803);
	
	var _item4 = _interopRequireDefault(_item3);
	
	var _item5 = __webpack_require__(1804);
	
	var _item6 = _interopRequireDefault(_item5);
	
	var _center = __webpack_require__(1797);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _item7 = __webpack_require__(1805);
	
	var _item8 = _interopRequireDefault(_item7);
	
	var _item9 = __webpack_require__(1806);
	
	var _item10 = _interopRequireDefault(_item9);
	
	var _item11 = __webpack_require__(1807);
	
	var _item12 = _interopRequireDefault(_item11);
	
	var _table = __webpack_require__(1812);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _planting = __webpack_require__(1810);
	
	var _planting2 = _interopRequireDefault(_planting);
	
	var _generatingData = __webpack_require__(1799);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _salesData = __webpack_require__(1811);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table3 = __webpack_require__(1813);
	
	var _table4 = _interopRequireDefault(_table3);
	
	var _pie = __webpack_require__(1809);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _bar = __webpack_require__(1795);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _harvestingPlan = __webpack_require__(1801);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _ev = __webpack_require__(1798);
	
	var _ev2 = _interopRequireDefault(_ev);
	
	var _video = __webpack_require__(1814);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _group = __webpack_require__(1800);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _list = __webpack_require__(1808);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      name: "浙江省农产品追溯数据舱",
	      outputValue: "",
	      productionScale: "",
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      timerDashboard: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.show = true;
	
	            case 1:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerDashboard);
	    this.timerDashboard = null;
	  },
	
	  methods: {},
	  components: {
	    "v-header": _chayeheader2.default,
	    "v-item1": _item2.default,
	    "v-item2": _item4.default,
	    "v-item3": _item6.default,
	    "v-center": _center2.default,
	    "v-item4": _item8.default,
	    "v-item5": _item10.default,
	    "v-item6": _item12.default,
	    "v-salesData": _salesData2.default,
	    "v-table": _table4.default,
	    "v-table2": _table2.default,
	    "v-harvestingPlan": _harvestingPlan2.default,
	    "v-generatingData": _generatingData2.default,
	    "v-pie": _pie2.default,
	    "v-bar": _bar2.default,
	    "v-list": _list2.default,
	    "v-ev": _ev2.default,
	    "v-video": _video2.default,
	    "v-planting": _planting2.default,
	    "v-group": _group2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      swiperData: ['总屏', '销售数据', '基地数据', '溯源数据', '精准扶贫'],
	      swiperOption: {
	        slidesPerView: 6,
	        speed: 300,
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // current swiper instance
	    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
	    console.log('this is current swiper instance object', this.swiper);
	    // this.swiper.slideTo(3, 1000, false)
	  },
	
	  computed: {
	    swiper: function swiper() {
	      return this.$refs.mySwiper.swiper;
	    }
	  },
	  // ['总屏', '销售数据', '基地数据', '溯源数据', '产品展示'],
	  methods: {
	    clickPage: function clickPage(index) {
	      if (index === 0) {
	        // 总屏
	        this.$router.push('/rundadashboard');
	      } else if (index === 1) {
	        // 销售数据
	        this.$router.push('/rundasalesDataCenter');
	      } else if (index === 2) {
	        // 基地数据
	        this.$router.push('/rundaindustryInformation');
	      } else if (index === 3) {
	        // 环境监测
	        this.$router.push('/rundatrace');
	      } else if (index === 4) {
	        // 溯源数据
	        this.$router.push('/rundahelper');
	      }
	    }
	  }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(140);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(172);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _centerBottom = __webpack_require__(1816);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	__webpack_require__(1615);
	
	__webpack_require__(1614);
	
	__webpack_require__(1400);
	
	__webpack_require__(1399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var MassifItem = function () {
	  function MassifItem(theme) {
	    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var index = arguments[3];
	    (0, _classCallCheck3.default)(this, MassifItem);
	    this.list = [];
	    this.type = 'left';
	
	    this.theme = theme;
	    this.text = text;
	    this.name = name;
	    this.index = index;
	  }
	
	  (0, _createClass3.default)(MassifItem, [{
	    key: 'setMassif',
	    value: function setMassif(massif) {
	      this.massif = massif;
	      return this;
	    }
	  }, {
	    key: 'setList',
	    value: function setList(list) {
	      this.list = list;
	      return this;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var style = {};
	      return style;
	    }
	  }, {
	    key: 'getThemeIndex',
	    value: function getThemeIndex() {
	      var _this = this;
	
	      return this.list.filter(function (item) {
	        return item.theme === _this.theme;
	      }).indexOf(this);
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var themeIndex = this.getThemeIndex();
	      return classNames('theme-' + this.theme, 'theme-index-' + themeIndex);
	    }
	  }]);
	  return MassifItem;
	}();
	
	var list = [new MassifItem(1, '', 'D10', 0), new MassifItem(1, '', 'D09', 1), new MassifItem(1, '', 'D08', 2), new MassifItem(1, '', 'D07', 3), new MassifItem(1, '', 'D06', 4), new MassifItem(1, '', 'D05', 5), new MassifItem(1, '', 'D04', 6), new MassifItem(1, '', 'D03', 7), new MassifItem(1, '', 'D02', 8), new MassifItem(1, '', 'D01', 9),
	//
	new MassifItem(2, '', '16-1', 0), new MassifItem(2, '', '16-3', 1), new MassifItem(2, '', '16-5', 2), new MassifItem(2, '', '16-7', 3), new MassifItem(2, '', '16-9', 4), new MassifItem(2, '', '16-11', 5), new MassifItem(2, '', '16-2', 6), new MassifItem(2, '', '16-4', 7), new MassifItem(2, '', '16-6', 8), new MassifItem(2, '', '16-8', 9), new MassifItem(2, '', '16-10', 10), new MassifItem(2, '', '16-12', 11),
	//
	new MassifItem(3, '', '', 0), new MassifItem(3, '', '', 1),
	//
	new MassifItem(4, '15', '15号棚', 0), new MassifItem(5, '', '', 1),
	//
	new MassifItem(6, '', '14号棚', 0), new MassifItem(6, '', '13号棚', 1),
	//
	new MassifItem(7, '', '12号棚', 1), new MassifItem(8, '', '11号棚', 0), new MassifItem(8, '', '9号棚', 1), new MassifItem(8, '', '3号棚', 2), new MassifItem(8, '', '8号棚', 3), new MassifItem(8, '', '2号棚', 4), new MassifItem(8, '', '7号棚', 5), new MassifItem(8, '', '1号棚', 6),
	//
	new MassifItem(9, '', '10号棚', 0), new MassifItem(10, '', '', 1),
	//
	new MassifItem(11, '', '6号棚', 0), new MassifItem(11, '', '5号棚', 1), new MassifItem(11, '', '4号棚', 2),
	//
	new MassifItem(12, '', '', 0), new MassifItem(13, '', '', 1), new MassifItem(14, '', '', 2),
	//
	new MassifItem(15, '', '展-2A', 0), new MassifItem(15, '', '展-2C', 1),
	//
	new MassifItem(16, '', '展-2B', 0), new MassifItem(16, '', '展-2D', 1),
	//
	new MassifItem(17, '', '展-叶菜区', 0), new MassifItem(17, '', '展-叶菜区', 1)];
	var rightlist = [new MassifItem(null), new MassifItem(15, '15', '581-15'), new MassifItem(16, '16', '581-16'), new MassifItem(14, '14', '581-14'), new MassifItem(17, '17', '581-17'), new MassifItem(13, '13', '581-13'), new MassifItem(18, '18', '581-18'), new MassifItem(12, '12', '581-12'), new MassifItem(19, '19', '581-19'), new MassifItem(11, '11', '581-11'), new MassifItem(20, '20', '581-20'), new MassifItem(10, '10', '581-10'), new MassifItem(21, '21', '581-21'), new MassifItem(9, '9', '581-9'), new MassifItem(22, '22', '581-22'), new MassifItem(8, '8', '581-8'), new MassifItem(23, '23', '581-23'), new MassifItem(7, '7', '581-7'), new MassifItem(24, '24', '581-24'), new MassifItem(6, '6', '581-6'), new MassifItem(25, '25', '581-25'), new MassifItem(5, '5', '581-5'), new MassifItem(26, '26', '581-26'), new MassifItem(4, '4', '581-4'), new MassifItem(27, '27', '581-27'), new MassifItem(3, '3', '581-3'), new MassifItem(28, '28', '581-28'), new MassifItem(2, '2', '581-2'), new MassifItem(29, '29', '581-29'), new MassifItem(1, '1', '581-1')];
	
	exports.default = {
	  props: ["productionScale", "outputValue"],
	  data: function data() {
	    return {
	      areaName: '',
	      timer: null,
	      massifList: [],
	      massifListR: [],
	      tip: true,
	      list: [],
	      datalist: [],
	      index: 0,
	      url: _config2.default.fileDomain
	    };
	  },
	
	  components: {
	    centerBottom: _centerBottom2.default
	  },
	  methods: {
	    show: function show(val, type) {
	      // console.log(type === '1')
	      if (type === '1') {
	        clearInterval(this.timer);
	      }
	      this.tip = true;
	      this.list = val;
	    },
	    tips: function tips() {
	      clearInterval(this.timer);
	      this.tip = true;
	    },
	    leave: function leave() {
	      this.tip = false;
	      this.time();
	    },
	    time: function time() {
	      var _this2 = this;
	
	      var count = this.datalist.length;
	      this.timer = setInterval(function () {
	        if (_this2.index > count) {
	          _this2.index = 0;
	        }
	        _this2.show(_this2.datalist[_this2.index]);
	        _this2.index = _this2.index + 1;
	        // console.log(this.index)
	      }, 3000);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, _resultData, key, i, j, data, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this3.$model('dataManagement').commonfn2(_this3.$apiUrl.DATAANALYSIS.GetMassIfInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                _resultData = res.results;
	
	                _resultData = {
	                  "10号棚": [{
	                    "massIfName": "10号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "4488.0",
	                    "hasHarvest": 0,
	                    "massId": "5da6b24187944a778a1e1867c8757923",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 4488
	                  }],
	                  "12号棚": [{
	                    "massIfName": "12号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1824.0",
	                    "hasHarvest": 0,
	                    "massId": "7f458d2a56d6428ea205bf60806e6c14",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1824
	                  }],
	                  "13号棚": [{
	                    "massIfName": "13号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "6161573284224bab92fd36ae41dc6e03",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "14号棚": [{
	                    "massIfName": "14号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "5adcad3d40b143ada96b2624a88b75dd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "15号棚": [{
	                    "massIfName": "15号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "405421605f8242ffbeca94ed87f76bcb",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "16-1": [{
	                    "massIfName": "16-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-1_20190822",
	                    "toHarvestDays": "-2",
	                    "hasHarvest": 0,
	                    "progressRate": 1.027027,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-22",
	                    "harvestQuantity": 64360,
	                    "harvestDamagedQuantity": 734,
	                    "massId": "628654838b564fc381d56e06f8072862",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-11-04",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-22 19:48:30",
	                    "harvestCreateTime": 1572861140941,
	                    "id": 186,
	                    "massAreaVal": 5960
	                  }],
	                  "16-10": [{
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20191015",
	                    "toHarvestDays": "51",
	                    "hasHarvest": 0,
	                    "progressRate": 0.32,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-13",
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-15 16:13:11",
	                    "id": 332,
	                    "massAreaVal": 5636
	                  }, {
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-06",
	                    "harvestQuantity": 14883,
	                    "harvestDamagedQuantity": 140,
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-12",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:44:45",
	                    "harvestCreateTime": 1571129662779,
	                    "id": 226,
	                    "massAreaVal": 5636
	                  }],
	                  "16-11": [{
	                    "massIfName": "16-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "7152.0",
	                    "traceBatchName": "美月西瓜_16-11_20190904",
	                    "toHarvestDays": "11",
	                    "hasHarvest": 0,
	                    "progressRate": 0.8513514,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-04 21:52:36",
	                    "id": 234,
	                    "massAreaVal": 7152
	                  }],
	                  "16-12": [{
	                    "massIfName": "16-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6768.0",
	                    "traceBatchName": "美月西瓜_16-12_20190924",
	                    "toHarvestDays": "24",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6712329,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-18",
	                    "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-24 15:00:59",
	                    "id": 300,
	                    "massAreaVal": 6768
	                  }],
	                  "16-2": [{
	                    "massIfName": "16-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-2_20190818",
	                    "toHarvestDays": "-8",
	                    "hasHarvest": 0,
	                    "progressRate": 1.1111112,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-18",
	                    "massId": "30596634280f4c88a320ef3dd911c41b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-18 21:58:05",
	                    "id": 183,
	                    "massAreaVal": 5640
	                  }],
	                  "16-3": [{
	                    "massIfName": "16-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-3_20190826",
	                    "toHarvestDays": "-66",
	                    "hasHarvest": 0,
	                    "progressRate": 12,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-26",
	                    "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-26 22:14:39",
	                    "id": 189,
	                    "massAreaVal": 5960
	                  }],
	                  "16-4": [{
	                    "massIfName": "16-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-4_20190831",
	                    "toHarvestDays": "6",
	                    "hasHarvest": 0,
	                    "progressRate": 0.91780823,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-31",
	                    "massId": "8095b224d21c469681b3adebbc2639b2",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-31 19:59:52",
	                    "id": 217,
	                    "massAreaVal": 5640
	                  }],
	                  "16-5": [{
	                    "massIfName": "16-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-5_20190923",
	                    "toHarvestDays": "3",
	                    "hasHarvest": 0,
	                    "progressRate": 0.95454544,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "f53c67ab0b484dcea2c0d6a397828200",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:15:05",
	                    "id": 296,
	                    "massAreaVal": 5960
	                  }],
	                  "16-6": [{
	                    "massIfName": "16-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5462.0",
	                    "hasHarvest": 0,
	                    "massId": "66afdfa9d0c94ebe942d02682354c218",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 5462
	                  }],
	                  "16-7": [{
	                    "massIfName": "16-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6536.0",
	                    "traceBatchName": "美月西瓜_16-7_20191012",
	                    "toHarvestDays": "40",
	                    "hasHarvest": 0,
	                    "progressRate": 0.4520548,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-04",
	                    "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:08:40",
	                    "id": 319,
	                    "massAreaVal": 6536
	                  }],
	                  "16-8": [{
	                    "massIfName": "16-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6203.0",
	                    "hasHarvest": 0,
	                    "massId": "7932fe634ff84135bf616c3665171bd0",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 6203
	                  }],
	                  "16-9": [{
	                    "massIfName": "16-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5736.0",
	                    "traceBatchName": "美月西瓜_16-9_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-13",
	                    "harvestQuantity": 13147,
	                    "harvestDamagedQuantity": 15,
	                    "massId": "56a5fbb4f6b641daa0d56bae99261067",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-21",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:45:56",
	                    "harvestCreateTime": 1571828586702,
	                    "id": 227,
	                    "massAreaVal": 5736
	                  }],
	                  "1号棚": [{
	                    "massIfName": "1号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "82a7d7497b2c480a8588ae633ed1fed5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "2号棚": [{
	                    "massIfName": "2号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "b648e2e829144d4d88db432519d3f0ca",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "3号棚": [{
	                    "massIfName": "3号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "60e1a5484b4e4185a6f84b413ec0123e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "4号棚": [{
	                    "massIfName": "4号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "581-1": [{
	                    "massIfName": "581-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "美月西瓜_581-1_20190908",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
	                    "productName": "美月西瓜",
	                    "harvestQuantity": 17198,
	                    "harvestDamagedQuantity": 250,
	                    "massId": "a71183836d634425be34001674d28011",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-22",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-08 19:08:26",
	                    "harvestCreateTime": 1571736980512,
	                    "id": 245,
	                    "massAreaVal": 6080
	                  }],
	                  "581-10": [{
	                    "massIfName": "581-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "hasHarvest": 0,
	                    "massId": "70fa77f342484e448b043fea4f15807b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6080
	                  }],
	                  "581-11": [{
	                    "massIfName": "581-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-12": [{
	                    "massIfName": "581-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "649cf669ea50497abf0e2d654a5a0394",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-13": [{
	                    "massIfName": "581-13",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "192737df21064002a87b1a900330a822",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-14": [{
	                    "massIfName": "581-14",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8901900a1de14e619baa1657e10c12b6",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-15": [{
	                    "massIfName": "581-15",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "1632a87c41264b449c2c2c50308780bd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-16": [{
	                    "massIfName": "581-16",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "43600f01a840498fa87358e1db1ad723",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-17": [{
	                    "massIfName": "581-17",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0767994c6c944a568fea24452a78503a",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-18": [{
	                    "massIfName": "581-18",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "6499f5114e32433f883f70b09be18911",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-19": [{
	                    "massIfName": "581-19",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "13d7b6c1471c49b0820234d8aadba8c8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-2": [{
	                    "massIfName": "581-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-2_20190930",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "1f959a5d82604b0da975f6002472ae24",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:26:21",
	                    "id": 315,
	                    "massAreaVal": 6688
	                  }],
	                  "581-20": [{
	                    "massIfName": "581-20",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "7a570059e21844999df90b76ed0e2cbe",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-21": [{
	                    "massIfName": "581-21",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-22": [{
	                    "massIfName": "581-22",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-23": [{
	                    "massIfName": "581-23",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-24": [{
	                    "massIfName": "581-24",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "c85f7ce299984c0ab29d4150b78a0645",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-25": [{
	                    "massIfName": "581-25",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8cb7080522154bb5a13c2e4f957ddec7",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-26": [{
	                    "massIfName": "581-26",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0a9bb5a9581946ee965c49cbb29263c5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-27": [{
	                    "massIfName": "581-27",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "11fe60cbd69d4ed2994386199ca425ec",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-28": [{
	                    "massIfName": "581-28",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-28_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
	                    "productName": "美月西瓜",
	                    "massId": "4d4f35f175dd4942ac698497cf409b00",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:49:26",
	                    "id": 297,
	                    "massAreaVal": 6688
	                  }],
	                  "581-29": [{
	                    "massIfName": "581-29",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "2816.0",
	                    "hasHarvest": 0,
	                    "massId": "809cdd4e59214c97b524abdb2b6aac64",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 2816
	                  }],
	                  "581-3": [{
	                    "massIfName": "581-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "29ec59c9be394d298e464d919a5268e3",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-4": [{
	                    "massIfName": "581-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "千禧圣女果_581-4_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-23",
	                    "massId": "70804d660171419e94de93509a066c1f",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:25:47",
	                    "id": 322,
	                    "massAreaVal": 6688
	                  }],
	                  "581-5": [{
	                    "massIfName": "581-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "千禧圣女果_581-5_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-24",
	                    "massId": "1eef15f5af1547d4b335ecd3920ccde0",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:27:03",
	                    "id": 323,
	                    "massAreaVal": 6080
	                  }],
	                  "581-6": [{
	                    "massIfName": "581-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-6_20190930",
	                    "toHarvestDays": "14",
	                    "hasHarvest": 0,
	                    "progressRate": 0.7307692,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-29",
	                    "massId": "3d2d32ca91004bf98d3745d3e33bf728",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:27:21",
	                    "id": 316,
	                    "massAreaVal": 6688
	                  }],
	                  "581-7": [{
	                    "massIfName": "581-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-7_20190825",
	                    "toHarvestDays": "-21",
	                    "hasHarvest": 0,
	                    "progressRate": 1.4038461,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-25",
	                    "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-25 22:34:36",
	                    "id": 188,
	                    "massAreaVal": 6688
	                  }],
	                  "581-8": [{
	                    "massIfName": "581-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "589a973f7b114735a322b6604f86caf4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-9": [{
	                    "massIfName": "581-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "21ad8dbaddd34a479b899d4f0714ef44",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "5号棚": [{
	                    "massIfName": "5号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "6cd116f8f77a455c8017db42df934b10",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "6号棚": [{
	                    "massIfName": "6号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "9c458864d4404387bf9a77664bb5059b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "7号棚": [{
	                    "massIfName": "7号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "65df5b086e1b4e7b84909f49d3068c9b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "8号棚": [{
	                    "massIfName": "8号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "dc03b56080c3499982395b2d52b23a7c",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "9号棚": [{
	                    "massIfName": "9号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "34534f5a1d344e4aadefa38cc1090154",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "D0": [{
	                    "massIfName": "D0",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "辣木_D0_20191017",
	                    "toHarvestDays": "827",
	                    "hasHarvest": 0,
	                    "progressRate": 0.045034643,
	                    "productUrl": "784bd0037268432a94587ce223230b39",
	                    "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
	                    "productName": "辣木",
	                    "startDate": "2019-09-28",
	                    "massId": "b20cf9abd0fc458c8465783005bb9ecd",
	                    "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:37:25",
	                    "id": 333,
	                    "massAreaVal": 0.38
	                  }],
	                  "D1": [{
	                    "massIfName": "D1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "美月西瓜_D1_20191018",
	                    "toHarvestDays": "22",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6393443,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-28",
	                    "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-18 12:10:53",
	                    "id": 353,
	                    "massAreaVal": 0.38
	                  }],
	                  "D10": [{
	                    "massIfName": "D10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D10_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "92dc3b5740db43c7874ea0b8a1d832af",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:47:21",
	                    "id": 338,
	                    "massAreaVal": 0.38
	                  }],
	                  "D2": [{
	                    "massIfName": "D2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D3": [{
	                    "massIfName": "D3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D4": [{
	                    "massIfName": "D4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D5": [{
	                    "massIfName": "D5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D5_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "5d12c9b3ec154568ba17aca75394a58f",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:57:20",
	                    "id": 339,
	                    "massAreaVal": 0.38
	                  }],
	                  "D6": [{
	                    "massIfName": "D6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D6_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "9679093957eb4348b9f75543a289382a",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:58:04",
	                    "id": 340,
	                    "massAreaVal": 0.38
	                  }],
	                  "D7": [{
	                    "massIfName": "D7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D7_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "fbde48394efe44158c5264fee351b931",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:44:50",
	                    "id": 335,
	                    "massAreaVal": 0.38
	                  }],
	                  "D8": [{
	                    "massIfName": "D8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D8_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "c2a1a4345da544be87b5f8618dd39b16",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:45:51",
	                    "id": 336,
	                    "massAreaVal": 0.38
	                  }],
	                  "D9": [{
	                    "massIfName": "D9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D9_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "85f25eee14804242901771c88003da36",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:46:40",
	                    "id": 337,
	                    "massAreaVal": 0.38
	                  }],
	                  "展-2A": [{
	                    "massIfName": "展-2A",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2B": [{
	                    "massIfName": "展-2B",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "c90327e44c0e451fafa3a2df9dff631f",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2C": [{
	                    "massIfName": "展-2C",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "曼西娜番茄_展-2C_20191029",
	                    "toHarvestDays": "82",
	                    "hasHarvest": 0,
	                    "progressRate": 0.344,
	                    "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
	                    "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
	                    "productName": "曼西娜番茄",
	                    "startDate": "2019-09-24",
	                    "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
	                    "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-29 17:01:17",
	                    "id": 380,
	                    "massAreaVal": 1532
	                  }],
	                  "展-2D": [{
	                    "massIfName": "展-2D",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
	                    "hasHarvest": 0,
	                    "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
	                    "productName": "永优黄灯笼辣椒",
	                    "startDate": "2019-09-05",
	                    "massId": "8fa29c0468de4d1e818b0ed2de06513f",
	                    "productId": "ed65a6819e7747e5be8db447620a3385",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-05 21:02:59",
	                    "id": 237,
	                    "massAreaVal": 1532
	                  }],
	                  "展-叶菜区": [{
	                    "massIfName": "展-叶菜区",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "3.46",
	                    "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "16182b0db47c44698a436be9e42231cc",
	                    "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
	                    "productName": "潮州快大夏皇白",
	                    "startDate": "2019-09-02",
	                    "harvestQuantity": 3921,
	                    "harvestDamagedQuantity": 0,
	                    "massId": "d7aac8fc55cf4d39871d844eb215d048",
	                    "productId": "648a21743c0a468499e37f807ef24e7f",
	                    "harvestDate": "2019-09-24",
	                    "areaUnitName": "亩",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:57:40",
	                    "harvestCreateTime": 1569290697617,
	                    "id": 298,
	                    "massAreaVal": 3.46
	                  }],
	                  "展示大棚": [{
	                    "massIfName": "展示大棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "9500.0",
	                    "hasHarvest": 0,
	                    "massId": "718722a0322a4b28b70de55a82a9a019",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 9500
	                  }]
	                };
	                for (key in _resultData) {
	                  for (i = 0; i < list.length; i++) {
	                    if (key === list[i].name) {
	                      list[i].setList(_resultData[key]);
	                      _this3.datalist.push(_resultData[key]);
	                    }
	                  }
	                  for (j = 0; j < rightlist.length; j++) {
	                    if (key === rightlist[j].name) {
	                      rightlist[j].setList(_resultData[key]);
	                      _this3.datalist.push(_resultData[key]);
	                    }
	                  }
	                }
	                _this3.massifList = list;
	                _this3.massifListR = rightlist;
	                console.log(_this3.datalist);
	                _this3.time();
	              } else {
	                // this.$message.showError(err);
	                data = {
	                  "10号棚": [{
	                    "massIfName": "10号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "4488.0",
	                    "hasHarvest": 0,
	                    "massId": "5da6b24187944a778a1e1867c8757923",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 4488
	                  }],
	                  "12号棚": [{
	                    "massIfName": "12号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1824.0",
	                    "hasHarvest": 0,
	                    "massId": "7f458d2a56d6428ea205bf60806e6c14",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1824
	                  }],
	                  "13号棚": [{
	                    "massIfName": "13号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "6161573284224bab92fd36ae41dc6e03",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "14号棚": [{
	                    "massIfName": "14号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "5adcad3d40b143ada96b2624a88b75dd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "15号棚": [{
	                    "massIfName": "15号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "405421605f8242ffbeca94ed87f76bcb",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "16-1": [{
	                    "massIfName": "16-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-1_20190822",
	                    "toHarvestDays": "-2",
	                    "hasHarvest": 0,
	                    "progressRate": 1.027027,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-22",
	                    "harvestQuantity": 64360,
	                    "harvestDamagedQuantity": 734,
	                    "massId": "628654838b564fc381d56e06f8072862",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-11-04",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-22 19:48:30",
	                    "harvestCreateTime": 1572861140941,
	                    "id": 186,
	                    "massAreaVal": 5960
	                  }],
	                  "16-10": [{
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20191015",
	                    "toHarvestDays": "51",
	                    "hasHarvest": 0,
	                    "progressRate": 0.32,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-13",
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-15 16:13:11",
	                    "id": 332,
	                    "massAreaVal": 5636
	                  }, {
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-06",
	                    "harvestQuantity": 14883,
	                    "harvestDamagedQuantity": 140,
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-12",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:44:45",
	                    "harvestCreateTime": 1571129662779,
	                    "id": 226,
	                    "massAreaVal": 5636
	                  }],
	                  "16-11": [{
	                    "massIfName": "16-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "7152.0",
	                    "traceBatchName": "美月西瓜_16-11_20190904",
	                    "toHarvestDays": "11",
	                    "hasHarvest": 0,
	                    "progressRate": 0.8513514,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-04 21:52:36",
	                    "id": 234,
	                    "massAreaVal": 7152
	                  }],
	                  "16-12": [{
	                    "massIfName": "16-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6768.0",
	                    "traceBatchName": "美月西瓜_16-12_20190924",
	                    "toHarvestDays": "24",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6712329,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-18",
	                    "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-24 15:00:59",
	                    "id": 300,
	                    "massAreaVal": 6768
	                  }],
	                  "16-2": [{
	                    "massIfName": "16-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-2_20190818",
	                    "toHarvestDays": "-8",
	                    "hasHarvest": 0,
	                    "progressRate": 1.1111112,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-18",
	                    "massId": "30596634280f4c88a320ef3dd911c41b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-18 21:58:05",
	                    "id": 183,
	                    "massAreaVal": 5640
	                  }],
	                  "16-3": [{
	                    "massIfName": "16-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-3_20190826",
	                    "toHarvestDays": "-66",
	                    "hasHarvest": 0,
	                    "progressRate": 12,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-26",
	                    "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-26 22:14:39",
	                    "id": 189,
	                    "massAreaVal": 5960
	                  }],
	                  "16-4": [{
	                    "massIfName": "16-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-4_20190831",
	                    "toHarvestDays": "6",
	                    "hasHarvest": 0,
	                    "progressRate": 0.91780823,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-31",
	                    "massId": "8095b224d21c469681b3adebbc2639b2",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-31 19:59:52",
	                    "id": 217,
	                    "massAreaVal": 5640
	                  }],
	                  "16-5": [{
	                    "massIfName": "16-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-5_20190923",
	                    "toHarvestDays": "3",
	                    "hasHarvest": 0,
	                    "progressRate": 0.95454544,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "f53c67ab0b484dcea2c0d6a397828200",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:15:05",
	                    "id": 296,
	                    "massAreaVal": 5960
	                  }],
	                  "16-6": [{
	                    "massIfName": "16-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5462.0",
	                    "hasHarvest": 0,
	                    "massId": "66afdfa9d0c94ebe942d02682354c218",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 5462
	                  }],
	                  "16-7": [{
	                    "massIfName": "16-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6536.0",
	                    "traceBatchName": "美月西瓜_16-7_20191012",
	                    "toHarvestDays": "40",
	                    "hasHarvest": 0,
	                    "progressRate": 0.4520548,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-04",
	                    "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:08:40",
	                    "id": 319,
	                    "massAreaVal": 6536
	                  }],
	                  "16-8": [{
	                    "massIfName": "16-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6203.0",
	                    "hasHarvest": 0,
	                    "massId": "7932fe634ff84135bf616c3665171bd0",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 6203
	                  }],
	                  "16-9": [{
	                    "massIfName": "16-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5736.0",
	                    "traceBatchName": "美月西瓜_16-9_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-13",
	                    "harvestQuantity": 13147,
	                    "harvestDamagedQuantity": 15,
	                    "massId": "56a5fbb4f6b641daa0d56bae99261067",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-21",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:45:56",
	                    "harvestCreateTime": 1571828586702,
	                    "id": 227,
	                    "massAreaVal": 5736
	                  }],
	                  "1号棚": [{
	                    "massIfName": "1号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "82a7d7497b2c480a8588ae633ed1fed5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "2号棚": [{
	                    "massIfName": "2号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "b648e2e829144d4d88db432519d3f0ca",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "3号棚": [{
	                    "massIfName": "3号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "60e1a5484b4e4185a6f84b413ec0123e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "4号棚": [{
	                    "massIfName": "4号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "581-1": [{
	                    "massIfName": "581-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "美月西瓜_581-1_20190908",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
	                    "productName": "美月西瓜",
	                    "harvestQuantity": 17198,
	                    "harvestDamagedQuantity": 250,
	                    "massId": "a71183836d634425be34001674d28011",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-22",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-08 19:08:26",
	                    "harvestCreateTime": 1571736980512,
	                    "id": 245,
	                    "massAreaVal": 6080
	                  }],
	                  "581-10": [{
	                    "massIfName": "581-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "hasHarvest": 0,
	                    "massId": "70fa77f342484e448b043fea4f15807b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6080
	                  }],
	                  "581-11": [{
	                    "massIfName": "581-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-12": [{
	                    "massIfName": "581-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "649cf669ea50497abf0e2d654a5a0394",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-13": [{
	                    "massIfName": "581-13",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "192737df21064002a87b1a900330a822",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-14": [{
	                    "massIfName": "581-14",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8901900a1de14e619baa1657e10c12b6",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-15": [{
	                    "massIfName": "581-15",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "1632a87c41264b449c2c2c50308780bd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-16": [{
	                    "massIfName": "581-16",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "43600f01a840498fa87358e1db1ad723",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-17": [{
	                    "massIfName": "581-17",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0767994c6c944a568fea24452a78503a",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-18": [{
	                    "massIfName": "581-18",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "6499f5114e32433f883f70b09be18911",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-19": [{
	                    "massIfName": "581-19",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "13d7b6c1471c49b0820234d8aadba8c8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-2": [{
	                    "massIfName": "581-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-2_20190930",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "1f959a5d82604b0da975f6002472ae24",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:26:21",
	                    "id": 315,
	                    "massAreaVal": 6688
	                  }],
	                  "581-20": [{
	                    "massIfName": "581-20",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "7a570059e21844999df90b76ed0e2cbe",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-21": [{
	                    "massIfName": "581-21",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-22": [{
	                    "massIfName": "581-22",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-23": [{
	                    "massIfName": "581-23",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-24": [{
	                    "massIfName": "581-24",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "c85f7ce299984c0ab29d4150b78a0645",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-25": [{
	                    "massIfName": "581-25",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8cb7080522154bb5a13c2e4f957ddec7",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-26": [{
	                    "massIfName": "581-26",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0a9bb5a9581946ee965c49cbb29263c5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-27": [{
	                    "massIfName": "581-27",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "11fe60cbd69d4ed2994386199ca425ec",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-28": [{
	                    "massIfName": "581-28",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-28_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
	                    "productName": "美月西瓜",
	                    "massId": "4d4f35f175dd4942ac698497cf409b00",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:49:26",
	                    "id": 297,
	                    "massAreaVal": 6688
	                  }],
	                  "581-29": [{
	                    "massIfName": "581-29",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "2816.0",
	                    "hasHarvest": 0,
	                    "massId": "809cdd4e59214c97b524abdb2b6aac64",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 2816
	                  }],
	                  "581-3": [{
	                    "massIfName": "581-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "29ec59c9be394d298e464d919a5268e3",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-4": [{
	                    "massIfName": "581-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "千禧圣女果_581-4_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-23",
	                    "massId": "70804d660171419e94de93509a066c1f",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:25:47",
	                    "id": 322,
	                    "massAreaVal": 6688
	                  }],
	                  "581-5": [{
	                    "massIfName": "581-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "千禧圣女果_581-5_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-24",
	                    "massId": "1eef15f5af1547d4b335ecd3920ccde0",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:27:03",
	                    "id": 323,
	                    "massAreaVal": 6080
	                  }],
	                  "581-6": [{
	                    "massIfName": "581-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-6_20190930",
	                    "toHarvestDays": "14",
	                    "hasHarvest": 0,
	                    "progressRate": 0.7307692,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-29",
	                    "massId": "3d2d32ca91004bf98d3745d3e33bf728",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:27:21",
	                    "id": 316,
	                    "massAreaVal": 6688
	                  }],
	                  "581-7": [{
	                    "massIfName": "581-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-7_20190825",
	                    "toHarvestDays": "-21",
	                    "hasHarvest": 0,
	                    "progressRate": 1.4038461,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-25",
	                    "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-25 22:34:36",
	                    "id": 188,
	                    "massAreaVal": 6688
	                  }],
	                  "581-8": [{
	                    "massIfName": "581-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "589a973f7b114735a322b6604f86caf4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-9": [{
	                    "massIfName": "581-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "21ad8dbaddd34a479b899d4f0714ef44",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "5号棚": [{
	                    "massIfName": "5号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "6cd116f8f77a455c8017db42df934b10",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "6号棚": [{
	                    "massIfName": "6号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "9c458864d4404387bf9a77664bb5059b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "7号棚": [{
	                    "massIfName": "7号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "65df5b086e1b4e7b84909f49d3068c9b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "8号棚": [{
	                    "massIfName": "8号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "dc03b56080c3499982395b2d52b23a7c",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "9号棚": [{
	                    "massIfName": "9号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "34534f5a1d344e4aadefa38cc1090154",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "D0": [{
	                    "massIfName": "D0",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "辣木_D0_20191017",
	                    "toHarvestDays": "827",
	                    "hasHarvest": 0,
	                    "progressRate": 0.045034643,
	                    "productUrl": "784bd0037268432a94587ce223230b39",
	                    "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
	                    "productName": "辣木",
	                    "startDate": "2019-09-28",
	                    "massId": "b20cf9abd0fc458c8465783005bb9ecd",
	                    "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:37:25",
	                    "id": 333,
	                    "massAreaVal": 0.38
	                  }],
	                  "D1": [{
	                    "massIfName": "D1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "美月西瓜_D1_20191018",
	                    "toHarvestDays": "22",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6393443,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-28",
	                    "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-18 12:10:53",
	                    "id": 353,
	                    "massAreaVal": 0.38
	                  }],
	                  "D10": [{
	                    "massIfName": "D10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D10_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "92dc3b5740db43c7874ea0b8a1d832af",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:47:21",
	                    "id": 338,
	                    "massAreaVal": 0.38
	                  }],
	                  "D2": [{
	                    "massIfName": "D2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D3": [{
	                    "massIfName": "D3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D4": [{
	                    "massIfName": "D4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D5": [{
	                    "massIfName": "D5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D5_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "5d12c9b3ec154568ba17aca75394a58f",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:57:20",
	                    "id": 339,
	                    "massAreaVal": 0.38
	                  }],
	                  "D6": [{
	                    "massIfName": "D6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D6_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "9679093957eb4348b9f75543a289382a",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:58:04",
	                    "id": 340,
	                    "massAreaVal": 0.38
	                  }],
	                  "D7": [{
	                    "massIfName": "D7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D7_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "fbde48394efe44158c5264fee351b931",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:44:50",
	                    "id": 335,
	                    "massAreaVal": 0.38
	                  }],
	                  "D8": [{
	                    "massIfName": "D8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D8_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "c2a1a4345da544be87b5f8618dd39b16",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:45:51",
	                    "id": 336,
	                    "massAreaVal": 0.38
	                  }],
	                  "D9": [{
	                    "massIfName": "D9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D9_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "85f25eee14804242901771c88003da36",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:46:40",
	                    "id": 337,
	                    "massAreaVal": 0.38
	                  }],
	                  "展-2A": [{
	                    "massIfName": "展-2A",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2B": [{
	                    "massIfName": "展-2B",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "c90327e44c0e451fafa3a2df9dff631f",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2C": [{
	                    "massIfName": "展-2C",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "曼西娜番茄_展-2C_20191029",
	                    "toHarvestDays": "82",
	                    "hasHarvest": 0,
	                    "progressRate": 0.344,
	                    "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
	                    "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
	                    "productName": "曼西娜番茄",
	                    "startDate": "2019-09-24",
	                    "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
	                    "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-29 17:01:17",
	                    "id": 380,
	                    "massAreaVal": 1532
	                  }],
	                  "展-2D": [{
	                    "massIfName": "展-2D",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
	                    "hasHarvest": 0,
	                    "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
	                    "productName": "永优黄灯笼辣椒",
	                    "startDate": "2019-09-05",
	                    "massId": "8fa29c0468de4d1e818b0ed2de06513f",
	                    "productId": "ed65a6819e7747e5be8db447620a3385",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-05 21:02:59",
	                    "id": 237,
	                    "massAreaVal": 1532
	                  }],
	                  "展-叶菜区": [{
	                    "massIfName": "展-叶菜区",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "3.46",
	                    "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "16182b0db47c44698a436be9e42231cc",
	                    "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
	                    "productName": "潮州快大夏皇白",
	                    "startDate": "2019-09-02",
	                    "harvestQuantity": 3921,
	                    "harvestDamagedQuantity": 0,
	                    "massId": "d7aac8fc55cf4d39871d844eb215d048",
	                    "productId": "648a21743c0a468499e37f807ef24e7f",
	                    "harvestDate": "2019-09-24",
	                    "areaUnitName": "亩",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:57:40",
	                    "harvestCreateTime": 1569290697617,
	                    "id": 298,
	                    "massAreaVal": 3.46
	                  }],
	                  "展示大棚": [{
	                    "massIfName": "展示大棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "9500.0",
	                    "hasHarvest": 0,
	                    "massId": "718722a0322a4b28b70de55a82a9a019",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 9500
	                  }]
	                };
	                resultData = data;
	
	                for (key in resultData) {
	                  for (i = 0; i < list.length; i++) {
	                    if (key === list[i].name) {
	                      list[i].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                  for (j = 0; j < rightlist.length; j++) {
	                    if (key === rightlist[j].name) {
	                      rightlist[j].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                }
	                _this3.massifList = list;
	                _this3.massifListR = rightlist;
	                console.log(_this3.datalist);
	                _this3.time();
	              }
	              console.log(_config2.default.fileDomain);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(167);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      dataY: [],
	      dataX: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: '20%',
	            left: '30%',
	            right: '10%',
	            bottom: '20%',
	            containLabel: true
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          splitNumber: 4,
	          name: '',
	          min: 0,
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	
	            formatter: function formatter(value, index) {
	              if (value > 10000) {
	                console.log(value);
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#eb64fb'
	              }, {
	                offset: 1,
	                color: '#3fbbff0d'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i, self;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results.dataList;
	                // console.log(resultData)
	
	                for (i = 0; i < resultData.length; i++) {
	                  _this.dataY.push(resultData[i].harvestQuantity);
	                  _this.dataX.push(resultData[i].month);
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	              self = _this;
	
	              self.chart();
	              self.init();
	              _this.timer = setInterval(function () {
	                // 某些定时器操作
	                self.getData();
	              }, 3000);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(167);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '采收计划',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 10000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetHarvestPlanList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                console.log(res.results);
	                for (i = 0; i < resultData.length; i++) {
	                  _this.sum += resultData[i].productionForecast;
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(167);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '种植批次数据',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                // console.log(resultData)
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(167);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '销售数据',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: 0
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          name: '万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              if (value > 10000) {
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(232,159,31,1)"
	              }, {
	                offset: 0.8,
	                color: "rgba(241,100,30,1)"
	              }], false)
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    this.tableData = this.salesData;
	    var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay'];
	    var myDate = new Date();
	    myDate.setDate(myDate.getDate() - 7);
	    var dateArray = [];
	    var dateTemp;
	    var flag = 1;
	    for (var i = 0; i < time.length; i++) {
	      var day = myDate.getDate() + i + 1;
	      dateTemp = myDate.getMonth() + 1 + "-" + day;
	      this.dataY.push(this.salesDataBar[0][time[i]]);
	      this.dataX.push(dateTemp);
	    }
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      self.getData();
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(167);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '实时销售订单',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = this.salesDataRealTime;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _salesData = __webpack_require__(1821);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table = __webpack_require__(1822);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _planting = __webpack_require__(1820);
	
	var _planting2 = _interopRequireDefault(_planting);
	
	var _harvestingPlan = __webpack_require__(1819);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _generatingData = __webpack_require__(1818);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _center = __webpack_require__(1817);
	
	var _center2 = _interopRequireDefault(_center);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      name: '智慧农业4.0',
	      outputValue: '',
	      productionScale: '',
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      timerDashboard: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Agriculture);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	                // console.log(resultData)
	
	                _this.outputValue = resultData.outputValue;
	                _this.productionScale = resultData.productionScale;
	                _this.salesData = resultData.salesData;
	                _this.salesDataBar = resultData.salesDataBar;
	                _this.salesDataRealTime = resultData.salesDataRealTime;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerDashboard = setTimeout(() => {
	              //   console.log("timerDashboard")
	              //   this.next()
	              // }, 30000);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerDashboard);
	    this.timerDashboard = null;
	  },
	
	  methods: {
	    next: function next() {
	      this.$router.push('/rundaindustryInformation');
	    },
	    prev: function prev() {
	      this.$router.push('/rundahelper');
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-salesData': _salesData2.default,
	    'v-table': _table2.default,
	    'v-harvestingPlan': _harvestingPlan2.default,
	    'v-generatingData': _generatingData2.default,
	    'v-center': _center2.default,
	    'v-planting': _planting2.default
	  }
	};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '智能环控中心',
	      show: false,
	      options: [{ text: '百色市田阳县气象监控站', value: false }],
	      listData: [{ temperature: 26, humidity: 94, winds: 1, air: 40 }, { temperature: 27, humidity: 93, winds: 2, air: 43 }, { temperature: 32, humidity: 91, winds: 2, air: 46 }, { temperature: 30, humidity: 95, winds: 2, air: 55 }, { temperature: 25, humidity: 89, winds: 3, air: 70 }],
	      num: 0
	    };
	  },
	  mounted: function mounted() {
	    var currentHour = new Date().getHours();
	    if (currentHour <= 8) {
	      this.num = 0;
	    } else if (currentHour <= 11 && currentHour > 8) {
	      this.num = 1;
	    } else if (currentHour <= 14 && currentHour > 11) {
	      this.num = 2;
	    } else if (currentHour <= 16 && currentHour > 14) {
	      this.num = 3;
	    } else {
	      this.num = 4;
	    }
	  },
	
	  methods: {
	    up: function up() {
	      this.show = !this.show;
	    }
	  },
	  components: {
	    'v-header': _header2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(209);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ["regionBar"],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '脱贫家庭数',
	      dataX: [],
	      dataY: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    console.log(this.regionBar);
	    var count = 0;
	    for (var i = 0; i < this.regionBar.length; i++) {
	      if (this.regionBar[i].name && count < 5) {
	        if (this.regionBar[i].name.indexOf('县') > -1) {
	          this.dataX.push(this.regionBar[i].name.split('县')[1]);
	        } else {
	          this.dataX.push(this.regionBar[i].name);
	        }
	        this.dataY.push(this.regionBar[i].number);
	        count++;
	      }
	    }
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.bars .main'));
	    this.myChart.setOption({
	      xAxis: {
	        data: this.dataX,
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          interval: 0,
	          color: '#77CAD8',
	          fontSize: 12
	        }
	      },
	      yAxis: {
	        nameTextStyle: {
	          color: ' #77CAD8',
	          fontSize: 12
	        },
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          color: '#77CAD8',
	          fontSize: 12,
	          formatter: function formatter(value) {
	            // if (value > 1000000) {
	            //   return value / 1000000 + "百万"
	            // } else
	            if (value > 10000) {
	              return value / 10000 + "万";
	            } else {
	              return value;
	            }
	          }
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: '#0177d4'
	          }
	        }
	      },
	      grid: {
	        top: '15%',
	        left: '3%',
	        right: '10%',
	        bottom: '10%',
	        containLabel: true
	      },
	      series: [{
	        type: 'bar',
	        barWidth: 18,
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#C0E450'
	            }, {
	              offset: 0.8,
	              color: '#75CD2D'
	            }], false)
	          }
	        },
	        data: this.dataY
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(209);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '贫困户分布',
	      dataX: [],
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var count = 0;
	    for (var i = 0; i < this.distributedBar.length; i++) {
	      if (this.distributedBar[i].regionName && count < 8) {
	        // this.dataX.push(this.distributedBar[i].regionName)
	        if (this.distributedBar[i].regionName.indexOf('县') > -1) {
	          this.dataX.push(this.distributedBar[i].regionName.split('县')[1]);
	        } else {
	          this.dataX.push(this.distributedBar[i].regionName);
	        }
	        this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName });
	        count++;
	      }
	    }
	    // console.log(this.chartData)
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie .main'));
	    this.myChart.setOption({
	      title: {
	        show: false
	      },
	      legend: [{
	        orient: 'vertical',
	        left: '5',
	        top: '5',
	        data: this.dataX,
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }],
	      toolbox: {
	        show: false
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['65%', '55%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 14,
	              position: 'outside',
	              formatter: '{d}',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(209);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['povertyAlleviaList'],
	  data: function data() {
	    return {
	      name: '',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    // boxWrap,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = this.povertyAlleviaList;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(209);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['productBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '扶贫产品排名',
	      dataX: [],
	      dataY1: [],
	      dataY2: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var count = 0;
	    for (var i = 0; i < this.productBar.length; i++) {
	      if (this.productBar[i].name && count < 3) {
	        this.dataX.push(this.productBar[i].name);
	        this.dataY1.push(this.productBar[i].output);
	        this.dataY2.push(this.productBar[i].amount);
	        count++;
	      }
	    }
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.twoWayBar .main'));
	
	    this.myChart.setOption({
	      tooltip: {
	
	        trigger: 'axis',
	        axisPointer: { // 坐标轴指示器，坐标轴触发有效
	          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
	        }
	      },
	      legend: {
	        data: ['产量', '金额'],
	        top: 5,
	        left: 110,
	        textStyle: {
	          color: '#fff',
	          fontSize: 16
	        }
	      },
	      grid: {
	        top: '15%',
	        left: '1%',
	        right: '8%',
	        bottom: '10%',
	        containLabel: true
	      },
	      xAxis: [{
	        type: 'value',
	        axisTick: { show: false },
	        axisLine: {
	          show: false
	        },
	        splitNumber: 3,
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 16,
	          formatter: function formatter(value) {
	            // if (value > 1000000) {
	            //   return value / 1000000 + "百万"
	            // } else
	            if (value > 10000) {
	              return value / 10000 + "万";
	            } else {
	              return value;
	            }
	          }
	        },
	        splitLine: {
	          lineStyle: {
	            color: '#0092EE'
	          }
	        }
	      }],
	      yAxis: [{
	        type: 'category',
	        axisTick: { show: false },
	        data: this.dataX,
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 18
	        }
	      }],
	      series: [{
	        name: '产量',
	        type: 'bar',
	        barWidth: 8,
	        label: {
	          normal: {
	            // show: true
	            // position: 'inside'
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF9E2C'
	            }, {
	              offset: 0.8,
	              color: '#FF4E00'
	            }], false)
	          }
	        },
	        data: this.dataY1
	      }, {
	        name: '金额',
	        type: 'bar',
	        barWidth: 8,
	        stack: '总量',
	        label: {
	          normal: {
	            // show: true
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#5EB5FF'
	            }, {
	              offset: 0.8,
	              color: '#00DAEE'
	            }], false)
	          }
	        },
	        data: this.dataY2
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _table = __webpack_require__(1827);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _bars = __webpack_require__(1825);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _twoWayBar = __webpack_require__(1828);
	
	var _twoWayBar2 = _interopRequireDefault(_twoWayBar);
	
	var _pie = __webpack_require__(1826);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '扶贫数据中心',
	      listdata: [],
	      regionBar: [],
	      productBar: [],
	      distributedBar: [],
	      povertyAlleviaList: [],
	      timerHelper: null,
	      show: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, list, key;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Helper);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	                list = {
	                  povertyNumber: '脱贫家庭数',
	                  povertyAlleviation: '扶贫人数',
	                  perIncome: '贫困户人均收入',
	                  totalAmount: '帮扶总额'
	                  // work: '提供就业岗位'
	
	                  // resultData.work = "800个"
	                };
	                for (key in list) {
	                  _this.listdata.push({ name: list[key], value: resultData[key] });
	                }
	                _this.regionBar = resultData.regionBar;
	                _this.productBar = resultData.productBar;
	                _this.distributedBar = resultData.distributedBar;
	                _this.povertyAlleviaList = resultData.povertyAlleviaList;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerHelper = setTimeout(() => {
	              //   console.log("timerHelper")
	              //   this.next()
	              // }, 30000);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerHelper);
	    this.timerHelper = null;
	  },
	
	  methods: {
	    clickChild: function clickChild(bool) {
	      this.child = bool;
	    },
	    backToDashboard: function backToDashboard() {
	      this.child = false;
	    },
	    next: function next() {
	      this.$router.push('/rundadashboard');
	    },
	    prev: function prev() {
	      this.$router.push('/rundasalesDataCenter');
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-table': _table2.default,
	    'v-bars': _bars2.default,
	    'v-twoWayBar': _twoWayBar2.default,
	    'v-pie': _pie2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(140);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(172);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	__webpack_require__(1401);
	
	__webpack_require__(1616);
	
	__webpack_require__(1403);
	
	__webpack_require__(1402);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MassifItem = function () {
	  function MassifItem(theme) {
	    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var index = arguments[3];
	    (0, _classCallCheck3.default)(this, MassifItem);
	    this.list = [];
	    this.type = 'left';
	
	    this.theme = theme;
	    this.text = text;
	    this.name = name;
	    this.index = index;
	  }
	
	  (0, _createClass3.default)(MassifItem, [{
	    key: 'setMassif',
	    value: function setMassif(massif) {
	      this.massif = massif;
	      return this;
	    }
	  }, {
	    key: 'setList',
	    value: function setList(list) {
	      this.list = list;
	      return this;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var style = {};
	      return style;
	    }
	  }, {
	    key: 'getThemeIndex',
	    value: function getThemeIndex() {
	      var _this = this;
	
	      return this.list.filter(function (item) {
	        return item.theme === _this.theme;
	      }).indexOf(this);
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var themeIndex = this.getThemeIndex();
	      return classNames('theme-' + this.theme, 'theme-index-' + themeIndex);
	    }
	  }]);
	  return MassifItem;
	}(); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var list = [new MassifItem(1, '', 'D10', 0), new MassifItem(1, '', 'D09', 1), new MassifItem(1, '', 'D08', 2), new MassifItem(1, '', 'D07', 3), new MassifItem(1, '', 'D06', 4), new MassifItem(1, '', 'D05', 5), new MassifItem(1, '', 'D04', 6), new MassifItem(1, '', 'D03', 7), new MassifItem(1, '', 'D02', 8), new MassifItem(1, '', 'D01', 9),
	//
	new MassifItem(2, '', '16-1', 0), new MassifItem(2, '', '16-3', 1), new MassifItem(2, '', '16-5', 2), new MassifItem(2, '', '16-7', 3), new MassifItem(2, '', '16-9', 4), new MassifItem(2, '', '16-11', 5), new MassifItem(2, '', '16-2', 6), new MassifItem(2, '', '16-4', 7), new MassifItem(2, '', '16-6', 8), new MassifItem(2, '', '16-8', 9), new MassifItem(2, '', '16-10', 10), new MassifItem(2, '', '16-12', 11),
	//
	new MassifItem(3, '', '', 0), new MassifItem(3, '', '', 1),
	//
	new MassifItem(4, '15', '15号棚', 0), new MassifItem(5, '', '', 1),
	//
	new MassifItem(6, '', '14号棚', 0), new MassifItem(6, '', '13号棚', 1),
	//
	new MassifItem(7, '', '12号棚', 1), new MassifItem(8, '', '11号棚', 0), new MassifItem(8, '', '9号棚', 1), new MassifItem(8, '', '3号棚', 2), new MassifItem(8, '', '8号棚', 3), new MassifItem(8, '', '2号棚', 4), new MassifItem(8, '', '7号棚', 5), new MassifItem(8, '', '1号棚', 6),
	//
	new MassifItem(9, '', '10号棚', 0), new MassifItem(10, '', '', 1),
	//
	new MassifItem(11, '', '6号棚', 0), new MassifItem(11, '', '5号棚', 1), new MassifItem(11, '', '4号棚', 2),
	//
	new MassifItem(12, '', '', 0), new MassifItem(13, '', '', 1), new MassifItem(14, '', '', 2),
	//
	new MassifItem(15, '', '展-2A', 0), new MassifItem(15, '', '展-2C', 1),
	//
	new MassifItem(16, '', '展-2B', 0), new MassifItem(16, '', '展-2D', 1),
	//
	new MassifItem(17, '', '展-叶菜区', 0), new MassifItem(17, '', '展-叶菜区', 1)];
	var rightlist = [new MassifItem(null), new MassifItem(15, '15', '581-15'), new MassifItem(16, '16', '581-16'), new MassifItem(14, '14', '581-14'), new MassifItem(17, '17', '581-17'), new MassifItem(13, '13', '581-13'), new MassifItem(18, '18', '581-18'), new MassifItem(12, '12', '581-12'), new MassifItem(19, '19', '581-19'), new MassifItem(11, '11', '581-11'), new MassifItem(20, '20', '581-20'), new MassifItem(10, '10', '581-10'), new MassifItem(21, '21', '581-21'), new MassifItem(9, '9', '581-9'), new MassifItem(22, '22', '581-22'), new MassifItem(8, '8', '581-8'), new MassifItem(23, '23', '581-23'), new MassifItem(7, '7', '581-7'), new MassifItem(24, '24', '581-24'), new MassifItem(6, '6', '581-6'), new MassifItem(25, '25', '581-25'), new MassifItem(5, '5', '581-5'), new MassifItem(26, '26', '581-26'), new MassifItem(4, '4', '581-4'), new MassifItem(27, '27', '581-27'), new MassifItem(3, '3', '581-3'), new MassifItem(28, '28', '581-28'), new MassifItem(2, '2', '581-2'), new MassifItem(29, '29', '581-29'), new MassifItem(1, '1', '581-1')];
	
	exports.default = {
	  props: ["productionScale", "outputValue"],
	  data: function data() {
	    return {
	      areaName: '',
	      url: _config2.default.fileDomain,
	      timer: null,
	      massifList: [],
	      massifListR: [],
	      tip: true,
	      list: [],
	      datalist: [],
	      index: 0
	    };
	  },
	
	  components: {},
	  methods: {
	    show: function show(val, type) {
	      // console.log(type === '1')
	      if (type === '1') {
	        clearInterval(this.timer);
	      }
	      this.tip = true;
	      this.list = val;
	    },
	    tips: function tips() {
	      clearInterval(this.timer);
	      this.tip = true;
	    },
	    leave: function leave() {
	      this.tip = false;
	      this.time();
	    },
	    time: function time() {
	      var _this2 = this;
	
	      var count = this.datalist.length;
	      this.timer = setInterval(function () {
	        if (_this2.index > count) {
	          _this2.index = 0;
	        }
	        _this2.show(_this2.datalist[_this2.index]);
	        _this2.index = _this2.index + 1;
	        // console.log(this.index)
	      }, 3000);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, _resultData, key, i, j, data, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this3.$model('dataManagement').commonfn2(_this3.$apiUrl.DATAANALYSIS.GetMassIfInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                _resultData = res.results;
	
	                _resultData = {
	                  "10号棚": [{
	                    "massIfName": "10号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "4488.0",
	                    "hasHarvest": 0,
	                    "massId": "5da6b24187944a778a1e1867c8757923",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 4488
	                  }],
	                  "12号棚": [{
	                    "massIfName": "12号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1824.0",
	                    "hasHarvest": 0,
	                    "massId": "7f458d2a56d6428ea205bf60806e6c14",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1824
	                  }],
	                  "13号棚": [{
	                    "massIfName": "13号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "6161573284224bab92fd36ae41dc6e03",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "14号棚": [{
	                    "massIfName": "14号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "5adcad3d40b143ada96b2624a88b75dd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "15号棚": [{
	                    "massIfName": "15号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "405421605f8242ffbeca94ed87f76bcb",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "16-1": [{
	                    "massIfName": "16-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-1_20190822",
	                    "toHarvestDays": "-2",
	                    "hasHarvest": 0,
	                    "progressRate": 1.027027,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-22",
	                    "harvestQuantity": 64360,
	                    "harvestDamagedQuantity": 734,
	                    "massId": "628654838b564fc381d56e06f8072862",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-11-04",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-22 19:48:30",
	                    "harvestCreateTime": 1572861140941,
	                    "id": 186,
	                    "massAreaVal": 5960
	                  }],
	                  "16-10": [{
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20191015",
	                    "toHarvestDays": "51",
	                    "hasHarvest": 0,
	                    "progressRate": 0.32,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-13",
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-15 16:13:11",
	                    "id": 332,
	                    "massAreaVal": 5636
	                  }, {
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-06",
	                    "harvestQuantity": 14883,
	                    "harvestDamagedQuantity": 140,
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-12",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:44:45",
	                    "harvestCreateTime": 1571129662779,
	                    "id": 226,
	                    "massAreaVal": 5636
	                  }],
	                  "16-11": [{
	                    "massIfName": "16-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "7152.0",
	                    "traceBatchName": "美月西瓜_16-11_20190904",
	                    "toHarvestDays": "11",
	                    "hasHarvest": 0,
	                    "progressRate": 0.8513514,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-04 21:52:36",
	                    "id": 234,
	                    "massAreaVal": 7152
	                  }],
	                  "16-12": [{
	                    "massIfName": "16-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6768.0",
	                    "traceBatchName": "美月西瓜_16-12_20190924",
	                    "toHarvestDays": "24",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6712329,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-18",
	                    "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-24 15:00:59",
	                    "id": 300,
	                    "massAreaVal": 6768
	                  }],
	                  "16-2": [{
	                    "massIfName": "16-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-2_20190818",
	                    "toHarvestDays": "-8",
	                    "hasHarvest": 0,
	                    "progressRate": 1.1111112,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-18",
	                    "massId": "30596634280f4c88a320ef3dd911c41b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-18 21:58:05",
	                    "id": 183,
	                    "massAreaVal": 5640
	                  }],
	                  "16-3": [{
	                    "massIfName": "16-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-3_20190826",
	                    "toHarvestDays": "-66",
	                    "hasHarvest": 0,
	                    "progressRate": 12,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-26",
	                    "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-26 22:14:39",
	                    "id": 189,
	                    "massAreaVal": 5960
	                  }],
	                  "16-4": [{
	                    "massIfName": "16-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-4_20190831",
	                    "toHarvestDays": "6",
	                    "hasHarvest": 0,
	                    "progressRate": 0.91780823,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-31",
	                    "massId": "8095b224d21c469681b3adebbc2639b2",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-31 19:59:52",
	                    "id": 217,
	                    "massAreaVal": 5640
	                  }],
	                  "16-5": [{
	                    "massIfName": "16-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-5_20190923",
	                    "toHarvestDays": "3",
	                    "hasHarvest": 0,
	                    "progressRate": 0.95454544,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "f53c67ab0b484dcea2c0d6a397828200",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:15:05",
	                    "id": 296,
	                    "massAreaVal": 5960
	                  }],
	                  "16-6": [{
	                    "massIfName": "16-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5462.0",
	                    "hasHarvest": 0,
	                    "massId": "66afdfa9d0c94ebe942d02682354c218",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 5462
	                  }],
	                  "16-7": [{
	                    "massIfName": "16-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6536.0",
	                    "traceBatchName": "美月西瓜_16-7_20191012",
	                    "toHarvestDays": "40",
	                    "hasHarvest": 0,
	                    "progressRate": 0.4520548,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-04",
	                    "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:08:40",
	                    "id": 319,
	                    "massAreaVal": 6536
	                  }],
	                  "16-8": [{
	                    "massIfName": "16-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6203.0",
	                    "hasHarvest": 0,
	                    "massId": "7932fe634ff84135bf616c3665171bd0",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 6203
	                  }],
	                  "16-9": [{
	                    "massIfName": "16-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5736.0",
	                    "traceBatchName": "美月西瓜_16-9_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-13",
	                    "harvestQuantity": 13147,
	                    "harvestDamagedQuantity": 15,
	                    "massId": "56a5fbb4f6b641daa0d56bae99261067",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-21",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:45:56",
	                    "harvestCreateTime": 1571828586702,
	                    "id": 227,
	                    "massAreaVal": 5736
	                  }],
	                  "1号棚": [{
	                    "massIfName": "1号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "82a7d7497b2c480a8588ae633ed1fed5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "2号棚": [{
	                    "massIfName": "2号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "b648e2e829144d4d88db432519d3f0ca",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "3号棚": [{
	                    "massIfName": "3号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "60e1a5484b4e4185a6f84b413ec0123e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "4号棚": [{
	                    "massIfName": "4号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "581-1": [{
	                    "massIfName": "581-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "美月西瓜_581-1_20190908",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
	                    "productName": "美月西瓜",
	                    "harvestQuantity": 17198,
	                    "harvestDamagedQuantity": 250,
	                    "massId": "a71183836d634425be34001674d28011",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-22",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-08 19:08:26",
	                    "harvestCreateTime": 1571736980512,
	                    "id": 245,
	                    "massAreaVal": 6080
	                  }],
	                  "581-10": [{
	                    "massIfName": "581-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "hasHarvest": 0,
	                    "massId": "70fa77f342484e448b043fea4f15807b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6080
	                  }],
	                  "581-11": [{
	                    "massIfName": "581-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-12": [{
	                    "massIfName": "581-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "649cf669ea50497abf0e2d654a5a0394",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-13": [{
	                    "massIfName": "581-13",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "192737df21064002a87b1a900330a822",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-14": [{
	                    "massIfName": "581-14",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8901900a1de14e619baa1657e10c12b6",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-15": [{
	                    "massIfName": "581-15",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "1632a87c41264b449c2c2c50308780bd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-16": [{
	                    "massIfName": "581-16",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "43600f01a840498fa87358e1db1ad723",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-17": [{
	                    "massIfName": "581-17",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0767994c6c944a568fea24452a78503a",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-18": [{
	                    "massIfName": "581-18",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "6499f5114e32433f883f70b09be18911",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-19": [{
	                    "massIfName": "581-19",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "13d7b6c1471c49b0820234d8aadba8c8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-2": [{
	                    "massIfName": "581-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-2_20190930",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "1f959a5d82604b0da975f6002472ae24",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:26:21",
	                    "id": 315,
	                    "massAreaVal": 6688
	                  }],
	                  "581-20": [{
	                    "massIfName": "581-20",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "7a570059e21844999df90b76ed0e2cbe",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-21": [{
	                    "massIfName": "581-21",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-22": [{
	                    "massIfName": "581-22",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-23": [{
	                    "massIfName": "581-23",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-24": [{
	                    "massIfName": "581-24",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "c85f7ce299984c0ab29d4150b78a0645",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-25": [{
	                    "massIfName": "581-25",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8cb7080522154bb5a13c2e4f957ddec7",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-26": [{
	                    "massIfName": "581-26",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0a9bb5a9581946ee965c49cbb29263c5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-27": [{
	                    "massIfName": "581-27",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "11fe60cbd69d4ed2994386199ca425ec",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-28": [{
	                    "massIfName": "581-28",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-28_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
	                    "productName": "美月西瓜",
	                    "massId": "4d4f35f175dd4942ac698497cf409b00",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:49:26",
	                    "id": 297,
	                    "massAreaVal": 6688
	                  }],
	                  "581-29": [{
	                    "massIfName": "581-29",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "2816.0",
	                    "hasHarvest": 0,
	                    "massId": "809cdd4e59214c97b524abdb2b6aac64",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 2816
	                  }],
	                  "581-3": [{
	                    "massIfName": "581-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "29ec59c9be394d298e464d919a5268e3",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-4": [{
	                    "massIfName": "581-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "千禧圣女果_581-4_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-23",
	                    "massId": "70804d660171419e94de93509a066c1f",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:25:47",
	                    "id": 322,
	                    "massAreaVal": 6688
	                  }],
	                  "581-5": [{
	                    "massIfName": "581-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "千禧圣女果_581-5_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-24",
	                    "massId": "1eef15f5af1547d4b335ecd3920ccde0",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:27:03",
	                    "id": 323,
	                    "massAreaVal": 6080
	                  }],
	                  "581-6": [{
	                    "massIfName": "581-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-6_20190930",
	                    "toHarvestDays": "14",
	                    "hasHarvest": 0,
	                    "progressRate": 0.7307692,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-29",
	                    "massId": "3d2d32ca91004bf98d3745d3e33bf728",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:27:21",
	                    "id": 316,
	                    "massAreaVal": 6688
	                  }],
	                  "581-7": [{
	                    "massIfName": "581-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-7_20190825",
	                    "toHarvestDays": "-21",
	                    "hasHarvest": 0,
	                    "progressRate": 1.4038461,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-25",
	                    "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-25 22:34:36",
	                    "id": 188,
	                    "massAreaVal": 6688
	                  }],
	                  "581-8": [{
	                    "massIfName": "581-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "589a973f7b114735a322b6604f86caf4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-9": [{
	                    "massIfName": "581-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "21ad8dbaddd34a479b899d4f0714ef44",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "5号棚": [{
	                    "massIfName": "5号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "6cd116f8f77a455c8017db42df934b10",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "6号棚": [{
	                    "massIfName": "6号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "9c458864d4404387bf9a77664bb5059b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "7号棚": [{
	                    "massIfName": "7号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "65df5b086e1b4e7b84909f49d3068c9b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "8号棚": [{
	                    "massIfName": "8号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "dc03b56080c3499982395b2d52b23a7c",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "9号棚": [{
	                    "massIfName": "9号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "34534f5a1d344e4aadefa38cc1090154",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "D0": [{
	                    "massIfName": "D0",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "辣木_D0_20191017",
	                    "toHarvestDays": "827",
	                    "hasHarvest": 0,
	                    "progressRate": 0.045034643,
	                    "productUrl": "784bd0037268432a94587ce223230b39",
	                    "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
	                    "productName": "辣木",
	                    "startDate": "2019-09-28",
	                    "massId": "b20cf9abd0fc458c8465783005bb9ecd",
	                    "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:37:25",
	                    "id": 333,
	                    "massAreaVal": 0.38
	                  }],
	                  "D1": [{
	                    "massIfName": "D1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "美月西瓜_D1_20191018",
	                    "toHarvestDays": "22",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6393443,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-28",
	                    "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-18 12:10:53",
	                    "id": 353,
	                    "massAreaVal": 0.38
	                  }],
	                  "D10": [{
	                    "massIfName": "D10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D10_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "92dc3b5740db43c7874ea0b8a1d832af",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:47:21",
	                    "id": 338,
	                    "massAreaVal": 0.38
	                  }],
	                  "D2": [{
	                    "massIfName": "D2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D3": [{
	                    "massIfName": "D3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D4": [{
	                    "massIfName": "D4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D5": [{
	                    "massIfName": "D5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D5_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "5d12c9b3ec154568ba17aca75394a58f",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:57:20",
	                    "id": 339,
	                    "massAreaVal": 0.38
	                  }],
	                  "D6": [{
	                    "massIfName": "D6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D6_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "9679093957eb4348b9f75543a289382a",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:58:04",
	                    "id": 340,
	                    "massAreaVal": 0.38
	                  }],
	                  "D7": [{
	                    "massIfName": "D7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D7_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "fbde48394efe44158c5264fee351b931",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:44:50",
	                    "id": 335,
	                    "massAreaVal": 0.38
	                  }],
	                  "D8": [{
	                    "massIfName": "D8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D8_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "c2a1a4345da544be87b5f8618dd39b16",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:45:51",
	                    "id": 336,
	                    "massAreaVal": 0.38
	                  }],
	                  "D9": [{
	                    "massIfName": "D9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D9_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "85f25eee14804242901771c88003da36",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:46:40",
	                    "id": 337,
	                    "massAreaVal": 0.38
	                  }],
	                  "展-2A": [{
	                    "massIfName": "展-2A",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2B": [{
	                    "massIfName": "展-2B",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "c90327e44c0e451fafa3a2df9dff631f",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2C": [{
	                    "massIfName": "展-2C",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "曼西娜番茄_展-2C_20191029",
	                    "toHarvestDays": "82",
	                    "hasHarvest": 0,
	                    "progressRate": 0.344,
	                    "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
	                    "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
	                    "productName": "曼西娜番茄",
	                    "startDate": "2019-09-24",
	                    "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
	                    "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-29 17:01:17",
	                    "id": 380,
	                    "massAreaVal": 1532
	                  }],
	                  "展-2D": [{
	                    "massIfName": "展-2D",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
	                    "hasHarvest": 0,
	                    "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
	                    "productName": "永优黄灯笼辣椒",
	                    "startDate": "2019-09-05",
	                    "massId": "8fa29c0468de4d1e818b0ed2de06513f",
	                    "productId": "ed65a6819e7747e5be8db447620a3385",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-05 21:02:59",
	                    "id": 237,
	                    "massAreaVal": 1532
	                  }],
	                  "展-叶菜区": [{
	                    "massIfName": "展-叶菜区",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "3.46",
	                    "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "16182b0db47c44698a436be9e42231cc",
	                    "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
	                    "productName": "潮州快大夏皇白",
	                    "startDate": "2019-09-02",
	                    "harvestQuantity": 3921,
	                    "harvestDamagedQuantity": 0,
	                    "massId": "d7aac8fc55cf4d39871d844eb215d048",
	                    "productId": "648a21743c0a468499e37f807ef24e7f",
	                    "harvestDate": "2019-09-24",
	                    "areaUnitName": "亩",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:57:40",
	                    "harvestCreateTime": 1569290697617,
	                    "id": 298,
	                    "massAreaVal": 3.46
	                  }],
	                  "展示大棚": [{
	                    "massIfName": "展示大棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "9500.0",
	                    "hasHarvest": 0,
	                    "massId": "718722a0322a4b28b70de55a82a9a019",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 9500
	                  }]
	                };
	                for (key in _resultData) {
	                  for (i = 0; i < list.length; i++) {
	                    if (key === list[i].name) {
	                      list[i].setList(_resultData[key]);
	                      _this3.datalist.push(_resultData[key]);
	                    }
	                  }
	                  for (j = 0; j < rightlist.length; j++) {
	                    if (key === rightlist[j].name) {
	                      rightlist[j].setList(_resultData[key]);
	                      _this3.datalist.push(_resultData[key]);
	                    }
	                  }
	                }
	                _this3.massifList = list;
	                _this3.massifListR = rightlist;
	                console.log(_this3.datalist);
	                _this3.time();
	              } else {
	                // this.$message.showError(err);
	                data = {
	                  "10号棚": [{
	                    "massIfName": "10号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "4488.0",
	                    "hasHarvest": 0,
	                    "massId": "5da6b24187944a778a1e1867c8757923",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 4488
	                  }],
	                  "12号棚": [{
	                    "massIfName": "12号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1824.0",
	                    "hasHarvest": 0,
	                    "massId": "7f458d2a56d6428ea205bf60806e6c14",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1824
	                  }],
	                  "13号棚": [{
	                    "massIfName": "13号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "6161573284224bab92fd36ae41dc6e03",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "14号棚": [{
	                    "massIfName": "14号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "1152.0",
	                    "hasHarvest": 0,
	                    "massId": "5adcad3d40b143ada96b2624a88b75dd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 1152
	                  }],
	                  "15号棚": [{
	                    "massIfName": "15号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "405421605f8242ffbeca94ed87f76bcb",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "16-1": [{
	                    "massIfName": "16-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-1_20190822",
	                    "toHarvestDays": "-2",
	                    "hasHarvest": 0,
	                    "progressRate": 1.027027,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4998b975ed0b47428978bb0d93bd9c74",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-22",
	                    "harvestQuantity": 64360,
	                    "harvestDamagedQuantity": 734,
	                    "massId": "628654838b564fc381d56e06f8072862",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-11-04",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-22 19:48:30",
	                    "harvestCreateTime": 1572861140941,
	                    "id": 186,
	                    "massAreaVal": 5960
	                  }],
	                  "16-10": [{
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20191015",
	                    "toHarvestDays": "51",
	                    "hasHarvest": 0,
	                    "progressRate": 0.32,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "949082d39cc7401e8cab70ca79004657",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-13",
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-15 16:13:11",
	                    "id": 332,
	                    "massAreaVal": 5636
	                  }, {
	                    "massIfName": "16-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5636.0",
	                    "traceBatchName": "美月西瓜_16-10_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "eb48887da2f8465d824659afb42fb3dc",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-06",
	                    "harvestQuantity": 14883,
	                    "harvestDamagedQuantity": 140,
	                    "massId": "06b9818a3a344d1cb98f5ece106d7139",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-12",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:44:45",
	                    "harvestCreateTime": 1571129662779,
	                    "id": 226,
	                    "massAreaVal": 5636
	                  }],
	                  "16-11": [{
	                    "massIfName": "16-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "7152.0",
	                    "traceBatchName": "美月西瓜_16-11_20190904",
	                    "toHarvestDays": "11",
	                    "hasHarvest": 0,
	                    "progressRate": 0.8513514,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "a339cbf54b2e430aa04297689118a07a",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "caf0c5e5f500424aab26b66a4b01d2fb",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-04 21:52:36",
	                    "id": 234,
	                    "massAreaVal": 7152
	                  }],
	                  "16-12": [{
	                    "massIfName": "16-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6768.0",
	                    "traceBatchName": "美月西瓜_16-12_20190924",
	                    "toHarvestDays": "24",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6712329,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7f87f62dab0540d7b275cb405b9c5788",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-18",
	                    "massId": "b84e9c0106d64227ab51a2e34e98d1cf",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-24 15:00:59",
	                    "id": 300,
	                    "massAreaVal": 6768
	                  }],
	                  "16-2": [{
	                    "massIfName": "16-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-2_20190818",
	                    "toHarvestDays": "-8",
	                    "hasHarvest": 0,
	                    "progressRate": 1.1111112,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1d6b950c60f14f87a85587c76aec6056",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-18",
	                    "massId": "30596634280f4c88a320ef3dd911c41b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-18 21:58:05",
	                    "id": 183,
	                    "massAreaVal": 5640
	                  }],
	                  "16-3": [{
	                    "massIfName": "16-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-3_20190826",
	                    "toHarvestDays": "-66",
	                    "hasHarvest": 0,
	                    "progressRate": 12,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "f48f9b325b734ddfa9b187aedb7d21e9",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-26",
	                    "massId": "b2bc1a0be0e84abe9a90f52ed90e5e1b",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-26 22:14:39",
	                    "id": 189,
	                    "massAreaVal": 5960
	                  }],
	                  "16-4": [{
	                    "massIfName": "16-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5640.0",
	                    "traceBatchName": "美月西瓜_16-4_20190831",
	                    "toHarvestDays": "6",
	                    "hasHarvest": 0,
	                    "progressRate": 0.91780823,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "69e05d8245014c2d9d0a84ec694bd5e6",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-31",
	                    "massId": "8095b224d21c469681b3adebbc2639b2",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-31 19:59:52",
	                    "id": 217,
	                    "massAreaVal": 5640
	                  }],
	                  "16-5": [{
	                    "massIfName": "16-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5960.0",
	                    "traceBatchName": "美月西瓜_16-5_20190923",
	                    "toHarvestDays": "3",
	                    "hasHarvest": 0,
	                    "progressRate": 0.95454544,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "83da26865fa441799bad62ac5958a975",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-04",
	                    "massId": "f53c67ab0b484dcea2c0d6a397828200",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:15:05",
	                    "id": 296,
	                    "massAreaVal": 5960
	                  }],
	                  "16-6": [{
	                    "massIfName": "16-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5462.0",
	                    "hasHarvest": 0,
	                    "massId": "66afdfa9d0c94ebe942d02682354c218",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 5462
	                  }],
	                  "16-7": [{
	                    "massIfName": "16-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6536.0",
	                    "traceBatchName": "美月西瓜_16-7_20191012",
	                    "toHarvestDays": "40",
	                    "hasHarvest": 0,
	                    "progressRate": 0.4520548,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "1984f8d59c2f4359979dff923e49071c",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-10-04",
	                    "massId": "ffb9b8a7890e449bbfbec5326a4d2a26",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:08:40",
	                    "id": 319,
	                    "massAreaVal": 6536
	                  }],
	                  "16-8": [{
	                    "massIfName": "16-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "6203.0",
	                    "hasHarvest": 0,
	                    "massId": "7932fe634ff84135bf616c3665171bd0",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "massAreaVal": 6203
	                  }],
	                  "16-9": [{
	                    "massIfName": "16-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "黄德振",
	                    "massArea": "5736.0",
	                    "traceBatchName": "美月西瓜_16-9_20190902",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "580db7cc3761457183af7b0be3fc0911",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-13",
	                    "harvestQuantity": 13147,
	                    "harvestDamagedQuantity": 15,
	                    "massId": "56a5fbb4f6b641daa0d56bae99261067",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-21",
	                    "areaUnitName": "平方米",
	                    "partitionName": "中荷温室",
	                    "partitionId": "27a088f7df044d32b339c8f9f5dbe6ac",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-02 23:45:56",
	                    "harvestCreateTime": 1571828586702,
	                    "id": 227,
	                    "massAreaVal": 5736
	                  }],
	                  "1号棚": [{
	                    "massIfName": "1号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "82a7d7497b2c480a8588ae633ed1fed5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "2号棚": [{
	                    "massIfName": "2号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "b648e2e829144d4d88db432519d3f0ca",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "3号棚": [{
	                    "massIfName": "3号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3840.0",
	                    "hasHarvest": 0,
	                    "massId": "60e1a5484b4e4185a6f84b413ec0123e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3840
	                  }],
	                  "4号棚": [{
	                    "massIfName": "4号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "e0121eb1b20249f5a4f1921689f0f4b8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "581-1": [{
	                    "massIfName": "581-1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "美月西瓜_581-1_20190908",
	                    "toHarvestDays": "0",
	                    "hasHarvest": 1,
	                    "progressRate": 1,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4803bec142df4c7c8b81344f14385969",
	                    "productName": "美月西瓜",
	                    "harvestQuantity": 17198,
	                    "harvestDamagedQuantity": 250,
	                    "massId": "a71183836d634425be34001674d28011",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "harvestDate": "2019-10-22",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 2,
	                    "createTime": "2019-09-08 19:08:26",
	                    "harvestCreateTime": 1571736980512,
	                    "id": 245,
	                    "massAreaVal": 6080
	                  }],
	                  "581-10": [{
	                    "massIfName": "581-10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "hasHarvest": 0,
	                    "massId": "70fa77f342484e448b043fea4f15807b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6080
	                  }],
	                  "581-11": [{
	                    "massIfName": "581-11",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "da7ea37570f6457da4b7ea57b3ba7a0e",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-12": [{
	                    "massIfName": "581-12",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "649cf669ea50497abf0e2d654a5a0394",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-13": [{
	                    "massIfName": "581-13",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "192737df21064002a87b1a900330a822",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-14": [{
	                    "massIfName": "581-14",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8901900a1de14e619baa1657e10c12b6",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-15": [{
	                    "massIfName": "581-15",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "1632a87c41264b449c2c2c50308780bd",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-16": [{
	                    "massIfName": "581-16",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "43600f01a840498fa87358e1db1ad723",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-17": [{
	                    "massIfName": "581-17",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0767994c6c944a568fea24452a78503a",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-18": [{
	                    "massIfName": "581-18",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "6499f5114e32433f883f70b09be18911",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-19": [{
	                    "massIfName": "581-19",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "13d7b6c1471c49b0820234d8aadba8c8",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-2": [{
	                    "massIfName": "581-2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-2_20190930",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "279c211d544a42d9ba77ace6ddbfe1b0",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "1f959a5d82604b0da975f6002472ae24",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:26:21",
	                    "id": 315,
	                    "massAreaVal": 6688
	                  }],
	                  "581-20": [{
	                    "massIfName": "581-20",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "7a570059e21844999df90b76ed0e2cbe",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-21": [{
	                    "massIfName": "581-21",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "ec30417d2aae4d62ba13b1d9ed8e641d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-22": [{
	                    "massIfName": "581-22",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "5ffdd43db13a4fa3aa042f8f7c043430",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-23": [{
	                    "massIfName": "581-23",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "cfdd0c990e1a478fbcbaf8ae60dfe231",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-24": [{
	                    "massIfName": "581-24",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "c85f7ce299984c0ab29d4150b78a0645",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-25": [{
	                    "massIfName": "581-25",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "8cb7080522154bb5a13c2e4f957ddec7",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-26": [{
	                    "massIfName": "581-26",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "0a9bb5a9581946ee965c49cbb29263c5",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-27": [{
	                    "massIfName": "581-27",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "11fe60cbd69d4ed2994386199ca425ec",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-28": [{
	                    "massIfName": "581-28",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-28_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "4ae35cea0e784b4f92cf5e3d6aaf88ea",
	                    "productName": "美月西瓜",
	                    "massId": "4d4f35f175dd4942ac698497cf409b00",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:49:26",
	                    "id": 297,
	                    "massAreaVal": 6688
	                  }],
	                  "581-29": [{
	                    "massIfName": "581-29",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "2816.0",
	                    "hasHarvest": 0,
	                    "massId": "809cdd4e59214c97b524abdb2b6aac64",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 2816
	                  }],
	                  "581-3": [{
	                    "massIfName": "581-3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "29ec59c9be394d298e464d919a5268e3",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-4": [{
	                    "massIfName": "581-4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "千禧圣女果_581-4_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "70fb136d8a1a42119a62263c7a60627d",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-23",
	                    "massId": "70804d660171419e94de93509a066c1f",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:25:47",
	                    "id": 322,
	                    "massAreaVal": 6688
	                  }],
	                  "581-5": [{
	                    "massIfName": "581-5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6080.0",
	                    "traceBatchName": "千禧圣女果_581-5_20191012",
	                    "hasHarvest": 0,
	                    "productUrl": "aafefdaa8f8a488c8f8a09a92252bdbd",
	                    "traceBatchInfoId": "cbab910912b74999aa4eff71fedee332",
	                    "productName": "千禧圣女果",
	                    "startDate": "2019-09-24",
	                    "massId": "1eef15f5af1547d4b335ecd3920ccde0",
	                    "productId": "5648db043ce64be28d3f8c30f8876164",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-12 12:27:03",
	                    "id": 323,
	                    "massAreaVal": 6080
	                  }],
	                  "581-6": [{
	                    "massIfName": "581-6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-6_20190930",
	                    "toHarvestDays": "14",
	                    "hasHarvest": 0,
	                    "progressRate": 0.7307692,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "7163ead1d62e425f964da3633ea6b121",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-29",
	                    "massId": "3d2d32ca91004bf98d3745d3e33bf728",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-30 20:27:21",
	                    "id": 316,
	                    "massAreaVal": 6688
	                  }],
	                  "581-7": [{
	                    "massIfName": "581-7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "traceBatchName": "美月西瓜_581-7_20190825",
	                    "toHarvestDays": "-21",
	                    "hasHarvest": 0,
	                    "progressRate": 1.4038461,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "cf0b69f5402e4d5992b08f156e7b7490",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-08-25",
	                    "massId": "80ee7363d44e4d4a92f2d629521ad4dd",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "partitionId": "5a1caa7fdf804f17b9402f1c937ac1c6",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-08-25 22:34:36",
	                    "id": 188,
	                    "massAreaVal": 6688
	                  }],
	                  "581-8": [{
	                    "massIfName": "581-8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "589a973f7b114735a322b6604f86caf4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "581-9": [{
	                    "massIfName": "581-9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "苏记春",
	                    "massArea": "6688.0",
	                    "hasHarvest": 0,
	                    "massId": "21ad8dbaddd34a479b899d4f0714ef44",
	                    "areaUnitName": "平方米",
	                    "partitionName": "581区域",
	                    "massAreaVal": 6688
	                  }],
	                  "5号棚": [{
	                    "massIfName": "5号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "6cd116f8f77a455c8017db42df934b10",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "6号棚": [{
	                    "massIfName": "6号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "960.0",
	                    "hasHarvest": 0,
	                    "massId": "9c458864d4404387bf9a77664bb5059b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 960
	                  }],
	                  "7号棚": [{
	                    "massIfName": "7号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "65df5b086e1b4e7b84909f49d3068c9b",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "8号棚": [{
	                    "massIfName": "8号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "dc03b56080c3499982395b2d52b23a7c",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "9号棚": [{
	                    "massIfName": "9号棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "3456.0",
	                    "hasHarvest": 0,
	                    "massId": "34534f5a1d344e4aadefa38cc1090154",
	                    "areaUnitName": "平方米",
	                    "partitionName": "老园区",
	                    "massAreaVal": 3456
	                  }],
	                  "D0": [{
	                    "massIfName": "D0",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "辣木_D0_20191017",
	                    "toHarvestDays": "827",
	                    "hasHarvest": 0,
	                    "progressRate": 0.045034643,
	                    "productUrl": "784bd0037268432a94587ce223230b39",
	                    "traceBatchInfoId": "332dd859a6654339959e881eee499dad",
	                    "productName": "辣木",
	                    "startDate": "2019-09-28",
	                    "massId": "b20cf9abd0fc458c8465783005bb9ecd",
	                    "productId": "f0465ccbd45d46ecb8f1c39bf6e6369e",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:37:25",
	                    "id": 333,
	                    "massAreaVal": 0.38
	                  }],
	                  "D1": [{
	                    "massIfName": "D1",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "美月西瓜_D1_20191018",
	                    "toHarvestDays": "22",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6393443,
	                    "productUrl": "7efa1db47ccd499a83413377beb70431",
	                    "traceBatchInfoId": "5595473d29d94e4fb47c8a3153bd3160",
	                    "productName": "美月西瓜",
	                    "startDate": "2019-09-28",
	                    "massId": "6c75b19a5f63487bbadf93dc843a1e1f",
	                    "productId": "0b2d4ee67c984d838cea64bafb64179d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-18 12:10:53",
	                    "id": 353,
	                    "massAreaVal": 0.38
	                  }],
	                  "D10": [{
	                    "massIfName": "D10",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D10_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "afd7d2d3cd6d452ba674a5b35dada11c",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "92dc3b5740db43c7874ea0b8a1d832af",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:47:21",
	                    "id": 338,
	                    "massAreaVal": 0.38
	                  }],
	                  "D2": [{
	                    "massIfName": "D2",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "14c6ba17c4b54cdb96e8cd70071c0a92",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D3": [{
	                    "massIfName": "D3",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "1cfef5a003534d8fb9f0e1dd1a9ce0cb",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D4": [{
	                    "massIfName": "D4",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "hasHarvest": 0,
	                    "massId": "b3a406d6d5f64d27a91c9ac737877a4d",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "massAreaVal": 0.38
	                  }],
	                  "D5": [{
	                    "massIfName": "D5",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D5_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "2aaaf3d574d0420f8ef93ad9c7809c82",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "5d12c9b3ec154568ba17aca75394a58f",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:57:20",
	                    "id": 339,
	                    "massAreaVal": 0.38
	                  }],
	                  "D6": [{
	                    "massIfName": "D6",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验西瓜_D6_20191017",
	                    "toHarvestDays": "21",
	                    "hasHarvest": 0,
	                    "progressRate": 0.6557377,
	                    "productUrl": "95800dc2c0a941f18af50325dc571bfc",
	                    "traceBatchInfoId": "9c7c6cc541634c4fae8ab5e2d9348a7d",
	                    "productName": "试验西瓜",
	                    "startDate": "2019-09-27",
	                    "massId": "9679093957eb4348b9f75543a289382a",
	                    "productId": "1d93f82fb76d4418bd2a5da1de452506",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:58:04",
	                    "id": 340,
	                    "massAreaVal": 0.38
	                  }],
	                  "D7": [{
	                    "massIfName": "D7",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D7_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "4c4e2abd4f204d2ab2d06b6f18698eb7",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "fbde48394efe44158c5264fee351b931",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:44:50",
	                    "id": 335,
	                    "massAreaVal": 0.38
	                  }],
	                  "D8": [{
	                    "massIfName": "D8",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D8_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "95ebe37edb454467a2e693b4c3d85092",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "c2a1a4345da544be87b5f8618dd39b16",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:45:51",
	                    "id": 336,
	                    "massAreaVal": 0.38
	                  }],
	                  "D9": [{
	                    "massIfName": "D9",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "莫达春",
	                    "massArea": "0.38",
	                    "traceBatchName": "试验圣女果_D9_20191017",
	                    "toHarvestDays": "120",
	                    "hasHarvest": 0,
	                    "progressRate": 0.31034482,
	                    "productUrl": "46676e2a1ef84a128d3c4d1e731ca8f5",
	                    "traceBatchInfoId": "cbeccc8fc6314d19bf391c4440fb1ee9",
	                    "productName": "试验圣女果",
	                    "startDate": "2019-09-13",
	                    "massId": "85f25eee14804242901771c88003da36",
	                    "productId": "91244f69d44341739cf6c175cbfb00f8",
	                    "areaUnitName": "亩",
	                    "partitionName": "单体棚",
	                    "partitionId": "23c5a2eec0104bf082047c61b6920c06",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-17 16:46:40",
	                    "id": 337,
	                    "massAreaVal": 0.38
	                  }],
	                  "展-2A": [{
	                    "massIfName": "展-2A",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "37615fa53d6b49ae943fcdb5c94f5edf",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2B": [{
	                    "massIfName": "展-2B",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "hasHarvest": 0,
	                    "massId": "c90327e44c0e451fafa3a2df9dff631f",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 1532
	                  }],
	                  "展-2C": [{
	                    "massIfName": "展-2C",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "曼西娜番茄_展-2C_20191029",
	                    "toHarvestDays": "82",
	                    "hasHarvest": 0,
	                    "progressRate": 0.344,
	                    "productUrl": "da99ceacf66b4f90bbaa1ab93fd49cec",
	                    "traceBatchInfoId": "6e42014a159b4fc0943d4f37fdc272be",
	                    "productName": "曼西娜番茄",
	                    "startDate": "2019-09-24",
	                    "massId": "097916fc0ba14ae6b1f08b05b653ce6c",
	                    "productId": "6e75b25cf8654cbb8ea2a77eb7e0c3b4",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-10-29 17:01:17",
	                    "id": 380,
	                    "massAreaVal": 1532
	                  }],
	                  "展-2D": [{
	                    "massIfName": "展-2D",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "1532.0",
	                    "traceBatchName": "永优黄灯笼辣椒_展-2D_20190905",
	                    "hasHarvest": 0,
	                    "traceBatchInfoId": "72f2636c81c0473ba925d921c80b78a4",
	                    "productName": "永优黄灯笼辣椒",
	                    "startDate": "2019-09-05",
	                    "massId": "8fa29c0468de4d1e818b0ed2de06513f",
	                    "productId": "ed65a6819e7747e5be8db447620a3385",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-05 21:02:59",
	                    "id": 237,
	                    "massAreaVal": 1532
	                  }],
	                  "展-叶菜区": [{
	                    "massIfName": "展-叶菜区",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "3.46",
	                    "traceBatchName": "潮州快大夏皇白_展-叶菜区_20190923",
	                    "hasHarvest": 0,
	                    "productUrl": "16182b0db47c44698a436be9e42231cc",
	                    "traceBatchInfoId": "ba48b86eadd441ceab28ef40f6e7296a",
	                    "productName": "潮州快大夏皇白",
	                    "startDate": "2019-09-02",
	                    "harvestQuantity": 3921,
	                    "harvestDamagedQuantity": 0,
	                    "massId": "d7aac8fc55cf4d39871d844eb215d048",
	                    "productId": "648a21743c0a468499e37f807ef24e7f",
	                    "harvestDate": "2019-09-24",
	                    "areaUnitName": "亩",
	                    "partitionName": "展示区",
	                    "partitionId": "a436f19ac3bc46cdb566b1c045f1c2c5",
	                    "organizationId": "864191543bbb45558801605515197f98",
	                    "endFlag": 3,
	                    "createTime": "2019-09-23 21:57:40",
	                    "harvestCreateTime": 1569290697617,
	                    "id": 298,
	                    "massAreaVal": 3.46
	                  }],
	                  "展示大棚": [{
	                    "massIfName": "展示大棚",
	                    "baseName": "海南润达现代农业集团股份有限公司",
	                    "principalName": "林鸿图",
	                    "massArea": "9500.0",
	                    "hasHarvest": 0,
	                    "massId": "718722a0322a4b28b70de55a82a9a019",
	                    "areaUnitName": "平方米",
	                    "partitionName": "展示区",
	                    "massAreaVal": 9500
	                  }]
	                };
	                resultData = data;
	
	                for (key in resultData) {
	                  for (i = 0; i < list.length; i++) {
	                    if (key === list[i].name) {
	                      list[i].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                  for (j = 0; j < rightlist.length; j++) {
	                    if (key === rightlist[j].name) {
	                      rightlist[j].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                }
	                _this3.massifList = list;
	                _this3.massifListR = rightlist;
	                console.log(_this3.datalist);
	                _this3.time();
	              }
	              console.log(_this3.url);
	              console.log(_config2.default);
	
	            case 8:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    tit: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      myChart: {},
	      colorList: {
	        '无霜期': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#C4F4FA'
	        }, {
	          offset: 1,
	          color: '#04CBE2'
	        }], false),
	        '年平均降雨量': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#3CA6FF'
	        }, {
	          offset: 1,
	          color: '#4451FF'
	        }], false),
	        '年平均日照时长': new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	          offset: 0,
	          color: '#F69211'
	        }, {
	          offset: 1,
	          color: '#EC5D24'
	        }], false)
	      },
	      dataList: {
	        '无霜期': [10, 12, 15, 20, 25, 30, 31, 31, 30, 20, 15, 20],
	        '年平均降雨量': [53, 67, 73, 87, 300, 340, 367, 316, 270, 245, 108, 71],
	        '年平均日照时长': [7, 10, 10, 11, 12, 12, 12, 12, 11, 10, 9, 8]
	      },
	      unitList: {
	        '无霜期': '天',
	        '年平均降雨量': 'ml',
	        '年平均日照时长': 'h'
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart2.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart2 = _echarts2.default.init(document.querySelector('.line .main'));
	    var option = {
	      title: {
	        text: '年平均降雨',
	        left: 'center',
	        top: '13%',
	        textStyle: {
	          color: '#fff',
	          fontSize: 14
	        }
	      },
	      grid: { // 设置图表位置
	        left: '18%',
	        bottom: '25%',
	        top: '35%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        name: 'ml',
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: "#77CAD8"
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          formatter: "{value}",
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            opacity: 0.3,
	            width: 1,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: this.dataList['年平均降雨量'],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: this.colorList['年平均降雨量']
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	
	    this.myChart2.setOption(option);
	
	    this.init();
	  }
	};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line3 .main'));
	    var option = {
	      title: {
	        text: '历史气温差',
	        left: 'center',
	        top: '13%',
	        textStyle: {
	          color: '#fff',
	          fontSize: 14
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '20%',
	        top: '35%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        name: '℃',
	        type: 'value',
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: "#77CAD8"
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          // formatter: "{value}℃",
	          formatter: "{value}",
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            width: 1,
	            opacity: 0.3,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: [29, 28, 30, 31, 34, 34, 35, 33, 34, 32, 31, 30],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF813C'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }, {
	        data: [13, 11, 16, 18, 24, 24, 24, 23, 24, 20, 19, 11],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#E4A537'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(option);
	    this.init();
	  }
	};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line4 .main'));
	    var option = {
	      title: {
	        text: '日均气温差',
	        left: 'center',
	        top: '13%',
	        textStyle: {
	          color: '#fff',
	          fontSize: 14
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '20%',
	        top: '35%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['春', '夏', '秋', '冬'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        name: '℃',
	        splitNumber: 3,
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: "#77CAD8"
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          formatter: "{value}",
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            width: 1,
	            opacity: 0.3,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: [26, 32, 32, 28],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF813C'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }, {
	        data: [19, 25, 26, 22],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#E4A537'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(option);
	    this.init();
	  }
	};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      myChart: {}
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.line2 .main'));
	    var option = {
	      title: {
	        text: '年平均昼夜温差',
	        left: 'center',
	        top: '13%',
	        textStyle: {
	          color: '#fff',
	          fontSize: 14
	        }
	      },
	      grid: { // 设置图表位置
	        left: '15%',
	        bottom: '20%',
	        top: '35%'
	      },
	      xAxis: {
	        type: 'category',
	        boundaryGap: false,
	        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
	        axisTick: {
	          show: false
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: false
	        }
	      },
	      yAxis: {
	        type: 'value',
	        name: '℃',
	        splitNumber: 3,
	        axisTick: {
	          show: false
	        },
	        nameTextStyle: {
	          color: "#77CAD8"
	        },
	        axisLine: {
	          show: true,
	          lineStyle: {
	            color: "#243C7E",
	            width: 1,
	            type: "solid"
	          }
	        },
	        axisLabel: {
	          show: true,
	          formatter: "{value}",
	          textStyle: {
	            color: "#77CAD8"
	          }
	        },
	        splitLine: {
	          show: true,
	          lineStyle: {
	            color: "#4797FA",
	            width: 1,
	            opacity: 0.3,
	            type: "solid"
	          }
	        }
	      },
	      series: [{
	        data: [24, 25, 28, 30, 33, 33, 32, 32, 33, 32, 29, 26],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF813C'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }, {
	        data: [19, 17, 20, 23, 26, 26, 26, 26, 26, 24, 24, 20],
	        type: 'line',
	        smooth: true,
	        showSymbol: false,
	        lineStyle: {
	          normal: {
	            width: 0
	          }
	        },
	        areaStyle: {
	          opacity: 1,
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#E4A537'
	            }, {
	              offset: 1,
	              color: '#FFE63D'
	            }], false)
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: '#f00'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(option);
	    this.init();
	  }
	};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(1830);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      areaName: '田阳县'
	    };
	  },
	
	  components: {
	    'v-map': _index2.default
	  },
	  mounted: function mounted() {},
	  created: function created() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _line = __webpack_require__(1831);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _lines = __webpack_require__(1834);
	
	var _lines2 = _interopRequireDefault(_lines);
	
	var _lines3 = __webpack_require__(1832);
	
	var _lines4 = _interopRequireDefault(_lines3);
	
	var _lines5 = __webpack_require__(1833);
	
	var _lines6 = _interopRequireDefault(_lines5);
	
	var _map = __webpack_require__(1835);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '智慧种植',
	      baseName: "",
	      baseManager: "",
	      contact: "",
	      baseArea: "",
	      timerIndustryInformation: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Smartplanting);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	
	                _this.baseName = resultData.baseName;
	                _this.baseManager = resultData.baseManager;
	                _this.contact = resultData.contact;
	                _this.baseArea = resultData.baseArea;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerIndustryInformation = setTimeout(() => {
	              //   console.log("timerIndustryInformation")
	              //   this.next()
	              // }, 30000);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerIndustryInformation);
	    this.timerIndustryInformation = null;
	  },
	
	  methods: {
	    // 下标改变事件
	    indexChange: function indexChange(newIndex) {
	      this.activeItem = newIndex;
	    },
	    next: function next() {
	      this.$router.push('/rundatrace');
	    },
	    prev: function prev() {
	      this.$router.push('/rundadashboard');
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-line': _line2.default,
	    'v-lines': _lines2.default,
	    'v-map': _map2.default,
	    'v-lines3': _lines4.default,
	    'v-lines4': _lines6.default
	  }
	};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '收支公开',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        "tooltip": {
	          "trigger": "axis",
	          "axisPointer": {
	            "type": "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        "legend": {
	          x: '40%',
	          top: '2%',
	          textStyle: {
	            color: '#FFF'
	          },
	          itemHeight: 4,
	          itemWidth: 14,
	          "data": ['收入', '支出']
	        },
	        "xAxis": [{
	          "type": "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "splitLine": {
	            "show": false
	          },
	          "axisTick": {
	            "show": false
	          },
	          "splitArea": {
	            "show": false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	          },
	          "data": [2012, 2013, 2014, 2015, 2016, 2017]
	        }],
	        "yAxis": [(0, _defineProperty3.default)({
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, -20]
	          },
	          "type": "value",
	          "splitLine": {
	            "show": false
	          },
	          "axisLine": {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "axisTick": {
	            "show": false
	          },
	          "axisLabel": {
	            "interval": 0
	
	          },
	          "splitArea": {
	            "show": false
	          }
	        }, 'axisLabel', {
	          interval: 0,
	          color: "#fff",
	          fontSize: 12
	        })],
	        "series": [{
	          "name": "收入",
	          "type": "bar",
	          "stack": "总量",
	          "barMaxWidth": 20,
	          "barGap": "10%",
	          "itemStyle": {
	            "normal": {
	              "color": "#76CD2E",
	              "label": {
	                "show": false,
	                "textStyle": {
	                  "color": "#fff"
	                },
	                "position": "insideTop"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [80, 60, 50, 60, 100, 110]
	        }, {
	          "name": "支出",
	          "type": "bar",
	          "stack": "总量",
	          "itemStyle": {
	            "normal": {
	              "color": "#486FF1",
	              "barBorderRadius": 0,
	              "label": {
	                "show": false,
	                "position": "top"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [10, 10, 20, 30, 40, 40]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index >= 6) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [80, 50, 60, 100, 150, 120];
	    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      swiperData: ['总屏', '销售数据', '基地数据', '溯源数据', '精准扶贫'],
	      swiperOption: {
	        slidesPerView: 6,
	        speed: 300,
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // current swiper instance
	    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
	    console.log('this is current swiper instance object', this.swiper);
	    // this.swiper.slideTo(3, 1000, false)
	  },
	
	  computed: {
	    swiper: function swiper() {
	      return this.$refs.mySwiper.swiper;
	    }
	  },
	  // ['总屏', '销售数据', '基地数据', '溯源数据', '产品展示'],
	  methods: {
	    clickPage: function clickPage(index) {
	      if (index === 0) {
	        // 总屏
	        this.$router.push('/rundadashboard');
	      } else if (index === 1) {
	        // 销售数据
	        this.$router.push('/rundasalesDataCenter');
	      } else if (index === 2) {
	        // 基地数据
	        this.$router.push('/rundaindustryInformation');
	      } else if (index === 3) {
	        // 环境监测
	        this.$router.push('/rundatrace');
	      } else if (index === 4) {
	        // 溯源数据
	        this.$router.push('/rundahelper');
	      }
	    }
	  }
	};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(140);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(172);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _centerBottom = __webpack_require__(1838);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	__webpack_require__(1618);
	
	__webpack_require__(1617);
	
	__webpack_require__(1405);
	
	__webpack_require__(1404);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var MassifItem = function () {
	  function MassifItem(theme) {
	    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var index = arguments[3];
	    (0, _classCallCheck3.default)(this, MassifItem);
	    this.list = [];
	    this.type = 'left';
	
	    this.theme = theme;
	    this.text = text;
	    this.name = name;
	    this.index = index;
	  }
	
	  (0, _createClass3.default)(MassifItem, [{
	    key: 'setMassif',
	    value: function setMassif(massif) {
	      this.massif = massif;
	      return this;
	    }
	  }, {
	    key: 'setList',
	    value: function setList(list) {
	      this.list = list;
	      return this;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      var style = {};
	      return style;
	    }
	  }, {
	    key: 'getThemeIndex',
	    value: function getThemeIndex() {
	      var _this = this;
	
	      return this.list.filter(function (item) {
	        return item.theme === _this.theme;
	      }).indexOf(this);
	    }
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var themeIndex = this.getThemeIndex();
	      return classNames('theme-' + this.theme, 'theme-index-' + themeIndex);
	    }
	  }]);
	  return MassifItem;
	}();
	
	var list = [new MassifItem(1, '', 'D10', 0), new MassifItem(1, '', 'D09', 1), new MassifItem(1, '', 'D08', 2), new MassifItem(1, '', 'D07', 3), new MassifItem(1, '', 'D06', 4), new MassifItem(1, '', 'D05', 5), new MassifItem(1, '', 'D04', 6), new MassifItem(1, '', 'D03', 7), new MassifItem(1, '', 'D02', 8), new MassifItem(1, '', 'D01', 9),
	//
	new MassifItem(2, '', '16-1', 0), new MassifItem(2, '', '16-3', 1), new MassifItem(2, '', '16-5', 2), new MassifItem(2, '', '16-7', 3), new MassifItem(2, '', '16-9', 4), new MassifItem(2, '', '16-11', 5), new MassifItem(2, '', '16-2', 6), new MassifItem(2, '', '16-4', 7), new MassifItem(2, '', '16-6', 8), new MassifItem(2, '', '16-8', 9), new MassifItem(2, '', '16-10', 10), new MassifItem(2, '', '16-12', 11),
	//
	new MassifItem(3, '', '', 0), new MassifItem(3, '', '', 1),
	//
	new MassifItem(4, '15', '15号棚', 0), new MassifItem(5, '', '', 1),
	//
	new MassifItem(6, '', '14号棚', 0), new MassifItem(6, '', '13号棚', 1),
	//
	new MassifItem(7, '', '12号棚', 1), new MassifItem(8, '', '11号棚', 0), new MassifItem(8, '', '9号棚', 1), new MassifItem(8, '', '3号棚', 2), new MassifItem(8, '', '8号棚', 3), new MassifItem(8, '', '2号棚', 4), new MassifItem(8, '', '7号棚', 5), new MassifItem(8, '', '1号棚', 6),
	//
	new MassifItem(9, '', '10号棚', 0), new MassifItem(10, '', '', 1),
	//
	new MassifItem(11, '', '6号棚', 0), new MassifItem(11, '', '5号棚', 1), new MassifItem(11, '', '4号棚', 2),
	//
	new MassifItem(12, '', '', 0), new MassifItem(13, '', '', 1), new MassifItem(14, '', '', 2),
	//
	new MassifItem(15, '', '展-2A', 0), new MassifItem(15, '', '展-2C', 1),
	//
	new MassifItem(16, '', '展-2B', 0), new MassifItem(16, '', '展-2D', 1),
	//
	new MassifItem(17, '', '展-叶菜区', 0), new MassifItem(17, '', '展-叶菜区', 1)];
	var rightlist = [new MassifItem(null), new MassifItem(15, '15', '581-15'), new MassifItem(16, '16', '581-16'), new MassifItem(14, '14', '581-14'), new MassifItem(17, '17', '581-17'), new MassifItem(13, '13', '581-13'), new MassifItem(18, '18', '581-18'), new MassifItem(12, '12', '581-12'), new MassifItem(19, '19', '581-19'), new MassifItem(11, '11', '581-11'), new MassifItem(20, '20', '581-20'), new MassifItem(10, '10', '581-10'), new MassifItem(21, '21', '581-21'), new MassifItem(9, '9', '581-9'), new MassifItem(22, '22', '581-22'), new MassifItem(8, '8', '581-8'), new MassifItem(23, '23', '581-23'), new MassifItem(7, '7', '581-7'), new MassifItem(24, '24', '581-24'), new MassifItem(6, '6', '581-6'), new MassifItem(25, '25', '581-25'), new MassifItem(5, '5', '581-5'), new MassifItem(26, '26', '581-26'), new MassifItem(4, '4', '581-4'), new MassifItem(27, '27', '581-27'), new MassifItem(3, '3', '581-3'), new MassifItem(28, '28', '581-28'), new MassifItem(2, '2', '581-2'), new MassifItem(29, '29', '581-29'), new MassifItem(1, '1', '581-1')];
	
	exports.default = {
	  props: ["productionScale", "outputValue"],
	  data: function data() {
	    return {
	      areaName: '',
	      timer: null,
	      massifList: [],
	      massifListR: [],
	      tip: true,
	      list: [],
	      datalist: [],
	      index: 0,
	      url: _config2.default.fileDomain
	    };
	  },
	
	  components: {
	    centerBottom: _centerBottom2.default
	  },
	  methods: {
	    show: function show(val, type) {
	      // console.log(type === '1')
	      if (type === '1') {
	        clearInterval(this.timer);
	      }
	      this.tip = true;
	      this.list = val;
	    },
	    tips: function tips() {
	      clearInterval(this.timer);
	      this.tip = true;
	    },
	    leave: function leave() {
	      this.tip = false;
	      this.time();
	    },
	    time: function time() {
	      var _this2 = this;
	
	      var count = this.datalist.length;
	      this.timer = setInterval(function () {
	        if (_this2.index > count) {
	          _this2.index = 0;
	        }
	        _this2.show(_this2.datalist[_this2.index]);
	        _this2.index = _this2.index + 1;
	        // console.log(this.index)
	      }, 3000);
	    }
	  },
	  mounted: function mounted() {
	    var _this3 = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, key, i, j;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this3.$model('dataManagement').commonfn2(_this3.$apiUrl.DATAANALYSIS.GetMassIfInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                for (key in resultData) {
	                  for (i = 0; i < list.length; i++) {
	                    if (key === list[i].name) {
	                      list[i].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                  for (j = 0; j < rightlist.length; j++) {
	                    if (key === rightlist[j].name) {
	                      rightlist[j].setList(resultData[key]);
	                      _this3.datalist.push(resultData[key]);
	                    }
	                  }
	                }
	                _this3.massifList = list;
	                _this3.massifListR = rightlist;
	                console.log(_this3.datalist);
	                _this3.time();
	              } else {
	                _this3.$message.showError(err);
	              }
	              console.log(_config2.default.fileDomain);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '环境质量管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      dataY: [],
	      dataX: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: '10%',
	            left: '20%',
	            right: '10%',
	            bottom: '20%',
	            containLabel: true
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          splitNumber: 4,
	          name: '百万',
	          min: 0,
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	
	            formatter: function formatter(value, index) {
	              return value / 1000000;
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#eb64fb'
	              }, {
	                offset: 1,
	                color: '#3fbbff0d'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i, self;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results.dataList;
	                // console.log(resultData)
	
	                for (i = 0; i < resultData.length; i++) {
	                  _this.dataY.push(resultData[i].harvestQuantity);
	                  _this.dataX.push(resultData[i].month);
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	              self = _this;
	
	              self.chart();
	              self.init();
	              _this.timer = setInterval(function () {
	                // 某些定时器操作
	                self.getData();
	              }, 3000);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '垃圾分类积分排行',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '王大力', productionForecast: 283 }, { id: '周建军', productionForecast: 270 }, { id: '李卫国', productionForecast: 262 }, { id: '王国强', productionForecast: 252 }];
	              _this.sum = 300;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '项目公开',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 22 }, { id: '绿化改造工程', productionForecast: 25 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 50;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#407FFF', '#F45E23', '#E6AF08', '#49C8CF'],
	      myChart: {},
	      name: '补贴发放',
	      dataX: [],
	      timer: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    // console.log(this.chartData)
	    this.dataX = ['危房改造', '大病救助', '留守儿童', '低保五保'];
	    this.chartData = [{ name: '危房改造', value: 30 }, { name: '大病救助', value: 20 }, { name: '留守儿童', value: 30 }, { name: '低保五保', value: 20 }];
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie1 .main'));
	    var op = {
	      title: {
	        text: '第三季度',
	        textStyle: {
	          color: '#33D8FB',
	          fontSize: 20
	        },
	        top: '%',
	        right: '5%'
	      },
	      legend: [{
	        orient: 'vertical',
	        right: '20',
	        bottom: '20',
	        itemHeight: 16,
	        itemWidth: 16,
	        data: this.dataX,
	        textStyle: {
	          color: "#FFF",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '75%'],
	        center: ['35%', '50%'],
	        data: data,
	        label: {
	          position: 'outside',
	          normal: {
	            // formatter: '{b|{b}}\n{hr|}\n{c|{c}%}',
	            // rich: {
	            //   b: {
	            //     fontSize: 16,
	            //     color: '#FFF',
	            //     align: 'left',
	            //     padding: 4
	            //   },
	            //   hr: {
	            //     borderColor: '#CCCCCC',
	            //     width: '100%',
	            //     borderWidth: 2,
	            //     height: 0
	            //   },
	            //   c: {
	            //     fontSize: 16,
	            //     align: 'center',
	            //     padding: 4,
	            //     color: '#00EDED'
	            //   }
	            // }
	          }
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '种植批次数据',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                // console.log(resultData)
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '人口情况',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.setOption({
	        animation: true,
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        xAxis: {
	          name: '年龄',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            // top: 20,
	            padding: [25, 0, 0, -10]
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	            // rotate: 30
	          }
	        },
	        yAxis: {
	          name: '人数',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, -20]
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              if (value > 10000) {
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(232,159,31,1)"
	              }, {
	                offset: 0.8,
	                color: "rgba(241,100,30,1)"
	              }], false)
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [80, 50, 60, 100, 150, 120];
	    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90'];
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      self.getData();
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '产业情况',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(76);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可视化管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _ljcheader = __webpack_require__(584);
	
	var _ljcheader2 = _interopRequireDefault(_ljcheader);
	
	var _planting = __webpack_require__(1845);
	
	var _planting2 = _interopRequireDefault(_planting);
	
	var _generatingData = __webpack_require__(1841);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _salesData = __webpack_require__(1846);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table = __webpack_require__(1847);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _pie = __webpack_require__(1844);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _bar = __webpack_require__(1837);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _center = __webpack_require__(1839);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _harvestingPlan = __webpack_require__(1843);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _ev = __webpack_require__(1840);
	
	var _ev2 = _interopRequireDefault(_ev);
	
	var _video = __webpack_require__(1848);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _group = __webpack_require__(1842);
	
	var _group2 = _interopRequireDefault(_group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      name: '数字鲁家大数据中心',
	      outputValue: '',
	      productionScale: '',
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      timerDashboard: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // new Swiper('.swiper-container', {
	              //   direction: 'horizontal', // 水平切换选项
	              //   loop: true, // 循环模式选项
	              //   autoplay: 3000,
	              //   navigation: {
	              //     nextl: '.swiper-button-next',
	              //     prevEl: '.swiper-button-prev'
	              //   }
	              // })
	              _this.show = true;
	              _context.next = 3;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Agriculture);
	
	            case 3:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	                // console.log(resultData)
	
	                _this.outputValue = resultData.outputValue;
	                _this.productionScale = resultData.productionScale;
	                _this.salesData = resultData.salesData;
	                _this.salesDataBar = resultData.salesDataBar;
	                _this.salesDataRealTime = resultData.salesDataRealTime;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerDashboard = setTimeout(() => {
	              //   console.log("timerDashboard")
	              //   this.next()
	              // }, 30000);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerDashboard);
	    this.timerDashboard = null;
	  },
	
	  methods: {
	    next: function next() {
	      this.$router.push('/rundaindustryInformation');
	    },
	    prev: function prev() {
	      this.$router.push('/rundahelper');
	    }
	  },
	  components: {
	    'v-header': _ljcheader2.default,
	    'v-salesData': _salesData2.default,
	    'v-table': _table2.default,
	    'v-harvestingPlan': _harvestingPlan2.default,
	    'v-generatingData': _generatingData2.default,
	    'v-center': _center2.default,
	    'v-pie': _pie2.default,
	    'v-bar': _bar2.default,
	    'v-ev': _ev2.default,
	    'v-video': _video2.default,
	    'v-planting': _planting2.default,
	    'v-group': _group2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["orderCustomer", "salesAmount", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '',
	      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
	      dataX: [],
	      dataY: []
	    };
	  },
	
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        grid: {
	          top: '10%',
	          left: '15%',
	          bottom: '15%'
	        },
	        xAxis: {
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          name: '',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              // if (value > 1000000) {
	              //   return value / 1000000 + "百万"
	              // } else
	              if (value > 10000) {
	                return value / 10000 + "万";
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#ffb52a'
	              }, {
	                offset: 1,
	                color: '#ffb52a'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    for (var i = 0; i < this.salesDataBar.length; i++) {
	      this.dataY.push(this.salesDataBar[i].lumpSum);
	      this.dataX.push(this.salesDataBar[i].month);
	    }
	    var dataArr = [];
	    var data = new Date();
	    var year = data.getFullYear();
	    data.setMonth(data.getMonth() + 1, 1);
	    for (var k = 0; k < 12; k++) {
	      data.setMonth(data.getMonth() - 1);
	      var m = data.getMonth() + 1;
	      m = m < 10 ? "0" + m : m;
	      dataArr.push(data.getFullYear() + "-" + m);
	    }
	    this.dataX = dataArr.reverse();
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '',
	      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
	      tableData: [{ name: '百色芒果', scale: '120.16万亩', output: '35.02亿', production: '672900吨', listed: '夏季' }, { name: '百色番茄', scale: '24.25万亩', output: '9.5亿', production: '850000吨', listed: '全年' }, { name: '田东香芒', scale: '23万亩', output: '7.6亿', production: '58000吨', listed: '夏季' }, { name: '凌云牛心李', scale: '5万亩', output: '2.4亿', production: '60000吨', listed: '秋季' }, { name: '德保山楂', scale: '8万亩', output: '1.8亿', production: '45000吨', listed: '夏季' }, { name: '西林沙塘桔', scale: '16.6万亩', output: '12亿', production: '400000吨', listed: '秋季' }, { name: '田阳香芒', scale: '39.7万亩', output: '11.3亿', production: '236000吨', listed: '夏季' }, { name: '平果火龙果', scale: '2.3万亩', output: '8亿', production: '8000吨', listed: '夏季' }, { name: '隆林板栗', scale: '13.78万亩', output: '0.28亿', production: '4000吨', listed: '秋季' }, { name: '凌云白毫茶', scale: '12.6万亩', output: '4.51亿', production: '5412吨', listed: '春季' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    // boxWrap,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: 0
	          },
	          data: ["百色芒果", "田东香芒", "百色番茄", "凌云牛心李", "德保山楂", "西林沙塘桔", "田阳香芒", "平果火龙果", "隆林板栗", "凌云白毫茶"],
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          barWidth: 18,
	          // itemStyle: {
	          //   normal: {
	          //     color: new echarts.graphic.LinearGradient(
	          //       0,
	          //       0,
	          //       0,
	          //       1,
	          //       [
	          //         {
	          //           offset: 0,
	          //           color: "rgba(232,159,31,1)"
	          //         },
	          //         {
	          //           offset: 0.8,
	          //           color: "rgba(241,100,30,1)"
	          //         }
	          //       ],
	          //       false
	          //     )
	          //   }
	          // },
	          data: this.data
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	// import boxWrap from '../common/boxWrap';
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(210);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ["regionalRanking"],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '订单地区排名',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    // console.log(this.regionalRanking)
	    for (var i = 0; i < this.regionalRanking.length; i++) {
	      this.sum += parseInt(this.regionalRanking[i].quantityOrder);
	      this.tableData.push({ name: this.regionalRanking[i].regionalName, num: this.regionalRanking[i].quantityOrder });
	    }
	    console.log(this.sum);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(210);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ["commodityRanking"],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '订单商品排名',
	      sum: 0,
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    console.log(this.commodityRanking);
	    for (var i = 0; i < this.commodityRanking.length; i++) {
	      this.sum += parseInt(this.commodityRanking[i].salesAmount);
	      this.tableData.push({ name: this.commodityRanking[i].commodityName, num: this.commodityRanking[i].salesAmount });
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(210);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['salesOrderAnalysis'],
	  data: function data() {
	    return {
	      name: '订单分析',
	      dataX: [],
	      dataY1: [],
	      dataY2: [],
	      nameX: ["本部订单", "外部订单"]
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: { // 坐标轴指示器，坐标轴触发有效
	            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
	          }
	        },
	        grid: {
	          left: '2%',
	          right: '4%',
	          bottom: '14%',
	          top: '16%',
	          containLabel: true
	        },
	        legend: {
	          data: this.nameX,
	          right: 10,
	          top: 12,
	          textStyle: {
	            color: "#fff"
	          },
	          itemWidth: 12,
	          itemHeight: 10
	          // itemGap: 35
	        },
	        xAxis: {
	          type: 'category',
	          data: this.dataX,
	          axisLine: {
	            lineStyle: {
	              color: '#014B84'
	            }
	          },
	          axisLabel: {
	            textStyle: {
	              color: '#FFF',
	              fontFamily: 'Microsoft YaHei'
	            }
	          }
	        },
	        yAxis: {
	          type: 'value',
	          axisLine: {
	            lineStyle: {
	              color: '#014B84'
	            }
	          },
	          axisLabel: {
	            textStyle: {
	              color: '#FFF',
	              fontFamily: 'Microsoft YaHei'
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: 'rgba(255,255,255,0.3)'
	            }
	          }
	        },
	        series: [{
	          name: '本部订单',
	          type: 'bar',
	          barWidth: '35%',
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#E89F1E'
	              }, {
	                offset: 1,
	                color: '#E89F1E'
	              }])
	            }
	          },
	          data: this.dataY1
	        }, {
	          name: '外部订单',
	          type: 'bar',
	          barWidth: '35%',
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#2492FF'
	              }, {
	                offset: 1,
	                color: '#2492FF'
	              }])
	
	            }
	
	          },
	          data: this.dataY2
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    for (var i = 0; i < this.salesOrderAnalysis.length; i++) {
	      this.dataX.push(this.salesOrderAnalysis[i].month);
	      this.dataY1.push(this.salesOrderAnalysis[i].headquartersOrder);
	      this.dataY2.push(this.salesOrderAnalysis[i].externalOrder);
	    }
	
	    var dataArr = [];
	    var data = new Date();
	    var year = data.getFullYear();
	    data.setMonth(data.getMonth() + 1, 1);
	    for (var k = 0; k < 6; k++) {
	      data.setMonth(data.getMonth() - 1);
	      var m = data.getMonth() + 1;
	      m = m < 10 ? "0" + m : m;
	      dataArr.push(data.getFullYear() + "-" + m);
	    }
	    this.dataX = dataArr.reverse();
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(210);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '实时销售订单',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    console.log(this.salesDataRealTime);
	    this.tableData = this.salesDataRealTime;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _salesData = __webpack_require__(1854);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table = __webpack_require__(1855);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _harvestingPlan = __webpack_require__(1852);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _orderProductRanking = __webpack_require__(1853);
	
	var _orderProductRanking2 = _interopRequireDefault(_orderProductRanking);
	
	var _generatingData = __webpack_require__(1851);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _center = __webpack_require__(1850);
	
	var _center2 = _interopRequireDefault(_center);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '销售数据中心',
	      show: false,
	      commodityRanking: [],
	      orderCustomer: "",
	      regionalRanking: [],
	      salesAmount: "",
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      salesOrderAnalysis: [],
	      salesDataCentertimer: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.salesDataCenter);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	
	                _this.commodityRanking = resultData.commodityRanking;
	                _this.orderCustomer = resultData.orderCustomer;
	                _this.regionalRanking = resultData.regionalRanking;
	                _this.salesAmount = resultData.salesAmount;
	                _this.salesData = resultData.salesData;
	                _this.salesDataBar = resultData.salesDataBar;
	                _this.salesDataRealTime = resultData.salesDataRealTime;
	                _this.salesOrderAnalysis = resultData.salesOrderAnalysis;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.salesDataCentertimer = setTimeout(() => {
	              //   console.log("salesDataCentertimer")
	              //   this.next()
	              // }, 30000);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.salesDataCentertimer);
	    this.salesDataCentertimer = null;
	  },
	
	  methods: {
	    next: function next() {
	      this.$router.push('/rundahelper');
	    },
	    prev: function prev() {
	      this.$router.push('/rundatrace');
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-salesData': _salesData2.default,
	    'v-table': _table2.default,
	    'v-harvestingPlan': _harvestingPlan2.default,
	    'v-generatingData': _generatingData2.default,
	    'v-center': _center2.default,
	    'v-orderProductRanking': _orderProductRanking2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ["regionBar"],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '脱贫家庭数',
	      dataX: [],
	      dataY: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    // console.log(this.regionBar)
	    var count = 0;
	    for (var i = 0; i < this.regionBar.length; i++) {
	      if (this.regionBar[i].name && count < 5) {
	        this.dataX.push(this.regionBar[i].name);
	        this.dataY.push(this.regionBar[i].number);
	        count++;
	      }
	    }
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.bars .main'));
	    this.myChart.setOption({
	      xAxis: {
	        data: this.dataX,
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          interval: 0,
	          color: '#77CAD8',
	          fontSize: 12
	        }
	      },
	      yAxis: {
	        nameTextStyle: {
	          color: ' #77CAD8',
	          fontSize: 12
	        },
	        axisLine: {
	          lineStyle: {
	            color: '#0177d4'
	          }
	        },
	        axisTick: {
	          show: false
	        },
	        axisLabel: {
	          color: '#77CAD8',
	          fontSize: 12
	        },
	        splitLine: {
	          show: false,
	          lineStyle: {
	            color: '#0177d4'
	          }
	        }
	      },
	      grid: {
	        left: '12%'
	      },
	      series: [{
	        type: 'bar',
	        barWidth: 18,
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#C0E450'
	            }, {
	              offset: 0.8,
	              color: '#75CD2D'
	            }], false)
	          }
	        },
	        data: this.dataY
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '数据来源统计',
	      dataX: [],
	      timer1: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    this.dataX = ['历史迁移', '手动录入', 'IOT录入', '非法入侵'];
	    this.chartData = [{ name: '历史迁移', value: 40 }, { name: '手动录入', value: 30 }, { name: 'IOT录入', value: 20 }, { name: '非法入侵', value: 10 }];
	    // console.log(this.chartData)
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie .main'));
	    var op = {
	      title: {
	        show: false
	      },
	      legend: [{
	        // orient: 'vertical',
	        // left: '10',
	        // top: '20',
	        bottom: 20,
	        data: this.dataX,
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['50%', '40%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer1);
	    this.timer1 = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer1);
	  }
	};

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '历史数据迁移统计',
	      dataX: [],
	      timer2: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    this.dataX = ['数据已迁移', '数据待迁移', '数据迁移中'];
	    this.chartData = [{ name: '数据已迁移', value: 40 }, { name: '数据待迁移', value: 30 }, { name: '数据迁移中', value: 30 }];
	    // console.log(this.chartData)
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie2 .main'));
	    var op = {
	      title: {
	        show: false
	      },
	      legend: [{
	        // orient: 'vertical',
	        // left: '10',
	        // top: '20',
	        bottom: 20,
	        data: this.dataX,
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['50%', '40%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer2);
	    this.timer2 = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 3) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer2);
	  }
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784', '#80EE44'],
	      myChart: {},
	      name: '数据类型统计',
	      dataX: [],
	      timer: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    // console.log(this.chartData)
	    this.dataX = ['主体信息数据', '网格化监管数据', '检测检验数据', '三品一标识认证数据', '公用品牌数据', '追溯数据'];
	    this.chartData = [{ name: '主体信息数据', value: 17 }, { name: '网格化监管数据', value: 17 }, { name: '检测检验数据', value: 9 }, { name: '三品一标识认证数据', value: 7 }, { name: '公用品牌数据', value: 13 }, { name: '追溯数据', value: 37 }];
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie1 .main'));
	    var op = {
	      title: {
	        show: false
	      },
	      legend: [{
	        // orient: 'vertical',
	        // left: '10',
	        // top: '20',
	        bottom: 20,
	        data: this.dataX,
	        textStyle: {
	          color: "#00fefb",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '60%'],
	        center: ['50%', '35%'],
	        data: data,
	        label: {
	          position: 'outside'
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 6) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['povertyAlleviaList'],
	  data: function data() {
	    return {
	      name: '',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    // boxWrap,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // this.tableData = this.povertyAlleviaList
	    this.tableData = [{
	      poor: "",
	      familyPopulation: "4",
	      regionName: "扎兰屯沙果溯源数据",
	      amount: "800"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: "呼伦贝尔草原白蘑溯源数据",
	      amount: "90"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: "凉城白瓜子溯源数据",
	      amount: "60"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: "丰镇月饼安全检测数据",
	      amount: "20"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: "阿尔巴斯白绒山羊溯源数据",
	      amount: "900"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: "托县辣椒检测数据",
	      amount: "600"
	    }, {
	      poor: "",
	      familyPopulation: "4",
	      regionName: " 正蓝旗乌日穆产品检测数据",
	      amount: "30"
	    }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(135);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['productBar'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '扶贫产品排名',
	      dataX: [],
	      dataY1: [],
	      dataY2: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var count = 0;
	    for (var i = 0; i < this.productBar.length; i++) {
	      if (this.productBar[i].name && count < 3) {
	        this.dataX.push(this.productBar[i].name);
	        this.dataY1.push(this.productBar[i].output);
	        this.dataY2.push(this.productBar[i].amount);
	        count++;
	      }
	    }
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.twoWayBar .main'));
	
	    this.myChart.setOption({
	      tooltip: {
	
	        trigger: 'axis',
	        axisPointer: { // 坐标轴指示器，坐标轴触发有效
	          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
	        }
	      },
	      legend: {
	        data: ['产量', '金额'],
	        top: 5,
	        left: 110,
	        textStyle: {
	          color: '#fff',
	          fontSize: 16
	        }
	      },
	      grid: {
	        top: '15%',
	        left: '3%',
	        right: '4%',
	        bottom: '10%',
	        containLabel: true
	      },
	      xAxis: [{
	        type: 'value',
	        axisTick: { show: false },
	        axisLine: {
	          show: false
	        },
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 16
	        },
	        splitLine: {
	          lineStyle: {
	            color: '#0092EE'
	          }
	        }
	      }],
	      yAxis: [{
	        type: 'category',
	        axisTick: { show: false },
	        data: this.dataX,
	        axisLabel: {
	          color: '#00DAEE',
	          fontSize: 18
	        }
	      }],
	      series: [{
	        name: '产量',
	        type: 'bar',
	        barWidth: 8,
	        label: {
	          normal: {
	            // show: true
	            // position: 'inside'
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#FF9E2C'
	            }, {
	              offset: 0.8,
	              color: '#FF4E00'
	            }], false)
	          }
	        },
	        data: this.dataY1
	      }, {
	        name: '金额',
	        type: 'bar',
	        barWidth: 8,
	        stack: '总量',
	        label: {
	          normal: {
	            // show: true
	          }
	        },
	        itemStyle: {
	          normal: {
	            color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	              offset: 0,
	              color: '#5EB5FF'
	            }, {
	              offset: 0.8,
	              color: '#00DAEE'
	            }], false)
	          }
	        },
	        data: this.dataY2
	      }]
	    });
	    this.init();
	  }
	};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _headers = __webpack_require__(1731);
	
	var _headers2 = _interopRequireDefault(_headers);
	
	var _table = __webpack_require__(1861);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _bars = __webpack_require__(1857);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _twoWayBar = __webpack_require__(1862);
	
	var _twoWayBar2 = _interopRequireDefault(_twoWayBar);
	
	var _pie = __webpack_require__(1860);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _pie3 = __webpack_require__(1858);
	
	var _pie4 = _interopRequireDefault(_pie3);
	
	var _pie5 = __webpack_require__(1859);
	
	var _pie6 = _interopRequireDefault(_pie5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '农畜产品质量安全大数据中心',
	      listdata: [],
	      regionBar: [],
	      productBar: [],
	      distributedBar: [],
	      povertyAlleviaList: [],
	      timerHelper: null,
	      show: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, list, key;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Helper);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	                list = {
	                  povertyNumber: '脱贫家庭数',
	                  povertyAlleviation: '扶贫人数',
	                  perIncome: '贫困户人均收入',
	                  totalAmount: '帮扶总额'
	                };
	
	                for (key in list) {
	                  _this.listdata.push({ name: list[key], value: resultData[key] });
	                }
	                _this.regionBar = resultData.regionBar;
	                _this.productBar = resultData.productBar;
	                _this.distributedBar = resultData.distributedBar;
	                _this.povertyAlleviaList = resultData.povertyAlleviaList;
	                console.log(_this.povertyAlleviaList);
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerHelper = setTimeout(() => {
	              //   console.log("timerHelper")
	              //   this.next()
	              // }, 15000);
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerHelper);
	    this.timerHelper = null;
	  },
	
	  methods: {
	    clickChild: function clickChild(bool) {
	      this.child = bool;
	    },
	    backToDashboard: function backToDashboard() {
	      this.child = false;
	    },
	    next: function next() {
	      this.$router.push('/rundadashboard');
	    },
	    prev: function prev() {
	      this.$router.push('/rundasalesDataCenter');
	    }
	  },
	  components: {
	    'v-header': _headers2.default,
	    'v-table': _table2.default,
	    'v-bars': _bars2.default,
	    'v-twoWayBar': _twoWayBar2.default,
	    'v-pie': _pie2.default,
	    'v-pie1': _pie4.default,
	    'v-pie2': _pie6.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '收支公开',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        "tooltip": {
	          "trigger": "axis",
	          "axisPointer": {
	            "type": "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        "legend": {
	          x: '40%',
	          top: '2%',
	          textStyle: {
	            color: '#FFF'
	          },
	          itemHeight: 4,
	          itemWidth: 14,
	          "data": ['收入', '支出']
	        },
	        "xAxis": [{
	          "type": "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "splitLine": {
	            "show": false
	          },
	          "axisTick": {
	            "show": false
	          },
	          "splitArea": {
	            "show": false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	          },
	          "data": [2012, 2013, 2014, 2015, 2016, 2017]
	        }],
	        "yAxis": [(0, _defineProperty3.default)({
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, -20]
	          },
	          "type": "value",
	          "splitLine": {
	            "show": false
	          },
	          "axisLine": {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "axisTick": {
	            "show": false
	          },
	          "axisLabel": {
	            "interval": 0
	
	          },
	          "splitArea": {
	            "show": false
	          }
	        }, 'axisLabel', {
	          interval: 0,
	          color: "#fff",
	          fontSize: 12
	        })],
	        "series": [{
	          "name": "收入",
	          "type": "bar",
	          "stack": "总量",
	          "barMaxWidth": 20,
	          "barGap": "10%",
	          "itemStyle": {
	            "normal": {
	              "color": "#76CD2E",
	              "label": {
	                "show": false,
	                "textStyle": {
	                  "color": "#fff"
	                },
	                "position": "insideTop"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [80, 60, 50, 60, 100, 110]
	        }, {
	          "name": "支出",
	          "type": "bar",
	          "stack": "总量",
	          "itemStyle": {
	            "normal": {
	              "color": "#486FF1",
	              "barBorderRadius": 0,
	              "label": {
	                "show": false,
	                "position": "top"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [10, 10, 20, 30, 40, 40]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index >= 6) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [80, 50, 60, 100, 150, 120];
	    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(25);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      swiperData: ['总屏', '销售数据', '基地数据', '溯源数据', '精准扶贫'],
	      swiperOption: {
	        slidesPerView: 6,
	        speed: 300,
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        }
	      }
	    };
	  },
	
	  components: {
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    // current swiper instance
	    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
	    console.log('this is current swiper instance object', this.swiper);
	    // this.swiper.slideTo(3, 1000, false)
	  },
	
	  computed: {
	    swiper: function swiper() {
	      return this.$refs.mySwiper.swiper;
	    }
	  },
	  // ['总屏', '销售数据', '基地数据', '溯源数据', '产品展示'],
	  methods: {
	    clickPage: function clickPage(index) {
	      if (index === 0) {
	        // 总屏
	        this.$router.push('/rundadashboard');
	      } else if (index === 1) {
	        // 销售数据
	        this.$router.push('/rundasalesDataCenter');
	      } else if (index === 2) {
	        // 基地数据
	        this.$router.push('/rundaindustryInformation');
	      } else if (index === 3) {
	        // 环境监测
	        this.$router.push('/rundatrace');
	      } else if (index === 4) {
	        // 溯源数据
	        this.$router.push('/rundahelper');
	      }
	    }
	  }
	};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _centerBottom = __webpack_require__(1865);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	var _index = __webpack_require__(1875);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1876);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["productionScale", "outputValue"],
	  data: function data() {
	    return {
	      areaName: '',
	      list: [true, false, false],
	      timer: null,
	      massifList: [],
	      massifListR: [],
	      tip: true,
	      datalist: [],
	      typeindex: 0,
	      url: _config2.default.fileDomain
	    };
	  },
	
	  components: {
	    centerBottom: _centerBottom2.default,
	    // countTo,
	    'v-table1': _index2.default,
	    'v-table2': _index4.default
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.time = setInterval(function () {
	                _this.typeindex = _this.typeindex + 1;
	                // if (this.typeindex > this.) {
	                //   this.typeindex = 0
	                // }
	                _this.list.push(_this.list.shift());
	                // this.changeType(this.list[this.typeindex], this.typeindex)
	                // this.$nextTick()
	                console.log(_this.list);
	              }, 3000);
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '环境质量管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      dataY: [],
	      dataX: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: '10%',
	            left: '20%',
	            right: '10%',
	            bottom: '20%',
	            containLabel: true
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          splitNumber: 4,
	          name: '百万',
	          min: 0,
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	
	            formatter: function formatter(value, index) {
	              return value / 1000000;
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#eb64fb'
	              }, {
	                offset: 1,
	                color: '#3fbbff0d'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i, self;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results.dataList;
	                // console.log(resultData)
	
	                for (i = 0; i < resultData.length; i++) {
	                  _this.dataY.push(resultData[i].harvestQuantity);
	                  _this.dataX.push(resultData[i].month);
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	              self = _this;
	
	              self.chart();
	              self.init();
	              _this.timer = setInterval(function () {
	                // 某些定时器操作
	                self.getData();
	              }, 3000);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '垃圾分类积分排行',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // const data = ['鹿邑县张万里农资门市部', '鹿邑县钻草农资经营门市部', '鹿邑县绍游农资商店', '鹿邑县星灿农业农村服务']
	              //   .map(x => ({
	              //     id: x,
	              //     productionForecast: Math.round(Math.random() * 10000 + 200)
	              //   }))
	              _this.tableData = [{ id: '鹿邑县张万里农资门市部', productionForecast: 10000 }, { id: '鹿邑县钻草农资经营门市部', productionForecast: 8888 }, { id: '鹿邑县绍游农资商店', productionForecast: 7777 }, { id: '鹿邑县星灿农业农村服务', productionForecast: 6666 }, { id: '鹿邑县张永明农资批零部', productionForecast: 5555 }];
	              _this.sum = 10000;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '项目公开',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 22 }, { id: '绿化改造工程', productionForecast: 25 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 50;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '产业情况',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    countTo: _vueCountTo2.default
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }];
	  }
	};
	// import '/../../../../static/css/swiper.css'

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#407FFF', '#F45E23', '#E6AF08', '#49C8CF'],
	      myChart: {},
	      name: '补贴发放',
	      dataX: [],
	      timer: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    // console.log(this.chartData)
	    this.dataX = ['危房改造', '大病救助', '留守儿童', '低保五保'];
	    this.chartData = [{ name: '危房改造', value: 30 }, { name: '大病救助', value: 20 }, { name: '留守儿童', value: 30 }, { name: '低保五保', value: 20 }];
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie1 .main'));
	    var op = {
	      title: {
	        text: '第三季度',
	        textStyle: {
	          color: '#33D8FB',
	          fontSize: 20
	        },
	        top: '%',
	        right: '5%'
	      },
	      legend: [{
	        orient: 'vertical',
	        right: '20',
	        bottom: '20',
	        itemHeight: 16,
	        itemWidth: 16,
	        data: this.dataX,
	        textStyle: {
	          color: "#FFF",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '75%'],
	        center: ['35%', '50%'],
	        data: data,
	        label: {
	          position: 'outside',
	          normal: {
	            // formatter: '{b|{b}}\n{hr|}\n{c|{c}%}',
	            // rich: {
	            //   b: {
	            //     fontSize: 16,
	            //     color: '#FFF',
	            //     align: 'left',
	            //     padding: 4
	            //   },
	            //   hr: {
	            //     borderColor: '#CCCCCC',
	            //     width: '100%',
	            //     borderWidth: 2,
	            //     height: 0
	            //   },
	            //   c: {
	            //     fontSize: 16,
	            //     align: 'center',
	            //     padding: 4,
	            //     color: '#00EDED'
	            //   }
	            // }
	          }
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '种植批次数据',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                // console.log(resultData)
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '区域在售登记种类',
	      dataY: [],
	      dataX: [],
	      type: {
	        '农药': 779,
	        '种子': 50,
	        '肥料': 200,
	        '兽药': 596,
	        '饲料': 354
	      },
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.setOption({
	        animation: true,
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        xAxis: {
	          name: '类型',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	            // top: 20,
	            // padding: [25, 0, 0, -10]
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	            // rotate: 30
	          }
	        },
	        yAxis: {
	          name: '交易量（笔）',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, 10]
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              if (value > 10000) {
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(232,159,31,1)"
	              }, {
	                offset: 0.8,
	                color: "rgba(241,100,30,1)"
	              }], false)
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [1000, 600, 100, Math.round(Math.random() * 100 + 100)];
	    this.dataX = ['进货台账', '销售台账', '高剧毒农药', '废弃物回收'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	
	    var that = this;
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      index++;
	      // console.log(index)
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '2018-08-03', orderNumber: '安吉盈元家庭农场', name1: '甲拌磷', id: 'PD85109-13', number: '10' }, { name: '2019-07-31', orderNumber: '安吉润发家庭农场有限公司', name1: '辛硫·甲拌磷', id: 'PD20100085', number: '10' }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '2018-08-03', orderNumber: '安吉盈元家庭农场', name1: '甲拌磷', id: 'PD85109-13', number: '实名登记' }, { name: '2019-07-31', orderNumber: '安吉润发家庭农场有限公司', name1: '辛硫·甲拌磷', id: 'PD20100085', number: '未登记' }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      time: null,
	      typeindex: 0,
	      list: ['农药', '种子', '肥料', '兽药', '饲料'],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"],
	      data: {
	        '农药': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好1' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好1' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好1' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好1' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' }],
	        '种子': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好2' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好2' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好2' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好2' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' }],
	        '肥料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好3' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好3' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好3' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好3' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' }],
	        '兽药': [],
	        '饲料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好4' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好4' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好4' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好4' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' }]
	      }
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    },
	    changeType: function changeType(item, index) {
	      var _this = this;
	
	      console.log(index);
	
	      this.typeindex = index;
	      this.tableData = this.data[item];
	      if (this.data[item].length === 0) {
	        setTimeout(function () {
	          _this.changeType(_this.list[index + 1], index + 1);
	        }, 1000);
	        return;
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.changeType(this.list[this.typeindex], this.typeindex);
	    this.time = setInterval(function () {
	      _this2.typeindex = _this2.typeindex + 1;
	      if (_this2.typeindex > 4) {
	        _this2.typeindex = 0;
	      }
	      _this2.changeType(_this2.list[_this2.typeindex], _this2.typeindex);
	      _this2.$nextTick();
	      console.log(_this2.typeindex);
	    }, 3000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.time);
	    this.time = null;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(50);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可视化管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _ljcheader = __webpack_require__(584);
	
	var _ljcheader2 = _interopRequireDefault(_ljcheader);
	
	var _planting = __webpack_require__(1873);
	
	var _planting2 = _interopRequireDefault(_planting);
	
	var _generatingData = __webpack_require__(1868);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _salesData = __webpack_require__(1874);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table = __webpack_require__(1877);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _pie = __webpack_require__(1872);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _bar = __webpack_require__(1864);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _center = __webpack_require__(1866);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _harvestingPlan = __webpack_require__(1870);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _ev = __webpack_require__(1867);
	
	var _ev2 = _interopRequireDefault(_ev);
	
	var _video = __webpack_require__(1878);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _group = __webpack_require__(1869);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _list = __webpack_require__(1871);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      name: '营销数据驾驶舱',
	      outputValue: '',
	      productionScale: '',
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      timerDashboard: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // new Swiper('.swiper-container', {
	              //   direction: 'horizontal', // 水平切换选项
	              //   loop: true, // 循环模式选项
	              //   autoplay: 3000,
	              //   navigation: {
	              //     nextl: '.swiper-button-next',
	              //     prevEl: '.swiper-button-prev'
	              //   }
	              // })
	              _this.show = true;
	              _context.next = 3;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Agriculture);
	
	            case 3:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = JSON.parse(res.results);
	                // console.log(resultData)
	
	                _this.outputValue = resultData.outputValue;
	                _this.productionScale = resultData.productionScale;
	                _this.salesData = resultData.salesData;
	                _this.salesDataBar = resultData.salesDataBar;
	                _this.salesDataRealTime = resultData.salesDataRealTime;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              // this.timerDashboard = setTimeout(() => {
	              //   console.log("timerDashboard")
	              //   this.next()
	              // }, 30000);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerDashboard);
	    this.timerDashboard = null;
	  },
	
	  methods: {
	    next: function next() {
	      this.$router.push('/rundaindustryInformation');
	    },
	    prev: function prev() {
	      this.$router.push('/rundahelper');
	    }
	  },
	  components: {
	    'v-header': _ljcheader2.default,
	    'v-salesData': _salesData2.default,
	    'v-table': _table2.default,
	    'v-harvestingPlan': _harvestingPlan2.default,
	    'v-generatingData': _generatingData2.default,
	    'v-center': _center2.default,
	    'v-pie': _pie2.default,
	    'v-bar': _bar2.default,
	    'v-list': _list2.default,
	    'v-ev': _ev2.default,
	    'v-video': _video2.default,
	    'v-planting': _planting2.default,
	    'v-group': _group2.default
	  }
	};

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(206);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _boxWrap = __webpack_require__(14);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var geoCoordMap = {
	  "海门": [121.15, 31.89],
	  "鄂尔多斯": [109.781327, 39.608266],
	  "招远": [120.38, 37.35],
	  "舟山": [122.207216, 29.985295],
	  "齐齐哈尔": [123.97, 47.33],
	  "盐城": [120.13, 33.38],
	  "赤峰": [118.87, 42.28],
	  "青岛": [120.33, 36.07],
	  "乳山": [121.52, 36.89],
	  "金昌": [102.188043, 38.520089],
	  "泉州": [118.58, 24.93],
	  "莱西": [120.53, 36.86],
	  "日照": [119.46, 35.42],
	  "胶南": [119.97, 35.88],
	  "南通": [121.05, 32.08],
	  "拉萨": [91.11, 29.97],
	  "云浮": [112.02, 22.93],
	  "梅州": [116.1, 24.55],
	  "文登": [122.05, 37.2],
	  "上海": [121.48, 31.22],
	  "攀枝花": [101.718637, 26.582347],
	  "威海": [122.1, 37.5],
	  "承德": [117.93, 40.97],
	  "厦门": [118.1, 24.46],
	  "汕尾": [115.375279, 22.786211],
	  "潮州": [116.63, 23.68],
	  "丹东": [124.37, 40.13],
	  "太仓": [121.1, 31.45],
	  "曲靖": [103.79, 25.51],
	  "烟台": [121.39, 37.52],
	  "福州": [119.3, 26.08],
	  "瓦房店": [121.979603, 39.627114],
	  "即墨": [120.45, 36.38],
	  "抚顺": [123.97, 41.97],
	  "玉溪": [102.52, 24.35],
	  "张家口": [114.87, 40.82],
	  "阳泉": [113.57, 37.85],
	  "莱州": [119.942327, 37.177017],
	  "湖州": [120.1, 30.86],
	  "汕头": [116.69, 23.39],
	  "昆山": [120.95, 31.39],
	  "宁波": [121.56, 29.86],
	  "湛江": [110.359377, 21.270708],
	  "揭阳": [116.35, 23.55],
	  "荣成": [122.41, 37.16],
	  "连云港": [119.16, 34.59],
	  "葫芦岛": [120.836932, 40.711052],
	  "常熟": [120.74, 31.64],
	  "东莞": [113.75, 23.04],
	  "河源": [114.68, 23.73],
	  "淮安": [119.15, 33.5],
	  "泰州": [119.9, 32.49],
	  "南宁": [108.33, 22.84],
	  "营口": [122.18, 40.65],
	  "惠州": [114.4, 23.09],
	  "江阴": [120.26, 31.91],
	  "蓬莱": [120.75, 37.8],
	  "韶关": [113.62, 24.84],
	  "嘉峪关": [98.289152, 39.77313],
	  "广州": [113.23, 23.16],
	  "延安": [109.47, 36.6],
	  "太原": [112.53, 37.87],
	  "清远": [113.01, 23.7],
	  "中山": [113.38, 22.52],
	  "昆明": [102.73, 25.04],
	  "寿光": [118.73, 36.86],
	  "盘锦": [122.070714, 41.119997],
	  "长治": [113.08, 36.18],
	  "深圳": [114.07, 22.62],
	  "珠海": [113.52, 22.3],
	  "宿迁": [118.3, 33.96],
	  "咸阳": [108.72, 34.36],
	  "铜川": [109.11, 35.09],
	  "平度": [119.97, 36.77],
	  "佛山": [113.11, 23.05],
	  "海口": [110.35, 20.02],
	  "江门": [113.06, 22.61],
	  "章丘": [117.53, 36.72],
	  "肇庆": [112.44, 23.05],
	  "大连": [121.62, 38.92],
	  "临汾": [111.5, 36.08],
	  "吴江": [120.63, 31.16],
	  "石嘴山": [106.39, 39.04],
	  "沈阳": [123.38, 41.8],
	  "苏州": [120.62, 31.32],
	  "茂名": [110.88, 21.68],
	  "嘉兴": [120.76, 30.77],
	  "长春": [125.35, 43.88],
	  "胶州": [120.03336, 36.264622],
	  "银川": [106.27, 38.47],
	  "张家港": [120.555821, 31.875428],
	  "三门峡": [111.19, 34.76],
	  "锦州": [121.15, 41.13],
	  "南昌": [115.89, 28.68],
	  "柳州": [109.4, 24.33],
	  "陵水": [110.0439879098, 18.5123869278],
	  "自贡": [104.778442, 29.33903],
	  "吉林": [126.57, 43.87],
	  "阳江": [111.95, 21.85],
	  "泸州": [105.39, 28.91],
	  "西宁": [101.74, 36.56],
	  "宜宾": [104.56, 29.77],
	  "呼和浩特": [111.65, 40.82],
	  "成都": [104.06, 30.67],
	  "大同": [113.3, 40.12],
	  "镇江": [119.44, 32.2],
	  "桂林": [110.28, 25.29],
	  "张家界": [110.479191, 29.117096],
	  "宜兴": [119.82, 31.36],
	  "北海": [109.12, 21.49],
	  "西安": [108.95, 34.27],
	  "金坛": [119.56, 31.74],
	  "东营": [118.49, 37.46],
	  "牡丹江": [129.58, 44.6],
	  "遵义": [106.9, 27.7],
	  "绍兴": [120.58, 30.01],
	  "扬州": [119.42, 32.39],
	  "常州": [119.95, 31.79],
	  "潍坊": [119.1, 36.62],
	  "重庆": [106.54, 29.59],
	  "台州": [121.420757, 28.656386],
	  "南京": [118.78, 32.04],
	  "滨州": [118.03, 37.36],
	  "贵阳": [106.71, 26.57],
	  "无锡": [120.29, 31.59],
	  "本溪": [123.73, 41.3],
	  "克拉玛依": [84.77, 45.59],
	  "渭南": [109.5, 34.52],
	  "马鞍山": [118.48, 31.56],
	  "宝鸡": [107.15, 34.38],
	  "焦作": [113.21, 35.24],
	  "句容": [119.16, 31.95],
	  "北京": [116.46, 39.92],
	  "徐州": [117.2, 34.26],
	  "衡水": [115.72, 37.72],
	  "包头": [110, 40.58],
	  "绵阳": [104.73, 31.48],
	  "乌鲁木齐": [87.68, 43.77],
	  "枣庄": [117.57, 34.86],
	  "杭州": [120.19, 30.26],
	  "淄博": [118.05, 36.78],
	  "鞍山": [122.85, 41.12],
	  "溧阳": [119.48, 31.43],
	  "库尔勒": [86.06, 41.68],
	  "安阳": [114.35, 36.1],
	  "开封": [114.35, 34.79],
	  "济南": [117, 36.65],
	  "德阳": [104.37, 31.13],
	  "温州": [120.65, 28.01],
	  "九江": [115.97, 29.71],
	  "邯郸": [114.47, 36.6],
	  "临安": [119.72, 30.23],
	  "兰州": [103.73, 36.03],
	  "沧州": [116.83, 38.33],
	  "临沂": [118.35, 35.05],
	  "南充": [106.110698, 30.837793],
	  "天津": [117.2, 39.13],
	  "富阳": [119.95, 30.07],
	  "泰安": [117.13, 36.18],
	  "诸暨": [120.23, 29.71],
	  "郑州": [113.65, 34.76],
	  "哈尔滨": [126.63, 45.75],
	  "聊城": [115.97, 36.45],
	  "芜湖": [118.38, 31.33],
	  "唐山": [118.02, 39.63],
	  "平顶山": [113.29, 33.75],
	  "邢台": [114.48, 37.05],
	  "德州": [116.29, 37.45],
	  "济宁": [116.59, 35.38],
	  "荆州": [112.239741, 30.335165],
	  "宜昌": [111.3, 30.7],
	  "义乌": [120.06, 29.32],
	  "丽水": [119.92, 28.45],
	  "洛阳": [112.44, 34.7],
	  "秦皇岛": [119.57, 39.95],
	  "株洲": [113.16, 27.83],
	  "石家庄": [114.48, 38.03],
	  "莱芜": [117.67, 36.19],
	  "常德": [111.69, 29.05],
	  "保定": [115.48, 38.85],
	  "湘潭": [112.91, 27.87],
	  "金华": [119.64, 29.12],
	  "岳阳": [113.09, 29.37],
	  "长沙": [113, 28.21],
	  "衢州": [118.88, 28.97],
	  "廊坊": [116.7, 39.53],
	  "菏泽": [115.480656, 35.23375],
	  "合肥": [117.27, 31.86],
	  "武汉": [114.31, 30.52],
	  "大庆": [125.03, 46.58],
	  "林芝地": [94.25, 29.59],
	  "果洛藏族自治": [97.42, 34.81],
	  "闵行": [121.23, 31.07],
	  "普洱": [100.9662264708, 22.8252001070],
	  "那曲地": [92.1, 31.47]
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var XNData = [[{ name: '陵水' }, { name: '广州', value: 35252 }], [{ name: '陵水' }, { name: '北京', value: 32674 }], [{ name: '陵水' }, { name: '上海', value: 32234 }], [{ name: '陵水' }, { name: '杭州', value: 24834 }], [{ name: '陵水' }, { name: '苏州', value: 20134 }], [{ name: '陵水' }, { name: '西安', value: 14365 }], [{ name: '陵水' }, { name: '厦门', value: 11543 }], [{ name: '陵水' }, { name: '长沙', value: 10789 }], [{ name: '陵水' }, { name: '南昌', value: 10103 }]];
	
	var planePath = 'arrow';
	
	var convertData = function convertData(data) {
	  var res = [];
	  for (var i = 0; i < data.length; i++) {
	    var dataItem = data[i];
	
	    var fromCoord = geoCoordMap[dataItem[0].name];
	    var toCoord = geoCoordMap[dataItem[1].name];
	    if (fromCoord && toCoord) {
	      res.push({
	        fromName: dataItem[0].name,
	        toName: dataItem[1].name,
	        coords: [fromCoord, toCoord],
	        value: dataItem[1].value
	      });
	    }
	  }
	  return res;
	};
	
	var color = ['#a6c84c', '#ffa022', '#46bee9']; // 航线的颜色
	var series = [];
	[['陵水', XNData]].forEach(function (item, i) {
	  series.push({
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 1,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0.7,
	      color: 'red', // arrow箭头的颜色
	      symbolSize: 3
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 0,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'lines',
	    zlevel: 3,
	    symbol: ['none', 'arrow'],
	    symbolSize: 10,
	    effect: {
	      show: true,
	      period: 6,
	      trailLength: 0,
	      symbol: planePath,
	      symbolSize: 15
	    },
	    lineStyle: {
	      normal: {
	        color: color[i],
	        width: 1,
	        opacity: 0.6,
	        curveness: 0.2
	      }
	    },
	    data: convertData(item[1])
	  }, {
	    name: item[0] + ' Top3',
	    type: 'effectScatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      brushType: 'stroke'
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        formatter: '{b}'
	      }
	    },
	    symbolSize: function symbolSize(val) {
	      return 1 + val[2] / 4000;
	    },
	    itemStyle: {
	      normal: {
	        color: color[i]
	      },
	      emphasis: {
	        areaColor: '#2B91B7'
	      }
	    },
	    data: item[1].map(function (dataItem) {
	      return {
	        name: dataItem[1].name,
	        value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
	      };
	    })
	  },
	  // 被攻击点
	  {
	    type: 'scatter',
	    coordinateSystem: 'geo',
	    zlevel: 2,
	    rippleEffect: {
	      period: 4,
	      brushType: 'stroke',
	      scale: 4
	    },
	    label: {
	      normal: {
	        show: true,
	        position: 'right',
	        color: '#0f0',
	        formatter: '{b}',
	        textStyle: {
	          color: "#0f0"
	        }
	      },
	      emphasis: {
	        show: true,
	        color: "#f60"
	      }
	    },
	    symbol: 'path://M512 39.384615l169.353846 295.384615 342.646154 63.015385-240.246154 248.123077L827.076923 984.615385l-315.076923-145.723077L196.923077 984.615385l43.323077-334.769231L0 401.723077l342.646154-63.015385L512 39.384615',
	    symbolSize: 20,
	    data: [{
	      name: item[0],
	      value: geoCoordMap[item[0]].concat([10])
	    }]
	  });
	});
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '农产品流通数据'
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    resizeFunc: function resizeFunc() {
	      this.myChart.resize();
	    },
	    init: function init() {
	      var resizeFunc = this.resizeFunc;
	      window.addEventListener('resize', resizeFunc);
	    }
	  },
	  mounted: function mounted() {
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.flow .main'));
	    this.myChart.setOption({
	      tooltip: {
	        show: false
	      },
	      legend: {
	        orient: 'vertical',
	        left: 'left',
	        data: ['广州', '深圳', '上海'],
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      geo: {
	        map: 'china',
	        roam: true,
	        itemStyle: {
	          normal: {
	            areaColor: '#3A64C8',
	            borderColor: '#195BB9',
	            borderWidth: 1
	          },
	          emphasis: {
	            areaColor: '#2B91B7'
	          }
	        }
	      },
	      series: series
	    });
	    this.init();
	  },
	  destroyed: function destroyed() {
	    var resizeFunc = this.resizeFunc;
	    window.removeEventListener('resize', resizeFunc);
	  }
	};

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAmap = __webpack_require__(583);
	
	var _vueAmap2 = _interopRequireDefault(_vueAmap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _china = __webpack_require__(206);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _flow = __webpack_require__(1880);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _map = __webpack_require__(853);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	_vue2.default.use(_vueAmap2.default);
	_vueAmap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool'],
	  uiVersion: '1.0.11'
	});
	// var geoCoordMap = {
	//   // '上海市': [121.473701, 31.230416],
	//   // '北京市': [116.407526, 39.90403],
	//   // '南京市': [118.796877, 32.060255],
	//   // '常州市': [119.973987, 31.810689],
	//   // '广州市': [113.264434, 23.129162],
	//   '杭州市': [120.15507, 30.274084],
	//   '浙江省杭州市': [120.15507, 30.274084],
	//   // '西安市': [108.940174, 34.341568],
	//   // '长沙市': [112.938814, 28.228209],
	//   "陵水": [110.0439879098, 18.5123869278]
	// }
	
	var geoCoordMap = {
	  "陵水": [110.0439879098, 18.5123869278],
	  '七台河市': ["131.003138", "45.771726"],
	  '三亚市': ["109.511909", "18.252847"],
	  '三明市': ["117.638678", "26.263406"],
	  '三沙市': ["112.338695", "16.831839"],
	  '三门峡市': ["111.200135", "34.772493"],
	  '上海市': ["121.473701", "31.230416"],
	  '上饶市': ["117.943433", "28.454863"],
	  '东莞市': ["113.751765", "23.020536"],
	  '东营市': ["118.674767", "37.434751"],
	  '中卫市': ["105.196902", "37.499972"],
	  '中山市': ["113.392782", "22.517645"],
	  '临夏回族自治州': ["103.210538", "35.601182"],
	  '临汾市': ["111.518976", "36.088005"],
	  '临沂市': ["118.356448", "35.104672"],
	  '临沧市': ["100.079583", "23.877573"],
	  '丹东市': ["124.354706", "40.000499"],
	  '丽水市': ["119.922796", "28.467630"],
	  '丽江市': ["100.227750", "26.855047"],
	  '乌兰察布市': ["113.132585", "40.994785"],
	  '乌海市': ["106.794249", "39.655388"],
	  '乌鲁木齐市': ["87.616848", "43.825592"],
	  '乐山市': ["103.765568", "29.552106"],
	  '九江市': ["116.001930", "29.705077"],
	  '云南省': ["102.710002", "25.045806"],
	  '云浮市': ["112.044491", "22.915094"],
	  '亳州市': ["115.778676", "33.844582"],
	  '伊春市': ["128.841147", "47.727536"],
	  '伊犁哈萨克自治州': ["81.324136", "43.916823"],
	  '佛山市': ["113.121416", "23.021548"],
	  '佳木斯市': ["130.318917", "46.799922"],
	  '保定市': ["115.464806", "38.873891"],
	  '保山市': ["99.161761", "25.112046"],
	  '信阳市': ["114.091023", "32.146983"],
	  '儋州市': ["109.580811", "19.521134"],
	  '克孜勒苏柯尔克孜自治州': ["76.167819", "39.714526"],
	  '克拉玛依市': ["84.889207", "45.579888"],
	  '六安市': ["116.521854", "31.733699"],
	  '六盘水市': ["104.830359", "26.592666"],
	  '兰州市': ["103.834303", "36.061089"],
	  '兴安盟': ["122.067042", "46.077561"],
	  '内江市': ["105.058433", "29.580228"],
	  '内蒙古自治区': ["111.765617", "40.817498"],
	  '凉山彝族自治州': ["102.267335", "27.881610"],
	  '包头市': ["109.840347", "40.657449"],
	  '北京市': ["116.407526", "39.904030"],
	  '北海市': ["109.119927", "21.481254"],
	  '十堰市': ["110.797990", "32.629397"],
	  '南京市': ["118.796877", "32.060255"],
	  '南充市': ["106.110698", "30.837793"],
	  '南宁市': ["108.366543", "22.817002"],
	  '南平市': ["118.177708", "26.641768"],
	  '南昌市': ["115.858197", "28.682892"],
	  '南通市': ["120.894291", "31.980171"],
	  '南阳市': ["112.528321", "32.990833"],
	  '博尔塔拉蒙古自治州': ["82.066159", "44.905588"],
	  '厦门市': ["118.089425", "24.479833"],
	  '双鸭山市': ["131.159133", "46.646508"],
	  '台州市': ["121.420757", "28.656386"],
	  '台湾省': ["121.508903", "25.044319"],
	  '合肥市': ["117.227239", "31.820586"],
	  '吉安市': ["114.992509", "27.113443"],
	  '吉林市': ["126.549576", "43.837883"],
	  '吉林省': ["125.325990", "43.896536"],
	  '吐鲁番市': ["89.189651", "42.951382"],
	  '吕梁市': ["111.144319", "37.518314"],
	  '吴忠市': ["106.198393", "37.997460"],
	  '周口市': ["114.696951", "33.626149"],
	  '呼伦贝尔市': ["119.765744", "49.211574"],
	  '呼和浩特市': ["111.749180", "40.842585"],
	  '和田地区': ["79.922211", "37.114157"],
	  '咸宁市': ["114.322492", "29.841443"],
	  '咸阳市': ["108.708991", "34.329605"],
	  '哈密市': ["93.514916", "42.818501"],
	  '哈尔滨市': ["126.534967", "45.803775"],
	  '唐山市': ["118.180193", "39.630867"],
	  '商丘市': ["115.656370", "34.414172"],
	  '商洛市': ["109.940477", "33.870422"],
	  '喀什地区': ["75.989755", "39.470400"],
	  '嘉兴市': ["120.755486", "30.746129"],
	  '嘉峪关市': ["98.289152", "39.773130"],
	  '四川省': ["104.075931", "30.651651"],
	  '四平市': ["124.350398", "43.166419"],
	  '固原市': ["106.242610", "36.015855"],
	  '塔城地区': ["82.980316", "46.745364"],
	  '大兴安岭地区': ["124.711080", "52.335206"],
	  '大同市': ["113.300129", "40.076762"],
	  '大庆市': ["125.103784", "46.589309"],
	  '大理白族自治州': ["100.267638", "25.606486"],
	  '大连市': ["121.614682", "38.914003"],
	  '天水市': ["105.724947", "34.580863"],
	  '天津市': ["117.200983", "39.084158"],
	  '太原市': ["112.548879", "37.870590"],
	  '威海市': ["122.120419", "37.513068"],
	  '娄底市': ["111.993497", "27.700062"],
	  '孝感市': ["113.916902", "30.924568"],
	  '宁夏回族自治区': ["106.258754", "38.471317"],
	  '宁德市': ["119.547932", "26.665617"],
	  '宁波市': ["121.550357", "29.874556"],
	  '安庆市': ["117.063754", "30.543494"],
	  '安康市': ["109.029022", "32.684714"],
	  '安徽省': ["117.284922", "31.861184"],
	  '安阳市': ["114.392392", "36.097577"],
	  '安顺市': ["105.947593", "26.253072"],
	  '定西市': ["104.626282", "35.580662"],
	  '宜宾市': ["104.643215", "28.751768"],
	  '宜昌市': ["111.286471", "30.691967"],
	  '宜春市': ["114.416778", "27.815619"],
	  '宝鸡市': ["107.237974", "34.361979"],
	  '宣城市': ["118.758816", "30.940718"],
	  '宿州市': ["116.964356", "33.646373"],
	  '宿迁市': ["118.275198", "33.963232"],
	  '山东省': ["117.020359", "36.668530"],
	  '山南市': ["91.773134", "29.237137"],
	  '山西省': ["112.562398", "37.873531"],
	  '岳阳市': ["113.128958", "29.357104"],
	  '崇左市': ["107.364711", "22.376532"],
	  '巴中市': ["106.747477", "31.867903"],
	  '巴彦淖尔市': ["107.387657", "40.743213"],
	  '巴音郭楞蒙古自治州': ["86.145298", "41.764115"],
	  '常州市': ["119.973987", "31.810689"],
	  '常德市': ["111.698497", "29.031673"],
	  '平凉市': ["106.665240", "35.543051"],
	  '平顶山市': ["113.192661", "33.766169"],
	  '广东省': ["113.266530", "23.132191"],
	  '广元市': ["105.843357", "32.435435"],
	  '广安市': ["106.633212", "30.455961"],
	  '广州市': ["113.264434", "23.129162"],
	  '广西壮族自治区': ["108.327546", "22.815478"],
	  '庆阳市': ["107.643631", "35.709077"],
	  '廊坊市': ["116.683752", "39.538047"],
	  '延安市': ["109.489727", "36.585455"],
	  '延边朝鲜族自治州': ["129.508946", "42.891253"],
	  '开封市': ["114.307581", "34.797239"],
	  '张家口市': ["114.887543", "40.824418"],
	  '张家界市': ["110.479191", "29.117096"],
	  '张掖市': ["100.449818", "38.925875"],
	  '徐州市': ["117.284124", "34.205768"],
	  '德宏傣族景颇族自治州': ["98.584895", "24.433353"],
	  '德州市': ["116.357464", "37.434092"],
	  '德阳市': ["104.397894", "31.126855"],
	  '忻州市': ["112.734174", "38.416663"],
	  '怀化市': ["109.998488", "27.554978"],
	  '怒江傈僳族自治州': ["98.853097", "25.852547"],
	  '恩施土家族苗族自治州': ["109.488172", "30.272156"],
	  '惠州市': ["114.416196", "23.111847"],
	  '成都市': ["104.066541", "30.572269"],
	  '扬州市': ["119.412966", "32.394210"],
	  '承德市': ["117.962410", "40.954071"],
	  '抚州市': ["116.358181", "27.949217"],
	  '抚顺市': ["123.957208", "41.880872"],
	  '拉萨市': ["91.140856", "29.645554"],
	  '揭阳市': ["116.372831", "23.549993"],
	  '攀枝花市': ["101.718637", "26.582347"],
	  '文山壮族苗族自治州': ["104.216248", "23.400733"],
	  '新乡市': ["113.926800", "35.303004"],
	  '新余市': ["114.917346", "27.817808"],
	  '新疆维吾尔自治区': ["87.627704", "43.793026"],
	  '无锡市': ["120.311910", "31.491169"],
	  '日喀则市': ["88.880583", "29.266869"],
	  '日照市': ["119.526888", "35.416377"],
	  '昆明市': ["102.832891", "24.880095"],
	  '昌吉回族自治州': ["87.308224", "44.011182"],
	  '昌都市': ["97.172020", "31.140969"],
	  '昭通市': ["103.717465", "27.338257"],
	  '晋中市': ["112.752694", "37.687024"],
	  '晋城市': ["112.851831", "35.490701"],
	  '普洱市': ["100.966512", "22.825065"],
	  '景德镇市': ["117.178419", "29.268835"],
	  '曲靖市': ["103.796167", "25.489999"],
	  '朔州市': ["112.432825", "39.331595"],
	  '朝阳市': ["120.450372", "41.573734"],
	  '本溪市': ["123.766485", "41.294175"],
	  '来宾市': ["109.221465", "23.750306"],
	  '杭州市': ["120.155070", "30.274084"],
	  '松原市': ["124.825117", "45.141789"],
	  '林芝市': ["94.361558", "29.648943"],
	  '果洛藏族自治州': ["100.244808", "34.471431"],
	  '枣庄市': ["117.323725", "34.810487"],
	  '柳州市': ["109.415953", "24.325502"],
	  '株洲市': ["113.134002", "27.827550"],
	  '桂林市': ["110.290194", "25.273566"],
	  '梅州市': ["116.122238", "24.288615"],
	  '梧州市': ["111.279115", "23.476962"],
	  '楚雄彝族自治州': ["101.528068", "25.045532"],
	  '榆林市': ["109.734589", "38.285390"],
	  '武威市': ["102.638011", "37.928264"],
	  '武汉市': ["114.305392", "30.593098"],
	  '毕节市': ["105.283992", "27.302589"],
	  '永州市': ["111.613445", "26.420394"],
	  '汉中市': ["107.023323", "33.067480"],
	  '汕头市': ["116.681972", "23.354091"],
	  '汕尾市': ["115.375278", "22.786211"],
	  '江苏省': ["118.763232", "32.061707"],
	  '江西省': ["115.909228", "28.675696"],
	  '江门市': ["113.081901", "22.578738"],
	  '池州市': ["117.491568", "30.664800"],
	  '沈阳市': ["123.431474", "41.805698"],
	  '沧州市': ["116.838834", "38.304477"],
	  '河北省': ["114.468664", "38.037057"],
	  '河南省': ["113.753602", "34.765515"],
	  '河池市': ["108.085261", "24.692931"],
	  '河源市': ["114.700447", "23.743538"],
	  '泉州市': ["118.675675", "24.874132"],
	  '泰安市': ["117.087614", "36.200252"],
	  '泰州市': ["119.923116", "32.455778"],
	  '泸州市': ["105.442258", "28.871811"],
	  '洛阳市': ["112.454040", "34.619682"],
	  '济南市': ["117.119999", "36.651216"],
	  '济宁市': ["116.587098", "35.414921"],
	  '浙江省': ["120.152791", "30.267446"],
	  '海东市': ["102.104287", "36.502039"],
	  '海北藏族自治州': ["100.900997", "36.954413"],
	  '海南省': ["110.349228", "20.017377"],
	  '海南藏族自治州': ["100.620373", "36.286437"],
	  '海口市': ["110.198293", "20.044001"],
	  '海西蒙古族藏族自治州': ["97.369751", "37.377139"],
	  '淄博市': ["118.054927", "36.813487"],
	  '淮北市': ["116.798265", "33.955844"],
	  '淮南市': ["116.999932", "32.625478"],
	  '淮安市': ["119.015285", "33.610353"],
	  '深圳市': ["114.057868", "22.543099"],
	  '清远市': ["113.056031", "23.681763"],
	  '温州市': ["120.699366", "27.994267"],
	  '渭南市': ["109.509786", "34.499995"],
	  '湖北省': ["114.341861", "30.546498"],
	  '湖南省': ["112.983810", "28.112444"],
	  '湖州市': ["120.086823", "30.894348"],
	  '湘潭市': ["112.944049", "27.829738"],
	  '湘西土家族苗族自治州': ["109.739172", "28.311947"],
	  '湛江市': ["110.359377", "21.270707"],
	  '滁州市': ["118.317106", "32.301556"],
	  '滨州市': ["117.970703", "37.381990"],
	  '漯河市': ["114.016539", "33.581412"],
	  '漳州市': ["117.647481", "24.512948"],
	  '潍坊市': ["119.161755", "36.706774"],
	  '潮州市': ["116.622603", "23.656950"],
	  '澳门特别行政区': ["113.543028", "22.186835"],
	  '濮阳市': ["115.029215", "35.761829"],
	  '烟台市': ["121.447935", "37.463822"],
	  '焦作市': ["113.241823", "35.215892"],
	  '牡丹江市': ["129.633168", "44.551653"],
	  '玉林市': ["110.164756", "22.636379"],
	  '玉树藏族自治州': ["97.091934", "33.011674"],
	  '玉溪市': ["102.546543", "24.352036"],
	  '珠海市': ["113.576726", "22.270715"],
	  '甘南藏族自治州': ["102.911027", "34.983385"],
	  '甘孜藏族自治州': ["101.962310", "30.049520"],
	  '甘肃省': ["103.826308", "36.059421"],
	  '白城市': ["122.839024", "45.619641"],
	  '白山市': ["126.423587", "41.939994"],
	  '白银市': ["104.138559", "36.544756"],
	  '百色市': ["106.618201", "23.902333"],
	  '益阳市': ["112.355180", "28.553860"],
	  '盐城市': ["120.163561", "33.347382"],
	  '盘锦市': ["122.070714", "41.119997"],
	  '眉山市': ["103.848538", "30.075439"],
	  '石嘴山市': ["106.383303", "38.983236"],
	  '石家庄市': ["114.514859", "38.042306"],
	  '福州市': ["119.296494", "26.074507"],
	  '福建省': ["119.295144", "26.100779"],
	  '秦皇岛市': ["119.600492", "39.935385"],
	  '红河哈尼族彝族自治州': ["103.374799", "23.363130"],
	  '绍兴市': ["120.580232", "30.029752"],
	  '绥化市': ["126.968887", "46.653845"],
	  '绵阳市': ["104.679114", "31.467450"],
	  '聊城市': ["115.985371", "36.456703"],
	  '肇庆市': ["112.465091", "23.047191"],
	  '自贡市': ["104.778442", "29.339030"],
	  '舟山市': ["122.207215", "29.985295"],
	  '芜湖市': ["118.432941", "31.352859"],
	  '苏州市': ["120.585315", "31.298886"],
	  '茂名市': ["110.925456", "21.662999"],
	  '荆州市': ["112.239741", "30.335165"],
	  '荆门市': ["112.199265", "31.035423"],
	  '莆田市': ["119.007777", "25.454084"],
	  '莱芜市': ["117.676723", "36.213813"],
	  '菏泽市': ["115.480656", "35.233750"],
	  '萍乡市': ["113.854556", "27.622768"],
	  '营口市': ["122.235417", "40.667012"],
	  '葫芦岛市': ["120.836932", "40.711052"],
	  '蚌埠市': ["117.389719", "32.916287"],
	  '衡水市': ["115.670177", "37.738920"],
	  '衡阳市': ["112.571997", "26.893230"],
	  '衢州市': ["118.859457", "28.970079"],
	  '襄阳市': ["112.122414", "32.008986"],
	  '西双版纳傣族自治州': ["100.797777", "22.007351"],
	  '西宁市': ["101.778228", "36.617144"],
	  '西安市': ["108.940174", "34.341568"],
	  '西藏自治区': ["91.117212", "29.646922"],
	  '许昌市': ["113.852640", "34.035506"],
	  '贵州省': ["106.707410", "26.598194"],
	  '贵港市': ["109.598926", "23.111530"],
	  '贵阳市': ["106.630153", "26.647661"],
	  '贺州市': ["111.566694", "24.403582"],
	  '资阳市': ["104.627636", "30.128901"],
	  '赣州市': ["114.935029", "25.831829"],
	  '赤峰市': ["118.886856", "42.257817"],
	  '辽宁省': ["123.429440", "41.835441"],
	  '辽源市': ["125.143532", "42.887918"],
	  '辽阳市': ["123.236944", "41.267244"],
	  '达州市': ["107.468023", "31.209571"],
	  '运城市': ["111.007528", "35.026412"],
	  '连云港市': ["119.221611", "34.596653"],
	  '迪庆藏族自治州': ["99.702234", "27.818882"],
	  '通化市': ["125.939697", "41.728401"],
	  '通辽市': ["122.243444", "43.652890"],
	  '遂宁市': ["105.592898", "30.532847"],
	  '遵义市': ["106.927389", "27.725654"],
	  '邢台市': ["114.504844", "37.070589"],
	  '那曲地区': ["92.051239", "31.476202"],
	  '邯郸市': ["114.538961", "36.625657"],
	  '邵阳市': ["111.467791", "27.238892"],
	  '郑州市': ["113.625368", "34.746599"],
	  '郴州市': ["113.014717", "25.770509"],
	  '鄂尔多斯市': ["109.781327", "39.608266"],
	  '鄂州市': ["114.894843", "30.391940"],
	  '酒泉市': ["98.494483", "39.732410"],
	  '重庆市': ["106.551556", "29.563009"],
	  '金华市': ["119.647444", "29.079059"],
	  '金昌市': ["102.188043", "38.520089"],
	  '钦州市': ["108.654146", "21.979933"],
	  '铁岭市': ["123.726166", "42.223769"],
	  '铜仁市': ["109.189598", "27.731514"],
	  '铜川市': ["108.945233", "34.896756"],
	  '铜陵市': ["117.812079", "30.945429"],
	  '银川市': ["106.230909", "38.487193"],
	  '锡林郭勒盟': ["116.048222", "43.933454"],
	  '锦州市': ["121.127003", "41.095119"],
	  '镇江市': ["119.425836", "32.187849"],
	  '长春市': ["125.323544", "43.817071"],
	  '长沙市': ["112.938814", "28.228209"],
	  '长治市': ["113.116255", "36.195386"],
	  '阜新市': ["121.670323", "42.021619"],
	  '阜阳市': ["115.814204", "32.890124"],
	  '防城港市': ["108.353846", "21.686860"],
	  '阳江市': ["111.982232", "21.857958"],
	  '阳泉市': ["113.580519", "37.856971"],
	  '阿克苏地区': ["80.260605", "41.168779"],
	  '阿勒泰地区': ["88.141253", "47.844924"],
	  '阿坝藏族羌族自治州': ["102.224653", "31.899413"],
	  '阿拉善盟': ["105.728969", "38.851892"],
	  '阿里地区': ["80.105804", "32.501111"],
	  '陇南市': ["104.921841", "33.400684"],
	  '陕西省': ["108.954239", "34.265472"],
	  '随州市': ["113.382458", "31.690215"],
	  '雅安市': ["103.013261", "29.980537"],
	  '青岛市': ["120.382639", "36.067082"],
	  '青海省': ["101.780199", "36.620901"],
	  '鞍山市': ["122.994329", "41.108647"],
	  '韶关市': ["113.597522", "24.810403"],
	  '香港特别行政区': ["114.163825", "22.276284"],
	  '马鞍山市': ["118.506759", "31.670452"],
	  '驻马店市': ["114.022298", "33.011529"],
	  '鸡西市': ["130.969333", "45.295075"],
	  '鹤壁市': ["114.297272", "35.747225"],
	  '鹤岗市': ["130.297964", "47.349916"],
	  '鹰潭市': ["117.069202", "28.260189"],
	  '黄冈市': ["114.872316", "30.453905"],
	  '黄南藏族自治州': ["102.015248", "35.519548"],
	  '黄山市': ["118.337481", "29.714655"],
	  '黄石市': ["115.038520", "30.199652"],
	  '黑河市': ["127.528560", "50.245329"],
	  '黑龙江省': ["126.661669", "45.742347"],
	  '黔东南苗族侗族自治州': ["107.982859", "26.583442"],
	  '黔南布依族苗族自治州': ["107.522097", "26.254092"],
	  '黔西南布依族苗族自治州': ["104.906396", "25.087825"],
	  '齐齐哈尔市': ["123.918186", "47.354348"],
	  '龙岩市': ["117.017536", "25.075123"]
	};
	
	var XNData = [
	  // [{ name: '陵水' }, { name: '长沙市', value: 35252 }],
	  // [{ name: '陵水' }, { name: '西安市', value: 32674 }]
	];
	
	var planePath = 'arrow';
	
	var convertData = function convertData(data) {
	  var res = [];
	  for (var i = 0; i < data.length; i++) {
	    var dataItem = data[i];
	
	    var fromCoord = geoCoordMap[dataItem[0].name];
	    var toCoord = geoCoordMap[dataItem[1].name];
	    if (fromCoord && toCoord) {
	      res.push({
	        fromName: dataItem[0].name,
	        toName: dataItem[1].name,
	        coords: [fromCoord, toCoord],
	        value: dataItem[1].value
	      });
	    }
	  }
	  return res;
	};
	
	var color = ['#a6c84c', '#ffa022', '#46bee9']; // 航线的颜色
	var series = [];
	exports.default = {
	  props: ["totalRelationCount", "cityStatisticsList"],
	  data: function data() {
	    return {
	      data: [],
	      dataX: [],
	      dataY: [],
	      city: [],
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      map: []
	    };
	  },
	
	  components: {
	    flow: _flow2.default
	  },
	  methods: {
	    show: function show(XNData) {
	      [['陵水', XNData]].forEach(function (item, i) {
	        series.push({
	          name: item[0] + ' Top3',
	          type: 'lines',
	          zlevel: 1,
	          effect: {
	            show: true,
	            period: 6,
	            trailLength: 0.7,
	            color: 'red', // arrow箭头的颜色
	            symbolSize: 3
	          },
	          lineStyle: {
	            normal: {
	              color: color[i],
	              width: 0,
	              curveness: 0.2
	            }
	          },
	          data: convertData(item[1])
	        }, {
	          name: item[0] + ' Top3',
	          type: 'lines',
	          zlevel: 3,
	          symbol: ['none', 'arrow'],
	          symbolSize: 10,
	          effect: {
	            show: true,
	            period: 6,
	            trailLength: 0,
	            symbol: planePath,
	            symbolSize: 15
	          },
	          lineStyle: {
	            normal: {
	              color: color[i],
	              width: 1,
	              opacity: 0.6,
	              curveness: 0.2
	            }
	          },
	          data: convertData(item[1])
	        }, {
	          name: item[0] + ' Top3',
	          type: 'effectScatter',
	          coordinateSystem: 'geo',
	          zlevel: 2,
	          rippleEffect: {
	            brushType: 'stroke'
	          },
	          label: {
	            normal: {
	              show: true,
	              position: 'right',
	              formatter: '{b}'
	            }
	          },
	          symbolSize: function symbolSize(val) {
	            return 10;
	          },
	          itemStyle: {
	            normal: {
	              color: color[i]
	            },
	            emphasis: {
	              areaColor: '#2B91B7'
	            }
	          },
	          data: item[1].map(function (dataItem) {
	            return {
	              name: dataItem[1].name,
	              value: geoCoordMap[dataItem[1].name]
	            };
	          })
	        },
	        // 被攻击点
	        {
	          type: 'scatter',
	          coordinateSystem: 'geo',
	          zlevel: 2,
	          rippleEffect: {
	            period: 4,
	            brushType: 'stroke',
	            scale: 4
	          },
	          label: {
	            normal: {
	              show: true,
	              position: 'right',
	              color: '#0f0',
	              formatter: '{b}',
	              textStyle: {
	                color: "#0f0"
	              }
	            },
	            emphasis: {
	              show: true,
	              color: "#f60"
	            }
	          },
	          symbol: 'path://M512 39.384615l169.353846 295.384615 342.646154 63.015385-240.246154 248.123077L827.076923 984.615385l-315.076923-145.723077L196.923077 984.615385l43.323077-334.769231L0 401.723077l342.646154-63.015385L512 39.384615',
	          symbolSize: 20,
	          data: [{
	            name: item[0],
	            value: geoCoordMap[item[0]].concat([10])
	          }]
	        });
	      });
	    },
	    resizeFunc: function resizeFunc() {
	      this.myChart.resize();
	    },
	    getLatitude: function getLatitude(regionCodeName) {
	      return new _promise2.default(function (resolve) {
	        var geocoder;
	        AMap.plugin(['AMap.Geocoder'], function () {
	          geocoder = new AMap.Geocoder({
	            radius: 1000,
	            extensions: 'all'
	          });
	          if (regionCodeName != null && regionCodeName !== undefined) {
	            geocoder.getLocation(regionCodeName, function (status, result) {
	              if (status === 'complete' && result.info === 'OK') {
	                var longitude = result.geocodes[0].location.lng;
	                var latitude = result.geocodes[0].location.lat;
	                geoCoordMap[regionCodeName] = [longitude, latitude];
	              } else {
	                this.$message.error('获取经纬度失败');
	              }
	              resolve();
	            });
	          }
	        });
	      });
	    },
	    init: function init() {
	      var resizeFunc = this.resizeFunc;
	      window.addEventListener('resize', resizeFunc);
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.int(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        tooltip: {
	          show: false
	        },
	        geo: {
	          map: 'china',
	          roam: true,
	          zoom: 1.2,
	          aspectScale: 0.8,
	          itemStyle: {
	            normal: {
	              areaColor: '#3A64C8',
	              borderColor: '#195BB9',
	              borderWidth: 1
	            },
	            emphasis: {
	              areaColor: '#2B91B7'
	            }
	          }
	        },
	        series: series
	      });
	      this.init();
	    }
	  },
	  destroyed: function destroyed() {
	    var resizeFunc = this.resizeFunc;
	    window.removeEventListener('resize', resizeFunc);
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _this.city = _this.cityStatisticsList;
	              XNData = [];
	              _promise2.default.all(_this.city.map(function () {
	                var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(cityItem) {
	                  var key;
	                  return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          for (key in geoCoordMap) {
	                            if (cityItem.province.replace("省", "").indexOf(key) > -1) {
	                              XNData.push([{ name: '陵水' }, { name: key, value: cityItem.scanCount }]);
	                            }
	                          }
	
	                          // await this.getLatitude(cityItem.province);
	
	                        case 1:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, _this);
	                }));
	
	                return function (_x) {
	                  return _ref.apply(this, arguments);
	                };
	              }()));
	              console.log(XNData);
	              _this.show(XNData);
	              _this.chart();
	              _this.data = _this.totalRelationCount.toString().split('');
	
	            case 7:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, _this);
	    }))();
	  }
	};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(168);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['provinceStatisticsList'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '扫码区域统计排行',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 90,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    this.tableData = this.provinceStatisticsList;
	    for (var i = 0; i < this.tableData.length; i++) {
	      this.sum += this.tableData[i].scanCount;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(168);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      data: [35.02, 9.5, 7.6, 2.4, 1.8, 12, 11.3, 8, 0.28, 4.51],
	      tableData: [{ name: '百色芒果', scale: '120.16万亩', output: '35.02亿', production: '672900吨', listed: '夏季' }, { name: '百色番茄', scale: '24.25万亩', output: '9.5亿', production: '850000吨', listed: '全年' }, { name: '田东香芒', scale: '23万亩', output: '7.6亿', production: '58000吨', listed: '夏季' }, { name: '凌云牛心李', scale: '5万亩', output: '2.4亿', production: '60000吨', listed: '秋季' }, { name: '德保山楂', scale: '8万亩', output: '1.8亿', production: '45000吨', listed: '夏季' }, { name: '西林沙塘桔', scale: '16.6万亩', output: '12亿', production: '400000吨', listed: '秋季' }, { name: '田阳香芒', scale: '39.7万亩', output: '11.3亿', production: '236000吨', listed: '夏季' }, { name: '平果火龙果', scale: '2.3万亩', output: '8亿', production: '8000吨', listed: '夏季' }, { name: '隆林板栗', scale: '13.78万亩', output: '0.28亿', production: '4000吨', listed: '秋季' }, { name: '凌云白毫茶', scale: '12.6万亩', output: '4.51亿', production: '5412吨', listed: '春季' }],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: 0
	          },
	          data: ["百色芒果", "田东香芒", "百色番茄", "凌云牛心李", "德保山楂", "西林沙塘桔", "田阳香芒", "平果火龙果", "隆林板栗", "凌云白毫茶"],
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          barWidth: 18,
	          // itemStyle: {
	          //   normal: {
	          //     color: new echarts.graphic.LinearGradient(
	          //       0,
	          //       0,
	          //       0,
	          //       1,
	          //       [
	          //         {
	          //           offset: 0,
	          //           color: "rgba(232,159,31,1)"
	          //         },
	          //         {
	          //           offset: 0.8,
	          //           color: "rgba(241,100,30,1)"
	          //         }
	          //       ],
	          //       false
	          //     )
	          //   }
	          // },
	          data: this.data
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      // 某些定时器操作
	      self.getData();
	    }, 3000);
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(168);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['productRelationStatisticsList'],
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可追溯商品排名',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    this.tableData = this.productRelationStatisticsList;
	    for (var i = 0; i < this.tableData.length; i++) {
	      this.sum += this.tableData[i].relationCount;
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(168);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['productRelationStatisticsList'],
	  data: function data() {
	    return {
	      name: '可追溯商品',
	      tableData: [],
	      url: _config2.default.fileDomain
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {},
	  mounted: function mounted() {
	    this.tableData = this.productRelationStatisticsList;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(168);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['productScanStatisticsList'],
	  data: function data() {
	    return {
	      name: '追溯产品展示',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = this.productScanStatisticsList;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _product = __webpack_require__(1885);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _table = __webpack_require__(1886);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _codeRanking = __webpack_require__(1882);
	
	var _codeRanking2 = _interopRequireDefault(_codeRanking);
	
	var _harvestingPlan = __webpack_require__(1884);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _generatingData = __webpack_require__(1883);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _center = __webpack_require__(1881);
	
	var _center2 = _interopRequireDefault(_center);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '智慧追溯',
	      productRelationStatisticsList: [],
	      productScanStatisticsList: [],
	      provinceStatisticsList: [],
	      totalRelationCount: '',
	      last12HourScanCount: [],
	      cityStatisticsList: [],
	      show: false,
	      tranceTime: null
	    };
	  },
	
	
	  // productRelationStatisticsList :可追溯商品排名
	  // productScanStatisticsList :追溯产品展示
	  // provinceStatisticsList :扫码区域统计排行
	  // totalRelationCount :可追溯商品排名
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.Trace);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	                // console.log(resultData)z
	
	                _this.productRelationStatisticsList = resultData.productRelationStatisticsList;
	                _this.productScanStatisticsList = resultData.productScanStatisticsList;
	                _this.provinceStatisticsList = resultData.provinceStatisticsList;
	                _this.totalRelationCount = resultData.totalRelationCount;
	                _this.last12HourScanCount = resultData.last12HourScanCount;
	                _this.cityStatisticsList = resultData.cityStatisticsList;
	                _this.show = true;
	              } else {
	                _this.$message.showError(err);
	              }
	              _this.tranceTime = setTimeout(function () {
	                console.log("tranceTime");
	                _this.next();
	              }, 30000);
	
	            case 7:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.tranceTime);
	    this.tranceTime = null;
	  },
	
	  methods: {
	    next: function next() {
	      this.$router.push('/rundasalesDataCenter');
	    },
	    prev: function prev() {
	      this.$router.push('/rundaindustryInformation');
	    }
	  },
	  components: {
	    'v-header': _header2.default,
	    'v-product': _product2.default,
	    'v-codeRanking': _codeRanking2.default,
	    'v-harvestingPlan': _harvestingPlan2.default,
	    'v-generatingData': _generatingData2.default,
	    'v-table': _table2.default,
	    'v-center': _center2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '收支公开',
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        "tooltip": {
	          "trigger": "axis",
	          "axisPointer": {
	            "type": "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        "legend": {
	          x: '40%',
	          top: '2%',
	          textStyle: {
	            color: '#FFF'
	          },
	          itemHeight: 4,
	          itemWidth: 14,
	          "data": ['收入', '支出']
	        },
	        "xAxis": [{
	          "type": "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "splitLine": {
	            "show": false
	          },
	          "axisTick": {
	            "show": false
	          },
	          "splitArea": {
	            "show": false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	          },
	          "data": [2012, 2013, 2014, 2015, 2016, 2017]
	        }],
	        "yAxis": [(0, _defineProperty3.default)({
	          name: '百万',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, -20]
	          },
	          "type": "value",
	          "splitLine": {
	            "show": false
	          },
	          "axisLine": {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          "axisTick": {
	            "show": false
	          },
	          "axisLabel": {
	            "interval": 0
	
	          },
	          "splitArea": {
	            "show": false
	          }
	        }, 'axisLabel', {
	          interval: 0,
	          color: "#fff",
	          fontSize: 12
	        })],
	        "series": [{
	          "name": "收入",
	          "type": "bar",
	          "stack": "总量",
	          "barMaxWidth": 20,
	          "barGap": "10%",
	          "itemStyle": {
	            "normal": {
	              "color": "#76CD2E",
	              "label": {
	                "show": false,
	                "textStyle": {
	                  "color": "#fff"
	                },
	                "position": "insideTop"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [80, 60, 50, 60, 100, 110]
	        }, {
	          "name": "支出",
	          "type": "bar",
	          "stack": "总量",
	          "itemStyle": {
	            "normal": {
	              "color": "#486FF1",
	              "barBorderRadius": 0,
	              "label": {
	                "show": false,
	                "position": "top"
	                // formatter: function (p) {
	                //   return p.value > 0 ? (p.value) : '';
	                // }
	              }
	            }
	          },
	          "data": [10, 10, 20, 30, 40, 40]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index >= 6) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [80, 50, 60, 100, 150, 120];
	    this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _icon = __webpack_require__(1637);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _icon3 = __webpack_require__(1638);
	
	var _icon4 = _interopRequireDefault(_icon3);
	
	var _icon5 = __webpack_require__(1639);
	
	var _icon6 = _interopRequireDefault(_icon5);
	
	var _icon7 = __webpack_require__(1640);
	
	var _icon8 = _interopRequireDefault(_icon7);
	
	var _icon9 = __webpack_require__(1641);
	
	var _icon10 = _interopRequireDefault(_icon9);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      list: [{
	        img: _icon2.default,
	        number: 359,
	        name: "月流失会员"
	      }, {
	        img: _icon4.default,
	        number: 10231,
	        name: "月新增会员"
	      }, {
	        img: _icon6.default,
	        number: 450,
	        name: "月流失数预估"
	      }, {
	        img: _icon8.default,
	        number: 8910,
	        name: "月新增预估"
	      }, {
	        img: _icon10.default,
	        number: 582424,
	        name: "月销量预估"
	      }]
	    };
	  },
	
	  components: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	var _config = __webpack_require__(97);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _centerBottom = __webpack_require__(1889);
	
	var _centerBottom2 = _interopRequireDefault(_centerBottom);
	
	var _index = __webpack_require__(1905);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1906);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ["productionScale", "outputValue"],
	  data: function data() {
	    return {
	      areaName: "",
	      list: [false, false, true],
	      timer: null,
	      massifList: [],
	      massifListR: [],
	      tip: true,
	      datalist: [],
	      typeindex: 0,
	      url: _config2.default.fileDomain
	    };
	  },
	
	  components: {
	    centerBottom: _centerBottom2.default,
	    countTo: _vueCountTo2.default,
	    "v-table1": _index2.default,
	    "v-table2": _index4.default
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.time = setInterval(function () {
	                _this.typeindex = _this.typeindex + 1;
	                _this.list.push(_this.list.shift());
	              }, 5000);
	
	            case 1:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: {
	    name: String,
	    min: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {},
	  data: function data() {
	    return {};
	  },
	
	  methods: {},
	  mounted: function mounted() {}
	};

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '环境质量管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: '生产数据',
	      dataY: [],
	      dataX: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	    // bar
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      // for (var i = 0; i < 7; i++) {
	      //   this.data[i] = this.data[i]
	      //   // this.data[i] = Math.floor(Math.random() * 100);
	      // }
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".line .main"));
	      this.myChart.setOption({
	        animation: true,
	        xAxis: {
	          grid: {
	            top: '10%',
	            left: '20%',
	            right: '10%',
	            bottom: '20%',
	            containLabel: true
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12,
	            rotate: 30
	          }
	        },
	        yAxis: {
	          splitNumber: 4,
	          name: '百万',
	          min: 0,
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	
	            formatter: function formatter(value, index) {
	              return value / 1000000;
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "line",
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 3,
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: '#eb64fb'
	              }, {
	                offset: 1,
	                color: '#3fbbff0d'
	              }], false)
	            }
	          },
	          itemStyle: {
	            color: "red",
	            borderColor: "#fff",
	            borderWidth: 10
	          },
	          areaStyle: {
	            normal: {
	              color: '#3fbbff0d'
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData, i, self;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetPlantingInfoStatistic);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results.dataList;
	                // console.log(resultData)
	
	                for (i = 0; i < resultData.length; i++) {
	                  _this.dataY.push(resultData[i].harvestQuantity);
	                  _this.dataX.push(resultData[i].month);
	                }
	              } else {
	                _this.$message.showError(err);
	              }
	
	              self = _this;
	
	              self.chart();
	              self.init();
	              _this.timer = setInterval(function () {
	                // 某些定时器操作
	                self.getData();
	              }, 3000);
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	};
	// import bar from 'components/dashboard/bar'

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '垃圾分类积分排行',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return 'cur';
	      }
	      if (index === 2) {
	        return 'cur1';
	      }
	      if (index === 3) {
	        return 'cur2';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // const data = ['鹿邑县张万里农资门市部', '鹿邑县钻草农资经营门市部', '鹿邑县绍游农资商店', '鹿邑县星灿农业农村服务']
	              //   .map(x => ({
	              //     id: x,
	              //     productionForecast: Math.round(Math.random() * 10000 + 200)
	              //   }))
	              _this.tableData = [{ id: '鹿邑县张万里农资门市部', productionForecast: 10000 }, { id: '鹿邑县钻草农资经营门市部', productionForecast: 8888 }, { id: '鹿邑县绍游农资商店', productionForecast: 7777 }, { id: '鹿邑县星灿农业农村服务', productionForecast: 6666 }, { id: '鹿邑县张永明农资批零部', productionForecast: 5555 }];
	              _this.sum = 10000;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '项目公开',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 22 }, { id: '绿化改造工程', productionForecast: 25 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 50;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      name: "新生男女比例"
	    };
	  },
	
	  components: {
	    countTo: _vueCountTo2.default
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "新增会员",
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      var _this = this;
	
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar .main"));
	      this.myChart.setOption({
	        tooltip: {
	          trigger: "axis",
	          axisPointer: {
	            type: "shadow",
	            textStyle: {
	              color: "#fff"
	            }
	          }
	        },
	        grid: {
	          top: "15%",
	          left: "5%",
	          right: "5%",
	          bottom: "10%",
	          containLabel: true
	        },
	        xAxis: [{
	          type: "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          splitLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          },
	          splitArea: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 16
	          },
	          data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"]
	        }],
	        yAxis: [(0, _defineProperty3.default)({
	          type: "value",
	          // splitLine: {
	          //   show: false
	          // },
	          axisLine: {
	            show: false,
	            lineStyle: {
	              color: "#144088"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0
	          },
	          splitArea: {
	            show: false
	          },
	          splitLine: {
	            show: true,
	            lineStyle: {
	              color: "#144088"
	            }
	          }
	        }, "axisLabel", {
	          interval: 0,
	          color: "#30ABE7",
	          fontSize: 14
	        }), {
	          name: "数量：个",
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 14,
	            position: "right",
	            padding: [10, 4, 0, -30]
	          },
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          }
	        }],
	        series: [{
	          name: "新增会员",
	          type: "bar",
	          barMaxWidth: 12,
	          barGap: "10%",
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 1, 0, 0, [{
	                offset: 0,
	                // color: "#03fef1"
	                color: "#0173ff"
	              }, {
	                offset: 0.8,
	                // color: "#0173ff"
	                color: "#03fef1"
	              }], false)
	            }
	          },
	          label: {
	            normal: {
	              show: true,
	              lineHeight: 30,
	              width: 80,
	              height: 30,
	              color: "#1FFFF2",
	              position: ["-12", "-20"],
	              fontSize: 14
	            }
	          },
	          data: [28124, 64142, 53102, 89234, 12355]
	        }]
	      });
	
	      var that = this;
	      var index = 0;
	      clearInterval(this.timer);
	      this.timer = setInterval(function () {
	        _this.myChart.dispatchAction({
	          type: "showTip",
	          seriesIndex: 0,
	          dataIndex: index
	        });
	        index++;
	        // console.log(index)
	        if (index > 5) {
	          index = 0;
	        }
	      }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    // this.dataY = [80, 50, 60, 100, 150, 120]
	    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      name: "公众号新增人数",
	      dataY: [],
	      dataX: [],
	      tableData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".area .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".area .main"));
	      this.myChart.setOption({
	        grid: {
	          top: "15%",
	          left: "5%",
	          right: "5%",
	          bottom: "3.6%",
	          containLabel: true
	        },
	        xAxis: [{
	          type: "category",
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          splitLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          },
	          splitArea: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 16
	          },
	          data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"]
	        }],
	        yAxis: [(0, _defineProperty3.default)({
	          type: "value",
	          // splitLine: {
	          //   show: false
	          // },
	          axisLine: {
	            show: false,
	            lineStyle: {
	              color: "#144088"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0
	          },
	          splitArea: {
	            show: false
	          },
	          splitLine: {
	            show: true,
	            lineStyle: {
	              color: "#144088"
	            }
	          }
	        }, "axisLabel", {
	          interval: 0,
	          color: "#30ABE7",
	          fontSize: 14
	        }), {
	          name: "数量：个",
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 14,
	            position: "right",
	            padding: [10, 4, 0, -30]
	          },
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          }
	        }],
	        series: [{
	          name: "注册总量",
	          type: "line",
	          smooth: false, // 是否平滑曲线显示
	          showAllSymbol: true,
	          symbol: "emptyCircle",
	          symbolSize: 10,
	          lineStyle: {
	            normal: {
	              color: "#3EF7AE" // 线条颜色
	            }
	          },
	          label: {
	            show: true,
	            position: "top",
	            textStyle: {
	              color: "#fff"
	            }
	          },
	          itemStyle: {
	            color: "#3EF7AE",
	            borderColor: "#3EF7AE",
	            borderWidth: 3
	          },
	          tooltip: {
	            show: false
	          },
	          areaStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(0,246,110,0.5)"
	              }, {
	                offset: 0.8,
	                color: "rgba(26,247,255,0.5)"
	              }], false)
	            }
	          },
	          data: [18124, 34142, 6355, 25102, 43234]
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var self = this;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      self.getData();
	    }, 5000);
	  }
	};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ["#AF69FF", "#00A0EA", "#13AF68", "#FFB52B", "#920784"],
	      myChart: {},
	      name: "会员购买商品排行",
	      tableData: [],
	      arr: ["会员积分兑换产品排行", "会员扫码产品排行", "会员参加活动排行", "会员购买商品排行"],
	      list: {
	        会员积分兑换产品排行: [{ id: "随机红包0.5～1元", productionForecast: 39987 }, { id: "光明纯牛奶250ml", productionForecast: 30231 }, { id: "滴滴打车优惠券（随机)", productionForecast: 25121 }, { id: "天猫超市优惠券（随机)", productionForecast: 22123 }, { id: "燕之屋燕窝70g", productionForecast: 20313 }, { id: "茅台体验装", productionForecast: 18219 }, { id: "帮宝适纸尿裤1片装", productionForecast: 16213 }, { id: "婴儿泡泡沐浴露", productionForecast: 12312 }, { id: "曼哈顿儿童咬胶", productionForecast: 10742 }, { id: "花王纸尿裤1片装", productionForecast: 9490 }],
	        会员扫码产品排行: [{ id: "光明新鲜杯优倍200ml", productionForecast: 609987 }, { id: "光明纯牛奶250ml", productionForecast: 590231 }, { id: "光明莫斯利安常温酸牛奶200g", productionForecast: 424121 }, { id: "光明优加纯牛奶250ml", productionForecast: 353123 }, {
	          id: "光明中老年奶粉高钙维生素E调制奶粉听装800g",
	          productionForecast: 300313
	        }, {
	          id: "光明优倍高品质巴氏杀菌鲜牛奶950ml",
	          productionForecast: 287219
	        }, { id: "光明随心订致优全鲜乳尊享杯260ml", productionForecast: 255213 }, { id: "光明噜渴酸奶盒装200ml", productionForecast: 202312 }, { id: "光明如实洋槐蜂蜜发酵乳135g", productionForecast: 198742 }, { id: "光明巧克力味含乳饮料250ml", productionForecast: 158490 }],
	        会员参加活动排行: [{ id: "微信红包", productionForecast: 599987 }, { id: "大转盘抽奖", productionForecast: 450231 }, { id: "翻牌活动", productionForecast: 394121 }, { id: "扫码拿抵扣券", productionForecast: 353123 }, {
	          id: "刮刮乐活动",
	          productionForecast: 292313
	        }, {
	          id: "微信抽免单",
	          productionForecast: 253219
	        }, { id: "签到领积分", productionForecast: 213213 }, { id: "投篮领抵扣券", productionForecast: 192312 }, { id: "集印花领红包", productionForecast: 158742 }, { id: "一起猜歌名", productionForecast: 128490 }],
	        会员购买商品排行: [{ id: "帮宝适纸尿裤", productionForecast: 109987 }, { id: "美赞臣荷兰版铂睿幼儿配方奶粉", productionForecast: 99987 }, { id: "life space婴儿益生菌粉", productionForecast: 97623 }, {
	          id: "lifeline care婴幼儿宝宝鱼油DHA维D3",
	          productionForecast: 83412
	        }, {
	          id: "费雪欢乐成长玩具套餐",
	          productionForecast: 80213
	        }, {
	          id: "曼哈顿咬胶婴幼儿咬胶",
	          productionForecast: 75213
	        }, { id: "花王纸尿裤", productionForecast: 64352 }, { id: "德国施巴婴儿泡泡沐浴露", productionForecast: 45099 }, { id: "儿童声波软毛电动牙刷", productionForecast: 42812 }, { id: "利其尔透透杯系列", productionForecast: 24123 }]
	      },
	      sum: 0,
	      index: 0,
	      swiperOption: {
	        slidesPerView: "auto",
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {
	    cla: function cla(index) {
	      if (index === 1) {
	        return "cur";
	      }
	      if (index === 2) {
	        return "cur1";
	      }
	      if (index === 3) {
	        return "cur2";
	      }
	    },
	    getData: function getData() {
	      this.tableData = [];
	      this.index = this.index + 1;
	      if (this.index >= 4) {
	        this.index = 0;
	      }
	      this.name = this.arr[this.index];
	      console.log(this.name);
	      this.tableData = this.list[this.arr[this.index]];
	      this.sum = this.list[this.arr[this.index]][0].productionForecast * 1.1;
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getData();
	    this.timer = setInterval(function () {
	      _this.getData();
	    }, 10000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var placeHolderStyle = {
	  normal: {
	    label: {
	      show: false
	    },
	    labelLine: {
	      show: false
	    }
	  }
	};
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "会员复购率",
	      dataY: [],
	      dataX: [],
	      tableData: [],
	      chartData: [],
	      swiperOption: {
	        slidesPerView: "auto",
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData(percent) {
	      return [{
	        value: percent,
	        name: percent
	      }, {
	        value: 1 - percent,
	        itemStyle: {
	          normal: {
	            color: "transparent"
	            // color: "#05296D"
	          }
	        }
	      }];
	    },
	
	    // getData() {
	    //   this.myChart = echarts.init(document.querySelector(".bar3D .main"));
	    //   this.myChart.clear();
	    //   this.chart();
	    // },
	    chart: function chart() {
	      this.data = ["15.80%", "20.50%", "16.15%", "30.90%", "25.90%"];
	      this.xdata = ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"];
	      var obj = {
	        领抵扣券: 10,
	        大转盘: 11,
	        翻牌活动: 12,
	        微信红包: 13,
	        刮刮乐: 14
	      };
	      var data = this.chartData;
	      this.myChart = _echarts2.default.init(document.querySelector(".bar3D .main"));
	      var op = {
	        color: ["rgb(14,109,233)", "rgb(0,175,109)", "#F4BB0C", "rgb(172,78,211)", "rgb(249,123,123)"],
	        yAxis: [{
	          type: "category",
	          inverse: true,
	          axisLine: {
	            show: false
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            inside: true,
	            textStyle: {
	              color: "#0EFCFF",
	              fontSize: 14
	            },
	            show: true
	          },
	          data: this.data
	        }],
	        xAxis: [{
	          show: false
	        }],
	        legend: {
	          bottom: "10",
	          itemHeight: 16,
	          itemWidth: 16,
	          data: this.xdata,
	          textStyle: {
	            color: "#fff",
	            fontSize: 16
	          },
	          top: "center",
	          left: "70%"
	          // formatter: function(name) {
	          //   return name + obj[name] + "人";
	          // }
	        },
	        grid: {
	          top: "10%",
	          bottom: "55%",
	          left: "40%",
	          containLabel: false
	        },
	        series: [{
	          name: this.xdata[0],
	          type: "pie",
	          clockWise: false,
	          hoverAnimation: false,
	          radius: [100, 110],
	          center: ["40%", "50%"],
	          itemStyle: placeHolderStyle,
	          data: this.getData(0.658)
	        }, {
	          name: this.xdata[1],
	          type: "pie",
	          clockWise: false,
	          hoverAnimation: false,
	          radius: [80, 90],
	          center: ["40%", "50%"],
	          itemStyle: placeHolderStyle,
	          data: this.getData(0.605)
	        }, {
	          name: this.xdata[2],
	          type: "pie",
	          clockWise: false,
	          hoverAnimation: false,
	          radius: [60, 70],
	          center: ["40%", "50%"],
	          itemStyle: placeHolderStyle,
	          data: this.getData(0.6615)
	        }, {
	          name: this.xdata[3],
	          type: "pie",
	          clockWise: false,
	          hoverAnimation: false,
	          radius: [40, 50],
	          center: ["40%", "50%"],
	          itemStyle: placeHolderStyle,
	          data: this.getData(0.709)
	        }, {
	          name: this.xdata[4],
	          type: "pie",
	          clockWise: false,
	          hoverAnimation: false,
	          radius: [20, 30],
	          center: ["40%", "50%"],
	          itemStyle: placeHolderStyle,
	          data: this.getData(0.759)
	        }]
	      };
	      this.myChart.setOption(op);
	      this.init();
	
	      // const that = this;
	      // let index = 0;
	      // clearInterval(this.timer);
	      // this.timer = setInterval(() => {
	      //   this.myChart.dispatchAction({
	      //     type: "showTip",
	      //     seriesIndex: 0,
	      //     dataIndex: index
	      //   });
	      //   index++;
	      //   // console.log(index)
	      //   if (index >= 6) {
	      //     index = 0;
	      //   }
	      // }, 3000);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    // this.dataY = [80, 50, 60, 100, 150, 120]
	    // this.dataX = ['1-18', '19-22', '23-35', '36-55', '56-75', '76-90']
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	  }
	};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: "微店转化率",
	      dataY: [],
	      dataX: [],
	      index: 0,
	      tab: 0,
	      tablist: ["10%", "20%", "15%", "25%", "30%"],
	      data: ["领抵扣券", "大转盘", "翻牌活动", "微信红包", "刮刮乐"],
	      tableData: [],
	      list: {
	        tableData1: [{ value: 80, name: "宝妈" }, { value: 60, name: "牛奶美食" }, { value: 40, name: "纯牛奶" }, { value: 50, name: "纸尿裤" }, { value: 50, name: "投资理财" }, { value: 30, name: "贝尔比" }, { value: 20, name: "打折" }, { value: 20, name: "天猫" }, { value: 25, name: "双十一" }, { value: 30, name: "周杰伦" }, { value: 20, name: "学区房" }, { value: 20, name: "生发素" }, { value: 20, name: "会员" },
	        // { value: 20, name: "积分" },
	        { value: 25, name: "天猫" }, { value: 30, name: "拼多多" }],
	        tableData2: [{ value: 80, name: "领养一头牛" }, { value: 60, name: "抽免单" }, { value: 40, name: "集印花" }, { value: 50, name: "积分兑换" }, { value: 50, name: "微信红包" }, { value: 30, name: "大转盘" },
	        // { value: 20, name: "抵扣" },
	        { value: 20, name: "翻牌" }, { value: 20, name: "打鱼" }, { value: 30, name: "测星座" }, { value: 20, name: "打地鼠" }, { value: 20, name: "签到" }, { value: 20, name: "赛车" }, { value: 20, name: "投篮" }, { value: 25, name: "对对碰" }, { value: 30, name: "刮刮乐" }]
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    chart: function chart() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar6 .main"));
	      var option = {
	        color: ["rgba(70,202,246,0.5)", "rgba(206,134,217,0.5)", "rgba(120,116,235,0.5)"],
	        calculable: true,
	        series: [{
	          type: "treemap",
	          width: "100%",
	          height: "100%",
	          // left: "10%",
	          roam: false, // 是否开启拖拽漫游（移动和缩放）
	          nodeClick: false, // 点击节点后的行为,false无反应
	          breadcrumb: {
	            show: false
	          },
	          label: {
	            normal: {
	              textStyle: {
	                fontWeight: "bold",
	                color: "rgba(255,255,255,1)",
	                fontSize: "30"
	              }
	            }
	          },
	          itemStyle: {
	            normal: {
	              label: {
	                show: true,
	                formatter: "{b}"
	              },
	              borderWidth: 5,
	              borderColor: "transparent "
	            }
	          },
	          data: this.tableData
	        }]
	      };
	      this.myChart.setOption(option);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {},
	  mounted: function mounted() {
	    var _this = this;
	
	    var self = this;
	    this.tableData = this.list.tableData1;
	    self.chart();
	    self.init();
	    this.timer = setInterval(function () {
	      if (_this.index === 1) {
	        _this.tableData = _this.list.tableData2;
	        _this.index = 2;
	      } else {
	        _this.tableData = _this.list.tableData1;
	        _this.index = 1;
	      }
	      _this.chart();
	    }, 15000);
	    this.indextimer = setInterval(function () {
	      _this.tab = _this.tab + 1;
	      if (_this.tab >= _this.tablist.length) {
	        _this.tab = 0;
	      }
	    }, 3000);
	  }
	};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueCountTo = __webpack_require__(95);
	
	var _vueCountTo2 = _interopRequireDefault(_vueCountTo);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '产业情况',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    countTo: _vueCountTo2.default
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }];
	  }
	};
	// import '/../../../../static/css/swiper.css'

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  props: ['distributedBar'],
	  data: function data() {
	    return {
	      color: ['#407FFF', '#F45E23', '#E6AF08', '#49C8CF'],
	      myChart: {},
	      name: '补贴发放',
	      dataX: [],
	      timer: null,
	      chartData: []
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener('resize', function () {
	        this.myChart.resize();
	      }.bind(this));
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var count = 0;
	    // for (var i = 0; i < this.distributedBar.length; i++) {
	    //   if (this.distributedBar[i].regionName && count < 8) {
	    //     this.dataX.push(this.distributedBar[i].regionName)
	    //     this.chartData.push({ value: this.distributedBar[i].number, name: this.distributedBar[i].regionName })
	    //     count++
	    //   }
	    //   // console.log(this.dataX, this.chartData)
	    // }
	    // console.log(this.chartData)
	    this.dataX = ['危房改造', '大病救助', '留守儿童', '低保五保'];
	    this.chartData = [{ name: '危房改造', value: 30 }, { name: '大病救助', value: 20 }, { name: '留守儿童', value: 30 }, { name: '低保五保', value: 20 }];
	    var data = this.chartData;
	    // 基于准备好的dom，初始化echarts实例
	    this.myChart = _echarts2.default.init(document.querySelector('.pie1 .main'));
	    var op = {
	      title: {
	        text: '第三季度',
	        textStyle: {
	          color: '#33D8FB',
	          fontSize: 20
	        },
	        top: '%',
	        right: '5%'
	      },
	      legend: [{
	        orient: 'vertical',
	        right: '20',
	        bottom: '20',
	        itemHeight: 16,
	        itemWidth: 16,
	        data: this.dataX,
	        textStyle: {
	          color: "#FFF",
	          fontSize: 14
	        }
	      }],
	      tooltip: {
	        // trigger: 'item',
	        formatter: "{b} : {d}% <br/> {c}"
	      },
	      color: this.color,
	      series: [{
	        name: '访问来源',
	        type: 'pie',
	        radius: ['30%', '75%'],
	        center: ['35%', '50%'],
	        data: data,
	        label: {
	          position: 'outside',
	          normal: {
	            // formatter: '{b|{b}}\n{hr|}\n{c|{c}%}',
	            // rich: {
	            //   b: {
	            //     fontSize: 16,
	            //     color: '#FFF',
	            //     align: 'left',
	            //     padding: 4
	            //   },
	            //   hr: {
	            //     borderColor: '#CCCCCC',
	            //     width: '100%',
	            //     borderWidth: 2,
	            //     height: 0
	            //   },
	            //   c: {
	            //     fontSize: 16,
	            //     align: 'center',
	            //     padding: 4,
	            //     color: '#00EDED'
	            //   }
	            // }
	          }
	        },
	        labelLine: {
	          show: true
	        },
	        itemStyle: {
	          position: 'outside',
	          normal: {
	            label: {
	              show: true,
	              fontSize: 16,
	              position: 'outside',
	              formatter: '{d}%',
	              color: "#fff"
	            },
	            labelLine: {
	              show: true
	            }
	          },
	          emphasis: {
	            shadowBlur: 10,
	            shadowOffsetX: 0,
	            shadowColor: 'rgba(0, 0, 0, 0.5)'
	          }
	        }
	      }]
	    };
	    this.myChart.setOption(op);
	    this.init();
	    // 切换具体的子地图
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      for (var i = 0; i < op.series[0].data.length; i++) {
	        op.series[0].data[i]['selected'] = false;
	      }
	      op.series[0].data[index]['selected'] = true;
	      _this.myChart.setOption(op);
	      index++;
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 4000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  }
	};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  data: function data() {
	    return {
	      name: '种植批次数据',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var _ref, err, res, resultData;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.next = 2;
	              return _this.$model('dataManagement').commonfn2(_this.$apiUrl.DATAANALYSIS.GetLastestPickingBatchList);
	
	            case 2:
	              _ref = _context.sent;
	              err = _ref.err;
	              res = _ref.res;
	
	              if (res.state === 200) {
	                resultData = res.results;
	
	                _this.tableData = resultData;
	                // console.log(resultData)
	              } else {
	                _this.$message.showError(err);
	              }
	
	            case 6:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  // props: ["salesData", "salesDataBar"],
	  data: function data() {
	    return {
	      name: '区域在售登记种类',
	      dataY: [],
	      dataX: [],
	      type: {
	        '农药': 779,
	        '种子': 50,
	        '肥料': 200,
	        '兽药': 596,
	        '饲料': 354
	      },
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide,
	    bar: _bar2.default
	  },
	  methods: {
	    init: function init() {
	      window.addEventListener("resize", function () {
	        this.myChart.resize();
	      }.bind(this));
	    },
	    getData: function getData() {
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.clear();
	      this.chart();
	    },
	    chart: function chart() {
	      // 基于准备好的dom，初始化echarts实例
	      this.myChart = _echarts2.default.init(document.querySelector(".bar2 .main"));
	      this.myChart.setOption({
	        animation: true,
	        grid: {
	          top: '15%',
	          left: '3%',
	          right: '10%',
	          bottom: '10%',
	          containLabel: true
	        },
	        xAxis: {
	          name: '类型',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12
	            // top: 20,
	            // padding: [25, 0, 0, -10]
	          },
	          data: this.dataX,
	          boundaryGap: true,
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            interval: 0,
	            color: "#fff",
	            fontSize: 12
	            // rotate: 30
	          }
	        },
	        yAxis: {
	          name: '交易量（笔）',
	          nameTextStyle: {
	            color: "#fff",
	            fontSize: 12,
	            padding: [25, 0, 0, 10]
	          },
	          axisLine: {
	            lineStyle: {
	              color: "#0177d4"
	            }
	          },
	          axisTick: {
	            show: false
	          },
	          axisLabel: {
	            color: "#fff",
	            fontSize: 12,
	            formatter: function formatter(value) {
	              if (value > 10000) {
	                return value / 10000;
	              } else {
	                return value;
	              }
	            }
	          },
	          splitLine: {
	            show: false,
	            lineStyle: {
	              color: "#0177d4"
	            }
	          }
	        },
	        series: [{
	          type: "bar",
	          barWidth: 18,
	          itemStyle: {
	            normal: {
	              color: new _echarts2.default.graphic.LinearGradient(0, 0, 0, 1, [{
	                offset: 0,
	                color: "rgba(232,159,31,1)"
	              }, {
	                offset: 0.8,
	                color: "rgba(241,100,30,1)"
	              }], false)
	            }
	          },
	          data: this.dataY
	        }]
	      });
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	    this.timer = null;
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    // this.tableData = this.salesData
	    // var time = ['oneDay', 'twoDay', 'threeDay', 'fourDay', 'fiveDay', 'sixDay', 'sevenDay']
	    // var myDate = new Date();
	    // myDate.setDate(myDate.getDate() - 7);
	    // var dateArray = []
	    // var dateTemp;
	    // var flag = 1;
	    // for (var i = 0; i < time.length; i++) {
	    //   let day = myDate.getDate() + i + 1;
	    //   dateTemp = (myDate.getMonth() + 1) + "-" + day
	    //   this.dataY.push(this.salesDataBar[0][time[i]])
	    //   this.dataX.push(dateTemp)
	    // }
	
	    this.dataY = [1000, 600, 100, Math.round(Math.random() * 100 + 100)];
	    this.dataX = ['进货台账', '销售台账', '高剧毒农药', '废弃物回收'];
	    var self = this;
	    self.chart();
	    self.init();
	    // this.timer = setInterval(() => {
	    //   self.getData()
	    // }, 3000);
	
	    var that = this;
	    var index = 0;
	    clearInterval(this.timer);
	    this.timer = setInterval(function () {
	      _this.myChart.dispatchAction({
	        type: "showTip",
	        seriesIndex: 0,
	        dataIndex: index
	      });
	      index++;
	      // console.log(index)
	      if (index >= 4) {
	        index = 0;
	      }
	    }, 3000);
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '2018-08-03', orderNumber: '安吉盈元家庭农场', name1: '甲拌磷', id: 'PD85109-13', number: '10' }, { name: '2019-07-31', orderNumber: '安吉润发家庭农场有限公司', name1: '辛硫·甲拌磷', id: 'PD20100085', number: '10' }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    this.tableData = [{ name: '2018-08-03', orderNumber: '安吉盈元家庭农场', name1: '甲拌磷', id: 'PD85109-13', number: '实名登记' }, { name: '2019-07-31', orderNumber: '安吉润发家庭农场有限公司', name1: '辛硫·甲拌磷', id: 'PD20100085', number: '未登记' }];
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '/../../../../static/css/swiper.css'
	exports.default = {
	  props: ['salesDataRealTime'],
	  data: function data() {
	    return {
	      name: '区域农业投入品流通销售排行榜',
	      tableData: [],
	      time: null,
	      typeindex: 0,
	      list: ['农药', '种子', '肥料', '兽药', '饲料'],
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 100,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // autoplay: false,
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      },
	      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"],
	      data: {
	        '农药': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好1' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好1' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好1' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好1' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好1' }],
	        '种子': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好2' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好2' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好2' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好2' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好2' }],
	        '肥料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好3' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好3' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好3' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好3' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好3' }],
	        '兽药': [],
	        '饲料': [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好4' }, { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好4' }, { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好4' }, { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好4' }, { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' }, { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好4' }]
	      }
	    };
	  },
	
	  methods: {
	    changeColor: function changeColor(index) {
	      if (index <= 3) {
	        return 'color:' + this.colorList[index];
	      } else {
	        return 'color:' + this.colorList[3];
	      }
	    },
	    changeType: function changeType(item, index) {
	      var _this = this;
	
	      console.log(index);
	
	      this.typeindex = index;
	      this.tableData = this.data[item];
	      if (this.data[item].length === 0) {
	        setTimeout(function () {
	          _this.changeType(_this.list[index + 1], index + 1);
	        }, 1000);
	        return;
	      }
	    }
	  },
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.changeType(this.list[this.typeindex], this.typeindex);
	    this.time = setInterval(function () {
	      _this2.typeindex = _this2.typeindex + 1;
	      if (_this2.typeindex > 4) {
	        _this2.typeindex = 0;
	      }
	      _this2.changeType(_this2.list[_this2.typeindex], _this2.typeindex);
	      _this2.$nextTick();
	      console.log(_this2.typeindex);
	    }, 3000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.time);
	    this.time = null;
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _boxWrap = __webpack_require__(38);
	
	var _boxWrap2 = _interopRequireDefault(_boxWrap);
	
	var _bar = __webpack_require__(18);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _echarts = __webpack_require__(5);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	__webpack_require__(9);
	
	var _vueAwesomeSwiper = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
	      myChart: {},
	      name: '可视化管理',
	      tableData: [],
	      sum: 0,
	      swiperOption: {
	        slidesPerView: 'auto',
	        // 一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
	        notNextTick: true,
	        // 循环
	        loop: true,
	        // 设定初始化时slide的索引
	        initialSlide: 0,
	        roundLengths: true,
	        height: 180,
	        // 自动播放
	        autoplay: {
	          delay: 3000,
	          stopOnLastSlide: false,
	          /* 触摸滑动后是否继续轮播 */
	          disableOnInteraction: false
	        },
	        // 滑动速度
	        speed: 800,
	        // 滑动方向
	        direction: "vertical",
	        // 小手掌抓取滑动
	        grabCursor: true
	      }
	    };
	  },
	
	  components: {
	    boxWrap: _boxWrap2.default,
	    swiper: _vueAwesomeSwiper.swiper,
	    swiperSlide: _vueAwesomeSwiper.swiperSlide
	  },
	  methods: {},
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.tableData = [{ id: '安全设施建设工程', productionForecast: 35 }, { id: '水资源管理设施工程', productionForecast: 43 }, { id: '垃圾分类管理基础设施', productionForecast: 10 }, { id: '绿化改造工程', productionForecast: 12 }, { id: '河道加固建设工程', productionForecast: 32 }];
	              _this.sum = 35 + 43 + 10 + 12 + 32;
	
	            case 2:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _swiper = __webpack_require__(134);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _yinxiaoheader = __webpack_require__(1732);
	
	var _yinxiaoheader2 = _interopRequireDefault(_yinxiaoheader);
	
	var _item = __webpack_require__(1895);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _item3 = __webpack_require__(1896);
	
	var _item4 = _interopRequireDefault(_item3);
	
	var _item5 = __webpack_require__(1897);
	
	var _item6 = _interopRequireDefault(_item5);
	
	var _center = __webpack_require__(1890);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _item7 = __webpack_require__(1898);
	
	var _item8 = _interopRequireDefault(_item7);
	
	var _item9 = __webpack_require__(1899);
	
	var _item10 = _interopRequireDefault(_item9);
	
	var _item11 = __webpack_require__(1900);
	
	var _item12 = _interopRequireDefault(_item11);
	
	var _planting = __webpack_require__(1903);
	
	var _planting2 = _interopRequireDefault(_planting);
	
	var _generatingData = __webpack_require__(1892);
	
	var _generatingData2 = _interopRequireDefault(_generatingData);
	
	var _salesData = __webpack_require__(1904);
	
	var _salesData2 = _interopRequireDefault(_salesData);
	
	var _table = __webpack_require__(1907);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _pie = __webpack_require__(1902);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _bar = __webpack_require__(1888);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _harvestingPlan = __webpack_require__(1894);
	
	var _harvestingPlan2 = _interopRequireDefault(_harvestingPlan);
	
	var _ev = __webpack_require__(1891);
	
	var _ev2 = _interopRequireDefault(_ev);
	
	var _video = __webpack_require__(1908);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _group = __webpack_require__(1893);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _list = __webpack_require__(1901);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    return {
	      show: false,
	      name: "营销数据驾驶舱",
	      outputValue: "",
	      productionScale: "",
	      salesData: [],
	      salesDataBar: [],
	      salesDataRealTime: [],
	      timerDashboard: null
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this.show = true;
	
	            case 1:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this);
	    }))();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timerDashboard);
	    this.timerDashboard = null;
	  },
	
	  methods: {},
	  components: {
	    "v-header": _yinxiaoheader2.default,
	    "v-item1": _item2.default,
	    "v-item2": _item4.default,
	    "v-item3": _item6.default,
	    "v-center": _center2.default,
	    "v-item4": _item8.default,
	    "v-item5": _item10.default,
	    "v-item6": _item12.default,
	    "v-salesData": _salesData2.default,
	    "v-table": _table2.default,
	    "v-harvestingPlan": _harvestingPlan2.default,
	    "v-generatingData": _generatingData2.default,
	    "v-pie": _pie2.default,
	    "v-bar": _bar2.default,
	    "v-list": _list2.default,
	    "v-ev": _ev2.default,
	    "v-video": _video2.default,
	    "v-planting": _planting2.default,
	    "v-group": _group2.default
	  }
	};

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(53);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _pie = __webpack_require__(1777);
	
	var _pie2 = _interopRequireDefault(_pie);
	
	var _table = __webpack_require__(1778);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _circle = __webpack_require__(1774);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _iot = __webpack_require__(1776);
	
	var _iot2 = _interopRequireDefault(_iot);
	
	var _bar = __webpack_require__(1766);
	
	var _bar2 = _interopRequireDefault(_bar);
	
	var _bars = __webpack_require__(585);
	
	var _bars2 = _interopRequireDefault(_bars);
	
	var _circleBar = __webpack_require__(1773);
	
	var _circleBar2 = _interopRequireDefault(_circleBar);
	
	var _flow = __webpack_require__(1775);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	var _center = __webpack_require__(1770);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _particles = __webpack_require__(586);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _defineProperty3.default)({
	  data: function data() {
	    return {
	      items: [],
	      name: '田阳县农业大脑',
	      child: false
	    };
	  },
	  mounted: function mounted() {},
	
	  components: {
	    particles: _particles2.default
	  },
	  methods: {
	    clickChild: function clickChild(bool) {
	      this.child = bool;
	    },
	    backToDashboard: function backToDashboard() {
	      this.child = false;
	    }
	  }
	}, 'components', {
	  'v-header': _header2.default,
	  'v-table': _table2.default,
	  'v-circle': _circle2.default,
	  'v-pie': _pie2.default,
	  'v-iot': _iot2.default,
	  'v-bar': _bar2.default,
	  'v-bars': _bars2.default,
	  'v-flow': _flow2.default,
	  'v-circle-bar': _circleBar2.default,
	  'v-center': _center2.default
	}); //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _line = __webpack_require__(1783);
	
	var _line2 = _interopRequireDefault(_line);
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _table = __webpack_require__(1786);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _center = __webpack_require__(1782);
	
	var _center2 = _interopRequireDefault(_center);
	
	var _traceProduct = __webpack_require__(1787);
	
	var _traceProduct2 = _interopRequireDefault(_traceProduct);
	
	var _product = __webpack_require__(1785);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _productQA = __webpack_require__(1784);
	
	var _productQA2 = _interopRequireDefault(_productQA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      items: [],
	      name: '田阳县农业大脑—可追溯商品数据中心'
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {},
	  components: {
	    'v-line': _line2.default,
	    'v-header': _header2.default,
	    'v-table': _table2.default,
	    'v-center': _center2.default,
	    'v-trace-product': _traceProduct2.default,
	    'v-product': _product2.default,
	    'v-product-QA': _productQA2.default
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(41);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _change = __webpack_require__(1710);
	
	var _change2 = _interopRequireDefault(_change);
	
	var _change3 = __webpack_require__(1711);
	
	var _change4 = _interopRequireDefault(_change3);
	
	var _change5 = __webpack_require__(1712);
	
	var _change6 = _interopRequireDefault(_change5);
	
	var _change7 = __webpack_require__(1713);
	
	var _change8 = _interopRequireDefault(_change7);
	
	var _pic = __webpack_require__(1715);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(1716);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(1717);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	var _pic7 = __webpack_require__(1718);
	
	var _pic8 = _interopRequireDefault(_pic7);
	
	var _pic9 = __webpack_require__(1719);
	
	var _pic10 = _interopRequireDefault(_pic9);
	
	var _pic11 = __webpack_require__(1720);
	
	var _pic12 = _interopRequireDefault(_pic11);
	
	var _pic13 = __webpack_require__(1721);
	
	var _pic14 = _interopRequireDefault(_pic13);
	
	var _pic15 = __webpack_require__(1722);
	
	var _pic16 = _interopRequireDefault(_pic15);
	
	var _pic17 = __webpack_require__(1723);
	
	var _pic18 = _interopRequireDefault(_pic17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	  data: function data() {
	    var that = this;
	    return {
	      name: '田阳县农业大脑——监控展示中心',
	      show: false,
	      key: 0,
	      checkedNames: [],
	      header: [1, 1, 1, 1],
	      n1: 1,
	      n2: 1,
	      n3: 1,
	      n4: 1,
	      checkedNames2: ['田阳县基地监控'],
	      options: [{ text: '田阳县基地监控', value: true }, { text: '田阳县基地监控1', value: false }, { text: '田阳县基地监控2', value: false }, { text: '田阳县基地监控3', value: false }, { text: '田阳县基地监控4', value: false }, { text: '田阳县基地监控5', value: false }, { text: '田阳县基地监控6', value: false }, { text: '田阳县基地监控7', value: false }, { text: '田阳县基地监控8', value: false }, { text: '田阳县基地监控9', value: false }, { text: '田阳县基地监控10', value: false }, { text: '田阳县基地监控11', value: false }, { text: '田阳县基地监控12', value: false }, { text: '田阳县基地监控13', value: false }, { text: '田阳县基地监控14', value: false }, { text: '田阳县基地监控15', value: false }, { text: '田阳县基地监控16', value: false }],
	      showList: [_pic2.default],
	      picList: [_pic2.default, _pic4.default, _pic6.default, _pic8.default, _pic10.default, _pic12.default, _pic14.default, _pic16.default, _pic18.default, _pic10.default, _pic12.default, _pic14.default, _pic16.default, _pic18.default, _pic10.default, _pic12.default],
	      status: true,
	      status1: false,
	      status2: false,
	      status3: false,
	      seq: 1
	    };
	  },
	  mounted: function mounted() {},
	
	  watch: {
	    checkedNames2: function checkedNames2(val, oldVal) {
	      var n = val.length;
	      this.checkedNames2 = val;
	      this.showList = this.picList.slice(0, n);
	    }
	  },
	  methods: {
	    keys: function keys(ind) {
	      if (ind === 1) {
	        this.checkedNames2 = this.checkedNames2.slice(0, 1);
	        this.width2(1);
	        this.n1++;
	        this.status = true;
	        this.status1 = false;
	        this.status2 = false;
	        this.status3 = false;
	      }
	      if (ind === 2) {
	        // if (this.checkedNames2.length < 4) {
	        //   let self = this
	        //   self.checkedNames2 = []
	        //   for (let i = 0; i < 4; i++) {
	        //     self.checkedNames2.push(self.options[i].text)
	        //   }
	        // }
	        this.checkedNames2 = this.checkedNames2.slice(0, 4);
	        this.width2(2);
	        this.n2++;
	        this.status1 = true;
	        this.status = false;
	        this.status2 = false;
	        this.status3 = false;
	      }
	      if (ind === 3) {
	        // if (this.checkedNames2.length < 9) {
	        //   let self = this
	        //   self.checkedNames2 = []
	        //   for (let i = 0; i < 9; i++) {
	        //     self.checkedNames2.push(self.options[i].text)
	        //   }
	        // }
	        this.checkedNames2 = this.checkedNames2.slice(0, 9);
	        this.width2(3);
	        this.n3++;
	        this.status2 = true;
	        this.status1 = false;
	        this.status = false;
	        this.status3 = false;
	      }
	      if (ind === 4) {
	        // if (this.checkedNames2.length < 16) {
	        //   let self = this
	        //   self.checkedNames2 = []
	        //   for (let i = 0; i < 16; i++) {
	        //     self.checkedNames2.push(self.options[i].text)
	        //   }
	        // }
	        this.checkedNames2 = this.checkedNames2.slice(0, 16);
	        this.width2(4);
	        this.n4++;
	        this.status3 = true;
	        this.status1 = false;
	        this.status2 = false;
	        this.status = false;
	      }
	    },
	    tog: function tog(key) {
	      if (key === 1) {
	        return "background-image:url('../../../static/img/video/change2.png')";
	      }
	      if (key === 2) {
	        return "background-image:url('../../../static/img/video/change3.png')";
	      }
	      if (key === 3) {
	        return "background-image:url('../../../static/img/video/change4.png')";
	      }
	    },
	    ID: function ID(index) {
	      return 'pic' + index;
	    },
	    print: function print() {
	      console.log(this.options);
	    },
	    up: function up() {
	      this.show = !this.show;
	    },
	    change: function change(index) {
	      if (index === 1) {
	        this.checkedNames2 = this.checkedNames2.slice(0, 1);
	        this.width(1);
	      }
	      if (index === 4) {
	        this.checkedNames2 = this.checkedNames2.slice(0, 4);
	        this.width(2);
	      }
	      if (index === 9) {
	        this.checkedNames2 = this.checkedNames2.slice(0, 9);
	      }
	      if (index === 16) {
	        this.checkedNames2 = this.checkedNames2.slice(0, 16);
	        this.width(4);
	      }
	      console.log(index);
	    },
	    width2: function width2(key) {
	      if (key === 1) {
	        return "pic1";
	      }
	      if (key === 2) {
	        return "pic2";
	      }
	      if (key === 4) {
	        return "pic4";
	      }
	    },
	    width: function width(key) {
	      if (this.status) {
	        return "width:94%;height:750px;background-image:url('../../../static/img/video/bg4.png');background-size:100% 100%";
	      }
	      if (this.status1) {
	        return "width:44%;height:360px;margin:1% 2%;";
	      }
	      if (this.status2) {
	        return "width: 278px;height: 240px;margin-right: 22px;margin-bottom: 15px;padding: 30px;";
	      }
	      if (this.status3) {
	        return "width:22%;height:170px;margin:1%;";
	      }
	    },
	    ids: function ids(index) {
	      return "checkbox" + index;
	    }
	  },
	  components: {
	    'v-header': _header2.default
	  }
	};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _index = __webpack_require__(832);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = {
	  DATAANALYSIS: _index2.default
	};
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$apiUrl = apiUrl;
	    Vue.apiUrl = apiUrl;
	  }
	};

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  // 智慧农业4.0
	  Agriculture: '/productmanage/datascreen/statistics/detail?pageId=d1',
	  // 采收计划
	  GetHarvestPlanList: '/productmanage/datascreen/statistics/getHarvestPlanList',
	  // 生产数据
	  GetPlantingInfoStatistic: '/apiInterface/trace/hainanrunda/massifinfostatistic/getPlantingInfoStatistic',
	  // 大棚
	  GetMassIfInfoStatistic: '/apiInterface/trace/hainanrunda/massifinfostatistic/getMassIfInfoStatistic',
	  // 种植批次
	  GetLastestPickingBatchList: '/trace/hainanrunda/massifinfostatistic/getLastestPickingBatchList',
	  // 智慧种植
	  Smartplanting: '/productmanage/datascreen/statistics/detail?pageId=d2',
	  // 智慧追溯
	  Trace: '/code/scanstatistics/getScanStatistics?organizationId=86ff1c47b5204e88918cb89bbd739f12',
	  // 扶贫
	  Helper: '/productmanage/datascreen/statistics/detail?pageId=d4',
	  // 销售中心
	  salesDataCenter: '/productmanage/datascreen/statistics/detail?pageId=d3'
	};

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(842);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	__webpack_require__(839);
	
	var _ajax = __webpack_require__(317);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _storage = __webpack_require__(318);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _setting = __webpack_require__(834);
	
	var _setting2 = _interopRequireDefault(_setting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (Vue, settings) {
	  _setting2.default.set(settings);
	  Vue.use(_utils2.default);
	  // Vue.use(components);
	  Vue.use(_ajax2.default);
	  Vue.use(_storage2.default);
	};
	// import components from './components';
	
	// import './assets/css/components.less';

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var settingVue = null;
	exports.default = {
	  get: function get() {
	    return settingVue;
	  },
	  set: function set(settings) {
	    settingVue = settings;
	  }
	};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 创建一个time毫秒内只能运行一次的function
	 * 在间隔时间内运行返回上次的运行结果
	 * 结束频繁调用后,最后一次如果没有运行,就再运行一次
	 * //demo
	 * const func = this.$createWait(() => {
	 *    //函数体
	 * },500);
	 * func();
	 * */
	var createWaite = function createWaite(func) {
	  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var lastRunTime = 0; //上次调用的时间
	  var lastResult = void 0;
	  var isFrequentRunning = false; //标识是否处于频繁调用状态
	  var frTimeout = null; //timeout
	  var lrTimeout = null;
	  return function () {
	    var _this = this;
	
	    var args = arguments;
	    var now = Date.now();
	    isFrequentRunning = true;
	    clearTimeout(frTimeout);
	    frTimeout = setTimeout(function () {
	      isFrequentRunning = false;
	    }, time);
	    //
	    if (now - lastRunTime > time) {
	      lastRunTime = now;
	      lastResult = func.apply(this, args);
	    } else {
	      clearTimeout(lrTimeout);
	      lrTimeout = setTimeout(function () {
	        if (!isFrequentRunning) {
	          lastRunTime = now;
	          lastResult = func.apply(_this, args);
	        }
	      }, time);
	    }
	    return lastResult;
	  };
	};
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$createWaite = createWaite;
	    Vue.createWaite = createWaite;
	  }
	};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventBus = new _vue2.default({
	  data: function data() {
	    return {};
	  }
	}); /**
	     * 用于不同组件之间发送事件
	     *
	     * a.vue
	     * methods:{
	     *  onEventTrigger(args){
	     *
	     *  }
	     * },
	     * mounted(){
	     *  //监听其它组件发来的事件
	     *  this.$eventBus.$on('eventName',this.onEventTrigger);
	     * },
	     * beforeDestroy(){
	     *  //组件销毁之前,关闭监听该事件
	     *  this.$eventBus.$off('eventName',this.onEventTrigger);
	     * }
	     * //-------------------------------
	     * b.vue
	     * this.$eventBus.$emit('eventName',args);
	     * */
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$eventBus = eventBus;
	    Vue.eventBus = eventBus;
	  }
	};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * arrayInstance.remove(val)
	 * 移除数组中的指定项
	 */
	if (typeof Array.prototype.remove != 'function') {
	  Array.prototype.remove = function (val) {
	    var index = this.indexOf(val);
	    if (index > -1) {
	      this.splice(index, 1);
	    }
	  };
	}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	var toString = Date.prototype.toString;
	/**
	 * 扩展date的toString方法，当传入format时，可返回对应格式的日期
	 * @returns {string}
	 */
	Date.prototype.toString = function (format) {
	  if (!format || typeof format !== 'string') {
	    return toString.call(this);
	  }
	  var year = this.getFullYear();
	  var month = this.getMonth() + 1;
	  var date = this.getDate();
	  var hour = this.getHours();
	  var minute = this.getMinutes();
	  var second = this.getSeconds();
	
	  year += '';
	  month = month < 10 ? '0' + month : month + '';
	  date = date < 10 ? '0' + date : date + '';
	  hour = hour < 10 ? '0' + hour : hour + '';
	  minute = minute < 10 ? '0' + minute : minute + '';
	  second = second < 10 ? '0' + second : second + '';
	
	  format = format.replace(/yyyy/g, year).replace(/yy/g, year.substr(2)).replace(/MM/g, month).replace(/dd/g, date).replace(/HH/g, hour).replace(/mm/g, minute).replace(/ss/g, second);
	  return format;
	};
	
	/**
	 * 在当前日期上加上n天，当入参为负数时，则为减去n天
	 */
	if (typeof Date.prototype.addDay != 'function') {
	  Date.prototype.addDay = function (day) {
	    if (typeof day == 'number') {
	      this.setDate(this.getDate() + day);
	    }
	    return this;
	  };
	}
	
	if (typeof Date.getRange != 'function') {
	  /**
	   * 获取两个日期之间的日期，包含起始和结束日期
	   * @param start 起始时间 （Date类型）
	   * @param end 结束时间（Date类型）
	   * @returns {Array} Date数组
	   */
	  Date.getRange = function (start, end) {
	    if (!start || !end) {
	      throw new Error('缺少必要参数start, end');
	    }
	
	    var startType = Object.prototype.toString.call(start).slice(8, -1);
	    var endType = Object.prototype.toString.call(end).slice(8, -1);
	    if (startType !== 'Date' || endType !== 'Date') {
	      throw new TypeError('start,end必须为Date类型');
	    }
	
	    start = new Date(start.getFullYear() + '/' + (start.getMonth() + 1) + '/' + start.getDate());
	    end = new Date(end.getFullYear() + '/' + (end.getMonth() + 1) + '/' + end.getDate());
	    if (start >= end) {
	      return [];
	    }
	
	    var dayTime = 24 * 60 * 60 * 1000; //一天的毫秒数
	    var subtractTime = end.getTime() - start.getTime();
	    var subtractDays = parseInt(subtractTime / dayTime) + 1;
	    var arr = [];
	    for (var i = 0; i < subtractDays; i++) {
	      arr.push(new Date(start.getTime() + i * dayTime));
	    }
	    return arr;
	  };
	}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(837);
	
	__webpack_require__(840);
	
	__webpack_require__(838);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(171);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Object.insertAfter(source, newObj)
	 * 在对象后面插入新的内容，返回添加之后的对象
	 */
	if (typeof Object.insertAfter != 'function') {
	  Object.insertAfter = function (source, obj) {
	    if (!source || !obj || (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) != 'object' || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) != 'object') {
	      return;
	    }
	    var temp = {};
	    for (var key in source) {
	      temp[key] = source[key];
	    }
	    for (var _key in obj) {
	      temp[_key] = obj[_key];
	    }
	    return temp;
	  };
	}
	
	/**
	 * Object.insertBefore(source, newObj)
	 * 在对象前面插入新的内容，返回添加之后的对象
	 */
	if (typeof Object.insertBefore != 'function') {
	  Object.insertBefore = function (source, obj) {
	    if (!source || !obj || (typeof source === 'undefined' ? 'undefined' : (0, _typeof3.default)(source)) != 'object' || (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) != 'object') {
	      return;
	    }
	    var temp = {};
	    for (var key in obj) {
	      temp[key] = obj[key];
	    }
	    for (var _key2 in source) {
	      temp[_key2] = source[_key2];
	    }
	    return temp;
	  };
	}
	/**
	 * 克隆json object
	 * */
	if (typeof Object.jsonClone != 'function') {
	  Object.jsonClone = function (jsonObject) {
	    return JSON.parse((0, _stringify2.default)(jsonObject));
	  };
	}
	/**
	 * Object.deepClone(source)
	 * 深拷贝一个对象
	 */
	if (typeof Object.deepClone != 'function') {
	  Object.deepClone = function (source) {
	    var result = void 0;
	    var objType = Object.prototype.toString.call(source).slice(8, -1);
	    if (objType == 'Object') {
	      result = {};
	    } else if (objType == 'Array') {
	      result = [];
	    } else {
	      return source;
	    }
	    for (var o in source) {
	      if (source.hasOwnProperty(o)) {
	        result[o] = Object.deepClone(source[o]);
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Object.transfer(source, target)
	 * 把source的属性赋值到target中，前提是target有此属性
	 */
	if (typeof Object.transfer != 'function') {
	  Object.transfer = function (source, target) {
	    for (var key in source) {
	      if (source.hasOwnProperty(key) && target.hasOwnProperty(key)) {
	        target[key] = source[key];
	      }
	    }
	  };
	}
	
	/**
	 * Object.sort(source, compareFn)
	 * 按compareFn对对象进行排序，返回排序之后的对象, compareFn格式与数组的比较函数相同：(keyValue1, keyValue2)=>{return 1;}
	 */
	if (typeof Object.sort != 'function') {
	  Object.sort = function (source, compareFn) {
	    if (!source || !compareFn) {
	      throw new Error('Object.sort缺少必要参数');
	    }
	    var arr = [],
	        newObject = {};
	    for (var key in source) {
	      arr.push({
	        key: key,
	        value: source[key]
	      });
	    }
	    arr.sort(compareFn).forEach(function (item) {
	      newObject[item.key] = item.value;
	    });
	    return newObject;
	  };
	}
	
	/**
	 * Object.deepMerge(target, source)
	 * 对象合并。和Object.assign不同的是，如果对象的属性也是对象（但不是数组），则也会合并，而不是覆盖。
	 */
	if (typeof Object.deepMerge != 'function') {
	  Object.deepMerge = function (target, source) {
	    if (!target || !source) {
	      return target;
	    }
	    for (var key in source) {
	      target[key] = target[key] && target[key].toString() === '[object Object]' && !Array.isArray(source[key]) ? Object.deepMerge(target[key], source[key]) : target[key] = source[key];
	    }
	    return target;
	  };
	}

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalDataVue = new _vue2.default({
	  data: function data() {
	    return {
	      saveData: []
	    };
	  },
	
	  methods: {
	    get: function get(key) {
	      var matchData = this.saveData.find(function (item) {
	        return item.key === key;
	      });
	      if (matchData) {
	        return matchData.value;
	      }
	    },
	    set: function set(key, value) {
	      var item = this.saveData.find(function (item) {
	        return item.key === key;
	      });
	      if (item) {
	        item.value = value;
	      } else {
	        this.saveData.push({ key: key, value: value });
	      }
	    }
	  }
	});
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$globalData = globalDataVue;
	    Vue.globalData = globalDataVue;
	  }
	};

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ajax = __webpack_require__(317);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _createWait = __webpack_require__(835);
	
	var _createWait2 = _interopRequireDefault(_createWait);
	
	var _eventBus = __webpack_require__(836);
	
	var _eventBus2 = _interopRequireDefault(_eventBus);
	
	var _globalData = __webpack_require__(841);
	
	var _globalData2 = _interopRequireDefault(_globalData);
	
	var _message = __webpack_require__(843);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _sleep = __webpack_require__(845);
	
	var _sleep2 = _interopRequireDefault(_sleep);
	
	var _storage = __webpack_require__(318);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _rules = __webpack_require__(844);
	
	var _rules2 = _interopRequireDefault(_rules);
	
	var _valid = __webpack_require__(846);
	
	var _valid2 = _interopRequireDefault(_valid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.use(_ajax2.default);
	    Vue.use(_createWait2.default);
	    Vue.use(_eventBus2.default);
	    Vue.use(_globalData2.default);
	    Vue.use(_message2.default);
	    Vue.use(_sleep2.default);
	    Vue.use(_storage2.default);
	    Vue.use(_rules2.default);
	    Vue.use(_valid2.default);
	  }
	};

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(141);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _messageBox = __webpack_require__(1397);
	
	var _messageBox2 = _interopRequireDefault(_messageBox);
	
	var _messageBox3 = __webpack_require__(1390);
	
	var _messageBox4 = _interopRequireDefault(_messageBox3);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _message = __webpack_require__(1398);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _base = __webpack_require__(1396);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _message3 = __webpack_require__(1391);
	
	var _message4 = _interopRequireDefault(_message3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var success = _message4.default.success,
	    warning = _message4.default.warning,
	    info = _message4.default.info,
	    error = _message4.default.error;
	
	var confirm = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '提示';
	    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'warning';
	    var result;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            result = false;
	            _context.prev = 1;
	            _context.next = 4;
	            return _messageBox4.default.confirm(text, title, {
	              confirmButtonText: '确定',
	              cancelButtonText: '取消',
	              type: type
	            });
	
	          case 4:
	            result = true;
	            _context.next = 10;
	            break;
	
	          case 7:
	            _context.prev = 7;
	            _context.t0 = _context['catch'](1);
	
	            result = false;
	
	          case 10:
	            return _context.abrupt('return', result);
	
	          case 11:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[1, 7]]);
	  }));
	
	  return function confirm() {
	    return _ref.apply(this, arguments);
	  };
	}();
	var showError = function showError(err) {
	  var errMsg = '';
	  if (typeof err === 'string') {
	    errMsg = err;
	  } else if ((typeof err === 'undefined' ? 'undefined' : (0, _typeof3.default)(err)) === 'object' && err.constructor === Error) {
	    errMsg = err.message;
	    console.error(err);
	  }
	  if (errMsg.length > 0) {
	    error(errMsg);
	  }
	};
	var message = { success: success, warning: warning, info: info, error: error, confirm: confirm, showError: showError };
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$message = message;
	    Vue.message = message;
	  }
	};

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 表单验证规则，已注入到Vue中，可通过Vue实例的.$formRules访问
	 * @module utils/rules
	 */
	var rules = exports.rules = {
	  //必填
	  required: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback(new Error('该项为必填项'));
	      }
	      if (Object.prototype.toString.call(value) === '[object Array]' && value.length === 0) {
	        return callback(new Error('该项为必填项'));
	      }
	      return callback();
	    },
	    trigger: 'change, blur'
	  },
	  //小数
	  decimal: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^[0-9]+([.]\d{1,2})?$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输数字，最多保留小数后两位'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //手机号
	  mobile: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入正确的手机号'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //固定电话
	  telephone: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /(^(0\d{2})-(\d{8})$)|(^(0\d{3})-(\d{7})$)|(^(0\d{3})-(\d{8})$)|(^(0\d{2})-(\d{8})-(\d+)$)|(^(0\d{3})-(\d{7})-(\d+)$)|(^(\d{7})$)|(^(\d{8})$)/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入正确的电话号码'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //手机号或者固定电话
	  phoneOrMobile: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg1 = /(^(0\d{2})-(\d{8})$)|(^(0\d{3})-(\d{7})$)|(^(0\d{3})-(\d{8})$)|(^(0\d{2})-(\d{8})-(\d+)$)|(^(0\d{3})-(\d{7})-(\d+)$)|(^(\d{7})$)|(^(\d{8})$)/;
	      var reg2 = /^1[3|4|5|6|7|8|9]\d{9}$/;
	      if (!reg1.test(value) && !reg2.test(value)) {
	        return callback(new Error('请输入正确的手机号或电话号码'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //最小长度
	  minLength: function minLength(length) {
	    return {
	      min: length,
	      message: '\u81F3\u5C11\u8F93\u5165' + length + '\u4E2A\u5B57\u7B26',
	      trigger: 'blur'
	    };
	  },
	  //最大长度
	  maxLength: function maxLength(length) {
	    return {
	      max: length,
	      message: '\u6700\u591A\u8F93\u5165' + length + '\u4E2A\u5B57\u7B26',
	      trigger: 'blur'
	    };
	  },
	  //整数
	  int: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^\-?\d+?$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入整数'));
	      }
	      if (value > Math.pow(2, 31) || value < -Math.pow(2, 31)) {
	        return callback(new Error('您输入的数字太大啦'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //范围内的整数
	  intRange: function intRange(min, max) {
	    return {
	      validator: function validator(rule, value, callback) {
	        if (value === '' || value === null || value === undefined) {
	          return callback();
	        }
	        var reg = /^\-?\d+?$/;
	        if (!reg.test(value)) {
	          return callback(new Error('请输入整数'));
	        }
	        if (min !== undefined && min !== null && value < min) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5927\u4E8E' + min + '\u7684\u6574\u6570'));
	        }
	        if (max !== undefined && max !== null && value > max) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5C0F\u4E8E' + max + '\u7684\u6574\u6570'));
	        }
	        if (value > Math.pow(2, 31) || value < -Math.pow(2, 31)) {
	          return callback(new Error('您输入的数字太大啦'));
	        }
	        return callback();
	      },
	      trigger: 'blur'
	    };
	  },
	  //范围内的长整型（64位）
	  longRange: function longRange(min, max) {
	    return {
	      validator: function validator(rule, value, callback) {
	        if (value === '' || value === null || value === undefined) {
	          return callback();
	        }
	        var reg = /^\-?\d+?$/;
	        if (!reg.test(value)) {
	          return callback(new Error('请输入整数'));
	        }
	        if (min !== undefined && min !== null && value < min) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5927\u4E8E' + min + '\u7684\u6574\u6570'));
	        }
	        if (max !== undefined && max !== null && value > max) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5C0F\u4E8E' + max + '\u7684\u6574\u6570'));
	        }
	        if (value > Math.pow(2, 63) || value < -Math.pow(2, 63)) {
	          return callback(new Error('您输入的数字太大啦'));
	        }
	        return callback();
	      },
	      trigger: 'blur'
	    };
	  },
	  //数字
	  number: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^\-?\d+(\.\d+)?$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入数字'));
	      }
	      if (value > Math.pow(2, 31) || value < -Math.pow(2, 31)) {
	        return callback(new Error('您输入的数字太大啦'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //范围内的数字
	  numberRange: function numberRange(min, max) {
	    return {
	      validator: function validator(rule, value, callback) {
	        if (value === '' || value === null || value === undefined) {
	          return callback();
	        }
	        var reg = /^\-?\d+(\.\d+)?$/;
	        if (!reg.test(value)) {
	          return callback(new Error('请输入数字'));
	        }
	        if (min !== undefined && min !== null && value < min) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5927\u4E8E' + min + '\u7684\u6570\u5B57'));
	        }
	        if (max !== undefined && max !== null && value > max) {
	          return callback(new Error('\u8BF7\u8F93\u5165\u5C0F\u4E8E' + max + '\u7684\u6570\u5B57'));
	        }
	        if (value > Math.pow(2, 31) || value < -Math.pow(2, 31)) {
	          return callback(new Error('您输入的数字太大啦'));
	        }
	        return callback();
	      },
	      trigger: 'blur'
	    };
	  },
	  //ip地址
	  ip: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])){3}$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入正确的IP地址'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //URL地址
	  url: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入正确的URL地址'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //防伪码
	  antifakeCode: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^(\d{20}|\d{21}|\d{22}|\d{36})$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入20位到22位或36位防伪码'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //物流码
	  logisticsCode: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /^(\d{16}|\d{17}|\d{18}|\d{32})$/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入16位到18位或32位物流码'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //身份证号
	  idCardNo: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	      if (!reg.test(value)) {
	        return callback(new Error('请输入正确的身份证号'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //指定长度
	  length: function length(_length) {
	    return {
	      validator: function validator(rule, value, callback) {
	        if (value === '' || value === null || value === undefined) {
	          return callback();
	        }
	        if (value.length != _length) {
	          return callback(new Error('\u8BF7\u8F93\u5165' + _length + '\u4F4D\u5B57\u7B26'));
	        }
	        return callback();
	      },
	      trigger: 'blur'
	    };
	  },
	  //汉字
	  chinese: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
	        return callback(new Error('\u8BF7\u8F93\u5165\u4E2D\u6587'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  },
	  //年月日时间（精确到秒）不超过当前时间
	  datepickerLimitMin: {
	    validator: function validator(rule, value, callback) {
	      if (value === '' || value === null || value === undefined) {
	        return callback();
	      }
	      var currentTime = parseInt(new Date().getTime());
	      if (parseInt(new Date(value).getTime()) > currentTime) {
	        return callback(new Error('\u9009\u62E9\u65F6\u95F4\u4E0D\u5F97\u5927\u4E8E\u63D0\u4EA4\u65F6\u95F4!'));
	      }
	      return callback();
	    },
	    trigger: 'blur'
	  }
	};
	
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$formRules = rules;
	  }
	};

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sleep = function sleep(time) {
	  return new _promise2.default(function (resolve) {
	    setTimeout(resolve, time);
	  });
	};
	exports.default = {
	  install: function install(Vue) {
	    Vue.prototype.$sleep = sleep;
	    Vue.sleep = sleep;
	  }
	};

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	/**
	 * const valid = await this.$validForm(this.$refs.form);
	 * */
	var validForm = function () {
	  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(form) {
	    var valid;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            valid = false;
	            _context.prev = 1;
	            _context.next = 4;
	            return form.validate();
	
	          case 4:
	            valid = _context.sent;
	            _context.next = 10;
	            break;
	
	          case 7:
	            _context.prev = 7;
	            _context.t0 = _context["catch"](1);
	
	            console.error(_context.t0);
	
	          case 10:
	            return _context.abrupt("return", valid);
	
	          case 11:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this, [[1, 7]]);
	  }));
	
	  return function validForm(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(vue) {
	    vue.prototype.$validForm = validForm;
	  }
	};

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(1725);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(851);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _store = __webpack_require__(852);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _model = __webpack_require__(848);
	
	var _model2 = _interopRequireDefault(_model);
	
	var _apiUrl = __webpack_require__(831);
	
	var _apiUrl2 = _interopRequireDefault(_apiUrl);
	
	var _index = __webpack_require__(833);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _vueAmap = __webpack_require__(583);
	
	var _vueAmap2 = _interopRequireDefault(_vueAmap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_model2.default);
	_vue2.default.use(_apiUrl2.default);
	_vue2.default.use(_index2.default);
	_vue2.default.use(_vueAmap2.default);
	_vueAmap2.default.initAMapApiLoader({
	  key: '12fea8c7f7f0ec1a0a851b89feaf84ea',
	  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.MouseTool'],
	  uiVersion: '1.0.11'
	});
	
	new _vue2.default({
	  router: _router2.default,
	  store: _store2.default,
	  template: '<App/>',
	  components: {
	    App: _App2.default
	  },
	  data: {
	    eventHub: new _vue2.default(),
	    charts: []
	  }
	}).$mount('#app');

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dataManagement = __webpack_require__(850);
	
	var _dataManagement2 = _interopRequireDefault(_dataManagement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import typicalmanagement from './modules/typicalmanagement/index';
	//
	var models = {
	  dataManagement: _dataManagement2.default
	};
	
	function model(modelName) {
	  return new models[modelName]();
	}
	model.install = function (Vue) {
	  Vue.prototype.$model = model;
	  Vue.model = model;
	};
	exports.default = model;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(219);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(140);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(324);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(323);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BaseModel = function (_Vue) {
	  (0, _inherits3.default)(BaseModel, _Vue);
	
	  function BaseModel() {
	    (0, _classCallCheck3.default)(this, BaseModel);
	    return (0, _possibleConstructorReturn3.default)(this, (BaseModel.__proto__ || (0, _getPrototypeOf2.default)(BaseModel)).apply(this, arguments));
	  }
	
	  return BaseModel;
	}(_vue2.default);
	
	exports.default = BaseModel;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(11);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(10);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _getPrototypeOf = __webpack_require__(219);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(140);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(172);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(324);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(323);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _base = __webpack_require__(849);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DataManagementModel = function (_BaseModel) {
	  (0, _inherits3.default)(DataManagementModel, _BaseModel);
	
	  function DataManagementModel() {
	    (0, _classCallCheck3.default)(this, DataManagementModel);
	    return (0, _possibleConstructorReturn3.default)(this, (DataManagementModel.__proto__ || (0, _getPrototypeOf2.default)(DataManagementModel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(DataManagementModel, [{
	    key: 'commonfn',
	
	    // 供应商管理方法
	    value: function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(url, data) {
	        var _ref2, err, res;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.$ajax.post(url, data);
	
	              case 2:
	                _ref2 = _context.sent;
	                err = _ref2.err;
	                res = _ref2.res;
	                return _context.abrupt('return', { err: err, res: res });
	
	              case 6:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function commonfn(_x, _x2) {
	        return _ref.apply(this, arguments);
	      }
	
	      return commonfn;
	    }()
	  }, {
	    key: 'commonfn2',
	    value: function () {
	      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(url, data) {
	        var _ref4, err, res;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _context2.next = 2;
	                return this.$ajax.get(url, data);
	
	              case 2:
	                _ref4 = _context2.sent;
	                err = _ref4.err;
	                res = _ref4.res;
	                return _context2.abrupt('return', { err: err, res: res });
	
	              case 6:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function commonfn2(_x3, _x4) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return commonfn2;
	    }()
	  }, {
	    key: 'download',
	    value: function () {
	      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(url, data) {
	        var _ref6, err, res;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _context3.next = 2;
	                return this.$ajax.download(url, data);
	
	              case 2:
	                _ref6 = _context3.sent;
	                err = _ref6.err;
	                res = _ref6.res;
	                return _context3.abrupt('return', { err: err, res: res });
	
	              case 6:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this);
	      }));
	
	      function download(_x5, _x6) {
	        return _ref5.apply(this, arguments);
	      }
	
	      return download;
	    }()
	  }]);
	  return DataManagementModel;
	}(_base2.default);
	
	exports.default = DataManagementModel;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(2116);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _dashboard = __webpack_require__(1823);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _trace = __webpack_require__(1887);
	
	var _trace2 = _interopRequireDefault(_trace);
	
	var _industryInformation = __webpack_require__(1836);
	
	var _industryInformation2 = _interopRequireDefault(_industryInformation);
	
	var _environmentMonitor = __webpack_require__(1824);
	
	var _environmentMonitor2 = _interopRequireDefault(_environmentMonitor);
	
	var _salesDataCenter = __webpack_require__(1856);
	
	var _salesDataCenter2 = _interopRequireDefault(_salesDataCenter);
	
	var _helper = __webpack_require__(1829);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _test = __webpack_require__(1863);
	
	var _test2 = _interopRequireDefault(_test);
	
	var _lujiacun = __webpack_require__(1849);
	
	var _lujiacun2 = _interopRequireDefault(_lujiacun);
	
	var _tourupin = __webpack_require__(1879);
	
	var _tourupin2 = _interopRequireDefault(_tourupin);
	
	var _yinxiao = __webpack_require__(1909);
	
	var _yinxiao2 = _interopRequireDefault(_yinxiao);
	
	var _chaye = __webpack_require__(1815);
	
	var _chaye2 = _interopRequireDefault(_chaye);
	
	var _dashboard3 = __webpack_require__(1789);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	var _base = __webpack_require__(1788);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _helpPoor = __webpack_require__(1791);
	
	var _helpPoor2 = _interopRequireDefault(_helpPoor);
	
	var _trace3 = __webpack_require__(1911);
	
	var _trace4 = _interopRequireDefault(_trace3);
	
	var _environmentMonitor3 = __webpack_require__(1790);
	
	var _environmentMonitor4 = _interopRequireDefault(_environmentMonitor3);
	
	var _product = __webpack_require__(1793);
	
	var _product2 = _interopRequireDefault(_product);
	
	var _industryInformation3 = __webpack_require__(1792);
	
	var _industryInformation4 = _interopRequireDefault(_industryInformation3);
	
	var _video = __webpack_require__(1912);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _recordInformation = __webpack_require__(1794);
	
	var _recordInformation2 = _interopRequireDefault(_recordInformation);
	
	var _secondMap = __webpack_require__(1910);
	
	var _secondMap2 = _interopRequireDefault(_secondMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 备案信息
	
	// 产业信息
	
	// 环境监测
	
	// 精准扶贫
	
	// 茶叶
	
	// 总屏(维度包含市，县)
	
	// 投入品
	
	// 测试
	
	// 润达扶贫
	
	
	// 润达环控中心
	
	
	// 润达数据屏智慧追溯
	_vue2.default.use(_vueRouter2.default);
	// 子屏
	
	// 视频监控
	
	// 产品展示
	
	// 溯源信息
	
	// 企业基地
	
	// 营销
	
	// 鲁家村
	
	// 润达扶贫
	
	
	// 润达销售数据中心
	
	
	// 润达数据屏智慧种植
	
	
	// 润达数据屏主屏
	
	
	var routes = [{
	  path: "/",
	  redirect: "/rundadashboard"
	}, {
	  path: "/chaye",
	  component: _chaye2.default
	}, {
	  path: "/yinxiao",
	  component: _yinxiao2.default
	}, {
	  path: "/test",
	  component: _test2.default
	}, {
	  path: "/lujiacun",
	  component: _lujiacun2.default
	}, {
	  path: "/tourupin",
	  component: _tourupin2.default
	}, {
	  path: "/rundadashboard",
	  component: _dashboard2.default
	}, {
	  path: "/rundatrace",
	  component: _trace2.default
	}, {
	  path: "/rundaindustryInformation",
	  component: _industryInformation2.default
	}, {
	  path: "/rundaenvironmentMonitor",
	  component: _environmentMonitor2.default
	}, {
	  path: "/rundasalesDataCenter",
	  component: _salesDataCenter2.default
	}, {
	  path: "/rundahelper",
	  component: _helper2.default
	}, {
	  path: "/dashboard",
	  component: _dashboard4.default
	}, {
	  path: "/base",
	  component: _base2.default
	}, {
	  path: "/helpPoor",
	  component: _helpPoor2.default
	}, {
	  path: "/trace",
	  component: _trace4.default
	}, {
	  path: "/environmentMonitor",
	  component: _environmentMonitor4.default
	}, {
	  path: "/product",
	  component: _product2.default
	}, {
	  path: "/industryInformation",
	  component: _industryInformation4.default
	}, {
	  path: "/video",
	  component: _video2.default
	}, {
	  path: "/recordInformation",
	  component: _recordInformation2.default
	}, {
	  path: "/secondMap",
	  component: _secondMap2.default
	}];
	var router = new _vueRouter2.default({
	  routes: routes,
	  linkActiveClass: "active"
	});
	
	router.afterEach(function (to, from) {
	  __webpack_require__(1724).refresh();
	});
	
	// router.push('/rundaindustryInformation');
	// router.push('/rundadashboard');
	// router.push("/rundadashboard");
	router.push("/chaye");
	
	exports.default = router;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(29);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2118);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  state: {
	    count: 0,
	    color: ['#325B69', '#698570', '#AE5548', '#6D9EA8', '#9CC2B0', '#C98769']
	  }
	});
	
	exports.default = store;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(79);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	exports.default = MapLoader;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MapLoader() {
	  // <-- 原作者这里使用的是module.exports
	  return new _promise2.default(function (resolve, reject) {
	    if (window.AMap) {
	      resolve(window.AMap);
	    } else {
	      var script = document.createElement('script');
	      script.type = 'text/javascript';
	      script.async = true;
	      script.src = 'http://webapi.amap.com/maps?v=1.4.14&callback=initAMap&key=12fea8c7f7f0ec1a0a851b89feaf84ea';
	      script.onerror = reject;
	      document.head.appendChild(script);
	    }
	    window.initAMap = function () {
	      resolve(window.AMap);
	    };
	  });
	}

/***/ }),
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1466 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1473 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1478 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1501 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1502 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1514 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1518 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1519 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1520 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1522 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1562 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1567 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1574 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1578 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1582 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1583 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1584 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1591 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1592 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1600 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1601 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1604 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1609 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1610 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1617 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 443,
		"./af.js": 443,
		"./ar": 450,
		"./ar-dz": 444,
		"./ar-dz.js": 444,
		"./ar-kw": 445,
		"./ar-kw.js": 445,
		"./ar-ly": 446,
		"./ar-ly.js": 446,
		"./ar-ma": 447,
		"./ar-ma.js": 447,
		"./ar-sa": 448,
		"./ar-sa.js": 448,
		"./ar-tn": 449,
		"./ar-tn.js": 449,
		"./ar.js": 450,
		"./az": 451,
		"./az.js": 451,
		"./be": 452,
		"./be.js": 452,
		"./bg": 453,
		"./bg.js": 453,
		"./bm": 454,
		"./bm.js": 454,
		"./bn": 455,
		"./bn.js": 455,
		"./bo": 456,
		"./bo.js": 456,
		"./br": 457,
		"./br.js": 457,
		"./bs": 458,
		"./bs.js": 458,
		"./ca": 459,
		"./ca.js": 459,
		"./cs": 460,
		"./cs.js": 460,
		"./cv": 461,
		"./cv.js": 461,
		"./cy": 462,
		"./cy.js": 462,
		"./da": 463,
		"./da.js": 463,
		"./de": 466,
		"./de-at": 464,
		"./de-at.js": 464,
		"./de-ch": 465,
		"./de-ch.js": 465,
		"./de.js": 466,
		"./dv": 467,
		"./dv.js": 467,
		"./el": 468,
		"./el.js": 468,
		"./en-SG": 469,
		"./en-SG.js": 469,
		"./en-au": 470,
		"./en-au.js": 470,
		"./en-ca": 471,
		"./en-ca.js": 471,
		"./en-gb": 472,
		"./en-gb.js": 472,
		"./en-ie": 473,
		"./en-ie.js": 473,
		"./en-il": 474,
		"./en-il.js": 474,
		"./en-nz": 475,
		"./en-nz.js": 475,
		"./eo": 476,
		"./eo.js": 476,
		"./es": 479,
		"./es-do": 477,
		"./es-do.js": 477,
		"./es-us": 478,
		"./es-us.js": 478,
		"./es.js": 479,
		"./et": 480,
		"./et.js": 480,
		"./eu": 481,
		"./eu.js": 481,
		"./fa": 482,
		"./fa.js": 482,
		"./fi": 483,
		"./fi.js": 483,
		"./fo": 484,
		"./fo.js": 484,
		"./fr": 487,
		"./fr-ca": 485,
		"./fr-ca.js": 485,
		"./fr-ch": 486,
		"./fr-ch.js": 486,
		"./fr.js": 487,
		"./fy": 488,
		"./fy.js": 488,
		"./ga": 489,
		"./ga.js": 489,
		"./gd": 490,
		"./gd.js": 490,
		"./gl": 491,
		"./gl.js": 491,
		"./gom-latn": 492,
		"./gom-latn.js": 492,
		"./gu": 493,
		"./gu.js": 493,
		"./he": 494,
		"./he.js": 494,
		"./hi": 495,
		"./hi.js": 495,
		"./hr": 496,
		"./hr.js": 496,
		"./hu": 497,
		"./hu.js": 497,
		"./hy-am": 498,
		"./hy-am.js": 498,
		"./id": 499,
		"./id.js": 499,
		"./is": 500,
		"./is.js": 500,
		"./it": 502,
		"./it-ch": 501,
		"./it-ch.js": 501,
		"./it.js": 502,
		"./ja": 503,
		"./ja.js": 503,
		"./jv": 504,
		"./jv.js": 504,
		"./ka": 505,
		"./ka.js": 505,
		"./kk": 506,
		"./kk.js": 506,
		"./km": 507,
		"./km.js": 507,
		"./kn": 508,
		"./kn.js": 508,
		"./ko": 509,
		"./ko.js": 509,
		"./ku": 510,
		"./ku.js": 510,
		"./ky": 511,
		"./ky.js": 511,
		"./lb": 512,
		"./lb.js": 512,
		"./lo": 513,
		"./lo.js": 513,
		"./lt": 514,
		"./lt.js": 514,
		"./lv": 515,
		"./lv.js": 515,
		"./me": 516,
		"./me.js": 516,
		"./mi": 517,
		"./mi.js": 517,
		"./mk": 518,
		"./mk.js": 518,
		"./ml": 519,
		"./ml.js": 519,
		"./mn": 520,
		"./mn.js": 520,
		"./mr": 521,
		"./mr.js": 521,
		"./ms": 523,
		"./ms-my": 522,
		"./ms-my.js": 522,
		"./ms.js": 523,
		"./mt": 524,
		"./mt.js": 524,
		"./my": 525,
		"./my.js": 525,
		"./nb": 526,
		"./nb.js": 526,
		"./ne": 527,
		"./ne.js": 527,
		"./nl": 529,
		"./nl-be": 528,
		"./nl-be.js": 528,
		"./nl.js": 529,
		"./nn": 530,
		"./nn.js": 530,
		"./pa-in": 531,
		"./pa-in.js": 531,
		"./pl": 532,
		"./pl.js": 532,
		"./pt": 534,
		"./pt-br": 533,
		"./pt-br.js": 533,
		"./pt.js": 534,
		"./ro": 535,
		"./ro.js": 535,
		"./ru": 536,
		"./ru.js": 536,
		"./sd": 537,
		"./sd.js": 537,
		"./se": 538,
		"./se.js": 538,
		"./si": 539,
		"./si.js": 539,
		"./sk": 540,
		"./sk.js": 540,
		"./sl": 541,
		"./sl.js": 541,
		"./sq": 542,
		"./sq.js": 542,
		"./sr": 544,
		"./sr-cyrl": 543,
		"./sr-cyrl.js": 543,
		"./sr.js": 544,
		"./ss": 545,
		"./ss.js": 545,
		"./sv": 546,
		"./sv.js": 546,
		"./sw": 547,
		"./sw.js": 547,
		"./ta": 548,
		"./ta.js": 548,
		"./te": 549,
		"./te.js": 549,
		"./tet": 550,
		"./tet.js": 550,
		"./tg": 551,
		"./tg.js": 551,
		"./th": 552,
		"./th.js": 552,
		"./tl-ph": 553,
		"./tl-ph.js": 553,
		"./tlh": 554,
		"./tlh.js": 554,
		"./tr": 555,
		"./tr.js": 555,
		"./tzl": 556,
		"./tzl.js": 556,
		"./tzm": 558,
		"./tzm-latn": 557,
		"./tzm-latn.js": 557,
		"./tzm.js": 558,
		"./ug-cn": 559,
		"./ug-cn.js": 559,
		"./uk": 560,
		"./uk.js": 560,
		"./ur": 561,
		"./ur.js": 561,
		"./uz": 563,
		"./uz-latn": 562,
		"./uz-latn.js": 562,
		"./uz.js": 563,
		"./vi": 564,
		"./vi.js": 564,
		"./x-pseudo": 565,
		"./x-pseudo.js": 565,
		"./yo": 566,
		"./yo.js": 566,
		"./zh-cn": 118,
		"./zh-cn.js": 118,
		"./zh-hk": 567,
		"./zh-hk.js": 567,
		"./zh-tw": 568,
		"./zh-tw.js": 568
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1619;


/***/ }),
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/base3.99b6dfd.jpg";

/***/ }),
/* 1626 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1627 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1628 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1629 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1630 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAmCAYAAADAzmuWAAAFiUlEQVRIS62XS28TVxTHz5332PHErwAJduKIloRAeIjgoCyipJX6AVpBNzSpU7XbFlDVRVkg0S/SBVJRY5pU0KJ21XbRTRcgIORFEmgS2zN+z8PPubeacRxMcEIevWv7N//zP497LoKDHkIQ/AgUXNoEYUCIoANxbxIqNA4cVl+KpkE7Wb6irZghHQZQZf9gQlDg71VBaEO+kiz2ZZZahvw9uakCjxcSpw8b+wNvQKXDdFtFoy+sPXSPVVSm/+hg5mrVUfhrtS+Q3Tu4AVrW0aAy747kXwgjjIj1rovJaxyHfp852SbvDdwANTUmHJ93TaiKMIKLIDIOMxkKp7+hHejB3A/++O7BjUo1JizPuSY0RRgBAJGUAWgeJ7sGU1/zvP5g5mQosTvwa0pRODbnnlBlYQQBiIAAcBmAdeLlzvPJ6yWh/MdqXyDzdvBW6Lx7QpOFESAgAgWAqwA0ixV/t3FbCuS+z5vMQuLMEX1n8JbwFctTCwogWn/E2LKAKN5OdVLqMO6ACDOLubUsDAzsUMfbeWoptcI3a1BfUI26u9RJxsE9zaaq+fWl9hJcRmZzxY3hF5hwbKamFCEQrU4lJgDFguLr0qLebnWKILJS1bFJt9DZ8npJWxkJld4ENyotoLDyrJYo21NUg9rh20qNn0WuFM/EpYCy7BpyH9V+FVvJo6V7HvV18Gvho7BsJSohjEBdad3TgBr1dOnTHF9R9LzjePyxdKWYZ/vb+3Pfcr7Mb8unupOvwFsTNbeRqA2o5SmzodSC8s6yXMg4exNzrnF1nR+mBWwEzmVu0C2le8+T87Ea+CahAh+s8lbvm3k0GFt0R+ySsuq07qmVqIAe9RxTp3mhLGsZ8YQ81zpmpPhhXAaBEXA6cCZ7SxDLU7PZ2VW0CZXKbabpCMfmPBOawo0CQYLtKQZidZW3U4t6Qvo0LxBZy3C98qw0bqTZYQAk2NFwFjj9nSBUf7LB5/8hbNore0mKXEwtuT/Xk/x79exjDJjjcdLdqU55OowoOMxYKe3oST5vmdDTrP1xtNEkFIPTwbMN4L4nT7iS2XE8/rjlupFhLwMCB0VvZJ/F+qF3c/dd7fqdKkMe4TTjScz6vzRy7EcUU+s8ILXuo2icDp5rBn7qvGak2I8BoRoY2z/W/cfU++6AcYd1UA/1FPbKz3xf6WnuQ0SBaKm1TlNw3Qo6Q4WTS64v8gn+fbu87J4FTLM46QnqU96gVrMix/ekFqXPNIW3kru9FfXkuQ9R/qJODSoLnoga50fteWD5h4FQNEn6OvW7/ne0aZouy0XD0RObkcaNFDcMBGrJ47ck741yswb4giuSjws2nLLgVgszxFIe9XZr0zxflgsq2ysveMc0hR/GJRAYB04HTqdvCWJ1o9zq13S9QSS6rWwyYaU5XLGUu0N1uNCrLLSO5f/lh2mRGIFz2Rt0S+He81Md6zu0NBNWFl2RfMyyBW0qpzmiuAPaXa9V0zyRi3nq+Npjz5Vihu1vP9uspbdTvihF8jFuE24NIcQQxdep3fWH9GnOYcZycb5TXpKGpCPGL82HUDM4MGFltpnnYMM9x9QpHsiyUWGqUMH5aq6oNh+b28KlSD7+Srk96FmS9Ab1aGt3fpIV2SdvH/Rb4YfptrL2ynMEqFaKFpyzZrM+KQW0XV5N23ruiqgxfpTUE2p1KEUUT6d+2xPa7WXa1BYUVmbdm3VuKy8CcE68HBzYy/W/bZ1LkXyCG0UEibgCwAg42RXe68Kyg+dqXBjFBRBZl5nsurCfFauZ8goaTK24P80uCqOM8yBLYRN4xYQLaw99n5RU9nRwMH0V88yfL/tb97HGboFbi3c5JZ5Iv2gZ8nfnpg+2eNfhDU8FzqCd1f/lqdCg3H7c1M8lsB83/wEQp8HkUHrgBgAAAABJRU5ErkJggg=="

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAlCAYAAABCr8kFAAAFm0lEQVRIS61WyW/UZhz9vm+8jj3jWezJQkKhySRoSELaikOBA6GknFshboCq9MCt6j/QGyqoEnThhrLAgQOVqiK1hNBDK5IGKoFE0wSSyWxZm8kkzHg8Y3u8fK6cjUBbIAGfbMl6er/lvfeDYP1xHAggdDa+t/kCgeN4wAOAGhcTKBFpxCD1PQYnTtjbxAOwbmaG9ShMwMiSO1hJXUQ0XUjMjqigo8PaDih8+35SwNjf/vdI4HOxQbkl1FXuqCVmPjMZUMAJuGWmsC2xEFFl53D698i3Hgbka1oLl9mA+YtBUdOpB8HSVkFhw19z9chBH6SHIl9ZFRRiAlZcai52e0PWbZMkp7YKClsSc/V6iezM3A2ftw0kAgQwxZmTUlOpmxPLAybJbQkUxtKL1cYT52jmnnjBxkiCHgAcG2CSw/GaJrmHDqi3Ld2bSaVerXzYOjIV1DCzf34keFaTyXcgAh53ug4GmPLiSWmP3MOFy7delSmsG55hWZGsMZepY9k4f0ZTyL0IbgLl8KQUlXvZoDpgmmYmU8iUXrRSEFx3PM1tS17bUuvNMndk8ZHwqV4iWjaYOgBTjJWQokoPG345qKsUFBsbI1SO87I2W1fOER25caFLLxMtcDNTL06K0XyvENL71RcwhY2Tk7SxQHkRTwksrTmQpEOlJfpQLi506cpTULza02RVVO7zhbV+1fCmM4WH/yofNo+P+/R8OLqc9H8cbiwPc2El4wCCKS/SB3MJoUsvrpUP16bvxUmpQe4TJK2/ZFuZ6eWUsrmnsGliXrQVz6HMPeki4zMf7diXv+qhjDEAMKUr3gMLj4NdmkK0ovXpOwCTLE5KjfIVf63WX9as9PT4zuK6omDTxNIOrNlHMsPiBdtAvK+2Mig2Kr00o/21CsofyI77uzSFbF3pqcsUu6BOSmoq9PnDWn/ZstLrTGFsNLnTsLnOqWHpnGkgERFA58XKoBgt9DK+yggABKUV6APZx0KXViBaoQcQcA2UoHHanT5frfxklriplPJnGcaS8zutEvowfVf60raQ6DIAAOicaPwm7VYuUz59FHmAV1fojsW4/7T6hGyBAK4ytQH20E4qtEu5FKxXbyB7ef5ZQBOJkAAAu6ZlAY0Jmz/UxpYuEpzxhCThXiXLfTQ3Gjxum8iP0Op/jglsNmjcrIvJX/iRNPb/gA7QONH4sa698B1iTE1dYDtyCf60rpAtjsvQ2ZBnKvRW6ZIQVm8g8jmG1qrbuNXofJV+J9JYvMoKlRk5692XiwufVBSiFUBArGud9OKUFJV7+Ej556c9HE3utB2uMzUknjN1jwhJoPsilaGaPflrtGBPF+fZtuxE4JReQq0rcnRWSsU0h1ORpnwfH648O+WNtRkSL9gW4v21+lD1nsI1SsAzhVlq31I8cLJSJlqAC4YBWFEMb7mKueILVW4+v9wri20UqYMzf4S+ZgLG49q2/HVaMObkWX/rUoI/VVGIFuDu33rPeJyMNMp9dFjrtwwj/bz7bEivMMsfDzeoD/hwqZCf5duX4r6TFZVsAWCzP1rJqma5lw7o/abJZf5Ty7t+TTNULc1jDVaxnO0vLLLvL8YDp4wyWnUbl5kDMO21EpEmpYd+iS/C9+47ZI6a5nmWqi3lPEezE4EuQyVjcDMz1kpUNcs9dFB/qcmuBD1TcGorRf5YLu47UykTsWd8kLMmq6JKLxMxbxmqOpWZ3PXCvF7LFHL/3EPprK4Q70IE0HqZ2wmq1dSTnaOu22AbSe5irwQUj+PVzXIPEzIHzBI59cqpt5rLns7MXem8XUGiu200b8WrmovdzDbC/unlMLh2OYTNeFWD0s0I6m3Tu7WQdyW5dtugw+kh8RuCtwvVseLr3TYr15fhb8/Gg5+FdpcGhLA2qJqvcX298fvwjV+wb/rG/gdyNawKo21bugAAAABJRU5ErkJggg=="

/***/ }),
/* 1632 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAeCAYAAADHJYVoAAACtklEQVRIiaXWT4hVdRTA8c+7M1NWmxZJ/6gMtIVCwpUyEiSmjQRhtRDKIpxXG0FokS7648BEEOTKlS2uJmkQiGkMEc6igf5ApK+YDPonghJYEY7CaBTjtDjnwWt4r/fmvQOXH/f8+d7D7/zO+d3a2KkFPcpKHMKz+KWprMrOAUWP4BWYxvpcV/QS1At8OaZwO/bkOpX6geA3YlJsyQvYiXq+T6a9L3gNh/EgxnEg9e/itdQfrjfU+oGP44n8wBuLbG/iYNrHO2bX4bQ8iaP4Bg/jrzY+1+MzPICnqtKHvcDvwgwWsA5nO2WWvg0M4/6qdL7VuHhbhsRZvhnbuoDhPJ5L/0P1hqH/g+/CRlG8413AoCp9gn0Zt6sTfJUozjm81Au4RV4WXTteb1jVDr5XFGkHLi+FXJXmsD3j9y6Gj2KT6LyPlph18wPN2E31htFW+Ku5vtIPuEVeb+UVWCMyn8bJQchVaQYnMFpvWFNga9r247pB4CnNMbG1EFnDp/hOdOQg8rFowNECa8Uxugf34XNUuLsfclW6jDNYW2AZ5nBL2msYS4cP8Lguo7WNzGHZMOYxgtlFDsPYks8/+B4/4ZIYE0O4Um+Yxc/4sir9mLEjmK+NnVo4i1uxWvdZ0k2+wKO4iN8KcfxuwB2ioIPKuuSdLHAsldtEIQeRPcmBY4W4FC7gedEA/WY/idPJuYCjBa5iQhRhvyjgH0sEn8aLeC85E1XpanO2vJNZP4S3xGye6RE8JYbevow/kTzD6XAtM57GZtyGp7FBzPbVbaAzeBtf40iCv8WWqnStFU6c30fwPh5Lx4Pif+V3cZksx5/4QRzfMbGVI6Ltn6lKl5rAdhd0TVR8Anembk6MiFlxX67ETWn7FbtxoCr9B9bp14KYkJvzWY97RVfOi2b7Styzx6vS3+0A/wLTwK4fAKqRnAAAAABJRU5ErkJggg=="

/***/ }),
/* 1633 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAC70lEQVRIicXXsWsXZxzH8Veu6qCm4tDE6iBK0qkSOFxKl3aQdlBCxUF0SXLNr01pkGr1jzCTi4pyxMkxVeJSstihIKIH4hgRMhRMNknJ4GKH5/mZy/X3uzuD4Hf5cXff5/N+nvt9n+/zuYGpp2+1iN04hRM4jqMYjM/W8RJPsITFPLXRJDjQAB7GFXSwN957gWWsxeshjGIkXv+LW7iap1a3A57GHPbhGW7gPl6Vk/I0/GaFAxjHDMbwGpfz1O224F2Yxzms4EIE9owuuBxZYRzXcBh3MZmn3pRzkh7QBxG6gGN10JrJ3I9jF6LWg6ywqw48LxTQTZwRCmdbkafWo8bNqDnfDzxtc6W/oKncv8CRBvjbqLWAc1lhugoeFgppBRMtoIT//rempAifiNpzWWG4DL4iVO8F7V7v/ig2lRX2t4CvR+19kSURmkNH2DJtC6kTx+3BT20GxIJ7hk5W2J0IHWmvsE/bxE7Mlq5nqxVbEzci61QiVBztV3sGh0rXB3G25dgu40Qi9N4XKh2pJi72uPd7m4F56lVkHU+Ehr/cEvq1MNFqHMuKd2+uKZZxNBFOmbWG5G7UbZ9LLTXWMFjtXHVxBD/UPP8uK3zZViwR9u1Qi9xZ/2+x1Wiz6iGsJ8IhPtqQ/Cl+bCF6Pit83pAzipeJ4BxGcKAmecqm44C/8C2+wp+l+zvxaz+ReGaP4Eki2BXCId4rPhHaXRn4DR7iUZ76vjKBmaywp49Wl7GUYFGwKzM1ySsV4JbI0y0TeIzJPlozkbWYYEPwSGN6r/rvfsCaCfxRfRZdyRhu5amNbpVeFTzSNVv/S/Q3bDUT+KcCHYzaryPr3fZYxWXBI93BwPvC+kVWGIiahwXzt1oGw23BmJ3G9Q8Bj9DrUfNu2XHuqORO4jP8LGz0Cdv0XfH13onQJZWCq3aiNzhpc+XP9d9mddDxOPZ01DpZtbfVFXfh54UqnsM9NYa+BOtl6DvvY+jL8VE+YcrxwT/a/gOQWNhTxwp04wAAAABJRU5ErkJggg=="

/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAACv0lEQVRIiZXWS4gdRRTG8d/tBGJifCzcJUbBF0Hj4u5NFJ8QQcQnUUZMjxsRBUESElBUjOIrGplR0RZx44DowigqOprNrHQuBAIxoisxiUTB8ZFFHI2LOm0qPT19bz5o6pyqc/5d1X26qnubZ48bQdfh9bDvwxf1QNVvTyhGgD6MT3F+XJ/hoWFJw8Bb8QJ6eBEvR85L2NKVuHTITJ8O+wFMhP0TnsUzmMNrpzLjW/B8doOJbOw5bA97ohzYOCp4Hd6Rlr8zrqZ24NXIf7ccuHQYeCXexwp8iUfaZhN6ENM4A++VA6d3gXfiIvyI2/FPB3ged+IQ1krPvRV8NcbDvge/dkBr/YJNOI77y4Erm+ClmAx7El+1QJZhebOz6tvjRGVMloNUaTV4HBfjsMXr8zvsX2RsK36WHsl4DS5iAB7Hn4skr8F5bQNV3+94Mtxt5cCSAhsj4QjeyuJbl96hN4JxLq4vpDcLFY5lgT/gAC4chVr1HcPb4d5V4IpwPm7E7o+772nAz+rgfxjt+gKrwznQCLpJqo5VAa/Vi/bsuHJ9G+3qvI6bH8tR3JjBc12GfVKl5Cpy41DYayxUDf8g61uX3WymEV8zDhf4OpxrW8A1vMz8j3AOduOORuw10c4WTry0u412opwZ0FtlVVQOFBgLd3eBKWnDXivtEcO0ABoaC8Ycpgr8gSdicFcMduneJrQcuASvhLuj6purl75LKqmV+JwFG/dfmX3SVhqb/HTkzkhn4//PdB63SSW0Ct9gm7Thw98tM18RMbORsw83V33zOZi0t26QjvrT8BQO4k1szuLGou9gxCyTKmV91XekDuq1/LD0pAp5DBe0zDTX93gUU1XfSaA2cK0CV0l/QZfjhuj/BHulMp1pAmt1/Vf8K72U6fBrwCb81rWMelanqqOjBHXNuKm9WGLhh9Gq/wCLiKJCYCOftgAAAABJRU5ErkJggg=="

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAQCAYAAADqDXTRAAABAklEQVQ4jb3TLUtDYRQH8J9jX8Fi8qMYBF/QIJoUsdlsq7PMbLMOy5o2k0mLgiwZ9BtYRGEwBgqXa/CEcd3uy9z2T89zznnOr9y7sHyZHmLJ/PJWRxf3WJwD+I6VGl6xio8Zg5/hvNSi8Ix19GYE9rAWjtpQo4sN9KcM9rEZ+2VReMQWBlMCB9jGw3Axi/L7Ue3g65/gd+y5yzZGoXCLvXg4Kbgbe/5kHAo32EdSEUxwEO9HJg+FaxxVgJOYv8obKkKhg2OkBXNpzHWKFpZBoY2THDiNfrvMsrIoXKAxpteIfqlUQeEczUytGfXSqYrCGVpxbsW9UuoToHCKJzm/RV5+AGLlNv5C8aoKAAAAAElFTkSuQmCC"

/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADQklEQVRYhc2Yv08UQRTHP3O30lhArqMgNHZGCAXYHPFHcREqLhpjbDj8B2zvhAhEyJ3/gZUcha2giYGYiCaSmFCIGEsaQkF5oTIhuRmLncW5u53dWW758U1ebmf2vXffnR9v3jyhPt0kJZSAFf08A9SdrCb/RL72UF1QugB4SolLJRD371d+BDMogUV6It6lJ4D6ONRjIyiaa7fC+nuBz8AaUHP82BtAXj9vA/uOdmWgCBQyU7+POwm+H2rv6wG+A2O6XUlAMinKQFU/7wDjmeLeiangKdlhdII/cgHBwEHaJE1yAGvZh63kADzCd3FApmr8HgGrKZGbbiNXyT76FToAYSMYwCS5A6xb9AaACWAY6Nd9R8AesAEchtisa59jQMV7HE4OwENGRqKa/rN1oH0BjwDLwAPs4UwBm8AssGv0HwMFYMp7shs5K+Lk3UjU+1AbYB6YA7KONk1gCViE1sh77enPSEMP+xTbyL3FP3eTIIv/UYPAM3A/HjwVPcXtmCc5ORMl4ABYcDWIW4MmRvCntVvMAR9oXZNWJBnBZdzXXBSy2teki3JUmDExgL9b08ID7TMsBLUggxQ4yARSCEddFxHaZ+yXeEqKUkh/+2E/7DgySdDi8++b22aycQoPKVbaO/FTdpNgf4hOt2j1KUWe/1eGUyQNM+cGGw9PNZkJ6d9uax+lzqjNp2qyDZ1cPKSoOzjbS4mU1ef15z/2CUlyXad4A/94Sms9KO0zFq4nySF+VjLRBSkTmzjEQHAP1OCnTAW6P02a2pcTMkoKHGVXSbGUQN8mS9qXdeeaSJIsgJ/PDXL2jKaufTgjaRxU+PncASklrHHIICFGppH0Gm2FZAHJKJIN3bbZKq0zqm1M3V4k03EERePlnaj3wdVwB3+DdFysOdulKSgMjAGVvsVv1kuTaMzdjSMXoES618660a70vfoaSjKjJIRIWUmqRruiJKsW3bPIqvYZtKuN2XvlUIKWolHRaFdQonYOhaOa9h20i40X9zuKSLbSR4GLKR4FvotAIVfb6ih92MpvxygxnnDk8iixoiXvaperbdVQYjxX2wrbgJFHXcfXnBdyr79Y/8tWPLoyuPIl4EsvosfhH1Wj/9wWkxeWAAAAAElFTkSuQmCC"

/***/ }),
/* 1637 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAALFUlEQVRYR7VZf3SV1ZXd+97vvbwXJNH8IgRQwKkscdpqcdUqGAJ0Wmd1Oo6ijo7V1Wn9UX/UX2AwKchDKMGEomWKdEbXKrZMu0Zq67RjXTOdwCOAqJVScYQFjqADJIQEJdC8JO99392zvgcBEpK8OHXuv+9+5+x77rnn7H0e8THX1UtbSq1nxyhwFxOcBOICyZXDmELIxbLmaLrhXAdpDkH4QNBuWrMr8IODm2pHt30clxzu5s8vPVAcR+QiGPwF4T4PmG4H7TLgbic1+87/0NKmQ3uBgqhnvCJDV+FgJhnwYsDFBPMGHH7bhcyeN2rHHhmO75wAr1yxP+51mYutsTeJuAzAm1Swwfn2vYjNPxakj3QmE+N7AKqvQ7Eq8X6ejRaPyASpAuMFF4p2BsEpkP4QuOAFP+52bX1kXNdQQIcEGF4nqesIXkvDt+X0oqdgb2P6uY+QSLjhRODUnkTCzIrecZ5PO5GGs+X0aYH/KumXQ137IADFaXWtEzzyHkkXSm5tBG5j4zCvJRfwWUsPFPuMVIL4GoG9vrR6c82ofWffAjAAQLFqacskGfMIARMY+0zqvz94e9s/XZ7J5fjj/F6VkBfkt3/GuuBeAY7OrUjWjt7dH+RZAKfVHZrokdUiAj/tr9yyoGLPQCf7OGAG3ytOXdx8kRf1HqBgfal+c0353jP39wF4VcOhsqivapEFgfOXb64du+eTATK0lWlLD1xkjTeX0rG0x/pXHy0/3PvFKYBViX0xlxe/ncQ1UrC4qabiDzkjJ3FW3fGiwB6LOy9O43fJBgVdjbUjPwwdTE68E7nknZ3BunU3BUNDFCvrmi819BYA+PeeaPrHva/7JEDx6vrmy6yzT4B8Lvlm2a+xjkMaDXOII45MkXQ/oT8HFBWYhvAWYH8I52LwdCGlowG4oydlW19PFB8bFOiNslWXH/6qhLvoB48n54/eFgYoC3DW0mPFPjvngVCXC+pzFtEbX7DTp1R9iQaLAFxKsBNwxwCOAGAFtBHMA9w5AH0AhwD8m2RXJ+cVHRzsZsJmkE/vURkadgX1yURFOyHx6rrmq4zxHofc/I015W/mutqqupbxMHYNiKsI7Ja4RjA7DIJbQVwPIB/gQUDtAGOQzgfhC/pn68cXNtYWDNJFxOl1hy4HzRIBi5rmlW1l1fLmEvn2XkB56e7M97YmxmXzZ7D1Z99+N2/suMJbCDQIOE4XfLs7Wr4+7o6WSZmfQpgi4PdyWGx9s8OPpAssI3cC+vvsfvH+kgklL6+7aeAUujKxvygai8wB1ENPz7Cq/sClcN4SKHg6WVPRmCt60+o+OC9i8+sAfR3QFoG3lo4vbWv/oG02hH8AcNyJd5ZNKGnqBTF1WfP5Ues1QLoW4EtK+feH1zdwEMQZT7bOlPQwTDA/DOktoG5QhnObFpTvy1VWwnx1XtdKwdxI4jcmk/fNIN3do3zUGOkhgb+zefrbxodGtZ62Jc5oOPLXglsN6f0gYmZveri0ZTBf2RQCloP8OacvbVkEgum8/Ke3PlI45PWGBqsSh89BXHNIzgG4K2Dk5ow9fijmRx8DOEfAq4Ef3Nq/v1YuO1xpDNYSak7LXL9lXmnzYACzzIn2QYYdpqqudY0UNDLdsy6ZmNCdK4KAOGN5++fgtBZgmYiV8P3nZewMQyyT1BoE7uZNtaN39to6cSjOJfWwhC1p475+ZjHu7zOsyYrm3UhyFqfXtbwCg/qN88qTufKv19AXl31Y6NNfDurWEyVGOwQegTCNRIHAn2WUXu4i57R53cZ6JvU5kU8RKBKUQFdqzdDBEKc/eagKDtVhDr4qmPuaasq2545e2B3+K1qUVzLWWnzTwNwHoBCCA/ERyG5JBVk70jskwlZZCPISiOMF9zsD3La+etR7uXxV1h28jLCrOH1Zy+/9NG7b8vjod3J99MVl7xUGtuArkMKyNAk00TDpARwQ0AOgnMAlAE6CRHeY3wAiAkhgj4QfAOmXktVjDoL9Se5pBFcvbZmczdkQoHP42pk5MxDQqU+2jYyA95LuLgAXgNgnhxcJ/kjIjAS8OaS+JCAO8H1KzaJpAeSDLIZUDmEsiSjE12CxcMMfS7YjwQGJ72mAw7nihMzMWOtXHM0KEhMAbSOwoDPlvTaiQCOd75YQvC5biIHfBIF+aCxaUn46Y2MSg4gXo4vLmS8D5m6EUZa2OePNLbug6I2BivbpK65reUVgQ1PNqA2DPZKZK9rHOF9rCEwH9LYcHiydWLq1eV97fpSYD+pbcjhMok7G/1Vy7sBFeHJC0ZK8tkuMUQOJqQJ+bv34Q2e3vjMeSa4yM+UfFSnsaL9B0NMSAhhVH3+37F+2VSCoGtFeCadnSZ1L8AmXwo+SKE1Vjmi9wPP5KWcyO5Pzxh74y5XK6+xsm2wjNPqjdruYm2BpHgT5xrFUydptCabOTKuwzCCWd4NgZ50q1F0Kvj8Qi6lKNJcw7q0ScR2AxiDDb2z6TmlL2FEC2/2DUFQJ/G1GvDssvlWJj85FPLOQxA0AtgQyiwxc+HBqSeZJWp0Bn6eLeF09qZ5tiYo+4EKgJySufYBElj3cQmg2gLnJmtHhi+yzZi7ZP0bRvJcATQRMTWuqZM3OBNOhNIgY/grkuc7xno3dq14OlV54eubHbxfM/GzdE7YTKAcx8eRL3gu4VUFgkhG4jqP7Duzvr3eyrY6mAdCLJ8mCXULyqQ3zRq3vn4eVSw6Os1HvlSxtcpHZGx477y0kZGbkt10D8FlAhyR7bXJe8YHek125oqMoz++5i8D9AMYgJLLAdkg9IC6F1AWyU8CeIMJv9O3L/chClm4F9h5IsYHoVuWSI+NMxH85FIAZeX+15bGi/wnFfCyIhd8sDB0LuDlZXRaS0lMrtAt5d1P8O8ntdx5rTICQIT8HYEq2lgO7nLVfbppTvP/U4XrpFtlNG6zOEtbpdYe/AKMEpLMIa+iIga0JJxrdkdiykFCENTFqsAByD4QawvfdHQOJ7ysSRwryY+lxjEaOrn+kuLmqvm0UoF8A/EIIiCFvVPpvwod0AuAJwkqaxXJYtLGm7LXTlN90VlNQSkFDn8eSkJmW11EIdGBzz/kdYWGdkmjOL4h7dwCY7cS17C75STLBnEQjCzjf/5aEmSTpqM2RILLyPx8r6uh9HPnGmyvQeC5eH5afPqLJBHYxDZ/NLZrEKcv2FsRYMOJ4W9CxY3l5Z6422RuhqU/uPifColC7oCtlU68vLDqebXm9osnpTmeDBZuqK7afEk3h5qzszI/fTodraMwTyerSt4bLboYHbqhdYlV922fh9DiE/+g5nH5+61Mnhkp9hPsV3907Km7ioaoaKZrlTdVl7/7pznNbyAp3682h43Hr0ND4ndNs/KzRx8z61gudw6OSCwJ5399cW/Lu/18kT44+PO8BQJ61rO9PxQYdHsGYuRLoXLDKZip2JBNZffuJrezwKNL8GWPsfSG1h9z3hjU86k3mmfWHJzohHL9NhPiTLmWacgr6YcI/oTnC8ZtuA7TPZswz6xeU7R3m+O20l+w8GroexnwVwNuSfpEdYNaM+XAosjkgzuwc52BRdoBJhuL+0wB/ne7WL19NnB4W9f92WCPgWI+d7GhvIvBZSG8CSDof73Vb/1h+OjPkCDgVjYyIBV6BNZgogxkgLxfwllHwQndesPNPGgGfeZozh+iQu4I0XZLbSWqPk2l25BE6lx1yWtmoM67IgKMFN4k0kyUXB83rn/gQvX/I+/4NoUkAxgsYRZpzAZ34GwKheHJHCYTi/X2B/+e/If4XW3rHa1xn/nIAAAAASUVORK5CYII="

/***/ }),
/* 1638 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1639 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAIiElEQVRYR71Za3BV1RX+1trn3psLU1QeCQkyhODASEfFkcpDQgKprX+cTlXsdAb9RZ1RZ+xUMUwCYa4CuTXgqzNqR/nRVv8Ua52OP5zWBkJ4BCxWlIoFlUeBvHiodEKSe8/eX+ecQEhubu5Novb8OnPOPmt9e6211/rWOoJRXuX1bVOMZ6bRuhsFMgeCGaSbCtVrQFcQihPtgXNfi2g7iJMEj4jRT61vz+yqLT47GpUy0sW315+eFEdkNhR3CtztgPY48FOFHHFkq+/8C0ZMKpBnaaOeehNVXImDzlHIjYArIPR9OLzXjfTR92uvPz8S3XkBLnruVNzr1huNmvspuBXAAaHd4XzzRcSMu2hT57uaEqW9gHCwQkpl4kTMRCeNT9tLE9SzsyhmmUBuA3nQOrvNj7tPWx6f3p0LaE6AgTtF+FOB/ERUDtHxLY/2WGNq65dIJNxILNC/JpHQquiq63wxZaJyLx1vIuQvJN/O5fZhAFKWJDtmeiIPk5xFujcicDsbR+iWfMCr6k9P8iWyFIKVAhzzyVd21xQdH+oFIAtASmV92xyqPi6AWjUvX/r85KEPXp2fzqd4NO8rE/TsuHM3G2cfIeDEueeaaouPZIIcAnBJsr3ME6mmwPop/zd76kqOZtvZaMAMv5Zyx4bW2V7Ue0wI45MNu2umHhu4fhDAxZvbC6M+qykywTp/y+7a649+O0ByS1lSf3q2UW+1kBdTnjTsfXJq55Uv+gFWJo4XuFj8QRHcRdoNzTUlB787y2UCpixNts5T8eoA/LU3mvrDldN9GSClvKH1VuPM0xDZ2nSg8B28KXaQmBXbzIJ58yfHNR53fm/e9JTNZurF2O26u/cfPHAOb96fIZ+mcn7n3SQeEt+ub1pX/EFgoFBRVf3FSb50rYGA3c42DEmiK7aZO25auNiorgHdXMiY8AFkUGUOW+ee2XNo395MkEExGCfek1RR6bYNTYmScwJSypOti1W99aBbt7Nm6oFM1y7YdKwo6qJbRXgnyC8J6Q1Bsm+DeS8RBuBEGAVkIinvpTS1av/aso7M5F6RbJ8P0Y0EnmpeU9gilVtaJ9M3jwCMpXrSz7Ykpl/IVLh0w4mZENMIIu4EjyjxLwtVZ1MjAqgmSgPnqDJbyNcA9IC2qrmu9HimrkWJUxOjBZEnAPaKx5elsuH0PDhvI2hfaKopacx2MPoA6nZCRcg7m+umf5bXalkWLN7YOsODvyOgE6Bbng0gQFn2TMdykr+C2nVSkWz/OYT3MS2rm+umDtlRoOeKBUkYB/3RnrppR5Cg3h49c51xLIj52YOy1yOtSs/7qWlfIiGuMtFW6rz09rA+DGPBQF9lsq0UwBaI/Ekq6tuegkBSsXEvtDx+zRD3ZgL0rf/jlsTMf9+WaJ083rObACwEAwkYTBauPtvX5Zu1HyRKzvWHSiA0B8CQOYn5pQQVpjLZ8TvSNkqq982mxMyebK4baMErAMs3nS0Ge18XcG4udxNyGBJ7YNfaKW0jBRjkZEZjK0SkSiqSbe9C0bBzzdSm4RJzNoBBLU2ZUzNEdIo6a7KBdGos6c5G7fSTTQnxlyROlonRIAZB65btTswYVNauyqBUPNNeCYfqIAb3Evpoc03hh8NZIhvAIAYX4fS1ChY4L3sMqk86SE8Lrv8qiMGlG89MB90fQz2iP2teN+3UsDqTZ24VmJek4tdt//RTeGDP+uJPRgMwjMGI20jHhSEnyqCrV56Jyr6utK4LYvC2hw5EoiVFMwI9qdaOk7kYUnl921xVvBECdA4rd9UWHx4NwFHE4CcpSa0cmpRzJ6qrAMfo4iAG0+b4LEGkWJwzokEdGxBFToSq1oftMFa/TsG6f3xSenZIjR8G59J+Fyfb3iVkc3NN0Y7RHJKRJuq+Mhn5rQiF4h7etba0Lf+3Aw7JWNNMfiV9KxYlTt3gefL34N43/GFLzfTP830bpBkUxO4jTFV/ou6mfXG4VjDrKc6lZQVN+byThX7ajI8YzIZga7icWJW2OOpFbNeugzM6h3N3X4trHhMBw1In4L0AVjfVFJ/Il6j7S10OgAs2dRTFXO+rEL0ZZBQihX0A2QmRFOg+7tXYQ/vXFmWwmT6hYakT3QzwrctkwWwUked3rCkK6mRmwrhci0dOFr4ZwAyyENItax4GWZCfbjFO1VXi/KEpSSJ+13/a2sPc9g1c3E+3RHrE2FdCwlqR7FwIZQJkXsJK8IJAhtRsCjp9ja1sqSkcdAgWJU/d4NmRHpIw5OaL6AY6PLWzpnDfVcqvXdUB771Eu3kslH84gOWbThQL9ZUwBPOkmZDyq7eaEPVcvKGxdsL5QU2TWrNBVF4bU9M00MUDD9AKmh98/8SU4FHORL3ictPk+AtnbN2u6pIP+5um8OQEbee4+IPicJeoPt1UPeWj/2fbWdlw9hY4rgfxt97O1O9bnu8bKg3qKYKsH9d40FV9j6JbmqsLx0Tt8yXizPdh4268J8TJf43D5sYB6WdI07O8oWOWc3iSdNbSe3F37eTPvjtLXh59eN5jAD1jpGF7ddEXAzcw7PAIqquDTtE5+5JJl3wcEM7RWibX+nB4FGm9WdU8GlB70D07ouFRn1DK8obOMkcE47cyUF7vZrp5pFPRfBvp6zmC8RsfAHjcpPXl7XWFx0Y4frsqPpxHg/dA9W4Ah0j+ORxg1ky7EHTh+YAMek9KVfLMxHCAKXIPgJsAeSfVw7f3Jq4OizJl5m28gxFwQa+Z68TcL8AtIA8AaHI+vugx/sVxqXTOEfClaGR8gfUmGEUZFcsgMp/AR0q7rSdmD3+jEfDA3QwcooNugYh2k+6wCI86aqsTOS/OhUNOQxN16iYqpJhwc0R0LuniEN3/rQ/RM00++DcE5wAoJVAkotcC7PsNAekh3VcCBGzlBCFj/g3xP8IjIGvL3SYcAAAAAElFTkSuQmCC"

/***/ }),
/* 1641 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1642 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1643 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1644 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/part1-content1.07c6038.png";

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro1.74c3705.png";

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro2.b47da83.png";

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro3.6a58897.png";

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro4.0545b83.png";

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro5.3427286.png";

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro6.78cbbbd.png";

/***/ }),
/* 1652 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro6.4545aab.png";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pro7.615052a.png";

/***/ }),
/* 1655 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1656 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAeCAYAAADHJYVoAAACtklEQVRIiaXWT4hVdRTA8c+7M1NWmxZJ/6gMtIVCwpUyEiSmjQRhtRDKIpxXG0FokS7648BEEOTKlS2uJmkQiGkMEc6igf5ApK+YDPonghJYEY7CaBTjtDjnwWt4r/fmvQOXH/f8+d7D7/zO+d3a2KkFPcpKHMKz+KWprMrOAUWP4BWYxvpcV/QS1At8OaZwO/bkOpX6geA3YlJsyQvYiXq+T6a9L3gNh/EgxnEg9e/itdQfrjfU+oGP44n8wBuLbG/iYNrHO2bX4bQ8iaP4Bg/jrzY+1+MzPICnqtKHvcDvwgwWsA5nO2WWvg0M4/6qdL7VuHhbhsRZvhnbuoDhPJ5L/0P1hqH/g+/CRlG8413AoCp9gn0Zt6sTfJUozjm81Au4RV4WXTteb1jVDr5XFGkHLi+FXJXmsD3j9y6Gj2KT6LyPlph18wPN2E31htFW+Ku5vtIPuEVeb+UVWCMyn8bJQchVaQYnMFpvWFNga9r247pB4CnNMbG1EFnDp/hOdOQg8rFowNECa8Uxugf34XNUuLsfclW6jDNYW2AZ5nBL2msYS4cP8Lguo7WNzGHZMOYxgtlFDsPYks8/+B4/4ZIYE0O4Um+Yxc/4sir9mLEjmK+NnVo4i1uxWvdZ0k2+wKO4iN8KcfxuwB2ioIPKuuSdLHAsldtEIQeRPcmBY4W4FC7gedEA/WY/idPJuYCjBa5iQhRhvyjgH0sEn8aLeC85E1XpanO2vJNZP4S3xGye6RE8JYbevow/kTzD6XAtM57GZtyGp7FBzPbVbaAzeBtf40iCv8WWqnStFU6c30fwPh5Lx4Pif+V3cZksx5/4QRzfMbGVI6Ltn6lKl5rAdhd0TVR8Anembk6MiFlxX67ETWn7FbtxoCr9B9bp14KYkJvzWY97RVfOi2b7Styzx6vS3+0A/wLTwK4fAKqRnAAAAABJRU5ErkJggg=="

/***/ }),
/* 1657 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAC70lEQVRIicXXsWsXZxzH8Veu6qCm4tDE6iBK0qkSOFxKl3aQdlBCxUF0SXLNr01pkGr1jzCTi4pyxMkxVeJSstihIKIH4hgRMhRMNknJ4GKH5/mZy/X3uzuD4Hf5cXff5/N+nvt9n+/zuYGpp2+1iN04hRM4jqMYjM/W8RJPsITFPLXRJDjQAB7GFXSwN957gWWsxeshjGIkXv+LW7iap1a3A57GHPbhGW7gPl6Vk/I0/GaFAxjHDMbwGpfz1O224F2Yxzms4EIE9owuuBxZYRzXcBh3MZmn3pRzkh7QBxG6gGN10JrJ3I9jF6LWg6ywqw48LxTQTZwRCmdbkafWo8bNqDnfDzxtc6W/oKncv8CRBvjbqLWAc1lhugoeFgppBRMtoIT//rempAifiNpzWWG4DL4iVO8F7V7v/ig2lRX2t4CvR+19kSURmkNH2DJtC6kTx+3BT20GxIJ7hk5W2J0IHWmvsE/bxE7Mlq5nqxVbEzci61QiVBztV3sGh0rXB3G25dgu40Qi9N4XKh2pJi72uPd7m4F56lVkHU+Ehr/cEvq1MNFqHMuKd2+uKZZxNBFOmbWG5G7UbZ9LLTXWMFjtXHVxBD/UPP8uK3zZViwR9u1Qi9xZ/2+x1Wiz6iGsJ8IhPtqQ/Cl+bCF6Pit83pAzipeJ4BxGcKAmecqm44C/8C2+wp+l+zvxaz+ReGaP4Eki2BXCId4rPhHaXRn4DR7iUZ76vjKBmaywp49Wl7GUYFGwKzM1ySsV4JbI0y0TeIzJPlozkbWYYEPwSGN6r/rvfsCaCfxRfRZdyRhu5amNbpVeFTzSNVv/S/Q3bDUT+KcCHYzaryPr3fZYxWXBI93BwPvC+kVWGIiahwXzt1oGw23BmJ3G9Q8Bj9DrUfNu2XHuqORO4jP8LGz0Cdv0XfH13onQJZWCq3aiNzhpc+XP9d9mddDxOPZ01DpZtbfVFXfh54UqnsM9NYa+BOtl6DvvY+jL8VE+YcrxwT/a/gOQWNhTxwp04wAAAABJRU5ErkJggg=="

/***/ }),
/* 1658 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAeCAYAAAAo5+5WAAACv0lEQVRIiZXWS4gdRRTG8d/tBGJifCzcJUbBF0Hj4u5NFJ8QQcQnUUZMjxsRBUESElBUjOIrGplR0RZx44DowigqOprNrHQuBAIxoisxiUTB8ZFFHI2LOm0qPT19bz5o6pyqc/5d1X26qnubZ48bQdfh9bDvwxf1QNVvTyhGgD6MT3F+XJ/hoWFJw8Bb8QJ6eBEvR85L2NKVuHTITJ8O+wFMhP0TnsUzmMNrpzLjW/B8doOJbOw5bA97ohzYOCp4Hd6Rlr8zrqZ24NXIf7ccuHQYeCXexwp8iUfaZhN6ENM4A++VA6d3gXfiIvyI2/FPB3ged+IQ1krPvRV8NcbDvge/dkBr/YJNOI77y4Erm+ClmAx7El+1QJZhebOz6tvjRGVMloNUaTV4HBfjsMXr8zvsX2RsK36WHsl4DS5iAB7Hn4skr8F5bQNV3+94Mtxt5cCSAhsj4QjeyuJbl96hN4JxLq4vpDcLFY5lgT/gAC4chVr1HcPb4d5V4IpwPm7E7o+772nAz+rgfxjt+gKrwznQCLpJqo5VAa/Vi/bsuHJ9G+3qvI6bH8tR3JjBc12GfVKl5Cpy41DYayxUDf8g61uX3WymEV8zDhf4OpxrW8A1vMz8j3AOduOORuw10c4WTry0u412opwZ0FtlVVQOFBgLd3eBKWnDXivtEcO0ABoaC8Ycpgr8gSdicFcMduneJrQcuASvhLuj6purl75LKqmV+JwFG/dfmX3SVhqb/HTkzkhn4//PdB63SSW0Ct9gm7Thw98tM18RMbORsw83V33zOZi0t26QjvrT8BQO4k1szuLGou9gxCyTKmV91XekDuq1/LD0pAp5DBe0zDTX93gUU1XfSaA2cK0CV0l/QZfjhuj/BHulMp1pAmt1/Vf8K72U6fBrwCb81rWMelanqqOjBHXNuKm9WGLhh9Gq/wCLiKJCYCOftgAAAABJRU5ErkJggg=="

/***/ }),
/* 1659 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAQCAYAAADqDXTRAAABAklEQVQ4jb3TLUtDYRQH8J9jX8Fi8qMYBF/QIJoUsdlsq7PMbLMOy5o2k0mLgiwZ9BtYRGEwBgqXa/CEcd3uy9z2T89zznnOr9y7sHyZHmLJ/PJWRxf3WJwD+I6VGl6xio8Zg5/hvNSi8Ix19GYE9rAWjtpQo4sN9KcM9rEZ+2VReMQWBlMCB9jGw3Axi/L7Ue3g65/gd+y5yzZGoXCLvXg4Kbgbe/5kHAo32EdSEUxwEO9HJg+FaxxVgJOYv8obKkKhg2OkBXNpzHWKFpZBoY2THDiNfrvMsrIoXKAxpteIfqlUQeEczUytGfXSqYrCGVpxbsW9UuoToHCKJzm/RV5+AGLlNv5C8aoKAAAAAElFTkSuQmCC"

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAADQklEQVRYhc2Yv08UQRTHP3O30lhArqMgNHZGCAXYHPFHcREqLhpjbDj8B2zvhAhEyJ3/gZUcha2giYGYiCaSmFCIGEsaQkF5oTIhuRmLncW5u53dWW758U1ebmf2vXffnR9v3jyhPt0kJZSAFf08A9SdrCb/RL72UF1QugB4SolLJRD371d+BDMogUV6It6lJ4D6ONRjIyiaa7fC+nuBz8AaUHP82BtAXj9vA/uOdmWgCBQyU7+POwm+H2rv6wG+A2O6XUlAMinKQFU/7wDjmeLeiangKdlhdII/cgHBwEHaJE1yAGvZh63kADzCd3FApmr8HgGrKZGbbiNXyT76FToAYSMYwCS5A6xb9AaACWAY6Nd9R8AesAEchtisa59jQMV7HE4OwENGRqKa/rN1oH0BjwDLwAPs4UwBm8AssGv0HwMFYMp7shs5K+Lk3UjU+1AbYB6YA7KONk1gCViE1sh77enPSEMP+xTbyL3FP3eTIIv/UYPAM3A/HjwVPcXtmCc5ORMl4ABYcDWIW4MmRvCntVvMAR9oXZNWJBnBZdzXXBSy2teki3JUmDExgL9b08ID7TMsBLUggxQ4yARSCEddFxHaZ+yXeEqKUkh/+2E/7DgySdDi8++b22aycQoPKVbaO/FTdpNgf4hOt2j1KUWe/1eGUyQNM+cGGw9PNZkJ6d9uax+lzqjNp2qyDZ1cPKSoOzjbS4mU1ef15z/2CUlyXad4A/94Sms9KO0zFq4nySF+VjLRBSkTmzjEQHAP1OCnTAW6P02a2pcTMkoKHGVXSbGUQN8mS9qXdeeaSJIsgJ/PDXL2jKaufTgjaRxU+PncASklrHHIICFGppH0Gm2FZAHJKJIN3bbZKq0zqm1M3V4k03EERePlnaj3wdVwB3+DdFysOdulKSgMjAGVvsVv1kuTaMzdjSMXoES618660a70vfoaSjKjJIRIWUmqRruiJKsW3bPIqvYZtKuN2XvlUIKWolHRaFdQonYOhaOa9h20i40X9zuKSLbSR4GLKR4FvotAIVfb6ih92MpvxygxnnDk8iixoiXvaperbdVQYjxX2wrbgJFHXcfXnBdyr79Y/8tWPLoyuPIl4EsvosfhH1Wj/9wWkxeWAAAAAElFTkSuQmCC"

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/certify01.a36b7e5.png";

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/certify02.1aa4eb2.png";

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/certify03.1baabaf.png";

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/flow-chart.2859804.png";

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic1.8772e03.png";

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic10.f7402ec.png";

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic11.8324709.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic13.5fb40cd.png";

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic14.3ebe9c1.png";

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic15.15fd231.png";

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic2.0b18570.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic3.8afd2f2.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic4.0a4cbf0.png";

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic5.37be376.png";

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic6.516be01.png";

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic7.c88e971.png";

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic8.4202e0b.png";

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic9.5d2cd31.png";

/***/ }),
/* 1679 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACZklEQVRIiaXVTWheVRAG4DdpVGKtYNqigpUGQSNBUHChWKS46MYa3OlCu7ciCGJXFRRFFEFxYVFw6aYrQRBx5w/4sxQUNy1af5rPamJsmhqh5nFxJ+TyeW/yhQ4c5t45M+87d2bOuUG2WPvxHs5gUOsM3sfsVvFbgb+IP/TLAt7GWB/GGNIjJ5IcSbIzyUKSU0k+TbKW5ECSmSR7kqwm+TjJw50oPcxzWKosf8BMh8/N+A5ruICj2ynRqQI/i72YwAs4jZ/xOiZxDX4s319wxSgEd2AR/+CJsr3ZUf+TtXcYy1jBoVEInimAAXbi6iLrkpswXtnDW8N44x1tmS69mmQlye4kV/YMwo3V9PP1vn/YoYvgr9I7Sv+aZL7DbyXJ9/W8nsDiKASfJ/k7yWSSWyrDp0q35ViSC0mmkuxKcinJZ/9D6+jBVZivmr7Tst+F1/AGDrTsx3EJ5zA1SpODdzXzfQ439PgE12pGGT7o8ukLnKopgi83Ifiwlci+7RAET9qY75c69p/GeVzEc304w4ZJ3IeDuBWfVIZ/4tGW3yHNYYSvcVvFHBwu6TDBVwW2VPoh/FRAC7gXt1dJaA7Y4fJfXwPs7iK4p0D/bRE8oLnofi/A3zR3kbLN4v5WUqv1xa92EXxRgQPcjenW3oOtkijAudb+NO7EN60v29EmmKkSrOGE7oYd0zR9Gc/2+Mxpru6LeKRN8FGrBHt6goPH8dgm++M2evbtOsE+G007uUnwqOt5zclexOxEkleS7E2ylOR0kqMd99N2ZDXJcpLrkrw8hkGS6y8TtE8GE0nOJun981+mzP8H/Z93Zq+rvTAAAAAASUVORK5CYII="

/***/ }),
/* 1680 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAACaElEQVQ4jZWVy0tVURTGfzd7DDLKbJBihPSiJtnALuTEfyBpEEFNehI1CYtAB0EFTQscJBGhWWE0aFATg6BRRJHQRKUnRWEJaUXRJTX8NTjr0O3kveqCzTp7r+/7zt5nn7UWKrMYu9W36p7Z4GcCbFH7TGw0fF+sz0m0Tj2kPgiRgtqqzg9fiPUH6sHA/6ORU68Ci4GVwBqghsS+AN3AeeAHsB/oCexJYB+wPLCfgDfACPAzpwq8AJ4CX4G3wJMYOWAncC5e+AE4BdwEpoB8jHqgCmgENhBHORNbX6tuVXepF9R3Tm/DakdcYF5dp84LHefzr71idlYLHIuRWlX6kBUttkmgt0RsObC9FLGc6AJgR2ZtCOgD6srwyooCLC167gRWkdx8BclJKoB5cxG9RHLb24DvwH2SnT8j+UMGgHZgxVxEjwB3gfXAOuAlsBcoAFdI/uFp+enWK8MXMvFBYDXQATwOPwJszghOBbcyFf0IbIzgQBHwHVBNki0NJBnXQJJdNSSfILWXwASwCfiI2qWOq1WR26qT6nF1Qv0WSdAafkT9rR4Lr3o6+ONqF2pzBE6olUEaNil1aXX6orZlsup5YL6p1cFXbUbNqY/UMXVZpF6x3VY71aESKXs4eGOhk0vLVVMArsf8cgmBrN0K/LWYN5mppx0ROKBWqDdmELyjLgy8wf+vSC9S+00up8Xks7SpvzJik+rZeHFL4PuDP23lr1VfB/CofzvBSfWi2q7Wx/rRwL0O3oztZDB2dU9tzMQbY93A/ddOSjWvJWp30ZHfqw/Dp9YTuDl307zaq34OodGY58vx/gBxUjB4BTSvVwAAAABJRU5ErkJggg=="

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABAUlEQVRIib2WQW7CMBBFn60egK4Qy+4K6iU4BifIRbhLDxD2XAKVXZeIHVlm91nY0KjNxMHFeZIVyfH8iSeeGTtJDLAENsAa+ABmcb4BDsAe+ASOpoKkvvEuqdZ46mjzR6tPvJLUPiB+o422gw62GcK/2VoOqieI37jvpBvznLBYtFHz7iD1Q98kzeJzLLUknKQl8DV0VgHXPXiJtV1WPp7zUmw8IYlKsXaSLvxkqEVuiBonDdeKfzrg5ZHFkVdj7rtvcU6ILPp21nhCVUwxT7xfGPMHTyi5Kc6EL7TGybDbj020XFae0Cx2BcR3wHGyYle8XE/ScCZpmU9v+k6Fry1X/MkH4kndDGoAAAAASUVORK5CYII="

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAYCAYAAAAYl8YPAAABb0lEQVQ4jZ2UP04CQRSHf2Cy0qAx0Wgh2HgILWy0UU/gCYSWhFtovMK2nkArghQmGDpqEpaGBi+wRPlsZpPh7S67+JLJ5P35fbuZN28qgDLsTNKDpHtJ55IOJX1Lmkh6k/QqaZZSAf6qAS/Aks22dHU1X++DjoBRAcTayOnWYAHwuSUosWHyhwnsKaMoAtpA032s6fwoo/Y5gTWA2CTfgTrr55msusv7FgMNAV2TmAJ7OSAfODW6roCBCT4WgJLVNrqBgIUJNkrCmka3qAA/kna8q7craZl1k40FkmLP/61Kmpui4xIgSTox/rwq6cME70rCbo3fF3Cd0c28a7GpmzdJcmgS296zL7wJuAJWpiACWq67gdtbpCdg5fRrgx7yPwsThg87AGZbgiKnS8EEXJKe0zyLgQtfn3XAnZKwjtXmtT4sAIVZujxYAPRyQD2XLw0TsA+MDWjs4pmaopfhFJg40MT5ufVln5q+2zfW/gG6lTsf/UGVPwAAAABJRU5ErkJggg=="

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic1.4c1018b.png";

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic2.3b84d51.png";

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic3.884be10.png";

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1690 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAFFUlEQVRYhcWZX2xTVRzHP7tpOyYdtFuYVMe2unbDUIYMMBGCgqKZ/BWMMZI4DL5qeFFMFjEhRh6UB8X3ZRmJiREkJmMj0YWhzESHMEaJso6VjmWbw9Hqitva0Ppwbrtzb7f1tuvmN1mW7+/ec86nPeeee36/5sXjcbJUEVABlAElgA3IV69NASFgFBgA7gD3sxkkL0PAfGATsB4oznCs+8BVoItWzxQ7vTkFXAJsBHZkCDWbfgCuAJPpbjQCWA3sBgo10bB/KYNn3QSvlzMxXEI0ZCMWEVOsWKYw20IUOEaxrwvw+L4+Ct1hXb/jQAtwaz6ALwBbNZHBc2X4m7cQvu0iHlPSfToxihLHWunDWd9J6f4B3dWfgPZsAF8D1iRd8Kod78cvM+5zG4KaTYVuH55jbdhrg1L0JvBNJoCvAmuTrveUh/6m3ckpnK8UyxTOQ+epPnJDinqBM0YAtdN67b3nGL6wLSdgejnqOlh/8pIUSZlu/Rqq1sB1f7B1weAAhi9so/vos1Jkq8qQlAy4BNiVdL2nPAydf37B4BIaat1O7ymPFNmlsqQAbgSWARDsttHftGfB4RLqb9pDsNumumUqiwYwH3kT9h7fSSxiWTTAWMSC9/hOKbIDsMiASWIGz5VlvZVsaIQnT4B5ZeZtx31uBs+VSZFNMmBtMuw/vSUrOFcDPPo0OPfCipey6gL/6c2Sq00AFpF48Yf9Swn3ubKCqzoI0X+FX/MOPFafOWC4z03Yv1R1xUCRgjgyCQ2edRt+fYGYyg2N03Bd70PvV2B+BJ46KqY7E8VjCoNn5eVVYUKc54SC18sNg5UfBucrAuafAHg/hdAl8fdXJ2z6TEz3ymfg7vfQZxA2eL0C6FZdmQlx2BSaGC6ZoYlWroZpMIA/f4WeBoiOkDzjtXqgYy/UnBDrsuogrHrRGOjE8ArJlZgQJ2GhaMiW0kCvQCOs3AITQP/XMNQ8833REfjtsFiLT7wuPlCgMW33REN2ydkU1P0GgFg0/WEgOgK/vA2Xd8Hy1enX2VCzuPfyG6JtOmn333wTkDftDR7/EwM594r/vzdor2+/qPXez+Hed8b61smESHDEglIsER5OFmTVk6yCFVpvXm68rWKJSG7KhMi+BKDZFuThyPwBWz3p75lNZltIciEFkRoKFTjuZd9zjlTgGJXcqILIW4Xs6+4sNk+KbDUyw4AJkVQLle734W+OpX2b1HwJxdI06h8KvQcY80LPu3PD5SkxVh3wSZGACZFQjwHFWCsfYK3sY9xXNWdHxR7tg6B/KPQ+0SadrJV9WCsfqG4MGDOp5hqJ86CzvpOeY3MDXtyefrBs5KzvlNw1mD5udSXDpfsHKHTLX/PiyOry6XLmLpgGnEKUI4Q8x9p0+9HCSrFEWPtRmxRpV5k0OckVRDkC7LVBnIdaFg3QeahFSuTHkWZUBpxE1EqEqo/cwFE3w+OYYznqOnQJfAtSUUm/ndxCJM9C60/+iKOuY0HhUhN3TTFpttKHti5z64u1+Jt2E4vmJtNTzBGcb7XovrkZ6zPGi0f3r9i5+cn8i0dWlw/Ph20UbZxX8Sih1PLb3W/LuXN6M+HbbuKxvJmbpQ5DoctHxZs/s+pAQHcx6/JbQqsR5YjUAubdM25CPRVqAXM5sYgoWSiWScy2vylwjGKrCVC6z0dh1UwFzPPAH3N/tP+nBNyO2EpyUgKWlZsiuroJG1GmgLKKgXKM/QwRQLz8M9Z/yPm1nOTFUvIAAAAASUVORK5CYII="

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/map.c602976.png";

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/1.d1db6c0.png";

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/2.5c2fc6b.png";

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/3.4d33a2f.png";

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/4.36c9043.png";

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/5.6585095.png";

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/6.5846265.png";

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/7.881bb50.png";

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/8.3bc3878.png";

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/9.83ee0e2.png";

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lb.716550b.png";

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lb2.f0a1d0b.png";

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/lb3.384ddd9.png";

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/p1.f642400.png";

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/p2.9276367.png";

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/p3.db1ebf6.png";

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1709 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAABfUlEQVRoge3aMWrcQBiG4UdCRdqASely8Ql8ATdpswK3qnwCl6ld5gSujLuASGsIuYBPYJzOpTHYndMpxWjBmI2l2eyOdvG8naRf8I70j2DmUzHvOj0H+IrP2LNdPOAKZy03UPUXvuAC5zjC3SR6/2YfDa5rmpYfxbzrDnCNY2FUSWkjauvQDd9xWMy77hL3ON2I2QAx4lDzDZ8qYRRH61faGBf4VQoT8XZimRh+Y6/sD/5MaRJDyzOUQ4Xbys6KV8MloBsuWY16ybmWYui+seLwMaL2f3gcUxQj/rSiyJu8/o4vewPLiBFfsNa2WYiOaY+X7OzkzOKpyeKpyeKpyeKpyeKpyeKpyeKpyeKpyeKpyeKpWWWVH7UaHyJ2m3nBu3jiG9mGG7sB9Jqx4mttj5e8u1bZefEPk1pEUPeupRB+zqbViWKGh1LINpuJZWJocFXhTAhof5ogoI2hD2hPcFgJ2XgjJLbnQo54a0uSuL6nZ4LjiRCJ3xS7+hPCX459QaCPSFIMAAAAAElFTkSuQmCC"

/***/ }),
/* 1711 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAB/0lEQVRoge3aPWsUQRzH8c8dpyjYCMFSEORIIdhI0ggiaUQE8Q60sLjGWBusxMbClOILiE2wExbbgPgG8gpiIggWKSSg+IB2azEbCOEeZlZv9xbu2wy7+1v47u3Ozs78r9XLcwWLeIobWDBbHGAL6xk70CkO3MEmNrCCz7XojeY8BtjuM8h42+rl+SK2cVe4qkrJErL98DS8wVKrl+ev8QWPp2I2gRRx6PMC5zrCVaz8f6WpsYn3baEj7tYsk8IeFtrFxp86TVLI+A3tScFZpbHinckRkE+OlKM/ZF9Ga9J5seJwNiH7L3yNCaWIfyspMpbj7/Fhd2AYKeKHvMKViNxN7OMlro8KHRG9l/EhVqKM+EVcjsidLNoLkfnTKRKNfavMxatmLl41c/Gqaax4mQHoVuR534v2Pk5E5H+kSJQR/5mY/zXuYOqc85Ay4s9xKSL3UJiEP8HyqNCRb5W1jE+xEmXEr+JaRO5R0S7jdkT+WYpEYzvnXLxq5uJVMxevmsaKlxmAHuBMRG6/aNfEDS7RM3zKiX9MzI8dxqv4VpnKMlzsAtBxYsUnruWVpewv3tjO2XjxU7VaJNAvXNtC8bNbr04SXRy0hdrmoGaZFAbY6mBdKNC+U0OBNoWiQLuKpY5QGx8IFdsNoY64a0YqccUz3RUcV4WS+E6rqX9C+At1PVZUK4CasAAAAABJRU5ErkJggg=="

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAACYklEQVRoge3aMWhTQRjA8V9C1AqiCKWTKIKUDoIOorMUxE1MRIoOceng4uIiuOggTuJuFSxuQijSpSCiY+ng4FSqQhFBEUEHUbfncK9awqXJPW2Sh/3D8cj33cH/JXf37t2lUs8yORO4jtMYNVx8xgJutViGWp44i1nMYBLvBqLXmf1oYqlBs8VcpZ5lE1jCeeGu+koroW4j9IbHOF6pZ9kjfMLVTTHrQoo4NLiDsZpwF5P/XmnTmMWzqjAQVwYsk8JrjFbzDz8HaZJCix9Q7VZxWCmteK17FZB1r1KMRiTWotKtXa/isDeh7t/wpZdKKeJfC4psSPs8HvsFYqSIrzGVl3YeYB73MBbJX8QJXFkfzEXnW6F9zxQRn8CZSPxFfj2FA5H8NmHNEWu7mipR2lllS7zflFa8yOB86M9AXM+b/DqFkUj+m7DePxnJvU+VKCK+auNZYHGD3Me8/CZ1Pb5Gka5yTXgYtZfLef5Vh/weXGiPN0K5nSpR5BsfySXa2ZFfd3fIV7C9Q25nqkRpB+eWeL8prXilnmWZ7gv3XuoUIrKszbq9SDTIiswq+3AoEl/NyzHsiuQX8/jhNgn4uLa11itFxM/hbiR+EzdwH0ci+YM4irlIbhaXUiRK28e3xPtNacWLDM63eBKJr80Kz8VXj9/xoUPbl6kSpZ3H/4uusinbcL1uALXTq/imdBP6+wY0FJRePPZWPpQ0cteqcPg5PlidJMbxuSrsdTQHLJNCEws13BIOaJ8awAFtCvkB7TSO14RHdVM4sZ0R1sYrhuQkLu/T44LjtHAkvlwp658QfgGVdoa+lwjB5AAAAABJRU5ErkJggg=="

/***/ }),
/* 1713 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAC0ElEQVRoge2aPWgUQRTHf3se+IHBD4IIAbW6pAlapQ2aRsRCb8FCi0MxtYIIgpVCSCGCgkUghQSxUFiS8kDEE5uQRtAmRAtPRETDeYhgtHAt3gxOxou7M+ayN+Afjr335s3y29s3b4d9F1XTFKUh4CpwFOint7QM1IGJBBYBymrgJDADTANjwNtC8NbWPqAGLMRQS2A2qqbpELAAnEKuakOVOMTGkg0PgZGomqb3gI/Apa6QZcgFHCCGm8CeMnIVY+uP1DXNAI9LyEJcKhjGRa+A/pIyVookcVEC3wBKWYG9qmDBy9khAKTZIX6KO/gSiLLm5QUH2OUQ+y/6nCfIBbztCfJX2XW80x3oJBdwra3AZsP+CXwBdrD6Fq+osW3W/DbQB2wyQL/rapFXPotzErmd+vNC+ZuW/wpw2vLpNHhm+SZdIYKtKv/BN1pRNU1TsutmnhgvdagqaVYdjyH1qSqXgTOG/R44hiy4PsM/pcauW/MPAQ+AQQUBcD+BGy4QPuADwEHD3qmOw0hJ1NqLlEQzVmvQ8jdcIYLN8WDBfVLlDjBn2Hovf9w63xs1drjDOc4D2w37nSuED/gwMGrYLWAeOALsNvx1NXbCmt9ALmbA8D0FXrtA+ICPAhcMu4lUjnPAfsPfRn51MxbgIlKV7EU76wIRbI4HC+6TKnVW783191v8rukgudwGrnU4xxRS57XmXSF8wF8CHwz7hzo2rDj9Gm+OP/UE2ddrfXKF8H3k24vzAPDcijurjnctf4Q88s3FeRtZtLkVbI4HC+6TKi0kPbT0U69pxX1dww+yazQXcssVItj9eLCpEiy4S4535TVc3hdAtvKCdyW/wb0joRVsqgQPvqVQCgfFirWEND8rxeI4qQIsl5Btaq1gGBfVgHoZmEAatI8ooEHrItWgHQdGykhvvIZ0bKeRPuISPdKJUzldQRjHkZb4YhTqnxB+AVoWoRA7kbZTAAAAAElFTkSuQmCC"

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic.8f5504d.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic1.b655ecf.png";

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic2.71e0fe2.png";

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic3.8ead0b0.png";

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic4.51da400.png";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic5.65fbb6a.png";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic6.e01fccd.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic7.0abe88d.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic8.535e2f4.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/pic9.a5e2ce1.png";

/***/ }),
/* 1724 */,
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1520)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(628),
	  /* template */
	  __webpack_require__(2024),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1564)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(629),
	  /* template */
	  __webpack_require__(2066),
	  /* scopeId */
	  "data-v-9f1e7220",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1471)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(630),
	  /* template */
	  __webpack_require__(1977),
	  /* scopeId */
	  "data-v-379957ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1419)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(631),
	  /* template */
	  __webpack_require__(1926),
	  /* scopeId */
	  "data-v-098ce30a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1536)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(632),
	  /* template */
	  __webpack_require__(2040),
	  /* scopeId */
	  "data-v-74555536",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1603)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(633),
	  /* template */
	  __webpack_require__(2105),
	  /* scopeId */
	  "data-v-eba38006",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1533)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(635),
	  /* template */
	  __webpack_require__(2037),
	  /* scopeId */
	  "data-v-6de21f8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1514)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(637),
	  /* template */
	  __webpack_require__(2018),
	  /* scopeId */
	  "data-v-60ca255c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1410)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(640),
	  /* template */
	  __webpack_require__(1917),
	  /* scopeId */
	  "data-v-031679ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1415)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(641),
	  /* template */
	  __webpack_require__(1922),
	  /* scopeId */
	  "data-v-07a04f04",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1426)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(642),
	  /* template */
	  __webpack_require__(1933),
	  /* scopeId */
	  "data-v-0aca34d4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1417)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(643),
	  /* template */
	  __webpack_require__(1924),
	  /* scopeId */
	  "data-v-07d324e6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1557)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(644),
	  /* template */
	  __webpack_require__(2059),
	  /* scopeId */
	  "data-v-8511e2c8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1444)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(645),
	  /* template */
	  __webpack_require__(1951),
	  /* scopeId */
	  "data-v-1cd646ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1448)
	__webpack_require__(1447)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(646),
	  /* template */
	  __webpack_require__(1954),
	  /* scopeId */
	  "data-v-1e7c05ec",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1596)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(647),
	  /* template */
	  __webpack_require__(2098),
	  /* scopeId */
	  "data-v-e53f6bbe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1445)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(648),
	  /* template */
	  __webpack_require__(1952),
	  /* scopeId */
	  "data-v-1d3ae392",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1550)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(649),
	  /* template */
	  __webpack_require__(2053),
	  /* scopeId */
	  "data-v-7be6e157",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1449)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(651),
	  /* template */
	  __webpack_require__(1955),
	  /* scopeId */
	  "data-v-1f6f9996",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1575)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(652),
	  /* template */
	  __webpack_require__(2077),
	  /* scopeId */
	  "data-v-b316c886",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1488)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(654),
	  /* template */
	  __webpack_require__(1993),
	  /* scopeId */
	  "data-v-44796fbb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1545)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(655),
	  /* template */
	  __webpack_require__(2048),
	  /* scopeId */
	  "data-v-76c74b06",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1591)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(656),
	  /* template */
	  __webpack_require__(2093),
	  /* scopeId */
	  "data-v-db6009da",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1466)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(657),
	  /* template */
	  __webpack_require__(1972),
	  /* scopeId */
	  "data-v-2ef5059a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1469)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(658),
	  /* template */
	  __webpack_require__(1975),
	  /* scopeId */
	  "data-v-345b60b6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1463)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(659),
	  /* template */
	  __webpack_require__(1969),
	  /* scopeId */
	  "data-v-2c0843a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1487)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(660),
	  /* template */
	  __webpack_require__(1992),
	  /* scopeId */
	  "data-v-43e29508",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1554)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(661),
	  /* template */
	  __webpack_require__(2056),
	  /* scopeId */
	  "data-v-7ec6b56a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1472)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(662),
	  /* template */
	  __webpack_require__(1978),
	  /* scopeId */
	  "data-v-37d518ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1578)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(663),
	  /* template */
	  __webpack_require__(2080),
	  /* scopeId */
	  "data-v-bcc02128",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1535)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(664),
	  /* template */
	  __webpack_require__(2039),
	  /* scopeId */
	  "data-v-7221b1ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1442)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(665),
	  /* template */
	  __webpack_require__(1949),
	  /* scopeId */
	  "data-v-1930828c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1414)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(666),
	  /* template */
	  __webpack_require__(1921),
	  /* scopeId */
	  "data-v-065bb5a0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1412)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(667),
	  /* template */
	  __webpack_require__(1919),
	  /* scopeId */
	  "data-v-04803821",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1586)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(668),
	  /* template */
	  __webpack_require__(2088),
	  /* scopeId */
	  "data-v-d08ff8f0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1482)
	__webpack_require__(1481)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(669),
	  /* template */
	  __webpack_require__(1987),
	  /* scopeId */
	  "data-v-3ec5fd25",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1561)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(670),
	  /* template */
	  __webpack_require__(2063),
	  /* scopeId */
	  "data-v-947dc06e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1451)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(671),
	  /* template */
	  __webpack_require__(1957),
	  /* scopeId */
	  "data-v-212c1a16",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1421)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(672),
	  /* template */
	  __webpack_require__(1928),
	  /* scopeId */
	  "data-v-09df73f1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1434)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(673),
	  /* template */
	  __webpack_require__(1941),
	  /* scopeId */
	  "data-v-120dc914",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1486)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(674),
	  /* template */
	  __webpack_require__(1991),
	  /* scopeId */
	  "data-v-4201f1f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1570)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(675),
	  /* template */
	  __webpack_require__(2072),
	  /* scopeId */
	  "data-v-ab71a794",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1601)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(676),
	  /* template */
	  __webpack_require__(2103),
	  /* scopeId */
	  "data-v-ea9dec86",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1526)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(677),
	  /* template */
	  __webpack_require__(2030),
	  /* scopeId */
	  "data-v-6a754232",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1407)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(678),
	  /* template */
	  __webpack_require__(1914),
	  /* scopeId */
	  "data-v-005ac359",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1528)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(679),
	  /* template */
	  __webpack_require__(2032),
	  /* scopeId */
	  "data-v-6ac9f368",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1468)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(680),
	  /* template */
	  __webpack_require__(1974),
	  /* scopeId */
	  "data-v-33c89d3f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1552)
	__webpack_require__(1551)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(681),
	  /* template */
	  __webpack_require__(2054),
	  /* scopeId */
	  "data-v-7cfe43be",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1409)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(682),
	  /* template */
	  __webpack_require__(1916),
	  /* scopeId */
	  "data-v-02ab8974",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1462)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(683),
	  /* template */
	  __webpack_require__(1968),
	  /* scopeId */
	  "data-v-2939c623",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1566)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(684),
	  /* template */
	  __webpack_require__(2068),
	  /* scopeId */
	  "data-v-a33449fe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1540)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(685),
	  /* template */
	  __webpack_require__(2043),
	  /* scopeId */
	  "data-v-75466b1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1519)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(686),
	  /* template */
	  __webpack_require__(2023),
	  /* scopeId */
	  "data-v-63619e6f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1531)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(687),
	  /* template */
	  __webpack_require__(2035),
	  /* scopeId */
	  "data-v-6b98a79e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1604)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(688),
	  /* template */
	  __webpack_require__(2106),
	  /* scopeId */
	  "data-v-ed93850c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1583)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(689),
	  /* template */
	  __webpack_require__(2085),
	  /* scopeId */
	  "data-v-c8498ffa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1597)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(690),
	  /* template */
	  __webpack_require__(2099),
	  /* scopeId */
	  "data-v-e5b11e88",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1553)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(691),
	  /* template */
	  __webpack_require__(2055),
	  /* scopeId */
	  "data-v-7deb1eea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1589)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(692),
	  /* template */
	  __webpack_require__(2091),
	  /* scopeId */
	  "data-v-d88697ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1610)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(693),
	  /* template */
	  __webpack_require__(2112),
	  /* scopeId */
	  "data-v-f94ad342",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1484)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(694),
	  /* template */
	  __webpack_require__(1989),
	  /* scopeId */
	  "data-v-3f289d4f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1590)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(695),
	  /* template */
	  __webpack_require__(2092),
	  /* scopeId */
	  "data-v-d9a502a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1431)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(696),
	  /* template */
	  __webpack_require__(1938),
	  /* scopeId */
	  "data-v-0e3829a0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1549)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(697),
	  /* template */
	  __webpack_require__(2052),
	  /* scopeId */
	  "data-v-7a2f16b5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1479)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(698),
	  /* template */
	  __webpack_require__(1985),
	  /* scopeId */
	  "data-v-3dfccc46",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1607)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(699),
	  /* template */
	  __webpack_require__(2109),
	  /* scopeId */
	  "data-v-f8576f2a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1525)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(700),
	  /* template */
	  __webpack_require__(2029),
	  /* scopeId */
	  "data-v-697a1fe7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1546)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(701),
	  /* template */
	  __webpack_require__(2049),
	  /* scopeId */
	  "data-v-77a9a640",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1423)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(702),
	  /* template */
	  __webpack_require__(1930),
	  /* scopeId */
	  "data-v-0a2ab2a1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1461)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(703),
	  /* template */
	  __webpack_require__(1967),
	  /* scopeId */
	  "data-v-291ee20d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1500)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(704),
	  /* template */
	  __webpack_require__(2004),
	  /* scopeId */
	  "data-v-570aefac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1473)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(705),
	  /* template */
	  __webpack_require__(1979),
	  /* scopeId */
	  "data-v-3849bd9a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1478)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(706),
	  /* template */
	  __webpack_require__(1984),
	  /* scopeId */
	  "data-v-3c00f432",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1509)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(708),
	  /* template */
	  __webpack_require__(2013),
	  /* scopeId */
	  "data-v-5e237ae4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1579)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(709),
	  /* template */
	  __webpack_require__(2081),
	  /* scopeId */
	  "data-v-c19b164e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1598)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(710),
	  /* template */
	  __webpack_require__(2100),
	  /* scopeId */
	  "data-v-e73788d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1465)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(711),
	  /* template */
	  __webpack_require__(1971),
	  /* scopeId */
	  "data-v-2e374782",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1510)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(712),
	  /* template */
	  __webpack_require__(2014),
	  /* scopeId */
	  "data-v-5e398c52",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1521)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(713),
	  /* template */
	  __webpack_require__(2025),
	  /* scopeId */
	  "data-v-65c7ec98",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1425)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(714),
	  /* template */
	  __webpack_require__(1932),
	  /* scopeId */
	  "data-v-0aa6c14e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1593)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(715),
	  /* template */
	  __webpack_require__(2095),
	  /* scopeId */
	  "data-v-e0dd5bcc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1456)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(716),
	  /* template */
	  __webpack_require__(1962),
	  /* scopeId */
	  "data-v-247604db",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1559)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(717),
	  /* template */
	  __webpack_require__(2061),
	  /* scopeId */
	  "data-v-8d4a90c8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1548)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(718),
	  /* template */
	  __webpack_require__(2051),
	  /* scopeId */
	  "data-v-79dca9bb",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1433)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(719),
	  /* template */
	  __webpack_require__(1940),
	  /* scopeId */
	  "data-v-102561e5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1446)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(720),
	  /* template */
	  __webpack_require__(1953),
	  /* scopeId */
	  "data-v-1e6f6674",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1428)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(721),
	  /* template */
	  __webpack_require__(1935),
	  /* scopeId */
	  "data-v-0bf4bc2f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1599)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(722),
	  /* template */
	  __webpack_require__(2101),
	  /* scopeId */
	  "data-v-e8cea17e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1498)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(723),
	  /* template */
	  __webpack_require__(2002),
	  /* scopeId */
	  "data-v-55146a27",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1592)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(724),
	  /* template */
	  __webpack_require__(2094),
	  /* scopeId */
	  "data-v-e059e2d8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1497)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(725),
	  /* template */
	  __webpack_require__(2001),
	  /* scopeId */
	  "data-v-549323d3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1496)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(726),
	  /* template */
	  __webpack_require__(2000),
	  /* scopeId */
	  "data-v-5372b0c7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1422)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(727),
	  /* template */
	  __webpack_require__(1929),
	  /* scopeId */
	  "data-v-0a18b7c4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1547)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(729),
	  /* template */
	  __webpack_require__(2050),
	  /* scopeId */
	  "data-v-79c70e76",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1429)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(730),
	  /* template */
	  __webpack_require__(1936),
	  /* scopeId */
	  "data-v-0cce602b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1460)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(731),
	  /* template */
	  __webpack_require__(1966),
	  /* scopeId */
	  "data-v-29146940",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1485)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(732),
	  /* template */
	  __webpack_require__(1990),
	  /* scopeId */
	  "data-v-408a167a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1556)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(733),
	  /* template */
	  __webpack_require__(2058),
	  /* scopeId */
	  "data-v-8353e68a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1454)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(734),
	  /* template */
	  __webpack_require__(1960),
	  /* scopeId */
	  "data-v-24579282",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1587)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(735),
	  /* template */
	  __webpack_require__(2089),
	  /* scopeId */
	  "data-v-d52ad3dc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1413)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(736),
	  /* template */
	  __webpack_require__(1920),
	  /* scopeId */
	  "data-v-04d6eec3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1507)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(738),
	  /* template */
	  __webpack_require__(2011),
	  /* scopeId */
	  "data-v-5cb82882",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1563)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(739),
	  /* template */
	  __webpack_require__(2065),
	  /* scopeId */
	  "data-v-9dd034fe",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1573)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(740),
	  /* template */
	  __webpack_require__(2075),
	  /* scopeId */
	  "data-v-b0e3517a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1516)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(741),
	  /* template */
	  __webpack_require__(2020),
	  /* scopeId */
	  "data-v-61516139",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1438)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(742),
	  /* template */
	  __webpack_require__(1945),
	  /* scopeId */
	  "data-v-17671ef8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1588)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(743),
	  /* template */
	  __webpack_require__(2090),
	  /* scopeId */
	  "data-v-d747cc52",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1476)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(744),
	  /* template */
	  __webpack_require__(1982),
	  /* scopeId */
	  "data-v-3ab740f7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1513)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(745),
	  /* template */
	  __webpack_require__(2017),
	  /* scopeId */
	  "data-v-60c81890",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1411)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(746),
	  /* template */
	  __webpack_require__(1918),
	  /* scopeId */
	  "data-v-03585892",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1493)
	__webpack_require__(1492)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(747),
	  /* template */
	  __webpack_require__(1997),
	  /* scopeId */
	  "data-v-4bac0caf",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1470)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(748),
	  /* template */
	  __webpack_require__(1976),
	  /* scopeId */
	  "data-v-3542d7ce",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1511)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(749),
	  /* template */
	  __webpack_require__(2015),
	  /* scopeId */
	  "data-v-5e588411",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1560)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(750),
	  /* template */
	  __webpack_require__(2062),
	  /* scopeId */
	  "data-v-8ef568d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1441)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(751),
	  /* template */
	  __webpack_require__(1948),
	  /* scopeId */
	  "data-v-1908c9ad",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1595)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(753),
	  /* template */
	  __webpack_require__(2097),
	  /* scopeId */
	  "data-v-e1cbe4ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1562)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(754),
	  /* template */
	  __webpack_require__(2064),
	  /* scopeId */
	  "data-v-9b12c158",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1435)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(755),
	  /* template */
	  __webpack_require__(1942),
	  /* scopeId */
	  "data-v-12c36a86",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1416)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(756),
	  /* template */
	  __webpack_require__(1923),
	  /* scopeId */
	  "data-v-07aef28c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1439)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(757),
	  /* template */
	  __webpack_require__(1946),
	  /* scopeId */
	  "data-v-1772f64a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1494)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(758),
	  /* template */
	  __webpack_require__(1998),
	  /* scopeId */
	  "data-v-4e506da2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1581)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(759),
	  /* template */
	  __webpack_require__(2083),
	  /* scopeId */
	  "data-v-c2ce9e58",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1555)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(760),
	  /* template */
	  __webpack_require__(2057),
	  /* scopeId */
	  "data-v-81630d68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1427)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(761),
	  /* template */
	  __webpack_require__(1934),
	  /* scopeId */
	  "data-v-0be5c48e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1518)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(762),
	  /* template */
	  __webpack_require__(2022),
	  /* scopeId */
	  "data-v-632df20e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1602)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(763),
	  /* template */
	  __webpack_require__(2104),
	  /* scopeId */
	  "data-v-eaa5e856",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1432)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(765),
	  /* template */
	  __webpack_require__(1939),
	  /* scopeId */
	  "data-v-0f6a397c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1502)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(766),
	  /* template */
	  __webpack_require__(2006),
	  /* scopeId */
	  "data-v-591c20e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1577)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(767),
	  /* template */
	  __webpack_require__(2079),
	  /* scopeId */
	  "data-v-b7c164ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1474)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(768),
	  /* template */
	  __webpack_require__(1980),
	  /* scopeId */
	  "data-v-38875dac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1437)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(769),
	  /* template */
	  __webpack_require__(1944),
	  /* scopeId */
	  "data-v-16f55bb8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1574)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(770),
	  /* template */
	  __webpack_require__(2076),
	  /* scopeId */
	  "data-v-b28c2394",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1408)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(771),
	  /* template */
	  __webpack_require__(1915),
	  /* scopeId */
	  "data-v-024f4aa7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1420)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(773),
	  /* template */
	  __webpack_require__(1927),
	  /* scopeId */
	  "data-v-098d09cc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1582)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(774),
	  /* template */
	  __webpack_require__(2084),
	  /* scopeId */
	  "data-v-c31c86e6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1594)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(775),
	  /* template */
	  __webpack_require__(2096),
	  /* scopeId */
	  "data-v-e102f94a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1517)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(776),
	  /* template */
	  __webpack_require__(2021),
	  /* scopeId */
	  "data-v-62ab061d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1453)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(777),
	  /* template */
	  __webpack_require__(1959),
	  /* scopeId */
	  "data-v-2327c9df",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1605)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(778),
	  /* template */
	  __webpack_require__(2107),
	  /* scopeId */
	  "data-v-f1b3f5c6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1522)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(779),
	  /* template */
	  __webpack_require__(2026),
	  /* scopeId */
	  "data-v-65d40dc8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1459)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(780),
	  /* template */
	  __webpack_require__(1965),
	  /* scopeId */
	  "data-v-27054aa3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1424)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(781),
	  /* template */
	  __webpack_require__(1931),
	  /* scopeId */
	  "data-v-0a6034c2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1534)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(783),
	  /* template */
	  __webpack_require__(2038),
	  /* scopeId */
	  "data-v-71a44b1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1450)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(784),
	  /* template */
	  __webpack_require__(1956),
	  /* scopeId */
	  "data-v-20d02569",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1569)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(785),
	  /* template */
	  __webpack_require__(2071),
	  /* scopeId */
	  "data-v-a85aadf0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1527)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(786),
	  /* template */
	  __webpack_require__(2031),
	  /* scopeId */
	  "data-v-6a820ccf",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1542)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(787),
	  /* template */
	  __webpack_require__(2045),
	  /* scopeId */
	  "data-v-759a636a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1606)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(788),
	  /* template */
	  __webpack_require__(2108),
	  /* scopeId */
	  "data-v-f39f2956",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1506)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(789),
	  /* template */
	  __webpack_require__(2010),
	  /* scopeId */
	  "data-v-5bfe79f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1529)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(790),
	  /* template */
	  __webpack_require__(2033),
	  /* scopeId */
	  "data-v-6ae21cc2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1543)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(791),
	  /* template */
	  __webpack_require__(2046),
	  /* scopeId */
	  "data-v-75d985e0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1504)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(792),
	  /* template */
	  __webpack_require__(2008),
	  /* scopeId */
	  "data-v-59f7efd1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1539)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(793),
	  /* template */
	  __webpack_require__(2042),
	  /* scopeId */
	  "data-v-7482d797",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1565)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(794),
	  /* template */
	  __webpack_require__(2067),
	  /* scopeId */
	  "data-v-a17d07f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1475)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(795),
	  /* template */
	  __webpack_require__(1981),
	  /* scopeId */
	  "data-v-39372f3a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1532)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(796),
	  /* template */
	  __webpack_require__(2036),
	  /* scopeId */
	  "data-v-6d7e0104",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1491)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(797),
	  /* template */
	  __webpack_require__(1996),
	  /* scopeId */
	  "data-v-4b3fa162",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1505)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(798),
	  /* template */
	  __webpack_require__(2009),
	  /* scopeId */
	  "data-v-5a1f4aa5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1406)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(800),
	  /* template */
	  __webpack_require__(1913),
	  /* scopeId */
	  "data-v-00317a14",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1490)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(801),
	  /* template */
	  __webpack_require__(1995),
	  /* scopeId */
	  "data-v-49992a5c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1495)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(802),
	  /* template */
	  __webpack_require__(1999),
	  /* scopeId */
	  "data-v-508ab70b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1576)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(803),
	  /* template */
	  __webpack_require__(2078),
	  /* scopeId */
	  "data-v-b6fa512c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1541)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(804),
	  /* template */
	  __webpack_require__(2044),
	  /* scopeId */
	  "data-v-758adc30",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1530)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(805),
	  /* template */
	  __webpack_require__(2034),
	  /* scopeId */
	  "data-v-6b4696b7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1524)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(806),
	  /* template */
	  __webpack_require__(2028),
	  /* scopeId */
	  "data-v-6935523e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1538)
	__webpack_require__(1537)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(807),
	  /* template */
	  __webpack_require__(2041),
	  /* scopeId */
	  "data-v-74562572",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1464)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(809),
	  /* template */
	  __webpack_require__(1970),
	  /* scopeId */
	  "data-v-2c6c0e23",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1512)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(810),
	  /* template */
	  __webpack_require__(2016),
	  /* scopeId */
	  "data-v-5f9a88ee",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1613)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(811),
	  /* template */
	  __webpack_require__(2115),
	  /* scopeId */
	  "data-v-ff5b683a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1572)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(812),
	  /* template */
	  __webpack_require__(2074),
	  /* scopeId */
	  "data-v-ad671f58",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1544)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(813),
	  /* template */
	  __webpack_require__(2047),
	  /* scopeId */
	  "data-v-765d6bbc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1503)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(814),
	  /* template */
	  __webpack_require__(2007),
	  /* scopeId */
	  "data-v-59b5fce3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1452)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(815),
	  /* template */
	  __webpack_require__(1958),
	  /* scopeId */
	  "data-v-22caa0b8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1609)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(816),
	  /* template */
	  __webpack_require__(2111),
	  /* scopeId */
	  "data-v-f9013b36",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1440)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(817),
	  /* template */
	  __webpack_require__(1947),
	  /* scopeId */
	  "data-v-18641526",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1567)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(818),
	  /* template */
	  __webpack_require__(2069),
	  /* scopeId */
	  "data-v-a56e7032",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1457)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(819),
	  /* template */
	  __webpack_require__(1963),
	  /* scopeId */
	  "data-v-25d437e0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1455)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(820),
	  /* template */
	  __webpack_require__(1961),
	  /* scopeId */
	  "data-v-246108f0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1611)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(821),
	  /* template */
	  __webpack_require__(2113),
	  /* scopeId */
	  "data-v-f9ad236e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1480)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(822),
	  /* template */
	  __webpack_require__(1986),
	  /* scopeId */
	  "data-v-3e7baefa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1612)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(823),
	  /* template */
	  __webpack_require__(2114),
	  /* scopeId */
	  "data-v-fef014d6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1436)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(824),
	  /* template */
	  __webpack_require__(1943),
	  /* scopeId */
	  "data-v-156ca856",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1489)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(825),
	  /* template */
	  __webpack_require__(1994),
	  /* scopeId */
	  "data-v-49027a72",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1608)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(826),
	  /* template */
	  __webpack_require__(2110),
	  /* scopeId */
	  "data-v-f87dc242",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1508)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(827),
	  /* template */
	  __webpack_require__(2012),
	  /* scopeId */
	  "data-v-5ceda828",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1499)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(828),
	  /* template */
	  __webpack_require__(2003),
	  /* scopeId */
	  "data-v-55df160c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1467)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(829),
	  /* template */
	  __webpack_require__(1973),
	  /* scopeId */
	  "data-v-2ff14d37",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1580)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(830),
	  /* template */
	  __webpack_require__(2082),
	  /* scopeId */
	  "data-v-c2913626",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 1913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("农业总产值")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("农业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("34.24 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent"
	  }, [_vm._v("5.60%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("牧业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("6.0151 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-1.82%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("1.342 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-18.83%")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("种植业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("79.2 "), _c('span', [_vm._v("万亩")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent"
	  }, [_vm._v("6.80%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("畜牧业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("30.703"), _c('span', [_vm._v("万头")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-1.12%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("15840 "), _c('span', [_vm._v("吨")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-16.58%")])])])])])
	}]}

/***/ }),
/* 1915 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "bars"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "circleBar"
	  }, _vm._l((_vm.data), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "active-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item-name-num"
	    }, [_c('span', {
	      staticClass: "item-name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.num))])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "nav"
	  }, [_c('swiper', {
	    ref: "mySwiper",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.swiperData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "nav-item"
	    }, [_c('div', {
	      staticClass: "nav-item-bg",
	      on: {
	        "click": function($event) {
	          return _vm.clickPage(index)
	        }
	      }
	    }, [_c('i'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])])
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [(_vm.tit == '年平均昼夜温差') ? _c('div', {
	    staticClass: "main main1"
	  }) : _vm._e(), _vm._v(" "), (_vm.tit == '年平均降雨量') ? _c('div', {
	    staticClass: "main main2"
	  }) : _vm._e(), _vm._v(" "), (_vm.tit == '无霜期') ? _c('div', {
	    staticClass: "main main3"
	  }) : _vm._e(), _vm._v(" "), (_vm.tit == '年平均日照时长') ? _c('div', {
	    staticClass: "main main4"
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1920 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bars"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "twoWayBar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map-wrap"
	  }, [_c('div', {
	    staticClass: "map",
	    on: {
	      "click": _vm.jumpChild
	    }
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "万元")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("农业总产值")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("农业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("176.58 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent"
	  }, [_vm._v("8.60%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("牧业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("73.77 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent"
	  }, [_vm._v("1.36%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("17.74 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-12.37%")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("种植业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("402.98 "), _c('span', [_vm._v("万亩")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent"
	  }, [_vm._v("11.73%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("畜牧业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("276.32"), _c('span', [_vm._v("万头")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-2.12%")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
	    staticClass: "num"
	  }, [_vm._v("237600 "), _c('span', [_vm._v("吨")])]), _vm._v(" "), _c('p', {
	    staticClass: "percent1"
	  }, [_vm._v("-8.79%")])])])])])
	}]}

/***/ }),
/* 1925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-amap', {
	    ref: "map",
	    staticClass: "amap-demo",
	    attrs: {
	      "vid": "amapDemo",
	      "zoom": _vm.zoom,
	      "center": _vm.center,
	      "plugin": _vm.plugin,
	      "amap-manager": _vm.amapManager,
	      "events": _vm.events
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1927 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "detail"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("企业信息介绍")]), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(576),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(577),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.address))])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": __webpack_require__(578),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.phone))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('img', {
	    staticClass: "img3",
	    attrs: {
	      "src": __webpack_require__(579),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("可追溯商品 12 种")]), _vm._v(" "), _c('div', {
	    staticClass: "trace-pro"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(300),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(300),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(300),
	      "alt": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": __webpack_require__(575),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("溯源基地 2 个")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(580),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("气象设备2台")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(581),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("监控设备14台")])])
	}]}

/***/ }),
/* 1929 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("总产值")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v(_vm._s(this.outputValue)), _c('span', [_vm._v("万元")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v(_vm._s(this.productionScale)), _c('span', [_vm._v("亩")])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tip),
	      expression: "tip"
	    }],
	    staticClass: "tip",
	    on: {
	      "mouseenter": _vm.tips,
	      "mouseleave": function($event) {
	        return _vm.leave()
	      }
	    }
	  }, _vm._l((_vm.list), function(item, index) {
	    return (index < 1) ? _c('ul', [_c('li', [_vm._v("大棚数据")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.massIfName))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), (item.hasHarvest == 1 && item.harvestQuantity > 0) ? [_c('li', [_vm._v("已采收")]), _vm._v(" "), _c('li', [_vm._v("采收质量" + _vm._s(item.harvestQuantity) + "斤")])] : (item.expectQuantity > 0) ? _c('li', [_vm._v("预计产量" + _vm._s(item.expectQuantity) + "斤")]) : (item.toHarvestDays >= 1) ? _c('li', [_vm._v("距离采收还有" + _vm._s(item.toHarvestDays) + "天")]) : _vm._e()], 2) : _vm._e()
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "leftMassif"
	  }, _vm._l((_vm.massifList), function(item, index) {
	    return _c('div', {
	      key: index,
	      class: ("theme-" + (item.theme) + "  theme-index-" + (item.index) + "  massifItem " + (item.list.length > 1 ? 'rateHalf' : '') + " "),
	      attrs: {
	        "title": item.name
	      }
	    }, [(item.list.length > 0) ? _c('div', {
	      staticClass: "content",
	      on: {
	        "click": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseenter": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseleave": function($event) {
	          return _vm.leave()
	        }
	      }
	    }, _vm._l((item.list), function(data, dataindex) {
	      return _c('div', [_c('div', {
	        key: ("" + dataindex + (data.productUrl)),
	        class: ("rate rate-" + dataindex),
	        style: (("width:" + (data.progressRate > 1 ? 100 : data.progressRate * 100) + "%"))
	      }), _vm._v(" "), (data.productUrl) ? _c('img', {
	        key: ("" + (data.productUrl)),
	        class: ("productImage product-image-" + dataindex),
	        attrs: {
	          "src": ("" + _vm.url + (data.productUrl))
	        }
	      }) : _vm._e()])
	    }), 0) : _c('div', {
	      staticClass: "empty"
	    })])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "rightMassif"
	  }, _vm._l((_vm.massifListR), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "massifItem",
	      class: ((item.list.length > 1 ? 'rateHalf' : '') + " " + (item.theme === null ? 'disabled' : '') + "  "),
	      attrs: {
	        "title": item.name
	      }
	    }, [(item.list.length > 0) ? _c('div', {
	      on: {
	        "click": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseenter": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseleave": function($event) {
	          return _vm.leave()
	        }
	      }
	    }, [_vm._l((item.list), function(data, dataindex) {
	      return [_c('div', {
	        class: ("rate rate-" + dataindex),
	        style: (("width:" + (data.progressRate > 1 ? 100 : data.progressRate * 100) + "%"))
	      }), _vm._v(" "), (data.productUrl) ? _c('img', {
	        class: ("productImage product-image-" + dataindex),
	        attrs: {
	          "src": ("" + _vm.url + (data.productUrl))
	        }
	      }) : _vm._e()]
	    })], 2) : _c('div', {
	      staticClass: "empty"
	    }, [_vm._v("可用")])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "swiper-container"
	  }, [(_vm.banner.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.banner), function(item, index) {
	    return _c('swiper-slide', {
	      key: index
	    }, [_c('img', {
	      attrs: {
	        "src": item,
	        "alt": ""
	      }
	    })])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1), _vm._v(" "), _vm._m(0)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "produce-flow"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("产品生产流程：")]), _vm._v(" "), _c('div', {
	    staticClass: "list"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1664),
	      "alt": ""
	    }
	  })])])
	}]}

/***/ }),
/* 1931 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.list[0]),
	      expression: "list[0]"
	    }],
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "tip"
	  }, [_vm._v("测试内容1")]), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.list[1]),
	      expression: "list[1]"
	    }],
	    staticClass: "item2"
	  }, [_c('div', {
	    staticClass: "tip"
	  }, [_vm._v("测试内容222")]), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.list[2]),
	      expression: "list[2]"
	    }],
	    staticClass: "item3"
	  }, [_c('div', {
	    staticClass: "tip"
	  }, [_vm._v("测试内容333")]), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })])]), _vm._v(" "), _c('v-table1'), _vm._v(" "), _c('v-table2')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1932 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "area"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map-wrap"
	  }, [_c('div', {
	    staticClass: "changeType"
	  }, [_c('div', {
	    staticClass: "nav-item",
	    on: {
	      "click": _vm.clickSatellite
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/dashboard/map-type-2.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("卫星地图")])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-item",
	    on: {
	      "click": _vm.clickNormal
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "static/img/dashboard/map-type-1.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("平面图")])])]), _vm._v(" "), _c('div', {
	    staticClass: "map"
	  }, [(!_vm.ifSatellite) ? _c('mapChart') : _c('satelliteMap')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "5px 10px",
	      "width": "470px"
	    },
	    attrs: {
	      "src": __webpack_require__(207)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("区域在售登记种类")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(299)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "type"
	  }, _vm._l((_vm.type), function(item, key, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('p', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])
	  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "title1"
	  }, [_vm._v("近30天区域店铺台账信息")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "number"
	  }, [_c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 1936 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1937 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.num))])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1939 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 1940 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1941 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "lines"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1942 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "分")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "分")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1943 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("高（剧）毒农药销售预警")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.name1))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item3",
	      class: {
	        rackA: item.number == '实名登记',
	          rackB: item.number == '未登记'
	      }
	    }, [_vm._v(_vm._s(item.number))])])
	  }), 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("经营主体")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("农药名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("实名情况")])])
	}]}

/***/ }),
/* 1944 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("客户名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("金额")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.lumpSum))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1945 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tip),
	      expression: "tip"
	    }],
	    staticClass: "tip",
	    on: {
	      "mouseenter": _vm.tips,
	      "mouseleave": function($event) {
	        return _vm.leave()
	      }
	    }
	  }, _vm._l((_vm.list), function(item, index) {
	    return (index < 1) ? _c('ul', [_c('li', [_vm._v("大棚数据")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.massIfName))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), (item.hasHarvest == 1 && item.harvestQuantity > 0) ? [_c('li', [_vm._v("已采收")]), _vm._v(" "), _c('li', [_vm._v("采收质量" + _vm._s(item.harvestQuantity) + "斤")])] : (item.expectQuantity > 0) ? _c('li', [_vm._v("预计产量" + _vm._s(item.expectQuantity) + "斤")]) : (item.toHarvestDays >= 1) ? _c('li', [_vm._v("距离采收还有" + _vm._s(item.toHarvestDays) + "天")]) : _vm._e()], 2) : _vm._e()
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "leftMassif"
	  }, _vm._l((_vm.massifList), function(item, index) {
	    return _c('div', {
	      key: index,
	      class: ("theme-" + (item.theme) + "  theme-index-" + (item.index) + "  massifItem " + (item.list.length > 1 ? 'rateHalf' : '') + " "),
	      attrs: {
	        "title": item.name
	      }
	    }, [(item.list.length > 0) ? _c('div', {
	      staticClass: "content",
	      on: {
	        "click": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseenter": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseleave": function($event) {
	          return _vm.leave()
	        }
	      }
	    }, _vm._l((item.list), function(data, dataindex) {
	      return _c('div', [_c('div', {
	        key: ("" + dataindex + (data.productUrl)),
	        class: ("rate rate-" + dataindex),
	        style: (("width:" + (data.progressRate > 1 ? 100 : data.progressRate * 100) + "%"))
	      }), _vm._v(" "), (data.productUrl) ? _c('img', {
	        key: ("" + (data.productUrl)),
	        class: ("productImage product-image-" + dataindex),
	        attrs: {
	          "src": ("" + _vm.url + (data.productUrl))
	        }
	      }) : _vm._e()])
	    }), 0) : _c('div', {
	      staticClass: "empty"
	    })])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "rightMassif"
	  }, _vm._l((_vm.massifListR), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "massifItem",
	      class: ((item.list.length > 1 ? 'rateHalf' : '') + " " + (item.theme === null ? 'disabled' : '') + "  "),
	      attrs: {
	        "title": item.name
	      }
	    }, [(item.list.length > 0) ? _c('div', {
	      on: {
	        "click": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseenter": function($event) {
	          return _vm.show(item.list, '1')
	        },
	        "mouseleave": function($event) {
	          return _vm.leave()
	        }
	      }
	    }, [_vm._l((item.list), function(data, dataindex) {
	      return [_c('div', {
	        class: ("rate rate-" + dataindex),
	        style: (("width:" + (data.progressRate > 1 ? 100 : data.progressRate * 100) + "%"))
	      }), _vm._v(" "), (data.productUrl) ? _c('img', {
	        class: ("productImage product-image-" + dataindex),
	        attrs: {
	          "src": ("" + _vm.url + (data.productUrl))
	        }
	      }) : _vm._e()]
	    })], 2) : _c('div', {
	      staticClass: "empty"
	    }, [_vm._v("可用")])])
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1946 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1947 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar3D"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1948 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('centerBottom')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("党员")]), _vm._v(" "), _c('div', {
	    staticClass: "number1"
	  }, [_vm._v("29人")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("本月党员学习")]), _vm._v(" "), _c('div', {
	    staticClass: "number2"
	  }, [_vm._v("5次")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("本月处理村务")]), _vm._v(" "), _c('div', {
	    staticClass: "number1"
	  }, [_vm._v("152项")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("本月发放补贴")]), _vm._v(" "), _c('div', {
	    staticClass: "number2"
	  }, [_vm._v("7304元")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [_c('span'), _vm._v("103户")]), _vm._v(" "), _c('div', {
	    staticClass: "dot"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container1"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [_c('span'), _vm._v("86户")]), _vm._v(" "), _c('div', {
	    staticClass: "dot"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container2"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [_c('span'), _vm._v("124户")]), _vm._v(" "), _c('div', {
	    staticClass: "dot"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container3"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [_c('span'), _vm._v("68户")]), _vm._v(" "), _c('div', {
	    staticClass: "dot"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulse1"
	  })])])
	}]}

/***/ }),
/* 1949 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "twoBars"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 1950 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 1952 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "circleBar"
	  }, [_c('div', {
	    staticClass: "main"
	  }), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "active-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item-name-num"
	    }, [_c('span', {
	      staticClass: "item-name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.num))])])])
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1953 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item name"
	    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1954 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "satelliteMap",
	    attrs: {
	      "id": _vm.id
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "flow"
	  }, [_c('div', {
	    staticClass: "main"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "custom-legend"
	  }, [_c('div', [_c('i', [_vm._v("1")]), _vm._v("广州 35252\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("2")]), _vm._v("北京 32674\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("3")]), _vm._v("上海 32234\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1956 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "base-detail",
	    style: (_vm.detailStyle),
	    attrs: {
	      "id": "detail"
	    }
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("基地详情")]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1682),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(1679),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.address))])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": __webpack_require__(1680),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.manager))])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(1681),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem.year))])])]), _vm._v(" "), _c('div', {
	    staticClass: "map-container"
	  }, [_c('el-amap', {
	    ref: "map",
	    staticClass: "map",
	    attrs: {
	      "vid": "amapDemo",
	      "zoom": _vm.zoom,
	      "center": _vm.center,
	      "plugin": _vm.plugin,
	      "amap-manager": _vm.amapManager,
	      "events": _vm.events
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("企业信息介绍")]), _vm._v(" "), _c('div', {
	    staticClass: "list1"
	  }, [_c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(576),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem1.name))])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(577),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem1.address))])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": __webpack_require__(578),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v(_vm._s(_vm.positionItem1.phone))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "top"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('span', [_vm._v("入网企业")]), _vm._v(" "), _c('span', [_vm._v("201个")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('span', [_vm._v("智能硬件设备个数")]), _vm._v(" "), _c('span', [_vm._v("40个")])]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('span', [_vm._v("追溯产品")]), _vm._v(" "), _c('span', [_vm._v("71种")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('img', {
	    staticClass: "img3",
	    attrs: {
	      "src": __webpack_require__(579),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("可追溯商品 12 种")]), _vm._v(" "), _c('div', {
	    staticClass: "trace-pro"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1686),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1687),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1688),
	      "alt": ""
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": __webpack_require__(575),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("溯源基地 2 个")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(580),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("气象设备2台")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": __webpack_require__(581),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "msg"
	  }, [_vm._v("监控设备14台")])])
	}]}

/***/ }),
/* 1958 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "area"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "twoWayBar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1960 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [(_vm.show) ? _c('v-salesData', {
	    attrs: {
	      "salesData": _vm.salesData,
	      "salesDataBar": _vm.salesDataBar
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "outputValue": _vm.outputValue,
	      "productionScale": _vm.productionScale
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-generatingData')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-harvestingPlan')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-planting')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1961 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1962 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": _vm.min,
	      "top": _vm.top
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar3D"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('ul', {
	    staticClass: "main"
	  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("经营主体入网数")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 990,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(1), _c('span', [_vm._v("待审核经营主体")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 10,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(2), _c('span', [_vm._v("经营限制农药")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(3), _c('span', [_vm._v("批发商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(4), _c('span', [_vm._v("零售商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(5), _c('span', [_vm._v("店铺交易活跃")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 800,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(293)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(294)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(295)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(296)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(297)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(298)
	    }
	  })])
	}]}

/***/ }),
/* 1964 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, _vm._l((_vm.listData), function(item, index) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "active-item"
	    }, [_c('div', {
	      staticStyle: {
	        "width": "100px"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "progress",
	      class: _vm.cla(index),
	      style: (_vm.width(item))
	    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.val))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1965 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "bottom"
	  })])
	}]}

/***/ }),
/* 1966 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item name"
	    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1967 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-line')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "positionTimes": _vm.positionTimes
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1968 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, _vm._l((_vm.listData), function(item, index) {
	    return _c('div', {
	      key: item.id,
	      staticClass: "active-item"
	    }, [_c('div', {
	      staticStyle: {
	        "width": "100px"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "progress",
	      class: _vm.cla(index),
	      style: (_vm.width(item))
	    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.val))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1969 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("广西田阳新靖田农产品贸易有限公司")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "chart"
	  }, [_c('div', [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("带动贫困户电商产品")]), _vm._v(" "), _c('v-two-bar')], 1), _vm._v(" "), _c('div', [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("带动贫困户")]), _vm._v(" "), _c('v-line')], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list"
	  }, [_c('div', {
	    staticClass: "list-item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v("510吨")]), _vm._v(" "), _c('p', {
	    staticClass: "word"
	  }, [_vm._v("带动贫困户电商产品产量")])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v("2585305")]), _vm._v(" "), _c('p', {
	    staticClass: "word"
	  }, [_vm._v("帮扶总额(元)")])]), _vm._v(" "), _c('div', {
	    staticClass: "list-item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v("184")]), _vm._v(" "), _c('p', {
	    staticClass: "word"
	  }, [_vm._v("带动贫困户数(户)")])])])
	}]}

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "30px 20px"
	    },
	    attrs: {
	      "src": __webpack_require__(208)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1971 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "万元")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1972 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.listData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.listData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "active-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item-name-num"
	    }, [_c('span', {
	      staticClass: "item-name",
	      style: (_vm.changeLength(index))
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.val))])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1973 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-line')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center')], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-trace-product')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-product')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-product-QA')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1692),
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 1975 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "bars"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1976 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": true
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "left-item left-item1"
	  }, [_vm._v("\n          " + _vm._s(_vm.baseName) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("基地负责人")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseManager))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("联系电话")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.contact))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("基地面积")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseArea))])])]), _vm._v(" "), _c('div', {
	    staticClass: "middle"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-lines')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-line', {
	    attrs: {
	      "tit": "无霜期"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-lines3')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-lines4')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('v-map', {
	    on: {
	      "indexChange": _vm.indexChange
	    }
	  })], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1977 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('div', {
	    staticClass: "part-1"
	  }, [_c('div', {
	    staticClass: "nav"
	  }, _vm._l((_vm.navItem), function(item, index) {
	    var _obj;
	
	    return _c('div', {
	      key: index,
	      class: [( _obj = {}, _obj['active'] = _vm.activeIndex == index, _obj )],
	      on: {
	        "click": function($event) {
	          return _vm.switchNav(index)
	        }
	      }
	    }, [_vm._v(_vm._s(item))])
	  }), 0), _vm._v(" "), (_vm.activeIndex === 0) ? _c('div', {
	    staticClass: "content content1"
	  }, [_vm._v("广西百色翠丰特色农产品有限责任公司主要经营：水果、食用菌、田七、农副土特产品、家禽、水产品、茶叶、预包装食品贸易等产品。\n")]) : _vm._e(), _vm._v(" "), (_vm.activeIndex === 1) ? _c('div', {
	    staticClass: "content content2"
	  }, [(_vm.banner.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.banner), function(item, index) {
	    return _c('swiper-slide', {
	      key: index
	    }, [_c('img', {
	      attrs: {
	        "src": item,
	        "alt": "",
	        "width": "152px"
	      }
	    })])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1978 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 1979 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("浙江龙井区块链溯源节点")]), _vm._v(" "), _c('ul', [(_vm.list.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.list), function(item, index) {
	    return _c('li', {
	      staticClass: "swiper-slide"
	    }, [_c('p', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.node))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("区块链编号")]), _c('span', [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("操作人")]), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (item.note.length) ? _c('p', [_c('span', [_vm._v(_vm._s(item.note))]), _c('span', [_vm._v(_vm._s(item.note1))])]) : _vm._e()])
	  }), 0) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1981 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [(_vm.show) ? _c('v-list', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_c('v-group')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "outputValue": _vm.outputValue,
	      "productionScale": _vm.productionScale
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item3"
	  }, [(_vm.show) ? _c('v-salesData') : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item4"
	  }, [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1982 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line3"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1984 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "nametop"
	  }, [_vm._v("商品流向地图")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('v-bottom')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 1985 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": !_vm.child,
	      "onBack": true
	    },
	    on: {
	      "backClick": _vm.backToDashboard
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-pie')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-table')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-bars')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-iot')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "child": _vm.child
	    },
	    on: {
	      "clickChild": _vm.clickChild
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-flow')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-circle-bar')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("区域在售登记种类")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(299)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "type"
	  }, _vm._l((_vm.type), function(item, key, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('p', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])
	  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "title1"
	  }, [_vm._v("近30天区域店铺台账信息")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "number"
	  }, [_c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 1987 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isClick),
	      expression: "isClick"
	    }],
	    staticClass: "modal"
	  }, [_c('p', [_vm._v("经度：E" + _vm._s(_vm.lng))]), _vm._v(" "), _c('p', [_vm._v("纬度：N" + _vm._s(_vm.lag))])]), _vm._v(" "), _c('div', {
	    staticClass: "map",
	    attrs: {
	      "id": _vm.id
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1988 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [(_vm.isDashboard) ? _c('div', {
	    staticClass: "left"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.time))]), _c('span', {
	    staticClass: "weekdays"
	  }, [_vm._v(_vm._s(_vm.weekdays))])]) : _c('div', {
	    staticClass: "left back",
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v("返回")]), _vm._v(" "), _c('h1', {
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
	    staticClass: "right"
	  }, [_vm._v("技术支持：甲骨文科技股份")]) : _c('div', {
	    staticClass: "right"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1693),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1694),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1695),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1696),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1697),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1698),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1699),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1700),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1701),
	      "alt": ""
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("类型")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("订单数")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("总额")])]), _vm._v(" "), _c('div', _vm._l((_vm.tableData), function(item, index) {
	    return (_vm.tableData.length > 0) ? _c('div', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.lumpSum))])]) : _vm._e()
	  }), 0)]), _vm._v(" "), (_vm.salesDataBar.length > 0) ? _c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    staticStyle: {
	      "margin-top": "20px"
	    },
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.area))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item red"
	    }, [_vm._v("红榜")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1992 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("脱贫人数")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.itemData1))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "tit"
	  }, [_vm._v("未脱贫人数")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_vm._v(_vm._s(_vm.itemData2))])]), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "detail-item"
	  }, [_vm._v("电商扶贫企业数（家）：324")]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_vm._v("电商带动贫困户数（户）：7293")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "detail-item"
	  }, [_vm._v("贫困户电商产品数（种）：19")]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_vm._v("电商扶贫增收（元/每户）：2007")])])
	}]}

/***/ }),
/* 1993 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1994 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("区域农业投入品流通销售排行榜")]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
	    return _c('div', {
	      key: item,
	      staticClass: "type",
	      class: {
	        active: index == _vm.typeindex
	      },
	      on: {
	        "click": function($event) {
	          return _vm.changeType(item, index)
	        }
	      }
	    }, [_vm._v(_vm._s(item))])
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.lumpSum))])])
	  }), 1) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("排名")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("商品名")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("数量")])])
	}]}

/***/ }),
/* 1995 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 5) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "tip"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.relationCount))])]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.relationCount / _vm.sum) * 100) + "%"))
	    })])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "tip"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.relationCount))])]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.relationCount / _vm.sum) * 100) + "%"))
	    })])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1996 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "describe"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("可追溯商品总量")]), _vm._v(" "), _c('div', {
	    staticClass: "total-num"
	  }, _vm._l((_vm.data), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item))])
	  }), 0)]), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("扫码区域")]), _vm._v(" "), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	}]}

/***/ }),
/* 1997 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('v-map')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1998 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item name"
	    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1999 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return (_vm.tableData.length > 0 && index < 6) ? _c('div', {
	      staticClass: "temp"
	    }, [_c('img', {
	      key: item.productUrl,
	      attrs: {
	        "src": ("" + _vm.url + (item.productUrl.split(',')[0]))
	      }
	    }), _vm._v(" "), _c('span', {
	      key: item.productName
	    }, [_vm._v(_vm._s(item.productName))])]) : _vm._e()
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "nav"
	  }, [_c('swiper', {
	    ref: "mySwiper",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.swiperData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "nav-item"
	    }, [_c('div', {
	      staticClass: "nav-item-bg",
	      on: {
	        "click": function($event) {
	          return _vm.clickPage(index)
	        }
	      }
	    }, [_c('i'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])])
	  }), 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_c('v-item2')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_c('v-item5')], 1), _vm._v(" "), _c('img', {
	    staticClass: "lf",
	    attrs: {
	      "src": __webpack_require__(1630)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "outputValue": _vm.outputValue,
	      "productionScale": _vm.productionScale
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item4"
	  }, [_c('v-item1')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item5"
	  }, [_c('v-item3')], 1), _vm._v(" "), _c('img', {
	    staticClass: "rl",
	    attrs: {
	      "src": __webpack_require__(1631)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item6"
	  }, [_c('v-table2')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("基地")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("批次名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("记录节点")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.base))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item2 white"
	    }, [_vm._v(_vm._s(item.node))])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-pie')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-table')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-circle')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-iot')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center')], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-flow')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-circle-bar')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.num / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.num) + "笔")])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("高（剧）毒农药销售预警")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.name1))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item3",
	      class: {
	        rackA: item.number == '实名登记',
	          rackB: item.number == '未登记'
	      }
	    }, [_vm._v(_vm._s(item.number))])])
	  }), 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("经营主体")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("农药名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("实名情况")])])
	}]}

/***/ }),
/* 2009 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 5) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.province))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.scanCount / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.scanCount))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.province))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.scanCount / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.scanCount))])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item name"
	    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-item1')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-item2')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-item3')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "outputValue": _vm.outputValue,
	      "productionScale": _vm.productionScale
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-item4')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('v-item5')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('v-item6')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "30px 20px"
	    },
	    attrs: {
	      "src": __webpack_require__(208)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('ul', [_c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1626)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("可追溯商品数量")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 1286708,
	      "endVal": 2286708,
	      "duration": 5000
	    }
	  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1627)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("累计扫码量")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 10785098,
	      "endVal": 18785098,
	      "duration": 5000
	    }
	  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1628)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("区块链存证批次数量")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 62480,
	      "duration": 5000
	    }
	  })], 1)]), _vm._v(" "), _c('li', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1629)
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("区块链存证节点数量")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 1376682,
	      "duration": 5000
	    }
	  })], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line4"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h1', {
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
	    staticClass: "right"
	  }, [_vm._v("技术支持：浙江甲骨文科技集团")]) : _c('div', {
	    staticClass: "right"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "particles-js"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 2020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "top"
	  }, [(_vm.show) ? _c('ul', _vm._l((_vm.listdata), function(item) {
	    return _c('li', [_c('p', [_vm._v(_vm._s(item.value))]), _c('p', [_vm._v(_vm._s(item.name))])])
	  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('div', [(_vm.show) ? _c('v-bars', {
	    attrs: {
	      "regionBar": _vm.regionBar
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.show) ? _c('v-twoWayBar', {
	    attrs: {
	      "productBar": _vm.productBar
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', [(_vm.show) ? _c('v-pie', {
	    attrs: {
	      "distributedBar": _vm.distributedBar
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "povertyAlleviaList": _vm.povertyAlleviaList
	    }
	  }) : _vm._e()], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2021 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "itemtransparent "
	    }), _vm._v(" "), _c('div', {
	      staticClass: "itemtransparent "
	    }), _vm._v(" "), _c('div', {
	      staticClass: "itemtransparent"
	    }, [_vm._v(_vm._s(item.regionName))]), _vm._v(" "), _c('div', {
	      staticClass: "itemtransparent"
	    }, [_vm._v(_vm._s(item.amount))])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("待迁移数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("已迁移数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item",
	    staticStyle: {
	      "width": "50%"
	    }
	  }, [_vm._v("迁移数据记录")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("蔬菜溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("小麦溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("数据名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("耗时/ms")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("生鲜乳检测数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("甜菜溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("水果溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("生猪溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("牛肉溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("羊肉溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("禽肉溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("牛奶溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item"
	  }, [_c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item right"
	  }, [_vm._v("蘑菇溯源数据")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  })])
	}]}

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-salesData') : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-pie') : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-bar', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center', {
	    attrs: {
	      "outputValue": _vm.outputValue,
	      "productionScale": _vm.productionScale
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-harvestingPlan')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-ev')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-video')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-group')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mainApp"
	  }, [_c('particles'), _vm._v(" "), _c('router-view', {
	    staticClass: "router-view"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [(_vm.isDashboard) ? _c('div', {
	    staticClass: "left"
	  }, [_c('span', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.time))]), _c('span', {
	    staticClass: "weekdays"
	  }, [_vm._v(_vm._s(_vm.weekdays))])]) : _c('div', {
	    staticClass: "left back",
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v("返回")]), _vm._v(" "), _c('h1', {
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
	    staticClass: "right"
	  }, [_vm._v("技术支持：甲骨文科技股份")]) : _c('div', {
	    staticClass: "right"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bottom"
	  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
	    return _c('li', [_c('p', [_c('img', {
	      attrs: {
	        "src": item.img
	      }
	    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.number))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-bars')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-two-way-bar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-table')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [_c('v-center')], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-bar')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-pie')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-analyse')], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map-wrap"
	  }, [_c('div', {
	    staticClass: "map",
	    on: {
	      "click": _vm.jumpChild
	    }
	  }, [(!_vm.ifSatellite) ? _c('mapChart') : _c('satelliteMap')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "万元")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('centerTop'), _vm._v(" "), _c('centerChildMap'), _vm._v(" "), _c('centerBottom')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("区域在售登记种类")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(299)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "type"
	  }, _vm._l((_vm.type), function(item, key, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('p', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])
	  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "title1"
	  }, [_vm._v("近30天区域店铺台账信息")]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "number"
	  }, [_c('div', {
	    staticStyle: {
	      "float": "left"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 2034 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("品种")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("产值/亿元")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("产量/吨")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("上市周期")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.scale))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.output))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.production))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.listed))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2036 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flow"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 2037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [(_vm.isDashboard) ? _c('div', {
	    staticClass: "left"
	  }) : _vm._e(), _vm._v(" "), _c('h1', {
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
	    staticClass: "right"
	  }) : _c('div', {
	    staticClass: "right"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "30px 20px"
	    },
	    attrs: {
	      "src": __webpack_require__(208)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.input))])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('img', {
	    staticClass: "img1",
	    attrs: {
	      "src": "static/img/base/weather-icon.png",
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.change(1)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "img2",
	    attrs: {
	      "src": "static/img/base/monitor-icon.png",
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.change(0)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "img3",
	    attrs: {
	      "src": "static/img/base/icon.png",
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.change(3)
	      }
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "img4",
	    attrs: {
	      "src": "static/img/base/icon0.png",
	      "alt": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.change(2)
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "describe"
	  }, [_c('p', [_vm._v("会员总人数")]), _vm._v(" "), _c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 3424089,
	      "duration": 5000
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    class: _vm.list[0] ? 'itemactive' : 'item'
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })]), _vm._v(" "), _c('div', {
	    class: _vm.list[1] ? 'item2active' : 'item2'
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })]), _vm._v(" "), _c('div', {
	    class: _vm.list[2] ? 'item3active' : 'item3'
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "mark"
	  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('centerBottom')], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tip"
	  }, [_c('p', [_vm._v("辽宁大连-中山广场店")]), _vm._v(" "), _c('p', [_vm._v("\"大转盘\"活动-进行中2019/10-20-2019/12/30")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：7834")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：2324")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：30.51%，环比提升3.21%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：16931")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：17087")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：896")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tip"
	  }, [_c('p', [_vm._v("重庆-解放路店")]), _vm._v(" "), _c('p', [_vm._v("\"大转盘\"活动-进行中2019/11-10-2020/2/30")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：3912")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：2892")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：29.56%，环比提升4.88%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：9768")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：10231")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：5435")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tip"
	  }, [_c('p', [_vm._v("浙江杭州-西湖店")]), _vm._v(" "), _c('p', [_vm._v("\"微信红包\"活动-进行中 2019/10-25-2019/12/15")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("新增会员数：6323")]), _vm._v(" "), _c('li', [_vm._v("新增公众号关注人数：3421")]), _vm._v(" "), _c('li', [_vm._v("会员复购率：25.24%，环比提升5.67%")]), _vm._v(" "), _c('li', [_vm._v("活动访问人数：13242")]), _vm._v(" "), _c('li', [_vm._v("扫码产品数：13532")]), _vm._v(" "), _c('li', [_vm._v("中奖人数：543")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "animate wave"
	  }, [_c('div', {
	    staticClass: "w1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "w2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "w3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "w4"
	  })])
	}]}

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("区域农业投入品流通销售排行榜")]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
	    return _c('div', {
	      key: item,
	      staticClass: "type",
	      class: {
	        active: index == _vm.typeindex
	      },
	      on: {
	        "click": function($event) {
	          return _vm.changeType(item, index)
	        }
	      }
	    }, [_vm._v(_vm._s(item))])
	  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.lumpSum))])])
	  }), 1) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("排名")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("商品名")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("数量")])])
	}]}

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "iot"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("物联网智能硬件设备数量:")]), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "device-wrap"
	  }, [_c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("监控设备")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("365")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("气象站")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("198")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("传感器")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("298")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("控制设备")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("153")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "monitor"
	  }, [_c('div', {
	    staticClass: "monitor1"
	  }, [(_vm.imgList1.length != 0) ? _c('swiper', {
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.imgList1), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "swiper-item"
	    }, [_c('img', {
	      staticClass: "slide-img",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "msg"
	    }, [_vm._v(_vm._s(item.name))])])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList1.length > 1),
	      expression: "imgList1.length>1"
	    }],
	    staticClass: "swiper-button-prev0"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList1.length > 1),
	      expression: "imgList1.length>1"
	    }],
	    staticClass: "swiper-button-next0"
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "monitor2"
	  }, [(_vm.imgList2.length != 0) ? _c('swiper', {
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption1
	    }
	  }, _vm._l((_vm.imgList2), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "swiper-item"
	    }, [_c('img', {
	      staticClass: "slide-img",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "msg"
	    }, [_vm._v(_vm._s(item.name))])])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList2.length > 1),
	      expression: "imgList2.length>1"
	    }],
	    staticClass: "swiper-button-prev1"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList2.length > 1),
	      expression: "imgList2.length>1"
	    }],
	    staticClass: "swiper-button-next1"
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "productScanStatisticsList": _vm.productScanStatisticsList
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-codeRanking', {
	    attrs: {
	      "provinceStatisticsList": _vm.provinceStatisticsList
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [(_vm.cityStatisticsList.length > 0) ? _c('v-center', {
	    attrs: {
	      "totalRelationCount": _vm.totalRelationCount,
	      "cityStatisticsList": _vm.cityStatisticsList
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-harvestingPlan', {
	    attrs: {
	      "productRelationStatisticsList": _vm.productRelationStatisticsList
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-product', {
	    attrs: {
	      "productRelationStatisticsList": _vm.productScanStatisticsList
	    }
	  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev",
	    on: {
	      "click": _vm.prev
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next",
	    on: {
	      "click": _vm.next
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('ul', {
	    staticClass: "main"
	  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("经营主体入网数")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 990,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(1), _c('span', [_vm._v("待审核经营主体")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 10,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(2), _c('span', [_vm._v("经营限制农药")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(3), _c('span', [_vm._v("批发商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(4), _c('span', [_vm._v("零售商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(5), _c('span', [_vm._v("店铺交易活跃")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 800,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(293)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(294)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(295)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(296)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(297)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(298)
	    }
	  })])
	}]}

/***/ }),
/* 2046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("农药销售实时情况")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.name1))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.number))])])
	  }), 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("经营主体")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("农药名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("销售数量")])])
	}]}

/***/ }),
/* 2047 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "title"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('p', [_vm._v("67.95%")]), _vm._v(" "), _c('p', [_vm._v("女")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 634,
	      "duration": 5000
	    }
	  }), _c('span', [_vm._v("人")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('p', [_vm._v("32.05%")]), _vm._v(" "), _c('p', [_vm._v("男")]), _vm._v(" "), _c('p', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 430,
	      "duration": 5000
	    }
	  }), _c('span', [_vm._v("人")])], 1)])])])
	},staticRenderFns: []}

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种类")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("产值")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("产量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("上市周期")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.scale))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.output))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.production))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.listed))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "area-list"
	  }, _vm._l((_vm.areaList), function(item, index) {
	    var _obj;
	
	    return _c('div', {
	      key: index,
	      staticClass: "item",
	      class: ['item', ( _obj = {}, _obj['active'] = index == 2, _obj )]
	    }, [_vm._v(_vm._s(item))])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "left-item left-item1"
	  }, [_vm._v("\n          " + _vm._s(_vm.baseDetailList[_vm.activeItem].baseName) + "\n        ")]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("基地负责人")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].name))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("联系电话")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].phone))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("管理机构")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].company))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("基地面积")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].total))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("承包时间")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].time))])]), _vm._v(" "), _c('div', {
	    staticClass: "left-item"
	  }, [_c('p', {
	    staticClass: "label"
	  }, [_vm._v("基地地址")]), _vm._v(" "), _c('p', {
	    staticClass: "val"
	  }, [_vm._v(_vm._s(_vm.baseDetailList[_vm.activeItem].region))])])]), _vm._v(" "), _c('div', {
	    staticClass: "middle"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('v-lines')], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-line', {
	    attrs: {
	      "tit": "年平均降雨量"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-line', {
	    attrs: {
	      "tit": "无霜期"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_c('v-line', {
	    attrs: {
	      "tit": "年平均日照时长"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('v-map', {
	    on: {
	      "indexChange": _vm.indexChange
	    }
	  })], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('ul', {
	    staticClass: "main"
	  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("经营主体入网数")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 990,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(1), _c('span', [_vm._v("待审核经营主体")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 10,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(2), _c('span', [_vm._v("经营限制农药")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(3), _c('span', [_vm._v("批发商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(4), _c('span', [_vm._v("零售商")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 100,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _c('span', [_vm._v("家")])]), _vm._v(" "), _c('li', [_vm._m(5), _c('span', [_vm._v("店铺交易活跃")]), _vm._v(" "), _c('span', [_c('countTo', {
	    staticClass: "count",
	    attrs: {
	      "startVal": 0,
	      "endVal": 800,
	      "duration": 5000
	    }
	  }), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')], 1), _vm._v(" "), _c('span', [_vm._v("家")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(293)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(294)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(295)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(296)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(297)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(298)
	    }
	  })])
	}]}

/***/ }),
/* 2052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('v-left-details'), _vm._v(" "), _c('v-map', {
	    attrs: {
	      "activeItem": _vm.activeItem
	    },
	    on: {
	      "indexChange": _vm.indexChange
	    }
	  }), _vm._v(" "), _c('v-details', {
	    attrs: {
	      "activeItem": _vm.activeItem
	    },
	    on: {
	      "indexChange": _vm.indexChange
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "circle"
	  }, [_c('div', {
	    staticClass: "main"
	  }, _vm._l((_vm.circleData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('div', [_c('div', {
	      staticStyle: {
	        "margin-bottom": "7px"
	      }
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.value))])])])
	  }), 0)])])
	},staticRenderFns: []}

/***/ }),
/* 2054 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "company"
	  }, [_vm._v(_vm._s(_vm.companyList[_vm.viewIndex]))]), _vm._v(" "), _c('div', {
	    staticClass: "satelliteMap",
	    attrs: {
	      "id": _vm.id
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('centerTop'), _vm._v(" "), _c('centerMap'), _vm._v(" "), _c('centerBottom')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2056 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('centerTop'), _vm._v(" "), _c('centerMiddle')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item-rank"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("主体")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("产业")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("经营情况")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.lumpSum))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2058 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("客户名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("数量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("金额")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.lumpSum))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('centerTop'), _vm._v(" "), (!_vm.child) ? _c('centerMap', {
	    attrs: {
	      "areaName": _vm.areaName
	    },
	    on: {
	      "clickMap": _vm.clickMap,
	      "clickChild": _vm.clickChild
	    }
	  }) : _vm._e(), _vm._v(" "), _c('centerBottom')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2061 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('ul', {
	    staticClass: "top"
	  }, _vm._l((_vm.tablist), function(n, index) {
	    return _c('li', [_c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (index == _vm.tab),
	        expression: "index == tab"
	      }]
	    }, [_vm._v(_vm._s(n))])])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "des"
	  }, _vm._l((_vm.data), function(item) {
	    return _c('li', [_c('p'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "bar6"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "bottom"
	  })])
	}]}

/***/ }),
/* 2063 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.data.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.data), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "active-item"
	    }, [_c('i', {
	      staticClass: "item-rank",
	      style: (_vm.changeColor(index))
	    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
	      staticClass: "item-name-num"
	    }, [_c('span', {
	      staticClass: "item-name",
	      style: (_vm.changeLength(index))
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('em', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.num))])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.poor))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.familyPopulation))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.regionName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.amount))])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("贫困户")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("家庭人口")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("所在地")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("帮扶金额")])])
	}]}

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "details"
	  }, [_c('div', {
	    staticClass: "part-1"
	  }, [_c('div', {
	    staticClass: "nav"
	  }, _vm._l((_vm.navItem), function(item, index) {
	    var _obj;
	
	    return _c('div', {
	      key: index,
	      class: ['icon', 'icon-' + item, ( _obj = {}, _obj['icon-active-' + item] = _vm.activeItem == index, _obj )],
	      on: {
	        "click": function($event) {
	          return _vm.switchNav(index)
	        }
	      }
	    })
	  }), 0), _vm._v(" "), (_vm.activeItem === 0) ? _c('div', {
	    staticClass: "content content1"
	  }, [(_vm.banner.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.banner), function(item, index) {
	    return _c('swiper-slide', {
	      key: index
	    }, [_c('div', {
	      staticClass: "swiper-div"
	    }, [_c('p', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('img', {
	      staticClass: "img-item",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('p', {
	      staticClass: "monitor"
	    }, [_vm._v("视频监控 " + _vm._s(index + 1) + "/" + _vm._s(_vm.banner.length))])])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeItem === 1) ? _c('div', {
	    staticClass: "content content2"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "see-details",
	    on: {
	      "click": _vm.showDetails
	    }
	  }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "modal-details"
	  }, [_c('i', {
	    staticClass: "close",
	    on: {
	      "click": _vm.hideDetails
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "static/img/base/weather-station.png",
	      "alt": ""
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.activeItem === 2) ? _c('div', {
	    staticClass: "content content3"
	  }, _vm._l((_vm.content3Data), function(item, index) {
	    return _c('div', {
	      key: index
	    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeItem === 3) ? _c('div', {
	    staticClass: "content content4"
	  }, _vm._l((_vm.content4Data), function(item, index) {
	    return _c('div', {
	      key: index
	    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
	  }), 0) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._v("\n        气象站\n        "), _c('span', [_vm._v("运行中")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "part-2"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("显示内容")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('div', [_c('div', {
	    staticStyle: {
	      "margin-bottom": "15px"
	    }
	  }, [_vm._v("摄像头（1个）")]), _vm._v(" "), _c('div', [_vm._v("传感设备（1个）")])]), _vm._v(" "), _c('div', [_c('div', {
	    staticStyle: {
	      "margin-bottom": "15px"
	    }
	  }, [_vm._v("气象站（1个）")]), _vm._v(" "), _c('div', [_vm._v("灌溉设备（1个）")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "part-3"
	  }, [_c('p', [_vm._v("地址：广西省百色市")]), _vm._v(" "), _c('p', [_vm._v("占地面积：20000余亩")])])
	}]}

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "5px 10px",
	      "width": "470px"
	    },
	    attrs: {
	      "src": __webpack_require__(207)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "flow"
	  }, [_c('div', {
	    staticClass: "main"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "custom-legend"
	  }, [_c('div', [_c('i', [_vm._v("1")]), _vm._v("广州 3563\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("2")]), _vm._v("深圳 3249\n      ")]), _vm._v(" "), _c('div', [_c('i', [_vm._v("3")]), _vm._v("上海 3202\n      ")])])])])
	},staticRenderFns: []}

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('ul', {
	    staticClass: "top"
	  }, _vm._l((_vm.tablist), function(n, index) {
	    return _c('li', [_c('span', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (index == _vm.tab),
	        expression: "index == tab"
	      }]
	    }, [_vm._v(_vm._s(n))])])
	  }), 0), _vm._v(" "), _c('ul', {
	    staticClass: "des"
	  }, _vm._l((_vm.data), function(item) {
	    return _c('li', [_c('p'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "bar6"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: {
	      'box-wrap-min': _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("经营主体交易排行榜")]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "笔")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "分")])])])
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "instruction"
	  }, _vm._l((_vm.instructionData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('div', {
	      staticClass: "item-name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.value))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "万元")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "斤")])])])
	  })], 2) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "twoWayBar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-salesData', {
	    attrs: {
	      "salesOrderAnalysis": _vm.salesOrderAnalysis
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item item2"
	  }, [(_vm.show) ? _c('v-harvestingPlan', {
	    attrs: {
	      "regionalRanking": _vm.regionalRanking
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "center"
	  }, [(_vm.show) ? _c('v-center', {
	    attrs: {
	      "orderCustomer": _vm.orderCustomer,
	      "salesAmount": _vm.salesAmount,
	      "salesDataBar": _vm.salesDataBar
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-orderProductRanking', {
	    attrs: {
	      "commodityRanking": _vm.commodityRanking
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [(_vm.show) ? _c('v-table', {
	    attrs: {
	      "salesDataRealTime": _vm.salesDataRealTime
	    }
	  }) : _vm._e()], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "iot"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("物联网智能硬件设备数量:")]), _vm._v(" "), _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "device-wrap"
	  }, [_c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("监控设备")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("1825")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("气象站")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("990")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("传感器")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("1490")])])]), _vm._v(" "), _c('div', {
	    staticClass: "device-item"
	  }, [_c('i', {
	    staticClass: "icon icon-device4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "device-detail"
	  }, [_c('div', {
	    staticClass: "device-name"
	  }, [_vm._v("控制设备")]), _vm._v(" "), _c('div', {
	    staticClass: "device-num"
	  }, [_vm._v("765")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "monitor"
	  }, [_c('div', {
	    staticClass: "monitor1"
	  }, [(_vm.imgList1.length != 0) ? _c('swiper', {
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.imgList1), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "swiper-item"
	    }, [_c('img', {
	      staticClass: "slide-img",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "msg"
	    }, [_vm._v(_vm._s(item.name))])])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList1.length > 1),
	      expression: "imgList1.length>1"
	    }],
	    staticClass: "swiper-button-prev0"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList1.length > 1),
	      expression: "imgList1.length>1"
	    }],
	    staticClass: "swiper-button-next0"
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "monitor2"
	  }, [(_vm.imgList2.length != 0) ? _c('swiper', {
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption1
	    }
	  }, _vm._l((_vm.imgList2), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "swiper-item"
	    }, [_c('img', {
	      staticClass: "slide-img",
	      attrs: {
	        "src": item.src,
	        "alt": ""
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "msg"
	    }, [_vm._v(_vm._s(item.name))])])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList2.length > 1),
	      expression: "imgList2.length>1"
	    }],
	    staticClass: "swiper-button-prev1"
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.imgList2.length > 1),
	      expression: "imgList2.length>1"
	    }],
	    staticClass: "swiper-button-next1"
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("产品名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("码关联数量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("扫码数量")])]), _vm._v(" "), (_vm.tableData.length > 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 5) ? _vm._l((_vm.tableData), function(item) {
	    return _c('swiper-slide', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.relationCount || 0))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.scanCount || 0))])])
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
	    return _c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.relationCount || 0))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.scanCount || 0))])])
	  })], 2) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "tip"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.num) + "元")])]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      style: (("width:" + ((item.num / _vm.sum) * 100) + "%"))
	    })])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('img', {
	    staticClass: "left-bg",
	    attrs: {
	      "src": __webpack_require__(1708),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "right-bg",
	    attrs: {
	      "src": __webpack_require__(1709),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "top"
	  }, [_c('div', {
	    staticClass: "select",
	    on: {
	      "click": _vm.up
	    }
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("百色市监控")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "oprate"
	  }, [_vm._v("收起 "), _c('img', {
	    staticStyle: {
	      "transform": "rotate(180deg)"
	    },
	    attrs: {
	      "src": __webpack_require__(582),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.show),
	      expression: "!show"
	    }],
	    staticClass: "oprate"
	  }, [_vm._v("展开 "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(582),
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "options"
	  }, _vm._l((_vm.options), function(item, index) {
	    return _c('div', {
	      key: item.id,
	      staticStyle: {
	        "display": "flex"
	      }
	    }, [_c('div', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.checkedNames2),
	        expression: "checkedNames2"
	      }],
	      staticClass: "cb",
	      attrs: {
	        "id": _vm.ids(index),
	        "type": "checkbox"
	      },
	      domProps: {
	        "value": item.text,
	        "checked": Array.isArray(_vm.checkedNames2) ? _vm._i(_vm.checkedNames2, item.text) > -1 : (_vm.checkedNames2)
	      },
	      on: {
	        "change": function($event) {
	          var $$a = _vm.checkedNames2,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = item.text,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.checkedNames2 = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.checkedNames2 = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.checkedNames2 = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('label', {
	      attrs: {
	        "for": _vm.ids(index)
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "icon"
	    }, [_vm._v(_vm._s(item.text))])])
	  }), 0)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "change"
	  }, [_c('div', {
	    staticClass: "head",
	    class: {
	      cr: _vm.status
	    },
	    on: {
	      "click": function($event) {
	        return _vm.keys(1)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "head cur2",
	    class: {
	      cr2: _vm.status1
	    },
	    on: {
	      "click": function($event) {
	        return _vm.keys(2)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "head cur3",
	    class: {
	      cr3: _vm.status2
	    },
	    on: {
	      "click": function($event) {
	        return _vm.keys(3)
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "head cur4",
	    class: {
	      cr4: _vm.status3
	    },
	    on: {
	      "click": function($event) {
	        return _vm.keys(4)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, _vm._l((_vm.showList), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "pic-item",
	      class: _vm.width2(),
	      style: (_vm.width()),
	      attrs: {
	        "id": _vm.ID(index)
	      }
	    }, [_c('img', {
	      attrs: {
	        "src": item,
	        "alt": ""
	      }
	    })])
	  }), 0)])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "total"
	  }, [_c('span', [_vm._v("百色市监控总数")]), _vm._v(" "), _c('span', [_vm._v("60个")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "left"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1714),
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "bar2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie2"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "main"
	  })])
	}]}

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "box-wrap",
	    class: _vm.min
	  }, [_c('div', {
	    staticClass: "name",
	    class: _vm.top
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
	    staticClass: "box"
	  }, [_c('img'), _vm._v(" "), _vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "select"
	  }, [_c('div', {
	    staticClass: "item",
	    on: {
	      "click": _vm.up
	    }
	  }, [_c('span', {
	    staticClass: "monitor-name",
	    staticStyle: {
	      "margin-right": "30px"
	    }
	  }, [_vm._v("百色市田阳县气象监控站")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "options"
	  }, _vm._l((_vm.options), function(item, index) {
	    return _c('div', {
	      key: item.id
	    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('span', [_vm._v(_vm._s(_vm.listData[_vm.num].temperature) + "°C")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1632),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("湿度" + _vm._s(_vm.listData[_vm.num].humidity) + "%")])]), _vm._v(" "), _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1633),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("西南风 " + _vm._s(_vm.listData[_vm.num].winds) + " 级")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1634),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("空气指数: " + _vm._s(_vm.listData[_vm.num].air))])])])]), _vm._v(" "), _vm._m(3)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("16：00 更新")]), _vm._v(" "), _c('img', {
	    staticClass: "down-arrow",
	    attrs: {
	      "src": __webpack_require__(1635),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', [_vm._v("晴")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1636),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', {
	    staticClass: "index-mark"
	  }, [_vm._v("优")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤温度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("24")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤湿度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("43")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("水质PH")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("6.9")]), _c('span', {
	    staticClass: "unit"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("水质温度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("23")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("CO2浓度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("453")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("PM2.5")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("13")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ug/m²")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤铵根离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("1.0")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤硝酸离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤钾离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("41.93")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("铜离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.01")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("铅离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.3")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("镉离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.01")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])])])
	}]}

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main main4"
	  })])])
	}]}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('ul', {
	    staticClass: "list",
	    attrs: {
	      "id": "list"
	    }
	  }, _vm._l((_vm.list), function(item, index) {
	    var _obj;
	
	    return _c('li', {
	      key: index,
	      class: [( _obj = {}, _obj['active'] = item.flag, _obj )]
	    }, [_vm._v(_vm._s(item.name))])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "lines"
	  }, [(_vm.num % 2 === 0) ? _c('div', {
	    staticClass: "main"
	  }) : _c('div', {
	    staticClass: "main1"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("产品名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("码关联数量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("扫码数量")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.codeNum))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.scanNum))])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2093 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [(_vm.listData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.listData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      class: _vm.changeClassName(index)
	    }, [_c('p', {
	      class: _vm.changeTitClass(index)
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      class: _vm.changeListClass(index)
	    }, [_c('div', {
	      class: _vm.changeListItemClass(index)
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v("采购总额(元)")]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.total))])]), _vm._v(" "), _c('div', {
	      staticClass: "list-item",
	      class: _vm.changeListItemClass(index)
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v("采购数量")]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.mount))])]), _vm._v(" "), _c('div', {
	      class: _vm.changeListItemClass(index)
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v("平均单价(元)")]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active"
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.price))])])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "5px 10px",
	      "width": "470px"
	    },
	    attrs: {
	      "src": __webpack_require__(207)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2095 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(item.id) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast))])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "30px 20px"
	    },
	    attrs: {
	      "src": __webpack_require__(208)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "circleBar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "describe"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("可追溯商品总量")]), _vm._v(" "), _c('div', {
	    staticClass: "total-num"
	  }, _vm._l((_vm.data), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item))])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 2100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("经营主体交易排行榜")]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "笔")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "分")])])])
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": _vm.min
	    }
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("抽检时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("抽检批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("基数(Kg)")]), _vm._v(" "), _c('div', {
	    staticClass: "item4"
	  }, [_vm._v("合格率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.base))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item4 white"
	    }, [_vm._v(_vm._s(item.node))])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "instruction"
	  }, _vm._l((_vm.instructionData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "item"
	    }, [_c('div', {
	      staticClass: "item-name"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item-num"
	    }, [_vm._v(_vm._s(item.value))])])
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "bar"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "nav"
	  }, [_c('swiper', {
	    ref: "mySwiper",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.swiperData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "nav-item"
	    }, [_c('div', {
	      staticClass: "nav-item-bg",
	      on: {
	        "click": function($event) {
	          return _vm.clickPage(index)
	        }
	      }
	    }, [_c('i'), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])])
	  }), 1), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "center"
	  }, [_c('div', {
	    staticClass: "describe"
	  }, [_c('div', {
	    staticClass: "left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("销售额")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v(_vm._s(this.salesAmount))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "right"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("订单客户")]), _vm._v(" "), _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_c('p', {
	    staticClass: "num"
	  }, [_vm._v(_vm._s(this.orderCustomer))])])])])]), _vm._v(" "), _vm._m(0)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "map"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v("销售数据")]), _vm._v(" "), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "line"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])])
	}]}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('h1', {
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.isDashboard) ? _c('div', {
	    staticClass: "right"
	  }, [_vm._v("技术支持：浙江甲骨文科技集团")]) : _c('div', {
	    staticClass: "right"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "bar1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	}]}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name,
	      "isDashboard": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('div', [_c('v-pie1')], 1), _vm._v(" "), _c('div', [_c('v-pie2')], 1), _vm._v(" "), _c('div', [_c('v-pie')], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', [_c('v-table', {
	    attrs: {
	      "povertyAlleviaList": _vm.povertyAlleviaList
	    }
	  })], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "pie1"
	  }, [_c('div', {
	    staticClass: "main"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "monitor"
	  }, [_c('v-header', {
	    attrs: {
	      "name": _vm.name
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("百色市田阳县")]), _vm._v(" "), _c('div', {
	    staticClass: "select"
	  }, [_c('div', {
	    staticClass: "item",
	    on: {
	      "click": _vm.up
	    }
	  }, [_c('span', {
	    staticClass: "monitor-name",
	    staticStyle: {
	      "margin-right": "30px"
	    }
	  }, [_vm._v("百色市田阳县气象监控站")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "options"
	  }, _vm._l((_vm.options), function(item, index) {
	    return _c('div', {
	      key: item.id
	    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('span', [_vm._v(_vm._s(_vm.listData[_vm.num].temperature) + "°C")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1656),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("湿度" + _vm._s(_vm.listData[_vm.num].humidity) + "%")])]), _vm._v(" "), _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1657),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("西南风 " + _vm._s(_vm.listData[_vm.num].winds) + " 级")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item item1"
	  }, [_vm._m(2), _vm._v(" "), _c('span', [_c('img', {
	    attrs: {
	      "src": __webpack_require__(1658),
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("空气指数: " + _vm._s(_vm.listData[_vm.num].air))])])])]), _vm._v(" "), _vm._m(3)])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("16：00 更新")]), _vm._v(" "), _c('img', {
	    staticClass: "down-arrow",
	    attrs: {
	      "src": __webpack_require__(1659),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', [_vm._v("晴")]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(1660),
	      "alt": ""
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('span', {
	    staticClass: "index-mark"
	  }, [_vm._v("优")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "detail"
	  }, [_c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤温度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("24")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤湿度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("43")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("水质PH")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("6.9")]), _c('span', {
	    staticClass: "unit"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("水质温度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("23")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("℃")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("CO2浓度")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("453")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("PM2.5")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("13")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ug/m²")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤铵根离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("1.0")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤硝酸离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("土壤钾离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("41.93")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("铜离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.01")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("铅离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.3")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])]), _vm._v(" "), _c('div', {
	    staticClass: "detail-item"
	  }, [_c('p', {
	    staticClass: "name"
	  }, [_vm._v("镉离子")]), _vm._v(" "), _c('p', {
	    staticClass: "data"
	  }, [_c('span', {
	    staticClass: "num"
	  }, [_vm._v("0.01")]), _c('span', {
	    staticClass: "unit"
	  }, [_vm._v("ppm")])])])])
	}]}

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "5px 10px",
	      "width": "470px"
	    },
	    attrs: {
	      "src": __webpack_require__(207)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_c('span', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(item.id) + "\n          ")]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast))])])])
	  }), 1) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name
	    }
	  }, [_c('div', {
	    staticClass: "bar-wrap"
	  }, [(_vm.banner.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.banner), function(item, index) {
	    return _c('swiper-slide', {
	      key: index
	    }, [_c('img', {
	      attrs: {
	        "src": item.url,
	        "alt": "",
	        "width": "122px"
	      }
	    }), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "text-align": "center",
	        "color": "#fff"
	      }
	    }, [_vm._v(_vm._s(item.name))])])
	  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-prev"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "swiper-button-next"
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('boxWrap', {
	    attrs: {
	      "name": _vm.name,
	      "min": true
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "list-item list-item1"
	  }, [_c('div', {
	    staticClass: "item"
	  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
	    staticClass: "item"
	  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item name"
	    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
	      staticClass: "item"
	    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
	  }), 1) : _vm._e()], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("农药销售实时情况")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
	      staticClass: "item1"
	    }, [_vm._v(_vm._s(item.orderNumber))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.name1))]), _vm._v(" "), _c('div', {
	      staticClass: "item2"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "item3"
	    }, [_vm._v(_vm._s(item.number))])])
	  }), 1) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-item1"
	  }, [_c('div', {
	    staticClass: "item1"
	  }, [_vm._v("销售时间")]), _vm._v(" "), _c('div', {
	    staticClass: "item1"
	  }, [_vm._v("经营主体")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("农药名称")]), _vm._v(" "), _c('div', {
	    staticClass: "item2"
	  }, [_vm._v("登记证号")]), _vm._v(" "), _c('div', {
	    staticClass: "item3"
	  }, [_vm._v("销售数量")])])
	}]}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "bar-wrap"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("经营主体交易排行榜")]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
	    ref: "mySwiper",
	    staticClass: "swiper-wrap",
	    attrs: {
	      "options": _vm.swiperOption
	    }
	  }, [(_vm.tableData.length > 3) ? _vm._l((_vm.tableData), function(item, index) {
	    return _c('swiper-slide', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "笔")]), _vm._v(" "), _c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })])])])
	  }) : _vm._l((_vm.tableData), function(item, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "list"
	    }, [_c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "name"
	    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('div', {
	      staticClass: "length"
	    }, [_c('div', {
	      staticClass: "active",
	      class: _vm.cla(index),
	      style: (("width:" + ((item.productionForecast / _vm.sum) * 100) + "%"))
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "num"
	    }, [_vm._v(_vm._s(item.productionForecast) + "分")])])])
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.0956f214a0d205bf54c5.js